import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_editor_terrain_proto from './dcei_editor_terrain_proto';
import * as dcei_editor_settings_proto from './dcei_editor_settings_proto';
import * as dcei_engine_data_proto from './dcei_engine_data_proto';
export class EditorData {
  get descriptor() {
    return EditorData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDataEditorData = false;
    this._dataEditorData = null;
    this._hasTerrainEditorData = false;
    this._terrainEditorData = null;
    this._hasArcadeData = false;
    this._arcadeData = null;
    this._hasAssetPreviewerData = false;
    this._assetPreviewerData = null;
    this._hasSettingsData = false;
    this._settingsData = null;
  }
  isEmpty() {
    if (this._hasDataEditorData && !this._dataEditorData.isEmpty()) return false;
    if (this._hasTerrainEditorData && !this._terrainEditorData.isEmpty()) return false;
    if (this._hasArcadeData && !this._arcadeData.isEmpty()) return false;
    if (this._hasAssetPreviewerData && !this._assetPreviewerData.isEmpty()) return false;
    if (this._hasSettingsData && !this._settingsData.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EditorData) {
      return value;
    }
    return EditorData.fromJson(value);
  }
  static fromJson(json) {
    const result = new EditorData();
    if (json.dataEditorData != null) {
      result._hasDataEditorData = true;
      result._dataEditorData = DataEditorData.fromJson(json.dataEditorData);
    }
    if (json.terrainEditorData != null) {
      result._hasTerrainEditorData = true;
      result._terrainEditorData = TerrainEditorData.fromJson(json.terrainEditorData);
    }
    if (json.arcadeData != null) {
      result._hasArcadeData = true;
      result._arcadeData = ArcadeData.fromJson(json.arcadeData);
    }
    if (json.assetPreviewerData != null) {
      result._hasAssetPreviewerData = true;
      result._assetPreviewerData = AssetPreviewerData.fromJson(json.assetPreviewerData);
    }
    if (json.settingsData != null) {
      result._hasSettingsData = true;
      result._settingsData = dcei_editor_settings_proto.SettingsData.fromJson(json.settingsData);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDataEditorData && !this._dataEditorData.isEmpty()) {
      result.dataEditorData = DataEditorData.toJson(this._dataEditorData);
    }
    if (this._hasTerrainEditorData && !this._terrainEditorData.isEmpty()) {
      result.terrainEditorData = TerrainEditorData.toJson(this._terrainEditorData);
    }
    if (this._hasArcadeData && !this._arcadeData.isEmpty()) {
      result.arcadeData = ArcadeData.toJson(this._arcadeData);
    }
    if (this._hasAssetPreviewerData && !this._assetPreviewerData.isEmpty()) {
      result.assetPreviewerData = AssetPreviewerData.toJson(this._assetPreviewerData);
    }
    if (this._hasSettingsData && !this._settingsData.isEmpty()) {
      result.settingsData = dcei_editor_settings_proto.SettingsData.toJson(this._settingsData);
    }
    return result;
  }
  /**
   * @returns {DataEditorData}
   */
  get dataEditorData() {
    return this._hasDataEditorData ? this._dataEditorData : DataEditorData.default;
  }
  get hasDataEditorData() {
    return this._hasDataEditorData;
  }
  setDataEditorData(path, value) {
    return {type: 'SET', path: path.concat(['dataEditorData']), value: value.toJson()};
  }
  deleteDataEditorData(path) {
    return {type: 'DELETE', path: path.concat(['dataEditorData'])};
  }
  /**
   * @returns {TerrainEditorData}
   */
  get terrainEditorData() {
    return this._hasTerrainEditorData ? this._terrainEditorData : TerrainEditorData.default;
  }
  get hasTerrainEditorData() {
    return this._hasTerrainEditorData;
  }
  setTerrainEditorData(path, value) {
    return {type: 'SET', path: path.concat(['terrainEditorData']), value: value.toJson()};
  }
  deleteTerrainEditorData(path) {
    return {type: 'DELETE', path: path.concat(['terrainEditorData'])};
  }
  /**
   * @returns {ArcadeData}
   */
  get arcadeData() {
    return this._hasArcadeData ? this._arcadeData : ArcadeData.default;
  }
  get hasArcadeData() {
    return this._hasArcadeData;
  }
  setArcadeData(path, value) {
    return {type: 'SET', path: path.concat(['arcadeData']), value: value.toJson()};
  }
  deleteArcadeData(path) {
    return {type: 'DELETE', path: path.concat(['arcadeData'])};
  }
  /**
   * @returns {AssetPreviewerData}
   */
  get assetPreviewerData() {
    return this._hasAssetPreviewerData ? this._assetPreviewerData : AssetPreviewerData.default;
  }
  get hasAssetPreviewerData() {
    return this._hasAssetPreviewerData;
  }
  setAssetPreviewerData(path, value) {
    return {type: 'SET', path: path.concat(['assetPreviewerData']), value: value.toJson()};
  }
  deleteAssetPreviewerData(path) {
    return {type: 'DELETE', path: path.concat(['assetPreviewerData'])};
  }
  /**
   * @returns {dcei_editor_settings_proto.SettingsData}
   */
  get settingsData() {
    return this._hasSettingsData ? this._settingsData : dcei_editor_settings_proto.SettingsData.default;
  }
  get hasSettingsData() {
    return this._hasSettingsData;
  }
  setSettingsData(path, value) {
    return {type: 'SET', path: path.concat(['settingsData']), value: value.toJson()};
  }
  deleteSettingsData(path) {
    return {type: 'DELETE', path: path.concat(['settingsData'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "dataEditorData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EditorData(this);
              copy._hasDataEditorData = true;
              copy._dataEditorData = DataEditorData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDataEditorData) {
                return this;
              }
              const copy = new EditorData(this);
              copy._hasDataEditorData = false;
              copy._dataEditorData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasDataEditorData) {
            const copy = new EditorData(this);
            copy._hasDataEditorData = true;
            copy._dataEditorData = DataEditorData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._dataEditorData.apply(type, path.slice(1), value);
          if (newValue === this._dataEditorData) {
            return this;
          }
          const copy = new EditorData(this);
          copy._dataEditorData = copy._dataEditorData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "terrainEditorData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EditorData(this);
              copy._hasTerrainEditorData = true;
              copy._terrainEditorData = TerrainEditorData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTerrainEditorData) {
                return this;
              }
              const copy = new EditorData(this);
              copy._hasTerrainEditorData = false;
              copy._terrainEditorData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTerrainEditorData) {
            const copy = new EditorData(this);
            copy._hasTerrainEditorData = true;
            copy._terrainEditorData = TerrainEditorData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._terrainEditorData.apply(type, path.slice(1), value);
          if (newValue === this._terrainEditorData) {
            return this;
          }
          const copy = new EditorData(this);
          copy._terrainEditorData = copy._terrainEditorData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "arcadeData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EditorData(this);
              copy._hasArcadeData = true;
              copy._arcadeData = ArcadeData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasArcadeData) {
                return this;
              }
              const copy = new EditorData(this);
              copy._hasArcadeData = false;
              copy._arcadeData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasArcadeData) {
            const copy = new EditorData(this);
            copy._hasArcadeData = true;
            copy._arcadeData = ArcadeData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._arcadeData.apply(type, path.slice(1), value);
          if (newValue === this._arcadeData) {
            return this;
          }
          const copy = new EditorData(this);
          copy._arcadeData = copy._arcadeData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "assetPreviewerData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EditorData(this);
              copy._hasAssetPreviewerData = true;
              copy._assetPreviewerData = AssetPreviewerData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAssetPreviewerData) {
                return this;
              }
              const copy = new EditorData(this);
              copy._hasAssetPreviewerData = false;
              copy._assetPreviewerData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasAssetPreviewerData) {
            const copy = new EditorData(this);
            copy._hasAssetPreviewerData = true;
            copy._assetPreviewerData = AssetPreviewerData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._assetPreviewerData.apply(type, path.slice(1), value);
          if (newValue === this._assetPreviewerData) {
            return this;
          }
          const copy = new EditorData(this);
          copy._assetPreviewerData = copy._assetPreviewerData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "settingsData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EditorData(this);
              copy._hasSettingsData = true;
              copy._settingsData = dcei_editor_settings_proto.SettingsData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSettingsData) {
                return this;
              }
              const copy = new EditorData(this);
              copy._hasSettingsData = false;
              copy._settingsData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasSettingsData) {
            const copy = new EditorData(this);
            copy._hasSettingsData = true;
            copy._settingsData = dcei_editor_settings_proto.SettingsData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._settingsData.apply(type, path.slice(1), value);
          if (newValue === this._settingsData) {
            return this;
          }
          const copy = new EditorData(this);
          copy._settingsData = copy._settingsData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EditorData} other
   * @returns {EditorData}
   */
  merge(other) {
    const copy = new EditorData(this);
    if (other._hasDataEditorData) {
      if (copy._hasDataEditorData) {
        copy._dataEditorData = copy.dataEditorData.merge(other.dataEditorData);
      } else {
        copy._dataEditorData = other._dataEditorData;
      }
      copy._hasDataEditorData = true;
    }
    if (other._hasTerrainEditorData) {
      if (copy._hasTerrainEditorData) {
        copy._terrainEditorData = copy.terrainEditorData.merge(other.terrainEditorData);
      } else {
        copy._terrainEditorData = other._terrainEditorData;
      }
      copy._hasTerrainEditorData = true;
    }
    if (other._hasArcadeData) {
      if (copy._hasArcadeData) {
        copy._arcadeData = copy.arcadeData.merge(other.arcadeData);
      } else {
        copy._arcadeData = other._arcadeData;
      }
      copy._hasArcadeData = true;
    }
    if (other._hasAssetPreviewerData) {
      if (copy._hasAssetPreviewerData) {
        copy._assetPreviewerData = copy.assetPreviewerData.merge(other.assetPreviewerData);
      } else {
        copy._assetPreviewerData = other._assetPreviewerData;
      }
      copy._hasAssetPreviewerData = true;
    }
    if (other._hasSettingsData) {
      if (copy._hasSettingsData) {
        copy._settingsData = copy.settingsData.merge(other.settingsData);
      } else {
        copy._settingsData = other._settingsData;
      }
      copy._hasSettingsData = true;
    }
    return copy;
  }
}
EditorData.default = new EditorData();
class EditorData_Builder {
  constructor(value) {
    this._value = new EditorData(value);
  }
  build() {
    return new EditorData(this._value);
  }
  setDataEditorData(value) {
    this._value._hasDataEditorData = true;
    this._value._dataEditorData = value;
    return this;
  }
  deleteDataEditorData() {
    this._value._hasDataEditorData = false;
    this._value._dataEditorData = null;
    return this;
  }
  setTerrainEditorData(value) {
    this._value._hasTerrainEditorData = true;
    this._value._terrainEditorData = value;
    return this;
  }
  deleteTerrainEditorData() {
    this._value._hasTerrainEditorData = false;
    this._value._terrainEditorData = null;
    return this;
  }
  setArcadeData(value) {
    this._value._hasArcadeData = true;
    this._value._arcadeData = value;
    return this;
  }
  deleteArcadeData() {
    this._value._hasArcadeData = false;
    this._value._arcadeData = null;
    return this;
  }
  setAssetPreviewerData(value) {
    this._value._hasAssetPreviewerData = true;
    this._value._assetPreviewerData = value;
    return this;
  }
  deleteAssetPreviewerData() {
    this._value._hasAssetPreviewerData = false;
    this._value._assetPreviewerData = null;
    return this;
  }
  setSettingsData(value) {
    this._value._hasSettingsData = true;
    this._value._settingsData = value;
    return this;
  }
  deleteSettingsData() {
    this._value._hasSettingsData = false;
    this._value._settingsData = null;
    return this;
  }
}
EditorData.Builder = EditorData_Builder;
class EditorData_WithParent {
  /**
   * @param {EditorData} value
   * @param {EditorData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EditorData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDataEditorData() {
    if (this._cachedHasDataEditorData === undefined) {
      if (this._value.hasDataEditorData) {
        this._cachedHasDataEditorData = true;
      } else {
        this._cachedHasDataEditorData = this._parent ? this._parent.hasDataEditorData : false;
      }
    }
    return this._cachedHasDataEditorData;
  }
  get dataEditorData() {
    if (!this._cachedDataEditorData) {
      if (this._value.hasDataEditorData) {
        this._cachedDataEditorData = new DataEditorData.WithParent(this._value.dataEditorData, this._parent && this._parent.hasDataEditorData ? this._parent.dataEditorData : null);
      } else {
        this._cachedDataEditorData = this._parent ? new DataEditorData.WithParent(DataEditorData.default, this._parent.dataEditorData) : DataEditorData.WithParent.default;
      }
    }
    return this._cachedDataEditorData;
  }
  get hasTerrainEditorData() {
    if (this._cachedHasTerrainEditorData === undefined) {
      if (this._value.hasTerrainEditorData) {
        this._cachedHasTerrainEditorData = true;
      } else {
        this._cachedHasTerrainEditorData = this._parent ? this._parent.hasTerrainEditorData : false;
      }
    }
    return this._cachedHasTerrainEditorData;
  }
  get terrainEditorData() {
    if (!this._cachedTerrainEditorData) {
      if (this._value.hasTerrainEditorData) {
        this._cachedTerrainEditorData = new TerrainEditorData.WithParent(this._value.terrainEditorData, this._parent && this._parent.hasTerrainEditorData ? this._parent.terrainEditorData : null);
      } else {
        this._cachedTerrainEditorData = this._parent ? new TerrainEditorData.WithParent(TerrainEditorData.default, this._parent.terrainEditorData) : TerrainEditorData.WithParent.default;
      }
    }
    return this._cachedTerrainEditorData;
  }
  get hasArcadeData() {
    if (this._cachedHasArcadeData === undefined) {
      if (this._value.hasArcadeData) {
        this._cachedHasArcadeData = true;
      } else {
        this._cachedHasArcadeData = this._parent ? this._parent.hasArcadeData : false;
      }
    }
    return this._cachedHasArcadeData;
  }
  get arcadeData() {
    if (!this._cachedArcadeData) {
      if (this._value.hasArcadeData) {
        this._cachedArcadeData = new ArcadeData.WithParent(this._value.arcadeData, this._parent && this._parent.hasArcadeData ? this._parent.arcadeData : null);
      } else {
        this._cachedArcadeData = this._parent ? new ArcadeData.WithParent(ArcadeData.default, this._parent.arcadeData) : ArcadeData.WithParent.default;
      }
    }
    return this._cachedArcadeData;
  }
  get hasAssetPreviewerData() {
    if (this._cachedHasAssetPreviewerData === undefined) {
      if (this._value.hasAssetPreviewerData) {
        this._cachedHasAssetPreviewerData = true;
      } else {
        this._cachedHasAssetPreviewerData = this._parent ? this._parent.hasAssetPreviewerData : false;
      }
    }
    return this._cachedHasAssetPreviewerData;
  }
  get assetPreviewerData() {
    if (!this._cachedAssetPreviewerData) {
      if (this._value.hasAssetPreviewerData) {
        this._cachedAssetPreviewerData = new AssetPreviewerData.WithParent(this._value.assetPreviewerData, this._parent && this._parent.hasAssetPreviewerData ? this._parent.assetPreviewerData : null);
      } else {
        this._cachedAssetPreviewerData = this._parent ? new AssetPreviewerData.WithParent(AssetPreviewerData.default, this._parent.assetPreviewerData) : AssetPreviewerData.WithParent.default;
      }
    }
    return this._cachedAssetPreviewerData;
  }
  get hasSettingsData() {
    if (this._cachedHasSettingsData === undefined) {
      if (this._value.hasSettingsData) {
        this._cachedHasSettingsData = true;
      } else {
        this._cachedHasSettingsData = this._parent ? this._parent.hasSettingsData : false;
      }
    }
    return this._cachedHasSettingsData;
  }
  get settingsData() {
    if (!this._cachedSettingsData) {
      if (this._value.hasSettingsData) {
        this._cachedSettingsData = new dcei_editor_settings_proto.SettingsData.WithParent(this._value.settingsData, this._parent && this._parent.hasSettingsData ? this._parent.settingsData : null);
      } else {
        this._cachedSettingsData = this._parent ? new dcei_editor_settings_proto.SettingsData.WithParent(dcei_editor_settings_proto.SettingsData.default, this._parent.settingsData) : dcei_editor_settings_proto.SettingsData.WithParent.default;
      }
    }
    return this._cachedSettingsData;
  }
  update(current, parent) {
    const result = new EditorData_WithParent(current, parent);
    if (this._cachedDataEditorData && this._value.hasDataEditorData && current.hasDataEditorData) {
      if (this._value.dataEditorData === current.dataEditorData && this._parent === parent) {
        result._cachedDataEditorData = this._cachedDataEditorData;
      } else {
        result._cachedDataEditorData = this._cachedDataEditorData.update(current.dataEditorData, parent && parent.hasDataEditorData ? parent.dataEditorData : null);
      }
    }
    if (this._cachedTerrainEditorData && this._value.hasTerrainEditorData && current.hasTerrainEditorData) {
      if (this._value.terrainEditorData === current.terrainEditorData && this._parent === parent) {
        result._cachedTerrainEditorData = this._cachedTerrainEditorData;
      } else {
        result._cachedTerrainEditorData = this._cachedTerrainEditorData.update(current.terrainEditorData, parent && parent.hasTerrainEditorData ? parent.terrainEditorData : null);
      }
    }
    if (this._cachedArcadeData && this._value.hasArcadeData && current.hasArcadeData) {
      if (this._value.arcadeData === current.arcadeData && this._parent === parent) {
        result._cachedArcadeData = this._cachedArcadeData;
      } else {
        result._cachedArcadeData = this._cachedArcadeData.update(current.arcadeData, parent && parent.hasArcadeData ? parent.arcadeData : null);
      }
    }
    if (this._cachedAssetPreviewerData && this._value.hasAssetPreviewerData && current.hasAssetPreviewerData) {
      if (this._value.assetPreviewerData === current.assetPreviewerData && this._parent === parent) {
        result._cachedAssetPreviewerData = this._cachedAssetPreviewerData;
      } else {
        result._cachedAssetPreviewerData = this._cachedAssetPreviewerData.update(current.assetPreviewerData, parent && parent.hasAssetPreviewerData ? parent.assetPreviewerData : null);
      }
    }
    if (this._cachedSettingsData && this._value.hasSettingsData && current.hasSettingsData) {
      if (this._value.settingsData === current.settingsData && this._parent === parent) {
        result._cachedSettingsData = this._cachedSettingsData;
      } else {
        result._cachedSettingsData = this._cachedSettingsData.update(current.settingsData, parent && parent.hasSettingsData ? parent.settingsData : null);
      }
    }
    return result;
  }
}
EditorData_WithParent.default = new EditorData_WithParent(EditorData.default, null);
EditorData.WithParent = EditorData_WithParent;
class EditorData_Descriptor {
  get dataEditorData() {
    if (!this._dataEditorData) {
      this._dataEditorData = {
        name: "dataEditorData",
        Name: "DataEditorData",
        number: 1,
        protoType: 11,
        protoName: "data_editor_data",
        type: DataEditorData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dataEditorData;
  }
  get terrainEditorData() {
    if (!this._terrainEditorData) {
      this._terrainEditorData = {
        name: "terrainEditorData",
        Name: "TerrainEditorData",
        number: 2,
        protoType: 11,
        protoName: "terrain_editor_data",
        type: TerrainEditorData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._terrainEditorData;
  }
  get arcadeData() {
    if (!this._arcadeData) {
      this._arcadeData = {
        name: "arcadeData",
        Name: "ArcadeData",
        number: 3,
        protoType: 11,
        protoName: "arcade_data",
        type: ArcadeData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._arcadeData;
  }
  get assetPreviewerData() {
    if (!this._assetPreviewerData) {
      this._assetPreviewerData = {
        name: "assetPreviewerData",
        Name: "AssetPreviewerData",
        number: 4,
        protoType: 11,
        protoName: "asset_previewer_data",
        type: AssetPreviewerData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._assetPreviewerData;
  }
  get settingsData() {
    if (!this._settingsData) {
      this._settingsData = {
        name: "settingsData",
        Name: "SettingsData",
        number: 11,
        protoType: 11,
        protoName: "settings_data",
        type: dcei_editor_settings_proto.SettingsData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._settingsData;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.dataEditorData,
        this.terrainEditorData,
        this.arcadeData,
        this.assetPreviewerData,
        this.settingsData,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDataEditorData",
        Name: "DummyOneofForDataEditorData",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTerrainEditorData",
        Name: "DummyOneofForTerrainEditorData",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForArcadeData",
        Name: "DummyOneofForArcadeData",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAssetPreviewerData",
        Name: "DummyOneofForAssetPreviewerData",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSettingsData",
        Name: "DummyOneofForSettingsData",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
EditorData.descriptor = new EditorData_Descriptor();
export class ArcadeData {
  get descriptor() {
    return ArcadeData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasToken = false;
    this._token = null;
  }
  isEmpty() {
    if (this._hasToken) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ArcadeData) {
      return value;
    }
    return ArcadeData.fromJson(value);
  }
  static fromJson(json) {
    const result = new ArcadeData();
    if (json.token != null) {
      result._hasToken = true;
      result._token = JsonToString.fromJson(json.token);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasToken) {
      result.token = JsonToString.toJson(this._token);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get token() {
    return this._hasToken ? this._token : JsonToString.default;
  }
  get hasToken() {
    return this._hasToken;
  }
  setToken(path, value) {
    return {type: 'SET', path: path.concat(['token']), value};
  }
  deleteToken(path) {
    return {type: 'DELETE', path: path.concat(['token'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "token": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArcadeData(this);
              copy._hasToken = true;
              copy._token = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasToken) {
                return this;
              }
              const copy = new ArcadeData(this);
              copy._hasToken = false;
              copy._token = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ArcadeData} other
   * @returns {ArcadeData}
   */
  merge(other) {
    const copy = new ArcadeData(this);
    if (other._hasToken) {
      copy._hasToken = true;
      copy._token = other._token;
    }
    return copy;
  }
}
ArcadeData.default = new ArcadeData();
class ArcadeData_Builder {
  constructor(value) {
    this._value = new ArcadeData(value);
  }
  build() {
    return new ArcadeData(this._value);
  }
  setToken(value) {
    this._value._hasToken = true;
    this._value._token = value;
    return this;
  }
  deleteToken() {
    this._value._hasToken = false;
    this._value._token = null;
    return this;
  }
}
ArcadeData.Builder = ArcadeData_Builder;
class ArcadeData_WithParent {
  /**
   * @param {ArcadeData} value
   * @param {ArcadeData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ArcadeData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasToken() {
    if (this._cachedHasToken === undefined) {
      if (this._value.hasToken) {
        this._cachedHasToken = true;
      } else {
        this._cachedHasToken = this._parent ? this._parent.hasToken : false;
      }
    }
    return this._cachedHasToken;
  }
  get token() {
    if (this._cachedToken === undefined) {
      if (this._value.hasToken) {
        this._cachedToken = this._value.token;
      } else {
        this._cachedToken = this._parent ? this._parent.token : this._value.token;
      }
    }
    return this._cachedToken;
  }
  update(current, parent) {
    const result = new ArcadeData_WithParent(current, parent);
    return result;
  }
}
ArcadeData_WithParent.default = new ArcadeData_WithParent(ArcadeData.default, null);
ArcadeData.WithParent = ArcadeData_WithParent;
class ArcadeData_Descriptor {
  get token() {
    if (!this._token) {
      this._token = {
        name: "token",
        Name: "Token",
        number: 1,
        protoType: 9,
        protoName: "token",
        type: JsonToString,
        options: {
          comments: "An authentication token used by arcade mode to auth against the platform server.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._token;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.token,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForToken",
        Name: "DummyOneofForToken",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ArcadeData.descriptor = new ArcadeData_Descriptor();
class DataModule_UiDefinitionsEntry {
  get descriptor() {
    return DataModule_UiDefinitionsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataModule_UiDefinitionsEntry) {
      return value;
    }
    return DataModule_UiDefinitionsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataModule_UiDefinitionsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = UiDefinition.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = UiDefinition.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {UiDefinition}
   */
  get value() {
    return this._hasValue ? this._value : UiDefinition.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataModule_UiDefinitionsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DataModule_UiDefinitionsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataModule_UiDefinitionsEntry(this);
              copy._hasValue = true;
              copy._value = UiDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new DataModule_UiDefinitionsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new DataModule_UiDefinitionsEntry(this);
            copy._hasValue = true;
            copy._value = UiDefinition.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new DataModule_UiDefinitionsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataModule_UiDefinitionsEntry} other
   * @returns {DataModule_UiDefinitionsEntry}
   */
  merge(other) {
    const copy = new DataModule_UiDefinitionsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
DataModule_UiDefinitionsEntry.default = new DataModule_UiDefinitionsEntry();
class DataModule_UiDefinitionsEntry_Builder {
  constructor(value) {
    this._value = new DataModule_UiDefinitionsEntry(value);
  }
  build() {
    return new DataModule_UiDefinitionsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
DataModule_UiDefinitionsEntry.Builder = DataModule_UiDefinitionsEntry_Builder;
class DataModule_UiDefinitionsEntry_WithParent {
  /**
   * @param {DataModule_UiDefinitionsEntry} value
   * @param {DataModule_UiDefinitionsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataModule_UiDefinitionsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new UiDefinition.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new UiDefinition.WithParent(UiDefinition.default, this._parent.value) : UiDefinition.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new DataModule_UiDefinitionsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
DataModule_UiDefinitionsEntry_WithParent.default = new DataModule_UiDefinitionsEntry_WithParent(DataModule_UiDefinitionsEntry.default, null);
DataModule_UiDefinitionsEntry.WithParent = DataModule_UiDefinitionsEntry_WithParent;
class DataModule_UiDefinitionsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: UiDefinition,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DataModule_UiDefinitionsEntry.descriptor = new DataModule_UiDefinitionsEntry_Descriptor();
export class DataModule {
  get descriptor() {
    return DataModule.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
    this._hasData = false;
    this._data = null;
    this._hasPath = false;
    this._path = null;
    this._hasUiXml = false;
    this._uiXml = null;
    this._hasModule = false;
    this._module = null;
    this._uiDefinitions = {};
    this._hasTriggerXml = false;
    this._triggerXml = null;
  }
  isEmpty() {
    if (this._hasName) return false;
    if (this._hasData && !this._data.isEmpty()) return false;
    if (this._hasPath) return false;
    if (this._hasUiXml) return false;
    if (this._hasModule) return false;
    if (Object.keys(this._uiDefinitions).length > 0) return false;
    if (this._hasTriggerXml) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataModule) {
      return value;
    }
    return DataModule.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataModule();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.data != null) {
      result._hasData = true;
      result._data = dcei_engine_data_proto.DataFile.fromJson(json.data);
    }
    if (json.path != null) {
      result._hasPath = true;
      result._path = JsonToString.fromJson(json.path);
    }
    if (json.uiXml != null) {
      result._hasUiXml = true;
      result._uiXml = JsonToString.fromJson(json.uiXml);
    }
    if (json.module != null) {
      result._hasModule = true;
      result._module = JsonToString.fromJson(json.module);
    }
    result._uiDefinitions = JsonToMap(json.uiDefinitions, JsonToString, UiDefinition);
    if (json.triggerXml != null) {
      result._hasTriggerXml = true;
      result._triggerXml = JsonToString.fromJson(json.triggerXml);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasData && !this._data.isEmpty()) {
      result.data = dcei_engine_data_proto.DataFile.toJson(this._data);
    }
    if (this._hasPath) {
      result.path = JsonToString.toJson(this._path);
    }
    if (this._hasUiXml) {
      result.uiXml = JsonToString.toJson(this._uiXml);
    }
    if (this._hasModule) {
      result.module = JsonToString.toJson(this._module);
    }
    if (Object.keys(this._uiDefinitions).length > 0) {
      result.uiDefinitions = MapToJson(this._uiDefinitions, JsonToString, UiDefinition);
    }
    if (this._hasTriggerXml) {
      result.triggerXml = JsonToString.toJson(this._triggerXml);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {dcei_engine_data_proto.DataFile}
   */
  get data() {
    return this._hasData ? this._data : dcei_engine_data_proto.DataFile.default;
  }
  get hasData() {
    return this._hasData;
  }
  setData(path, value) {
    return {type: 'SET', path: path.concat(['data']), value: value.toJson()};
  }
  deleteData(path) {
    return {type: 'DELETE', path: path.concat(['data'])};
  }
  /**
   * @returns {string}
   */
  get path() {
    return this._hasPath ? this._path : JsonToString.default;
  }
  get hasPath() {
    return this._hasPath;
  }
  setPath(path, value) {
    return {type: 'SET', path: path.concat(['path']), value};
  }
  deletePath(path) {
    return {type: 'DELETE', path: path.concat(['path'])};
  }
  /**
   * @returns {string}
   */
  get uiXml() {
    return this._hasUiXml ? this._uiXml : JsonToString.default;
  }
  get hasUiXml() {
    return this._hasUiXml;
  }
  setUiXml(path, value) {
    return {type: 'SET', path: path.concat(['uiXml']), value};
  }
  deleteUiXml(path) {
    return {type: 'DELETE', path: path.concat(['uiXml'])};
  }
  /**
   * @returns {string}
   */
  get module() {
    return this._hasModule ? this._module : JsonToString.default;
  }
  get hasModule() {
    return this._hasModule;
  }
  setModule(path, value) {
    return {type: 'SET', path: path.concat(['module']), value};
  }
  deleteModule(path) {
    return {type: 'DELETE', path: path.concat(['module'])};
  }
  /**
   * @returns {Object<string, UiDefinition>}
   */
  get uiDefinitions() {
    return this._uiDefinitions;
  }
  setUiDefinitions(path, value) {
    return {type: 'SET', path: path.concat(['uiDefinitions']), value: MapToJson(value, JsonToString, UiDefinition)};
  }
  setUiDefinitionsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['uiDefinitions', key]), value: value.toJson()};
  }
  deleteUiDefinitions(path) {
    return {type: 'DELETE', path: path.concat(['uiDefinitions'])};
  }
  deleteUiDefinitionsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['uiDefinitions', key])};
  }
  /**
   * @returns {string}
   */
  get triggerXml() {
    return this._hasTriggerXml ? this._triggerXml : JsonToString.default;
  }
  get hasTriggerXml() {
    return this._hasTriggerXml;
  }
  setTriggerXml(path, value) {
    return {type: 'SET', path: path.concat(['triggerXml']), value};
  }
  deleteTriggerXml(path) {
    return {type: 'DELETE', path: path.concat(['triggerXml'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataModule(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new DataModule(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "data": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataModule(this);
              copy._hasData = true;
              copy._data = dcei_engine_data_proto.DataFile.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasData) {
                return this;
              }
              const copy = new DataModule(this);
              copy._hasData = false;
              copy._data = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasData) {
            const copy = new DataModule(this);
            copy._hasData = true;
            copy._data = dcei_engine_data_proto.DataFile.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._data.apply(type, path.slice(1), value);
          if (newValue === this._data) {
            return this;
          }
          const copy = new DataModule(this);
          copy._data = copy._data.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "path": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataModule(this);
              copy._hasPath = true;
              copy._path = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPath) {
                return this;
              }
              const copy = new DataModule(this);
              copy._hasPath = false;
              copy._path = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "uiXml": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataModule(this);
              copy._hasUiXml = true;
              copy._uiXml = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUiXml) {
                return this;
              }
              const copy = new DataModule(this);
              copy._hasUiXml = false;
              copy._uiXml = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "module": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataModule(this);
              copy._hasModule = true;
              copy._module = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasModule) {
                return this;
              }
              const copy = new DataModule(this);
              copy._hasModule = false;
              copy._module = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "uiDefinitions": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._uiDefinitions).length === 0) {
                return this;
              }
              const copy = new DataModule(this);
              copy._uiDefinitions = {};
              return copy;
            }
            case 'SET': {
              const copy = new DataModule(this);
              copy._uiDefinitions = {};
              for (let key in value) {
                copy._uiDefinitions[key] = UiDefinition.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new DataModule(this);
              copy._uiDefinitions = {...copy._uiDefinitions};
              copy._uiDefinitions[path[1]] = UiDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._uiDefinitions[path[1]]) {
                return this;
              }
              const copy = new DataModule(this);
              copy._uiDefinitions = {...copy._uiDefinitions};
              delete copy._uiDefinitions[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._uiDefinitions[key] === undefined) {
            const copy = new DataModule(this);
            copy._uiDefinitions = {...copy._uiDefinitions};
            copy._uiDefinitions[key] = UiDefinition.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._uiDefinitions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataModule(this);
          copy._uiDefinitions = {...copy._uiDefinitions};
          copy._uiDefinitions[key] = newValue;
          return copy;
        }
      }
      case "triggerXml": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataModule(this);
              copy._hasTriggerXml = true;
              copy._triggerXml = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTriggerXml) {
                return this;
              }
              const copy = new DataModule(this);
              copy._hasTriggerXml = false;
              copy._triggerXml = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataModule} other
   * @returns {DataModule}
   */
  merge(other) {
    const copy = new DataModule(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasData) {
      if (copy._hasData) {
        copy._data = copy.data.merge(other.data);
      } else {
        copy._data = other._data;
      }
      copy._hasData = true;
    }
    if (other._hasPath) {
      copy._hasPath = true;
      copy._path = other._path;
    }
    if (other._hasUiXml) {
      copy._hasUiXml = true;
      copy._uiXml = other._uiXml;
    }
    if (other._hasModule) {
      copy._hasModule = true;
      copy._module = other._module;
    }
    copy._uiDefinitions = {...this._uiDefinitions, ...other._uiDefinitions};
    if (other._hasTriggerXml) {
      copy._hasTriggerXml = true;
      copy._triggerXml = other._triggerXml;
    }
    return copy;
  }
}
DataModule.default = new DataModule();
DataModule.UiDefinitionsEntry = DataModule_UiDefinitionsEntry;
class DataModule_Builder {
  constructor(value) {
    this._value = new DataModule(value);
  }
  build() {
    return new DataModule(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setData(value) {
    this._value._hasData = true;
    this._value._data = value;
    return this;
  }
  deleteData() {
    this._value._hasData = false;
    this._value._data = null;
    return this;
  }
  setPath(value) {
    this._value._hasPath = true;
    this._value._path = value;
    return this;
  }
  deletePath() {
    this._value._hasPath = false;
    this._value._path = null;
    return this;
  }
  setUiXml(value) {
    this._value._hasUiXml = true;
    this._value._uiXml = value;
    return this;
  }
  deleteUiXml() {
    this._value._hasUiXml = false;
    this._value._uiXml = null;
    return this;
  }
  setModule(value) {
    this._value._hasModule = true;
    this._value._module = value;
    return this;
  }
  deleteModule() {
    this._value._hasModule = false;
    this._value._module = null;
    return this;
  }
  setUiDefinitions(key, value) {
    this._value._uiDefinitions = {...this._value._uiDefinitions, [key]: value};
    return this;
  }
  addAllUiDefinitions(values) {
    this._value._uiDefinitions = {...this._value._uiDefinitions, ...values};
    return this;
  }
  deleteUiDefinitions(key) {
    this._value._uiDefinitions = {...this._value._uiDefinitions};
    delete this._value._uiDefinitions[key];
    return this;
  }
  clearUiDefinitions() {
    this._value._uiDefinitions = {};
    return this;
  }
  setTriggerXml(value) {
    this._value._hasTriggerXml = true;
    this._value._triggerXml = value;
    return this;
  }
  deleteTriggerXml() {
    this._value._hasTriggerXml = false;
    this._value._triggerXml = null;
    return this;
  }
}
DataModule.Builder = DataModule_Builder;
class DataModule_WithParent {
  /**
   * @param {DataModule} value
   * @param {DataModule_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataModule.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasData() {
    if (this._cachedHasData === undefined) {
      if (this._value.hasData) {
        this._cachedHasData = true;
      } else {
        this._cachedHasData = this._parent ? this._parent.hasData : false;
      }
    }
    return this._cachedHasData;
  }
  get data() {
    if (!this._cachedData) {
      if (this._value.hasData) {
        this._cachedData = new dcei_engine_data_proto.DataFile.WithParent(this._value.data, this._parent && this._parent.hasData ? this._parent.data : null);
      } else {
        this._cachedData = this._parent ? new dcei_engine_data_proto.DataFile.WithParent(dcei_engine_data_proto.DataFile.default, this._parent.data) : dcei_engine_data_proto.DataFile.WithParent.default;
      }
    }
    return this._cachedData;
  }
  get hasPath() {
    if (this._cachedHasPath === undefined) {
      if (this._value.hasPath) {
        this._cachedHasPath = true;
      } else {
        this._cachedHasPath = this._parent ? this._parent.hasPath : false;
      }
    }
    return this._cachedHasPath;
  }
  get path() {
    if (this._cachedPath === undefined) {
      if (this._value.hasPath) {
        this._cachedPath = this._value.path;
      } else {
        this._cachedPath = this._parent ? this._parent.path : this._value.path;
      }
    }
    return this._cachedPath;
  }
  get hasUiXml() {
    if (this._cachedHasUiXml === undefined) {
      if (this._value.hasUiXml) {
        this._cachedHasUiXml = true;
      } else {
        this._cachedHasUiXml = this._parent ? this._parent.hasUiXml : false;
      }
    }
    return this._cachedHasUiXml;
  }
  get uiXml() {
    if (this._cachedUiXml === undefined) {
      if (this._value.hasUiXml) {
        this._cachedUiXml = this._value.uiXml;
      } else {
        this._cachedUiXml = this._parent ? this._parent.uiXml : this._value.uiXml;
      }
    }
    return this._cachedUiXml;
  }
  get hasModule() {
    if (this._cachedHasModule === undefined) {
      if (this._value.hasModule) {
        this._cachedHasModule = true;
      } else {
        this._cachedHasModule = this._parent ? this._parent.hasModule : false;
      }
    }
    return this._cachedHasModule;
  }
  get module() {
    if (this._cachedModule === undefined) {
      if (this._value.hasModule) {
        this._cachedModule = this._value.module;
      } else {
        this._cachedModule = this._parent ? this._parent.module : this._value.module;
      }
    }
    return this._cachedModule;
  }
  get selfUiDefinitions() {
    if (!this._selfUiDefinitions) {
      this._selfUiDefinitions = {};
      for (let i in this._value.uiDefinitions) {
        this._selfUiDefinitions[i] = new UiDefinition.WithParent(this._value.uiDefinitions[i], null);
      }
    }
    return this._selfUiDefinitions;
  }
  get inherentUiDefinitions() {
    if (!this._inherentUiDefinitions) {
      this._inherentUiDefinitions = this._parent ? this._parent.uiDefinitions : {};
    }
    return this._inherentUiDefinitions;
  }
  get uiDefinitions() {
    if (!this._allUiDefinitions) {
      this._allUiDefinitions = this._parent ? {...this._parent.uiDefinitions, ...this.selfUiDefinitions} : this.selfUiDefinitions;
    }
    return this._allUiDefinitions;
  }
  get hasTriggerXml() {
    if (this._cachedHasTriggerXml === undefined) {
      if (this._value.hasTriggerXml) {
        this._cachedHasTriggerXml = true;
      } else {
        this._cachedHasTriggerXml = this._parent ? this._parent.hasTriggerXml : false;
      }
    }
    return this._cachedHasTriggerXml;
  }
  get triggerXml() {
    if (this._cachedTriggerXml === undefined) {
      if (this._value.hasTriggerXml) {
        this._cachedTriggerXml = this._value.triggerXml;
      } else {
        this._cachedTriggerXml = this._parent ? this._parent.triggerXml : this._value.triggerXml;
      }
    }
    return this._cachedTriggerXml;
  }
  update(current, parent) {
    const result = new DataModule_WithParent(current, parent);
    if (this._cachedData && this._value.hasData && current.hasData) {
      if (this._value.data === current.data && this._parent === parent) {
        result._cachedData = this._cachedData;
      } else {
        result._cachedData = this._cachedData.update(current.data, parent && parent.hasData ? parent.data : null);
      }
    }
    if (this._selfUiDefinitions) {
      if (this._value.uiDefinitions === current.uiDefinitions) {
        result._selfUiDefinitions = this._selfUiDefinitions;
      } else {
        result._selfUiDefinitions = {};
        for (let i in current.uiDefinitions) {
          const oldValue = this._value.uiDefinitions[i];
          if (oldValue) {
            const oldCache = this._selfUiDefinitions[i];
            if (oldValue === current.uiDefinitions[i]) {
              result._selfUiDefinitions[i] = oldCache;
            } else {
              result._selfUiDefinitions[i] = oldCache.update(current.uiDefinitions[i], null);
            }
          } else {
            result._selfUiDefinitions[i] = new UiDefinition.WithParent(current.uiDefinitions[i], null);
          }
        }
      }
    }
    return result;
  }
}
DataModule_WithParent.default = new DataModule_WithParent(DataModule.default, null);
DataModule.WithParent = DataModule_WithParent;
class DataModule_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get data() {
    if (!this._data) {
      this._data = {
        name: "data",
        Name: "Data",
        number: 2,
        protoType: 11,
        protoName: "data",
        type: dcei_engine_data_proto.DataFile,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._data;
  }
  get path() {
    if (!this._path) {
      this._path = {
        name: "path",
        Name: "Path",
        number: 3,
        protoType: 9,
        protoName: "path",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._path;
  }
  get uiXml() {
    if (!this._uiXml) {
      this._uiXml = {
        name: "uiXml",
        Name: "UiXml",
        number: 4,
        protoType: 9,
        protoName: "ui_xml",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._uiXml;
  }
  get module() {
    if (!this._module) {
      this._module = {
        name: "module",
        Name: "Module",
        number: 5,
        protoType: 9,
        protoName: "module",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._module;
  }
  get uiDefinitions() {
    if (!this._uiDefinitions) {
      this._uiDefinitions = {
        name: "uiDefinitions",
        Name: "UiDefinitions",
        number: 6,
        protoType: 11,
        protoName: "ui_definitions",
        isMap: true,
        keyType: JsonToString,
        valueType: UiDefinition,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._uiDefinitions;
  }
  get triggerXml() {
    if (!this._triggerXml) {
      this._triggerXml = {
        name: "triggerXml",
        Name: "TriggerXml",
        number: 7,
        protoType: 9,
        protoName: "trigger_xml",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._triggerXml;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
        this.data,
        this.path,
        this.uiXml,
        this.module,
        this.uiDefinitions,
        this.triggerXml,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForData",
        Name: "DummyOneofForData",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPath",
        Name: "DummyOneofForPath",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUiXml",
        Name: "DummyOneofForUiXml",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForModule",
        Name: "DummyOneofForModule",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTriggerXml",
        Name: "DummyOneofForTriggerXml",
        fields: [
          this.fields[6],
        ],
      });
    }
    return this._oneofs;
  }
}
DataModule.descriptor = new DataModule_Descriptor();
class DataEditorData_UiDefinitionsEntry {
  get descriptor() {
    return DataEditorData_UiDefinitionsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataEditorData_UiDefinitionsEntry) {
      return value;
    }
    return DataEditorData_UiDefinitionsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataEditorData_UiDefinitionsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = UiDefinition.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = UiDefinition.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {UiDefinition}
   */
  get value() {
    return this._hasValue ? this._value : UiDefinition.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData_UiDefinitionsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DataEditorData_UiDefinitionsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData_UiDefinitionsEntry(this);
              copy._hasValue = true;
              copy._value = UiDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new DataEditorData_UiDefinitionsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new DataEditorData_UiDefinitionsEntry(this);
            copy._hasValue = true;
            copy._value = UiDefinition.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new DataEditorData_UiDefinitionsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataEditorData_UiDefinitionsEntry} other
   * @returns {DataEditorData_UiDefinitionsEntry}
   */
  merge(other) {
    const copy = new DataEditorData_UiDefinitionsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
DataEditorData_UiDefinitionsEntry.default = new DataEditorData_UiDefinitionsEntry();
class DataEditorData_UiDefinitionsEntry_Builder {
  constructor(value) {
    this._value = new DataEditorData_UiDefinitionsEntry(value);
  }
  build() {
    return new DataEditorData_UiDefinitionsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
DataEditorData_UiDefinitionsEntry.Builder = DataEditorData_UiDefinitionsEntry_Builder;
class DataEditorData_UiDefinitionsEntry_WithParent {
  /**
   * @param {DataEditorData_UiDefinitionsEntry} value
   * @param {DataEditorData_UiDefinitionsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataEditorData_UiDefinitionsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new UiDefinition.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new UiDefinition.WithParent(UiDefinition.default, this._parent.value) : UiDefinition.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new DataEditorData_UiDefinitionsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
DataEditorData_UiDefinitionsEntry_WithParent.default = new DataEditorData_UiDefinitionsEntry_WithParent(DataEditorData_UiDefinitionsEntry.default, null);
DataEditorData_UiDefinitionsEntry.WithParent = DataEditorData_UiDefinitionsEntry_WithParent;
class DataEditorData_UiDefinitionsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: UiDefinition,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DataEditorData_UiDefinitionsEntry.descriptor = new DataEditorData_UiDefinitionsEntry_Descriptor();
export class DataEditorData {
  get descriptor() {
    return DataEditorData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPath = false;
    this._path = null;
    this._hasName = false;
    this._name = null;
    this._dependencies = [];
    this._uiDefinitions = {};
    this._directDependencies = [];
    this._registryDependencies = [];
    this._hasDependenciesFlow = false;
    this._dependenciesFlow = null;
    this._hasTerrain = false;
    this._terrain = null;
    this._hasWaypoints = false;
    this._waypoints = null;
    this._hasGameEntityList = false;
    this._gameEntityList = null;
    this._hasPathfinding = false;
    this._pathfinding = null;
    this._hasSaving = false;
    this._saving = null;
    this._hasSavingException = false;
    this._savingException = null;
    this._hasLastSaveTime = false;
    this._lastSaveTime = null;
    this._hasForceSaving = false;
    this._forceSaving = null;
    this._hasPlaying = false;
    this._playing = null;
    this._hasPackagesPath = false;
    this._packagesPath = null;
    this._resolvedRegistryDependencies = [];
    this._hasReplayFilePath = false;
    this._replayFilePath = null;
    this._playerLogs = [];
    this._hasSearchFilter = false;
    this._searchFilter = null;
    this._hasUiPreview = false;
    this._uiPreview = null;
    this._hasUnitPreview = false;
    this._unitPreview = null;
    this._hasLocalSettingsData = false;
    this._localSettingsData = null;
  }
  isEmpty() {
    if (this._hasPath) return false;
    if (this._hasName) return false;
    if (this._dependencies.length > 0) return false;
    if (Object.keys(this._uiDefinitions).length > 0) return false;
    if (this._directDependencies.length > 0) return false;
    if (this._registryDependencies.length > 0) return false;
    if (this._hasDependenciesFlow) return false;
    if (this._hasTerrain) return false;
    if (this._hasWaypoints) return false;
    if (this._hasGameEntityList) return false;
    if (this._hasPathfinding) return false;
    if (this._hasSaving) return false;
    if (this._hasSavingException) return false;
    if (this._hasLastSaveTime) return false;
    if (this._hasForceSaving) return false;
    if (this._hasPlaying) return false;
    if (this._hasPackagesPath) return false;
    if (this._resolvedRegistryDependencies.length > 0) return false;
    if (this._hasReplayFilePath) return false;
    if (this._playerLogs.length > 0) return false;
    if (this._hasSearchFilter) return false;
    if (this._hasUiPreview && !this._uiPreview.isEmpty()) return false;
    if (this._hasUnitPreview && !this._unitPreview.isEmpty()) return false;
    if (this._hasLocalSettingsData && !this._localSettingsData.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataEditorData) {
      return value;
    }
    return DataEditorData.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataEditorData();
    if (json.path != null) {
      result._hasPath = true;
      result._path = JsonToString.fromJson(json.path);
    }
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    result._dependencies = JsonToList(json.dependencies, DataModule);
    result._uiDefinitions = JsonToMap(json.uiDefinitions, JsonToString, UiDefinition);
    result._directDependencies = JsonToList(json.directDependencies, JsonToString);
    result._registryDependencies = JsonToList(json.registryDependencies, dcei_engine_data_proto.RegistryDependency);
    if (json.dependenciesFlow != null) {
      result._hasDependenciesFlow = true;
      result._dependenciesFlow = JsonToString.fromJson(json.dependenciesFlow);
    }
    if (json.terrain != null) {
      result._hasTerrain = true;
      result._terrain = JsonToString.fromJson(json.terrain);
    }
    if (json.waypoints != null) {
      result._hasWaypoints = true;
      result._waypoints = JsonToString.fromJson(json.waypoints);
    }
    if (json.gameEntityList != null) {
      result._hasGameEntityList = true;
      result._gameEntityList = JsonToString.fromJson(json.gameEntityList);
    }
    if (json.pathfinding != null) {
      result._hasPathfinding = true;
      result._pathfinding = JsonToString.fromJson(json.pathfinding);
    }
    if (json.saving != null) {
      result._hasSaving = true;
      result._saving = JsonToBoolean.fromJson(json.saving);
    }
    if (json.savingException != null) {
      result._hasSavingException = true;
      result._savingException = JsonToBoolean.fromJson(json.savingException);
    }
    if (json.lastSaveTime != null) {
      result._hasLastSaveTime = true;
      result._lastSaveTime = JsonToString.fromJson(json.lastSaveTime);
    }
    if (json.forceSaving != null) {
      result._hasForceSaving = true;
      result._forceSaving = JsonToString.fromJson(json.forceSaving);
    }
    if (json.playing != null) {
      result._hasPlaying = true;
      result._playing = JsonToBoolean.fromJson(json.playing);
    }
    if (json.packagesPath != null) {
      result._hasPackagesPath = true;
      result._packagesPath = JsonToString.fromJson(json.packagesPath);
    }
    result._resolvedRegistryDependencies = JsonToList(json.resolvedRegistryDependencies, dcei_engine_data_proto.RegistryDependency);
    if (json.replayFilePath != null) {
      result._hasReplayFilePath = true;
      result._replayFilePath = JsonToString.fromJson(json.replayFilePath);
    }
    result._playerLogs = JsonToList(json.playerLogs, JsonToString);
    if (json.searchFilter != null) {
      result._hasSearchFilter = true;
      result._searchFilter = JsonToString.fromJson(json.searchFilter);
    }
    if (json.uiPreview != null) {
      result._hasUiPreview = true;
      result._uiPreview = UiPreviewData.fromJson(json.uiPreview);
    }
    if (json.unitPreview != null) {
      result._hasUnitPreview = true;
      result._unitPreview = UnitPreviewData.fromJson(json.unitPreview);
    }
    if (json.localSettingsData != null) {
      result._hasLocalSettingsData = true;
      result._localSettingsData = dcei_editor_settings_proto.LocalSettingsData.fromJson(json.localSettingsData);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPath) {
      result.path = JsonToString.toJson(this._path);
    }
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._dependencies.length > 0) {
      result.dependencies = ArrayToJson(this._dependencies, DataModule);
    }
    if (Object.keys(this._uiDefinitions).length > 0) {
      result.uiDefinitions = MapToJson(this._uiDefinitions, JsonToString, UiDefinition);
    }
    if (this._directDependencies.length > 0) {
      result.directDependencies = ArrayToJson(this._directDependencies, JsonToString);
    }
    if (this._registryDependencies.length > 0) {
      result.registryDependencies = ArrayToJson(this._registryDependencies, dcei_engine_data_proto.RegistryDependency);
    }
    if (this._hasDependenciesFlow) {
      result.dependenciesFlow = JsonToString.toJson(this._dependenciesFlow);
    }
    if (this._hasTerrain) {
      result.terrain = JsonToString.toJson(this._terrain);
    }
    if (this._hasWaypoints) {
      result.waypoints = JsonToString.toJson(this._waypoints);
    }
    if (this._hasGameEntityList) {
      result.gameEntityList = JsonToString.toJson(this._gameEntityList);
    }
    if (this._hasPathfinding) {
      result.pathfinding = JsonToString.toJson(this._pathfinding);
    }
    if (this._hasSaving) {
      result.saving = JsonToBoolean.toJson(this._saving);
    }
    if (this._hasSavingException) {
      result.savingException = JsonToBoolean.toJson(this._savingException);
    }
    if (this._hasLastSaveTime) {
      result.lastSaveTime = JsonToString.toJson(this._lastSaveTime);
    }
    if (this._hasForceSaving) {
      result.forceSaving = JsonToString.toJson(this._forceSaving);
    }
    if (this._hasPlaying) {
      result.playing = JsonToBoolean.toJson(this._playing);
    }
    if (this._hasPackagesPath) {
      result.packagesPath = JsonToString.toJson(this._packagesPath);
    }
    if (this._resolvedRegistryDependencies.length > 0) {
      result.resolvedRegistryDependencies = ArrayToJson(this._resolvedRegistryDependencies, dcei_engine_data_proto.RegistryDependency);
    }
    if (this._hasReplayFilePath) {
      result.replayFilePath = JsonToString.toJson(this._replayFilePath);
    }
    if (this._playerLogs.length > 0) {
      result.playerLogs = ArrayToJson(this._playerLogs, JsonToString);
    }
    if (this._hasSearchFilter) {
      result.searchFilter = JsonToString.toJson(this._searchFilter);
    }
    if (this._hasUiPreview && !this._uiPreview.isEmpty()) {
      result.uiPreview = UiPreviewData.toJson(this._uiPreview);
    }
    if (this._hasUnitPreview && !this._unitPreview.isEmpty()) {
      result.unitPreview = UnitPreviewData.toJson(this._unitPreview);
    }
    if (this._hasLocalSettingsData && !this._localSettingsData.isEmpty()) {
      result.localSettingsData = dcei_editor_settings_proto.LocalSettingsData.toJson(this._localSettingsData);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get path() {
    return this._hasPath ? this._path : JsonToString.default;
  }
  get hasPath() {
    return this._hasPath;
  }
  setPath(path, value) {
    return {type: 'SET', path: path.concat(['path']), value};
  }
  deletePath(path) {
    return {type: 'DELETE', path: path.concat(['path'])};
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {DataModule[]}
   */
  get dependencies() {
    return this._dependencies;
  }
  addDependencies(path, value) {
    return {type: 'ADD', path: path.concat(['dependencies']), value: value.toJson()};
  }
  setDependencies(path, value) {
    return {type: 'SET', path: path.concat(['dependencies']), value: ArrayToJson(value, DataModule)};
  }
  setDependenciesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['dependencies', key]), value: value.toJson()};
  }
  deleteDependencies(path) {
    return {type: 'DELETE', path: path.concat(['dependencies'])};
  }
  deleteDependenciesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['dependencies', key])};
  }
  /**
   * @returns {Object<string, UiDefinition>}
   */
  get uiDefinitions() {
    return this._uiDefinitions;
  }
  setUiDefinitions(path, value) {
    return {type: 'SET', path: path.concat(['uiDefinitions']), value: MapToJson(value, JsonToString, UiDefinition)};
  }
  setUiDefinitionsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['uiDefinitions', key]), value: value.toJson()};
  }
  deleteUiDefinitions(path) {
    return {type: 'DELETE', path: path.concat(['uiDefinitions'])};
  }
  deleteUiDefinitionsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['uiDefinitions', key])};
  }
  /**
   * @returns {string[]}
   */
  get directDependencies() {
    return this._directDependencies;
  }
  addDirectDependencies(path, value) {
    return {type: 'ADD', path: path.concat(['directDependencies']), value};
  }
  setDirectDependencies(path, value) {
    return {type: 'SET', path: path.concat(['directDependencies']), value: ArrayToJson(value, JsonToString)};
  }
  setDirectDependenciesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['directDependencies', key]), value};
  }
  deleteDirectDependencies(path) {
    return {type: 'DELETE', path: path.concat(['directDependencies'])};
  }
  deleteDirectDependenciesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['directDependencies', key])};
  }
  /**
   * @returns {dcei_engine_data_proto.RegistryDependency[]}
   */
  get registryDependencies() {
    return this._registryDependencies;
  }
  addRegistryDependencies(path, value) {
    return {type: 'ADD', path: path.concat(['registryDependencies']), value: value.toJson()};
  }
  setRegistryDependencies(path, value) {
    return {type: 'SET', path: path.concat(['registryDependencies']), value: ArrayToJson(value, dcei_engine_data_proto.RegistryDependency)};
  }
  setRegistryDependenciesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['registryDependencies', key]), value: value.toJson()};
  }
  deleteRegistryDependencies(path) {
    return {type: 'DELETE', path: path.concat(['registryDependencies'])};
  }
  deleteRegistryDependenciesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['registryDependencies', key])};
  }
  /**
   * @returns {string}
   */
  get dependenciesFlow() {
    return this._hasDependenciesFlow ? this._dependenciesFlow : JsonToString.default;
  }
  get hasDependenciesFlow() {
    return this._hasDependenciesFlow;
  }
  setDependenciesFlow(path, value) {
    return {type: 'SET', path: path.concat(['dependenciesFlow']), value};
  }
  deleteDependenciesFlow(path) {
    return {type: 'DELETE', path: path.concat(['dependenciesFlow'])};
  }
  /**
   * @returns {string}
   */
  get terrain() {
    return this._hasTerrain ? this._terrain : JsonToString.default;
  }
  get hasTerrain() {
    return this._hasTerrain;
  }
  setTerrain(path, value) {
    return {type: 'SET', path: path.concat(['terrain']), value};
  }
  deleteTerrain(path) {
    return {type: 'DELETE', path: path.concat(['terrain'])};
  }
  /**
   * @returns {string}
   */
  get waypoints() {
    return this._hasWaypoints ? this._waypoints : JsonToString.default;
  }
  get hasWaypoints() {
    return this._hasWaypoints;
  }
  setWaypoints(path, value) {
    return {type: 'SET', path: path.concat(['waypoints']), value};
  }
  deleteWaypoints(path) {
    return {type: 'DELETE', path: path.concat(['waypoints'])};
  }
  /**
   * @returns {string}
   */
  get gameEntityList() {
    return this._hasGameEntityList ? this._gameEntityList : JsonToString.default;
  }
  get hasGameEntityList() {
    return this._hasGameEntityList;
  }
  setGameEntityList(path, value) {
    return {type: 'SET', path: path.concat(['gameEntityList']), value};
  }
  deleteGameEntityList(path) {
    return {type: 'DELETE', path: path.concat(['gameEntityList'])};
  }
  /**
   * @returns {string}
   */
  get pathfinding() {
    return this._hasPathfinding ? this._pathfinding : JsonToString.default;
  }
  get hasPathfinding() {
    return this._hasPathfinding;
  }
  setPathfinding(path, value) {
    return {type: 'SET', path: path.concat(['pathfinding']), value};
  }
  deletePathfinding(path) {
    return {type: 'DELETE', path: path.concat(['pathfinding'])};
  }
  /**
   * @returns {boolean}
   */
  get saving() {
    return this._hasSaving ? this._saving : JsonToBoolean.default;
  }
  get hasSaving() {
    return this._hasSaving;
  }
  setSaving(path, value) {
    return {type: 'SET', path: path.concat(['saving']), value};
  }
  deleteSaving(path) {
    return {type: 'DELETE', path: path.concat(['saving'])};
  }
  /**
   * @returns {boolean}
   */
  get savingException() {
    return this._hasSavingException ? this._savingException : JsonToBoolean.default;
  }
  get hasSavingException() {
    return this._hasSavingException;
  }
  setSavingException(path, value) {
    return {type: 'SET', path: path.concat(['savingException']), value};
  }
  deleteSavingException(path) {
    return {type: 'DELETE', path: path.concat(['savingException'])};
  }
  /**
   * @returns {string}
   */
  get lastSaveTime() {
    return this._hasLastSaveTime ? this._lastSaveTime : JsonToString.default;
  }
  get hasLastSaveTime() {
    return this._hasLastSaveTime;
  }
  setLastSaveTime(path, value) {
    return {type: 'SET', path: path.concat(['lastSaveTime']), value};
  }
  deleteLastSaveTime(path) {
    return {type: 'DELETE', path: path.concat(['lastSaveTime'])};
  }
  /**
   * @returns {string}
   */
  get forceSaving() {
    return this._hasForceSaving ? this._forceSaving : JsonToString.default;
  }
  get hasForceSaving() {
    return this._hasForceSaving;
  }
  setForceSaving(path, value) {
    return {type: 'SET', path: path.concat(['forceSaving']), value};
  }
  deleteForceSaving(path) {
    return {type: 'DELETE', path: path.concat(['forceSaving'])};
  }
  /**
   * @returns {boolean}
   */
  get playing() {
    return this._hasPlaying ? this._playing : JsonToBoolean.default;
  }
  get hasPlaying() {
    return this._hasPlaying;
  }
  setPlaying(path, value) {
    return {type: 'SET', path: path.concat(['playing']), value};
  }
  deletePlaying(path) {
    return {type: 'DELETE', path: path.concat(['playing'])};
  }
  /**
   * @returns {string}
   */
  get packagesPath() {
    return this._hasPackagesPath ? this._packagesPath : JsonToString.default;
  }
  get hasPackagesPath() {
    return this._hasPackagesPath;
  }
  setPackagesPath(path, value) {
    return {type: 'SET', path: path.concat(['packagesPath']), value};
  }
  deletePackagesPath(path) {
    return {type: 'DELETE', path: path.concat(['packagesPath'])};
  }
  /**
   * @returns {dcei_engine_data_proto.RegistryDependency[]}
   */
  get resolvedRegistryDependencies() {
    return this._resolvedRegistryDependencies;
  }
  addResolvedRegistryDependencies(path, value) {
    return {type: 'ADD', path: path.concat(['resolvedRegistryDependencies']), value: value.toJson()};
  }
  setResolvedRegistryDependencies(path, value) {
    return {type: 'SET', path: path.concat(['resolvedRegistryDependencies']), value: ArrayToJson(value, dcei_engine_data_proto.RegistryDependency)};
  }
  setResolvedRegistryDependenciesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['resolvedRegistryDependencies', key]), value: value.toJson()};
  }
  deleteResolvedRegistryDependencies(path) {
    return {type: 'DELETE', path: path.concat(['resolvedRegistryDependencies'])};
  }
  deleteResolvedRegistryDependenciesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['resolvedRegistryDependencies', key])};
  }
  /**
   * @returns {string}
   */
  get replayFilePath() {
    return this._hasReplayFilePath ? this._replayFilePath : JsonToString.default;
  }
  get hasReplayFilePath() {
    return this._hasReplayFilePath;
  }
  setReplayFilePath(path, value) {
    return {type: 'SET', path: path.concat(['replayFilePath']), value};
  }
  deleteReplayFilePath(path) {
    return {type: 'DELETE', path: path.concat(['replayFilePath'])};
  }
  /**
   * @returns {string[]}
   */
  get playerLogs() {
    return this._playerLogs;
  }
  addPlayerLogs(path, value) {
    return {type: 'ADD', path: path.concat(['playerLogs']), value};
  }
  setPlayerLogs(path, value) {
    return {type: 'SET', path: path.concat(['playerLogs']), value: ArrayToJson(value, JsonToString)};
  }
  setPlayerLogsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['playerLogs', key]), value};
  }
  deletePlayerLogs(path) {
    return {type: 'DELETE', path: path.concat(['playerLogs'])};
  }
  deletePlayerLogsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['playerLogs', key])};
  }
  /**
   * @returns {string}
   */
  get searchFilter() {
    return this._hasSearchFilter ? this._searchFilter : JsonToString.default;
  }
  get hasSearchFilter() {
    return this._hasSearchFilter;
  }
  setSearchFilter(path, value) {
    return {type: 'SET', path: path.concat(['searchFilter']), value};
  }
  deleteSearchFilter(path) {
    return {type: 'DELETE', path: path.concat(['searchFilter'])};
  }
  /**
   * @returns {UiPreviewData}
   */
  get uiPreview() {
    return this._hasUiPreview ? this._uiPreview : UiPreviewData.default;
  }
  get hasUiPreview() {
    return this._hasUiPreview;
  }
  setUiPreview(path, value) {
    return {type: 'SET', path: path.concat(['uiPreview']), value: value.toJson()};
  }
  deleteUiPreview(path) {
    return {type: 'DELETE', path: path.concat(['uiPreview'])};
  }
  /**
   * @returns {UnitPreviewData}
   */
  get unitPreview() {
    return this._hasUnitPreview ? this._unitPreview : UnitPreviewData.default;
  }
  get hasUnitPreview() {
    return this._hasUnitPreview;
  }
  setUnitPreview(path, value) {
    return {type: 'SET', path: path.concat(['unitPreview']), value: value.toJson()};
  }
  deleteUnitPreview(path) {
    return {type: 'DELETE', path: path.concat(['unitPreview'])};
  }
  /**
   * @returns {dcei_editor_settings_proto.LocalSettingsData}
   */
  get localSettingsData() {
    return this._hasLocalSettingsData ? this._localSettingsData : dcei_editor_settings_proto.LocalSettingsData.default;
  }
  get hasLocalSettingsData() {
    return this._hasLocalSettingsData;
  }
  setLocalSettingsData(path, value) {
    return {type: 'SET', path: path.concat(['localSettingsData']), value: value.toJson()};
  }
  deleteLocalSettingsData(path) {
    return {type: 'DELETE', path: path.concat(['localSettingsData'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "path": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._hasPath = true;
              copy._path = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPath) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._hasPath = false;
              copy._path = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "dependencies": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._dependencies = [];        for (let i of value) {
                copy._dependencies.push(DataModule.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new DataEditorData(this);
              copy._dependencies = copy._dependencies.concat([DataModule.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._dependencies.length === 0) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._dependencies = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._dependencies.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._dependencies = copy._dependencies.slice();
              copy._dependencies[path[1]] = DataModule.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new DataEditorData(this);
              copy._dependencies = copy._dependencies.slice(0, path[1]).concat(copy._dependencies.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._dependencies.length) {
            return this;
          }
          const oldValue = this._dependencies[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataEditorData(this);
          copy._dependencies = copy._dependencies.slice();
          copy._dependencies[key] = newValue;
          return copy;
        }
      }
      case "uiDefinitions": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._uiDefinitions).length === 0) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._uiDefinitions = {};
              return copy;
            }
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._uiDefinitions = {};
              for (let key in value) {
                copy._uiDefinitions[key] = UiDefinition.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._uiDefinitions = {...copy._uiDefinitions};
              copy._uiDefinitions[path[1]] = UiDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._uiDefinitions[path[1]]) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._uiDefinitions = {...copy._uiDefinitions};
              delete copy._uiDefinitions[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._uiDefinitions[key] === undefined) {
            const copy = new DataEditorData(this);
            copy._uiDefinitions = {...copy._uiDefinitions};
            copy._uiDefinitions[key] = UiDefinition.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._uiDefinitions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataEditorData(this);
          copy._uiDefinitions = {...copy._uiDefinitions};
          copy._uiDefinitions[key] = newValue;
          return copy;
        }
      }
      case "directDependencies": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._directDependencies = [];        for (let i of value) {
                copy._directDependencies.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new DataEditorData(this);
              copy._directDependencies = copy._directDependencies.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._directDependencies.length === 0) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._directDependencies = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._directDependencies.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._directDependencies = copy._directDependencies.slice();
              copy._directDependencies[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new DataEditorData(this);
              copy._directDependencies = copy._directDependencies.slice(0, path[1]).concat(copy._directDependencies.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._directDependencies.length) {
            return this;
          }
          const oldValue = this._directDependencies[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataEditorData(this);
          copy._directDependencies = copy._directDependencies.slice();
          copy._directDependencies[key] = newValue;
          return copy;
        }
      }
      case "registryDependencies": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._registryDependencies = [];        for (let i of value) {
                copy._registryDependencies.push(dcei_engine_data_proto.RegistryDependency.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new DataEditorData(this);
              copy._registryDependencies = copy._registryDependencies.concat([dcei_engine_data_proto.RegistryDependency.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._registryDependencies.length === 0) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._registryDependencies = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._registryDependencies.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._registryDependencies = copy._registryDependencies.slice();
              copy._registryDependencies[path[1]] = dcei_engine_data_proto.RegistryDependency.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new DataEditorData(this);
              copy._registryDependencies = copy._registryDependencies.slice(0, path[1]).concat(copy._registryDependencies.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._registryDependencies.length) {
            return this;
          }
          const oldValue = this._registryDependencies[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataEditorData(this);
          copy._registryDependencies = copy._registryDependencies.slice();
          copy._registryDependencies[key] = newValue;
          return copy;
        }
      }
      case "dependenciesFlow": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._hasDependenciesFlow = true;
              copy._dependenciesFlow = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDependenciesFlow) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._hasDependenciesFlow = false;
              copy._dependenciesFlow = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "terrain": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._hasTerrain = true;
              copy._terrain = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTerrain) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._hasTerrain = false;
              copy._terrain = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "waypoints": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._hasWaypoints = true;
              copy._waypoints = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWaypoints) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._hasWaypoints = false;
              copy._waypoints = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "gameEntityList": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._hasGameEntityList = true;
              copy._gameEntityList = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGameEntityList) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._hasGameEntityList = false;
              copy._gameEntityList = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "pathfinding": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._hasPathfinding = true;
              copy._pathfinding = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPathfinding) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._hasPathfinding = false;
              copy._pathfinding = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "saving": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._hasSaving = true;
              copy._saving = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSaving) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._hasSaving = false;
              copy._saving = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "savingException": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._hasSavingException = true;
              copy._savingException = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSavingException) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._hasSavingException = false;
              copy._savingException = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "lastSaveTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._hasLastSaveTime = true;
              copy._lastSaveTime = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLastSaveTime) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._hasLastSaveTime = false;
              copy._lastSaveTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "forceSaving": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._hasForceSaving = true;
              copy._forceSaving = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasForceSaving) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._hasForceSaving = false;
              copy._forceSaving = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "playing": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._hasPlaying = true;
              copy._playing = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlaying) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._hasPlaying = false;
              copy._playing = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "packagesPath": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._hasPackagesPath = true;
              copy._packagesPath = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPackagesPath) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._hasPackagesPath = false;
              copy._packagesPath = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "resolvedRegistryDependencies": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._resolvedRegistryDependencies = [];        for (let i of value) {
                copy._resolvedRegistryDependencies.push(dcei_engine_data_proto.RegistryDependency.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new DataEditorData(this);
              copy._resolvedRegistryDependencies = copy._resolvedRegistryDependencies.concat([dcei_engine_data_proto.RegistryDependency.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._resolvedRegistryDependencies.length === 0) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._resolvedRegistryDependencies = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._resolvedRegistryDependencies.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._resolvedRegistryDependencies = copy._resolvedRegistryDependencies.slice();
              copy._resolvedRegistryDependencies[path[1]] = dcei_engine_data_proto.RegistryDependency.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new DataEditorData(this);
              copy._resolvedRegistryDependencies = copy._resolvedRegistryDependencies.slice(0, path[1]).concat(copy._resolvedRegistryDependencies.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._resolvedRegistryDependencies.length) {
            return this;
          }
          const oldValue = this._resolvedRegistryDependencies[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataEditorData(this);
          copy._resolvedRegistryDependencies = copy._resolvedRegistryDependencies.slice();
          copy._resolvedRegistryDependencies[key] = newValue;
          return copy;
        }
      }
      case "replayFilePath": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._hasReplayFilePath = true;
              copy._replayFilePath = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasReplayFilePath) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._hasReplayFilePath = false;
              copy._replayFilePath = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "playerLogs": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._playerLogs = [];        for (let i of value) {
                copy._playerLogs.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new DataEditorData(this);
              copy._playerLogs = copy._playerLogs.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._playerLogs.length === 0) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._playerLogs = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._playerLogs.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._playerLogs = copy._playerLogs.slice();
              copy._playerLogs[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new DataEditorData(this);
              copy._playerLogs = copy._playerLogs.slice(0, path[1]).concat(copy._playerLogs.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._playerLogs.length) {
            return this;
          }
          const oldValue = this._playerLogs[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataEditorData(this);
          copy._playerLogs = copy._playerLogs.slice();
          copy._playerLogs[key] = newValue;
          return copy;
        }
      }
      case "searchFilter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._hasSearchFilter = true;
              copy._searchFilter = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSearchFilter) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._hasSearchFilter = false;
              copy._searchFilter = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "uiPreview": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._hasUiPreview = true;
              copy._uiPreview = UiPreviewData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUiPreview) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._hasUiPreview = false;
              copy._uiPreview = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasUiPreview) {
            const copy = new DataEditorData(this);
            copy._hasUiPreview = true;
            copy._uiPreview = UiPreviewData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._uiPreview.apply(type, path.slice(1), value);
          if (newValue === this._uiPreview) {
            return this;
          }
          const copy = new DataEditorData(this);
          copy._uiPreview = copy._uiPreview.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "unitPreview": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._hasUnitPreview = true;
              copy._unitPreview = UnitPreviewData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitPreview) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._hasUnitPreview = false;
              copy._unitPreview = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasUnitPreview) {
            const copy = new DataEditorData(this);
            copy._hasUnitPreview = true;
            copy._unitPreview = UnitPreviewData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._unitPreview.apply(type, path.slice(1), value);
          if (newValue === this._unitPreview) {
            return this;
          }
          const copy = new DataEditorData(this);
          copy._unitPreview = copy._unitPreview.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "localSettingsData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataEditorData(this);
              copy._hasLocalSettingsData = true;
              copy._localSettingsData = dcei_editor_settings_proto.LocalSettingsData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLocalSettingsData) {
                return this;
              }
              const copy = new DataEditorData(this);
              copy._hasLocalSettingsData = false;
              copy._localSettingsData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLocalSettingsData) {
            const copy = new DataEditorData(this);
            copy._hasLocalSettingsData = true;
            copy._localSettingsData = dcei_editor_settings_proto.LocalSettingsData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._localSettingsData.apply(type, path.slice(1), value);
          if (newValue === this._localSettingsData) {
            return this;
          }
          const copy = new DataEditorData(this);
          copy._localSettingsData = copy._localSettingsData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataEditorData} other
   * @returns {DataEditorData}
   */
  merge(other) {
    const copy = new DataEditorData(this);
    if (other._hasPath) {
      copy._hasPath = true;
      copy._path = other._path;
    }
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    copy._dependencies = this._dependencies.concat(other._dependencies);
    copy._uiDefinitions = {...this._uiDefinitions, ...other._uiDefinitions};
    copy._directDependencies = this._directDependencies.concat(other._directDependencies);
    copy._registryDependencies = this._registryDependencies.concat(other._registryDependencies);
    if (other._hasDependenciesFlow) {
      copy._hasDependenciesFlow = true;
      copy._dependenciesFlow = other._dependenciesFlow;
    }
    if (other._hasTerrain) {
      copy._hasTerrain = true;
      copy._terrain = other._terrain;
    }
    if (other._hasWaypoints) {
      copy._hasWaypoints = true;
      copy._waypoints = other._waypoints;
    }
    if (other._hasGameEntityList) {
      copy._hasGameEntityList = true;
      copy._gameEntityList = other._gameEntityList;
    }
    if (other._hasPathfinding) {
      copy._hasPathfinding = true;
      copy._pathfinding = other._pathfinding;
    }
    if (other._hasSaving) {
      copy._hasSaving = true;
      copy._saving = other._saving;
    }
    if (other._hasSavingException) {
      copy._hasSavingException = true;
      copy._savingException = other._savingException;
    }
    if (other._hasLastSaveTime) {
      copy._hasLastSaveTime = true;
      copy._lastSaveTime = other._lastSaveTime;
    }
    if (other._hasForceSaving) {
      copy._hasForceSaving = true;
      copy._forceSaving = other._forceSaving;
    }
    if (other._hasPlaying) {
      copy._hasPlaying = true;
      copy._playing = other._playing;
    }
    if (other._hasPackagesPath) {
      copy._hasPackagesPath = true;
      copy._packagesPath = other._packagesPath;
    }
    copy._resolvedRegistryDependencies = this._resolvedRegistryDependencies.concat(other._resolvedRegistryDependencies);
    if (other._hasReplayFilePath) {
      copy._hasReplayFilePath = true;
      copy._replayFilePath = other._replayFilePath;
    }
    copy._playerLogs = this._playerLogs.concat(other._playerLogs);
    if (other._hasSearchFilter) {
      copy._hasSearchFilter = true;
      copy._searchFilter = other._searchFilter;
    }
    if (other._hasUiPreview) {
      if (copy._hasUiPreview) {
        copy._uiPreview = copy.uiPreview.merge(other.uiPreview);
      } else {
        copy._uiPreview = other._uiPreview;
      }
      copy._hasUiPreview = true;
    }
    if (other._hasUnitPreview) {
      if (copy._hasUnitPreview) {
        copy._unitPreview = copy.unitPreview.merge(other.unitPreview);
      } else {
        copy._unitPreview = other._unitPreview;
      }
      copy._hasUnitPreview = true;
    }
    if (other._hasLocalSettingsData) {
      if (copy._hasLocalSettingsData) {
        copy._localSettingsData = copy.localSettingsData.merge(other.localSettingsData);
      } else {
        copy._localSettingsData = other._localSettingsData;
      }
      copy._hasLocalSettingsData = true;
    }
    return copy;
  }
}
DataEditorData.default = new DataEditorData();
DataEditorData.UiDefinitionsEntry = DataEditorData_UiDefinitionsEntry;
class DataEditorData_Builder {
  constructor(value) {
    this._value = new DataEditorData(value);
  }
  build() {
    return new DataEditorData(this._value);
  }
  setPath(value) {
    this._value._hasPath = true;
    this._value._path = value;
    return this;
  }
  deletePath() {
    this._value._hasPath = false;
    this._value._path = null;
    return this;
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  addAllDependencies(values) {
    this._value._dependencies = this._value._dependencies.concat(values);
    return this;
  }
  addDependencies(value) {
    this._value._dependencies = this._value._dependencies.concat([value]);
    return this;
  }
  setDependencies(index, value) {
    this._value._dependencies = this._value._dependencies.concat();
    this._value._dependencies[index] = value;
    return this;
  }
  clearDependencies() {
    this._value._dependencies = [];
    return this;
  }
  setUiDefinitions(key, value) {
    this._value._uiDefinitions = {...this._value._uiDefinitions, [key]: value};
    return this;
  }
  addAllUiDefinitions(values) {
    this._value._uiDefinitions = {...this._value._uiDefinitions, ...values};
    return this;
  }
  deleteUiDefinitions(key) {
    this._value._uiDefinitions = {...this._value._uiDefinitions};
    delete this._value._uiDefinitions[key];
    return this;
  }
  clearUiDefinitions() {
    this._value._uiDefinitions = {};
    return this;
  }
  addAllDirectDependencies(values) {
    this._value._directDependencies = this._value._directDependencies.concat(values);
    return this;
  }
  addDirectDependencies(value) {
    this._value._directDependencies = this._value._directDependencies.concat([value]);
    return this;
  }
  setDirectDependencies(index, value) {
    this._value._directDependencies = this._value._directDependencies.concat();
    this._value._directDependencies[index] = value;
    return this;
  }
  clearDirectDependencies() {
    this._value._directDependencies = [];
    return this;
  }
  addAllRegistryDependencies(values) {
    this._value._registryDependencies = this._value._registryDependencies.concat(values);
    return this;
  }
  addRegistryDependencies(value) {
    this._value._registryDependencies = this._value._registryDependencies.concat([value]);
    return this;
  }
  setRegistryDependencies(index, value) {
    this._value._registryDependencies = this._value._registryDependencies.concat();
    this._value._registryDependencies[index] = value;
    return this;
  }
  clearRegistryDependencies() {
    this._value._registryDependencies = [];
    return this;
  }
  setDependenciesFlow(value) {
    this._value._hasDependenciesFlow = true;
    this._value._dependenciesFlow = value;
    return this;
  }
  deleteDependenciesFlow() {
    this._value._hasDependenciesFlow = false;
    this._value._dependenciesFlow = null;
    return this;
  }
  setTerrain(value) {
    this._value._hasTerrain = true;
    this._value._terrain = value;
    return this;
  }
  deleteTerrain() {
    this._value._hasTerrain = false;
    this._value._terrain = null;
    return this;
  }
  setWaypoints(value) {
    this._value._hasWaypoints = true;
    this._value._waypoints = value;
    return this;
  }
  deleteWaypoints() {
    this._value._hasWaypoints = false;
    this._value._waypoints = null;
    return this;
  }
  setGameEntityList(value) {
    this._value._hasGameEntityList = true;
    this._value._gameEntityList = value;
    return this;
  }
  deleteGameEntityList() {
    this._value._hasGameEntityList = false;
    this._value._gameEntityList = null;
    return this;
  }
  setPathfinding(value) {
    this._value._hasPathfinding = true;
    this._value._pathfinding = value;
    return this;
  }
  deletePathfinding() {
    this._value._hasPathfinding = false;
    this._value._pathfinding = null;
    return this;
  }
  setSaving(value) {
    this._value._hasSaving = true;
    this._value._saving = value;
    return this;
  }
  deleteSaving() {
    this._value._hasSaving = false;
    this._value._saving = null;
    return this;
  }
  setSavingException(value) {
    this._value._hasSavingException = true;
    this._value._savingException = value;
    return this;
  }
  deleteSavingException() {
    this._value._hasSavingException = false;
    this._value._savingException = null;
    return this;
  }
  setLastSaveTime(value) {
    this._value._hasLastSaveTime = true;
    this._value._lastSaveTime = value;
    return this;
  }
  deleteLastSaveTime() {
    this._value._hasLastSaveTime = false;
    this._value._lastSaveTime = null;
    return this;
  }
  setForceSaving(value) {
    this._value._hasForceSaving = true;
    this._value._forceSaving = value;
    return this;
  }
  deleteForceSaving() {
    this._value._hasForceSaving = false;
    this._value._forceSaving = null;
    return this;
  }
  setPlaying(value) {
    this._value._hasPlaying = true;
    this._value._playing = value;
    return this;
  }
  deletePlaying() {
    this._value._hasPlaying = false;
    this._value._playing = null;
    return this;
  }
  setPackagesPath(value) {
    this._value._hasPackagesPath = true;
    this._value._packagesPath = value;
    return this;
  }
  deletePackagesPath() {
    this._value._hasPackagesPath = false;
    this._value._packagesPath = null;
    return this;
  }
  addAllResolvedRegistryDependencies(values) {
    this._value._resolvedRegistryDependencies = this._value._resolvedRegistryDependencies.concat(values);
    return this;
  }
  addResolvedRegistryDependencies(value) {
    this._value._resolvedRegistryDependencies = this._value._resolvedRegistryDependencies.concat([value]);
    return this;
  }
  setResolvedRegistryDependencies(index, value) {
    this._value._resolvedRegistryDependencies = this._value._resolvedRegistryDependencies.concat();
    this._value._resolvedRegistryDependencies[index] = value;
    return this;
  }
  clearResolvedRegistryDependencies() {
    this._value._resolvedRegistryDependencies = [];
    return this;
  }
  setReplayFilePath(value) {
    this._value._hasReplayFilePath = true;
    this._value._replayFilePath = value;
    return this;
  }
  deleteReplayFilePath() {
    this._value._hasReplayFilePath = false;
    this._value._replayFilePath = null;
    return this;
  }
  addAllPlayerLogs(values) {
    this._value._playerLogs = this._value._playerLogs.concat(values);
    return this;
  }
  addPlayerLogs(value) {
    this._value._playerLogs = this._value._playerLogs.concat([value]);
    return this;
  }
  setPlayerLogs(index, value) {
    this._value._playerLogs = this._value._playerLogs.concat();
    this._value._playerLogs[index] = value;
    return this;
  }
  clearPlayerLogs() {
    this._value._playerLogs = [];
    return this;
  }
  setSearchFilter(value) {
    this._value._hasSearchFilter = true;
    this._value._searchFilter = value;
    return this;
  }
  deleteSearchFilter() {
    this._value._hasSearchFilter = false;
    this._value._searchFilter = null;
    return this;
  }
  setUiPreview(value) {
    this._value._hasUiPreview = true;
    this._value._uiPreview = value;
    return this;
  }
  deleteUiPreview() {
    this._value._hasUiPreview = false;
    this._value._uiPreview = null;
    return this;
  }
  setUnitPreview(value) {
    this._value._hasUnitPreview = true;
    this._value._unitPreview = value;
    return this;
  }
  deleteUnitPreview() {
    this._value._hasUnitPreview = false;
    this._value._unitPreview = null;
    return this;
  }
  setLocalSettingsData(value) {
    this._value._hasLocalSettingsData = true;
    this._value._localSettingsData = value;
    return this;
  }
  deleteLocalSettingsData() {
    this._value._hasLocalSettingsData = false;
    this._value._localSettingsData = null;
    return this;
  }
}
DataEditorData.Builder = DataEditorData_Builder;
class DataEditorData_WithParent {
  /**
   * @param {DataEditorData} value
   * @param {DataEditorData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataEditorData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPath() {
    if (this._cachedHasPath === undefined) {
      if (this._value.hasPath) {
        this._cachedHasPath = true;
      } else {
        this._cachedHasPath = this._parent ? this._parent.hasPath : false;
      }
    }
    return this._cachedHasPath;
  }
  get path() {
    if (this._cachedPath === undefined) {
      if (this._value.hasPath) {
        this._cachedPath = this._value.path;
      } else {
        this._cachedPath = this._parent ? this._parent.path : this._value.path;
      }
    }
    return this._cachedPath;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get selfDependencies() {
    if (!this._selfDependencies) {
      this._selfDependencies = [];
      for (let i of this._value.dependencies) {
        this._selfDependencies.push(new DataModule.WithParent(i, null));
      }
    }
    return this._selfDependencies;
  }
  get inherentDependencies() {
    if (!this._inherentDependencies) {
      this._inherentDependencies = this._parent ? this._parent.dependencies : [];
    }
    return this._inherentDependencies;
  }
  get dependencies() {
    if (!this._allDependencies) {
      this._allDependencies = this._parent ? this._parent.dependencies.concat(this.selfDependencies) : this.selfDependencies;
    }
    return this._allDependencies;
  }
  get selfUiDefinitions() {
    if (!this._selfUiDefinitions) {
      this._selfUiDefinitions = {};
      for (let i in this._value.uiDefinitions) {
        this._selfUiDefinitions[i] = new UiDefinition.WithParent(this._value.uiDefinitions[i], null);
      }
    }
    return this._selfUiDefinitions;
  }
  get inherentUiDefinitions() {
    if (!this._inherentUiDefinitions) {
      this._inherentUiDefinitions = this._parent ? this._parent.uiDefinitions : {};
    }
    return this._inherentUiDefinitions;
  }
  get uiDefinitions() {
    if (!this._allUiDefinitions) {
      this._allUiDefinitions = this._parent ? {...this._parent.uiDefinitions, ...this.selfUiDefinitions} : this.selfUiDefinitions;
    }
    return this._allUiDefinitions;
  }
  get selfDirectDependencies() {
    return this._value.directDependencies;
  }
  get inherentDirectDependencies() {
    if (!this._inherentDirectDependencies) {
      this._inherentDirectDependencies = this._parent ? this._parent.directDependencies : [];
    }
    return this._inherentDirectDependencies;
  }
  get directDependencies() {
    if (!this._allDirectDependencies) {
      this._allDirectDependencies = this._parent ? this._parent.directDependencies.concat(this.selfDirectDependencies) : this.selfDirectDependencies;
    }
    return this._allDirectDependencies;
  }
  get selfRegistryDependencies() {
    if (!this._selfRegistryDependencies) {
      this._selfRegistryDependencies = [];
      for (let i of this._value.registryDependencies) {
        this._selfRegistryDependencies.push(new dcei_engine_data_proto.RegistryDependency.WithParent(i, null));
      }
    }
    return this._selfRegistryDependencies;
  }
  get inherentRegistryDependencies() {
    if (!this._inherentRegistryDependencies) {
      this._inherentRegistryDependencies = this._parent ? this._parent.registryDependencies : [];
    }
    return this._inherentRegistryDependencies;
  }
  get registryDependencies() {
    if (!this._allRegistryDependencies) {
      this._allRegistryDependencies = this._parent ? this._parent.registryDependencies.concat(this.selfRegistryDependencies) : this.selfRegistryDependencies;
    }
    return this._allRegistryDependencies;
  }
  get hasDependenciesFlow() {
    if (this._cachedHasDependenciesFlow === undefined) {
      if (this._value.hasDependenciesFlow) {
        this._cachedHasDependenciesFlow = true;
      } else {
        this._cachedHasDependenciesFlow = this._parent ? this._parent.hasDependenciesFlow : false;
      }
    }
    return this._cachedHasDependenciesFlow;
  }
  get dependenciesFlow() {
    if (this._cachedDependenciesFlow === undefined) {
      if (this._value.hasDependenciesFlow) {
        this._cachedDependenciesFlow = this._value.dependenciesFlow;
      } else {
        this._cachedDependenciesFlow = this._parent ? this._parent.dependenciesFlow : this._value.dependenciesFlow;
      }
    }
    return this._cachedDependenciesFlow;
  }
  get hasTerrain() {
    if (this._cachedHasTerrain === undefined) {
      if (this._value.hasTerrain) {
        this._cachedHasTerrain = true;
      } else {
        this._cachedHasTerrain = this._parent ? this._parent.hasTerrain : false;
      }
    }
    return this._cachedHasTerrain;
  }
  get terrain() {
    if (this._cachedTerrain === undefined) {
      if (this._value.hasTerrain) {
        this._cachedTerrain = this._value.terrain;
      } else {
        this._cachedTerrain = this._parent ? this._parent.terrain : this._value.terrain;
      }
    }
    return this._cachedTerrain;
  }
  get hasWaypoints() {
    if (this._cachedHasWaypoints === undefined) {
      if (this._value.hasWaypoints) {
        this._cachedHasWaypoints = true;
      } else {
        this._cachedHasWaypoints = this._parent ? this._parent.hasWaypoints : false;
      }
    }
    return this._cachedHasWaypoints;
  }
  get waypoints() {
    if (this._cachedWaypoints === undefined) {
      if (this._value.hasWaypoints) {
        this._cachedWaypoints = this._value.waypoints;
      } else {
        this._cachedWaypoints = this._parent ? this._parent.waypoints : this._value.waypoints;
      }
    }
    return this._cachedWaypoints;
  }
  get hasGameEntityList() {
    if (this._cachedHasGameEntityList === undefined) {
      if (this._value.hasGameEntityList) {
        this._cachedHasGameEntityList = true;
      } else {
        this._cachedHasGameEntityList = this._parent ? this._parent.hasGameEntityList : false;
      }
    }
    return this._cachedHasGameEntityList;
  }
  get gameEntityList() {
    if (this._cachedGameEntityList === undefined) {
      if (this._value.hasGameEntityList) {
        this._cachedGameEntityList = this._value.gameEntityList;
      } else {
        this._cachedGameEntityList = this._parent ? this._parent.gameEntityList : this._value.gameEntityList;
      }
    }
    return this._cachedGameEntityList;
  }
  get hasPathfinding() {
    if (this._cachedHasPathfinding === undefined) {
      if (this._value.hasPathfinding) {
        this._cachedHasPathfinding = true;
      } else {
        this._cachedHasPathfinding = this._parent ? this._parent.hasPathfinding : false;
      }
    }
    return this._cachedHasPathfinding;
  }
  get pathfinding() {
    if (this._cachedPathfinding === undefined) {
      if (this._value.hasPathfinding) {
        this._cachedPathfinding = this._value.pathfinding;
      } else {
        this._cachedPathfinding = this._parent ? this._parent.pathfinding : this._value.pathfinding;
      }
    }
    return this._cachedPathfinding;
  }
  get hasSaving() {
    if (this._cachedHasSaving === undefined) {
      if (this._value.hasSaving) {
        this._cachedHasSaving = true;
      } else {
        this._cachedHasSaving = this._parent ? this._parent.hasSaving : false;
      }
    }
    return this._cachedHasSaving;
  }
  get saving() {
    if (this._cachedSaving === undefined) {
      if (this._value.hasSaving) {
        this._cachedSaving = this._value.saving;
      } else {
        this._cachedSaving = this._parent ? this._parent.saving : this._value.saving;
      }
    }
    return this._cachedSaving;
  }
  get hasSavingException() {
    if (this._cachedHasSavingException === undefined) {
      if (this._value.hasSavingException) {
        this._cachedHasSavingException = true;
      } else {
        this._cachedHasSavingException = this._parent ? this._parent.hasSavingException : false;
      }
    }
    return this._cachedHasSavingException;
  }
  get savingException() {
    if (this._cachedSavingException === undefined) {
      if (this._value.hasSavingException) {
        this._cachedSavingException = this._value.savingException;
      } else {
        this._cachedSavingException = this._parent ? this._parent.savingException : this._value.savingException;
      }
    }
    return this._cachedSavingException;
  }
  get hasLastSaveTime() {
    if (this._cachedHasLastSaveTime === undefined) {
      if (this._value.hasLastSaveTime) {
        this._cachedHasLastSaveTime = true;
      } else {
        this._cachedHasLastSaveTime = this._parent ? this._parent.hasLastSaveTime : false;
      }
    }
    return this._cachedHasLastSaveTime;
  }
  get lastSaveTime() {
    if (this._cachedLastSaveTime === undefined) {
      if (this._value.hasLastSaveTime) {
        this._cachedLastSaveTime = this._value.lastSaveTime;
      } else {
        this._cachedLastSaveTime = this._parent ? this._parent.lastSaveTime : this._value.lastSaveTime;
      }
    }
    return this._cachedLastSaveTime;
  }
  get hasForceSaving() {
    if (this._cachedHasForceSaving === undefined) {
      if (this._value.hasForceSaving) {
        this._cachedHasForceSaving = true;
      } else {
        this._cachedHasForceSaving = this._parent ? this._parent.hasForceSaving : false;
      }
    }
    return this._cachedHasForceSaving;
  }
  get forceSaving() {
    if (this._cachedForceSaving === undefined) {
      if (this._value.hasForceSaving) {
        this._cachedForceSaving = this._value.forceSaving;
      } else {
        this._cachedForceSaving = this._parent ? this._parent.forceSaving : this._value.forceSaving;
      }
    }
    return this._cachedForceSaving;
  }
  get hasPlaying() {
    if (this._cachedHasPlaying === undefined) {
      if (this._value.hasPlaying) {
        this._cachedHasPlaying = true;
      } else {
        this._cachedHasPlaying = this._parent ? this._parent.hasPlaying : false;
      }
    }
    return this._cachedHasPlaying;
  }
  get playing() {
    if (this._cachedPlaying === undefined) {
      if (this._value.hasPlaying) {
        this._cachedPlaying = this._value.playing;
      } else {
        this._cachedPlaying = this._parent ? this._parent.playing : this._value.playing;
      }
    }
    return this._cachedPlaying;
  }
  get hasPackagesPath() {
    if (this._cachedHasPackagesPath === undefined) {
      if (this._value.hasPackagesPath) {
        this._cachedHasPackagesPath = true;
      } else {
        this._cachedHasPackagesPath = this._parent ? this._parent.hasPackagesPath : false;
      }
    }
    return this._cachedHasPackagesPath;
  }
  get packagesPath() {
    if (this._cachedPackagesPath === undefined) {
      if (this._value.hasPackagesPath) {
        this._cachedPackagesPath = this._value.packagesPath;
      } else {
        this._cachedPackagesPath = this._parent ? this._parent.packagesPath : this._value.packagesPath;
      }
    }
    return this._cachedPackagesPath;
  }
  get selfResolvedRegistryDependencies() {
    if (!this._selfResolvedRegistryDependencies) {
      this._selfResolvedRegistryDependencies = [];
      for (let i of this._value.resolvedRegistryDependencies) {
        this._selfResolvedRegistryDependencies.push(new dcei_engine_data_proto.RegistryDependency.WithParent(i, null));
      }
    }
    return this._selfResolvedRegistryDependencies;
  }
  get inherentResolvedRegistryDependencies() {
    if (!this._inherentResolvedRegistryDependencies) {
      this._inherentResolvedRegistryDependencies = this._parent ? this._parent.resolvedRegistryDependencies : [];
    }
    return this._inherentResolvedRegistryDependencies;
  }
  get resolvedRegistryDependencies() {
    if (!this._allResolvedRegistryDependencies) {
      this._allResolvedRegistryDependencies = this._parent ? this._parent.resolvedRegistryDependencies.concat(this.selfResolvedRegistryDependencies) : this.selfResolvedRegistryDependencies;
    }
    return this._allResolvedRegistryDependencies;
  }
  get hasReplayFilePath() {
    if (this._cachedHasReplayFilePath === undefined) {
      if (this._value.hasReplayFilePath) {
        this._cachedHasReplayFilePath = true;
      } else {
        this._cachedHasReplayFilePath = this._parent ? this._parent.hasReplayFilePath : false;
      }
    }
    return this._cachedHasReplayFilePath;
  }
  get replayFilePath() {
    if (this._cachedReplayFilePath === undefined) {
      if (this._value.hasReplayFilePath) {
        this._cachedReplayFilePath = this._value.replayFilePath;
      } else {
        this._cachedReplayFilePath = this._parent ? this._parent.replayFilePath : this._value.replayFilePath;
      }
    }
    return this._cachedReplayFilePath;
  }
  get selfPlayerLogs() {
    return this._value.playerLogs;
  }
  get inherentPlayerLogs() {
    if (!this._inherentPlayerLogs) {
      this._inherentPlayerLogs = this._parent ? this._parent.playerLogs : [];
    }
    return this._inherentPlayerLogs;
  }
  get playerLogs() {
    if (!this._allPlayerLogs) {
      this._allPlayerLogs = this._parent ? this._parent.playerLogs.concat(this.selfPlayerLogs) : this.selfPlayerLogs;
    }
    return this._allPlayerLogs;
  }
  get hasSearchFilter() {
    if (this._cachedHasSearchFilter === undefined) {
      if (this._value.hasSearchFilter) {
        this._cachedHasSearchFilter = true;
      } else {
        this._cachedHasSearchFilter = this._parent ? this._parent.hasSearchFilter : false;
      }
    }
    return this._cachedHasSearchFilter;
  }
  get searchFilter() {
    if (this._cachedSearchFilter === undefined) {
      if (this._value.hasSearchFilter) {
        this._cachedSearchFilter = this._value.searchFilter;
      } else {
        this._cachedSearchFilter = this._parent ? this._parent.searchFilter : this._value.searchFilter;
      }
    }
    return this._cachedSearchFilter;
  }
  get hasUiPreview() {
    if (this._cachedHasUiPreview === undefined) {
      if (this._value.hasUiPreview) {
        this._cachedHasUiPreview = true;
      } else {
        this._cachedHasUiPreview = this._parent ? this._parent.hasUiPreview : false;
      }
    }
    return this._cachedHasUiPreview;
  }
  get uiPreview() {
    if (!this._cachedUiPreview) {
      if (this._value.hasUiPreview) {
        this._cachedUiPreview = new UiPreviewData.WithParent(this._value.uiPreview, this._parent && this._parent.hasUiPreview ? this._parent.uiPreview : null);
      } else {
        this._cachedUiPreview = this._parent ? new UiPreviewData.WithParent(UiPreviewData.default, this._parent.uiPreview) : UiPreviewData.WithParent.default;
      }
    }
    return this._cachedUiPreview;
  }
  get hasUnitPreview() {
    if (this._cachedHasUnitPreview === undefined) {
      if (this._value.hasUnitPreview) {
        this._cachedHasUnitPreview = true;
      } else {
        this._cachedHasUnitPreview = this._parent ? this._parent.hasUnitPreview : false;
      }
    }
    return this._cachedHasUnitPreview;
  }
  get unitPreview() {
    if (!this._cachedUnitPreview) {
      if (this._value.hasUnitPreview) {
        this._cachedUnitPreview = new UnitPreviewData.WithParent(this._value.unitPreview, this._parent && this._parent.hasUnitPreview ? this._parent.unitPreview : null);
      } else {
        this._cachedUnitPreview = this._parent ? new UnitPreviewData.WithParent(UnitPreviewData.default, this._parent.unitPreview) : UnitPreviewData.WithParent.default;
      }
    }
    return this._cachedUnitPreview;
  }
  get hasLocalSettingsData() {
    if (this._cachedHasLocalSettingsData === undefined) {
      if (this._value.hasLocalSettingsData) {
        this._cachedHasLocalSettingsData = true;
      } else {
        this._cachedHasLocalSettingsData = this._parent ? this._parent.hasLocalSettingsData : false;
      }
    }
    return this._cachedHasLocalSettingsData;
  }
  get localSettingsData() {
    if (!this._cachedLocalSettingsData) {
      if (this._value.hasLocalSettingsData) {
        this._cachedLocalSettingsData = new dcei_editor_settings_proto.LocalSettingsData.WithParent(this._value.localSettingsData, this._parent && this._parent.hasLocalSettingsData ? this._parent.localSettingsData : null);
      } else {
        this._cachedLocalSettingsData = this._parent ? new dcei_editor_settings_proto.LocalSettingsData.WithParent(dcei_editor_settings_proto.LocalSettingsData.default, this._parent.localSettingsData) : dcei_editor_settings_proto.LocalSettingsData.WithParent.default;
      }
    }
    return this._cachedLocalSettingsData;
  }
  update(current, parent) {
    const result = new DataEditorData_WithParent(current, parent);
    if (this._selfDependencies) {
      if (this._value.dependencies === current.dependencies) {
        result._selfDependencies = this._selfDependencies;
      } else {
        result._selfDependencies = [];
        for (let i = 0; i < current.dependencies.length; i++) {
          const oldValue = this._value.dependencies[i];
          if (oldValue) {
            const oldCache = this._selfDependencies[i];
            if (oldValue === current.dependencies[i]) {
              result._selfDependencies[i] = oldCache;
            } else {
              result._selfDependencies[i] = oldCache.update(current.dependencies[i], null);
            }
          } else {
            result._selfDependencies[i] = new DataModule.WithParent(current.dependencies[i], null);
          }
        }
      }
    }
    if (this._selfUiDefinitions) {
      if (this._value.uiDefinitions === current.uiDefinitions) {
        result._selfUiDefinitions = this._selfUiDefinitions;
      } else {
        result._selfUiDefinitions = {};
        for (let i in current.uiDefinitions) {
          const oldValue = this._value.uiDefinitions[i];
          if (oldValue) {
            const oldCache = this._selfUiDefinitions[i];
            if (oldValue === current.uiDefinitions[i]) {
              result._selfUiDefinitions[i] = oldCache;
            } else {
              result._selfUiDefinitions[i] = oldCache.update(current.uiDefinitions[i], null);
            }
          } else {
            result._selfUiDefinitions[i] = new UiDefinition.WithParent(current.uiDefinitions[i], null);
          }
        }
      }
    }
    if (this._selfRegistryDependencies) {
      if (this._value.registryDependencies === current.registryDependencies) {
        result._selfRegistryDependencies = this._selfRegistryDependencies;
      } else {
        result._selfRegistryDependencies = [];
        for (let i = 0; i < current.registryDependencies.length; i++) {
          const oldValue = this._value.registryDependencies[i];
          if (oldValue) {
            const oldCache = this._selfRegistryDependencies[i];
            if (oldValue === current.registryDependencies[i]) {
              result._selfRegistryDependencies[i] = oldCache;
            } else {
              result._selfRegistryDependencies[i] = oldCache.update(current.registryDependencies[i], null);
            }
          } else {
            result._selfRegistryDependencies[i] = new dcei_engine_data_proto.RegistryDependency.WithParent(current.registryDependencies[i], null);
          }
        }
      }
    }
    if (this._selfResolvedRegistryDependencies) {
      if (this._value.resolvedRegistryDependencies === current.resolvedRegistryDependencies) {
        result._selfResolvedRegistryDependencies = this._selfResolvedRegistryDependencies;
      } else {
        result._selfResolvedRegistryDependencies = [];
        for (let i = 0; i < current.resolvedRegistryDependencies.length; i++) {
          const oldValue = this._value.resolvedRegistryDependencies[i];
          if (oldValue) {
            const oldCache = this._selfResolvedRegistryDependencies[i];
            if (oldValue === current.resolvedRegistryDependencies[i]) {
              result._selfResolvedRegistryDependencies[i] = oldCache;
            } else {
              result._selfResolvedRegistryDependencies[i] = oldCache.update(current.resolvedRegistryDependencies[i], null);
            }
          } else {
            result._selfResolvedRegistryDependencies[i] = new dcei_engine_data_proto.RegistryDependency.WithParent(current.resolvedRegistryDependencies[i], null);
          }
        }
      }
    }
    if (this._cachedUiPreview && this._value.hasUiPreview && current.hasUiPreview) {
      if (this._value.uiPreview === current.uiPreview && this._parent === parent) {
        result._cachedUiPreview = this._cachedUiPreview;
      } else {
        result._cachedUiPreview = this._cachedUiPreview.update(current.uiPreview, parent && parent.hasUiPreview ? parent.uiPreview : null);
      }
    }
    if (this._cachedUnitPreview && this._value.hasUnitPreview && current.hasUnitPreview) {
      if (this._value.unitPreview === current.unitPreview && this._parent === parent) {
        result._cachedUnitPreview = this._cachedUnitPreview;
      } else {
        result._cachedUnitPreview = this._cachedUnitPreview.update(current.unitPreview, parent && parent.hasUnitPreview ? parent.unitPreview : null);
      }
    }
    if (this._cachedLocalSettingsData && this._value.hasLocalSettingsData && current.hasLocalSettingsData) {
      if (this._value.localSettingsData === current.localSettingsData && this._parent === parent) {
        result._cachedLocalSettingsData = this._cachedLocalSettingsData;
      } else {
        result._cachedLocalSettingsData = this._cachedLocalSettingsData.update(current.localSettingsData, parent && parent.hasLocalSettingsData ? parent.localSettingsData : null);
      }
    }
    return result;
  }
}
DataEditorData_WithParent.default = new DataEditorData_WithParent(DataEditorData.default, null);
DataEditorData.WithParent = DataEditorData_WithParent;
class DataEditorData_Descriptor {
  get path() {
    if (!this._path) {
      this._path = {
        name: "path",
        Name: "Path",
        number: 1,
        protoType: 9,
        protoName: "path",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._path;
  }
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 2,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get dependencies() {
    if (!this._dependencies) {
      this._dependencies = {
        name: "dependencies",
        Name: "Dependencies",
        number: 3,
        protoType: 11,
        protoName: "dependencies",
        type: DataModule,
        isRepeated: true,
        options: {
          comments: "Sorted from dependencies to dependents.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dependencies;
  }
  get uiDefinitions() {
    if (!this._uiDefinitions) {
      this._uiDefinitions = {
        name: "uiDefinitions",
        Name: "UiDefinitions",
        number: 4,
        protoType: 11,
        protoName: "ui_definitions",
        isMap: true,
        keyType: JsonToString,
        valueType: UiDefinition,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._uiDefinitions;
  }
  get directDependencies() {
    if (!this._directDependencies) {
      this._directDependencies = {
        name: "directDependencies",
        Name: "DirectDependencies",
        number: 5,
        protoType: 9,
        protoName: "direct_dependencies",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._directDependencies;
  }
  get registryDependencies() {
    if (!this._registryDependencies) {
      this._registryDependencies = {
        name: "registryDependencies",
        Name: "RegistryDependencies",
        number: 6,
        protoType: 11,
        protoName: "registry_dependencies",
        type: dcei_engine_data_proto.RegistryDependency,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._registryDependencies;
  }
  get dependenciesFlow() {
    if (!this._dependenciesFlow) {
      this._dependenciesFlow = {
        name: "dependenciesFlow",
        Name: "DependenciesFlow",
        number: 7,
        protoType: 9,
        protoName: "dependencies_flow",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dependenciesFlow;
  }
  get terrain() {
    if (!this._terrain) {
      this._terrain = {
        name: "terrain",
        Name: "Terrain",
        number: 11,
        protoType: 9,
        protoName: "terrain",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._terrain;
  }
  get waypoints() {
    if (!this._waypoints) {
      this._waypoints = {
        name: "waypoints",
        Name: "Waypoints",
        number: 12,
        protoType: 9,
        protoName: "waypoints",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._waypoints;
  }
  get gameEntityList() {
    if (!this._gameEntityList) {
      this._gameEntityList = {
        name: "gameEntityList",
        Name: "GameEntityList",
        number: 13,
        protoType: 9,
        protoName: "gameEntityList",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gameEntityList;
  }
  get pathfinding() {
    if (!this._pathfinding) {
      this._pathfinding = {
        name: "pathfinding",
        Name: "Pathfinding",
        number: 14,
        protoType: 9,
        protoName: "pathfinding",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._pathfinding;
  }
  get saving() {
    if (!this._saving) {
      this._saving = {
        name: "saving",
        Name: "Saving",
        number: 21,
        protoType: 8,
        protoName: "saving",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._saving;
  }
  get savingException() {
    if (!this._savingException) {
      this._savingException = {
        name: "savingException",
        Name: "SavingException",
        number: 22,
        protoType: 8,
        protoName: "saving_exception",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._savingException;
  }
  get lastSaveTime() {
    if (!this._lastSaveTime) {
      this._lastSaveTime = {
        name: "lastSaveTime",
        Name: "LastSaveTime",
        number: 23,
        protoType: 9,
        protoName: "last_save_time",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._lastSaveTime;
  }
  get forceSaving() {
    if (!this._forceSaving) {
      this._forceSaving = {
        name: "forceSaving",
        Name: "ForceSaving",
        number: 24,
        protoType: 9,
        protoName: "force_saving",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._forceSaving;
  }
  get playing() {
    if (!this._playing) {
      this._playing = {
        name: "playing",
        Name: "Playing",
        number: 31,
        protoType: 8,
        protoName: "playing",
        type: JsonToBoolean,
        options: {
          comments: "Instruct the level player to play the current data.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playing;
  }
  get packagesPath() {
    if (!this._packagesPath) {
      this._packagesPath = {
        name: "packagesPath",
        Name: "PackagesPath",
        number: 36,
        protoType: 9,
        protoName: "packages_path",
        type: JsonToString,
        options: {
          comments: "Where to resolve module dependencies.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._packagesPath;
  }
  get resolvedRegistryDependencies() {
    if (!this._resolvedRegistryDependencies) {
      this._resolvedRegistryDependencies = {
        name: "resolvedRegistryDependencies",
        Name: "ResolvedRegistryDependencies",
        number: 37,
        protoType: 11,
        protoName: "resolved_registry_dependencies",
        type: dcei_engine_data_proto.RegistryDependency,
        isRepeated: true,
        options: {
          comments: "Resolved versions of registry module dependencies.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._resolvedRegistryDependencies;
  }
  get replayFilePath() {
    if (!this._replayFilePath) {
      this._replayFilePath = {
        name: "replayFilePath",
        Name: "ReplayFilePath",
        number: 35,
        protoType: 9,
        protoName: "replay_file_path",
        type: JsonToString,
        options: {
          comments: "If set, play this replay file instead.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._replayFilePath;
  }
  get playerLogs() {
    if (!this._playerLogs) {
      this._playerLogs = {
        name: "playerLogs",
        Name: "PlayerLogs",
        number: 41,
        protoType: 9,
        protoName: "player_logs",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Log info returned by the level player.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerLogs;
  }
  get searchFilter() {
    if (!this._searchFilter) {
      this._searchFilter = {
        name: "searchFilter",
        Name: "SearchFilter",
        number: 51,
        protoType: 9,
        protoName: "search_filter",
        type: JsonToString,
        options: {
          comments: "Shared data editor settings",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._searchFilter;
  }
  get uiPreview() {
    if (!this._uiPreview) {
      this._uiPreview = {
        name: "uiPreview",
        Name: "UiPreview",
        number: 61,
        protoType: 11,
        protoName: "ui_preview",
        type: UiPreviewData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._uiPreview;
  }
  get unitPreview() {
    if (!this._unitPreview) {
      this._unitPreview = {
        name: "unitPreview",
        Name: "UnitPreview",
        number: 62,
        protoType: 11,
        protoName: "unit_preview",
        type: UnitPreviewData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitPreview;
  }
  get localSettingsData() {
    if (!this._localSettingsData) {
      this._localSettingsData = {
        name: "localSettingsData",
        Name: "LocalSettingsData",
        number: 71,
        protoType: 11,
        protoName: "local_settings_data",
        type: dcei_editor_settings_proto.LocalSettingsData,
        options: {
          comments: "Settings data saved with the current map.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._localSettingsData;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.path,
        this.name,
        this.dependencies,
        this.uiDefinitions,
        this.directDependencies,
        this.registryDependencies,
        this.dependenciesFlow,
        this.terrain,
        this.waypoints,
        this.gameEntityList,
        this.pathfinding,
        this.saving,
        this.savingException,
        this.lastSaveTime,
        this.forceSaving,
        this.playing,
        this.packagesPath,
        this.resolvedRegistryDependencies,
        this.replayFilePath,
        this.playerLogs,
        this.searchFilter,
        this.uiPreview,
        this.unitPreview,
        this.localSettingsData,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPath",
        Name: "DummyOneofForPath",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDependenciesFlow",
        Name: "DummyOneofForDependenciesFlow",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTerrain",
        Name: "DummyOneofForTerrain",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWaypoints",
        Name: "DummyOneofForWaypoints",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGameEntityList",
        Name: "DummyOneofForGameEntityList",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPathfinding",
        Name: "DummyOneofForPathfinding",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSaving",
        Name: "DummyOneofForSaving",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSavingException",
        Name: "DummyOneofForSavingException",
        fields: [
          this.fields[12],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLastSaveTime",
        Name: "DummyOneofForLastSaveTime",
        fields: [
          this.fields[13],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForForceSaving",
        Name: "DummyOneofForForceSaving",
        fields: [
          this.fields[14],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPlaying",
        Name: "DummyOneofForPlaying",
        fields: [
          this.fields[15],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPackagesPath",
        Name: "DummyOneofForPackagesPath",
        fields: [
          this.fields[16],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForReplayFilePath",
        Name: "DummyOneofForReplayFilePath",
        fields: [
          this.fields[18],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSearchFilter",
        Name: "DummyOneofForSearchFilter",
        fields: [
          this.fields[20],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUiPreview",
        Name: "DummyOneofForUiPreview",
        fields: [
          this.fields[21],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnitPreview",
        Name: "DummyOneofForUnitPreview",
        fields: [
          this.fields[22],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLocalSettingsData",
        Name: "DummyOneofForLocalSettingsData",
        fields: [
          this.fields[23],
        ],
      });
    }
    return this._oneofs;
  }
}
DataEditorData.descriptor = new DataEditorData_Descriptor();
export class UiDefinition {
  get descriptor() {
    return UiDefinition.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasXml = false;
    this._xml = null;
    this._hasRevision = false;
    this._revision = null;
  }
  isEmpty() {
    if (this._hasXml) return false;
    if (this._hasRevision) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UiDefinition) {
      return value;
    }
    return UiDefinition.fromJson(value);
  }
  static fromJson(json) {
    const result = new UiDefinition();
    if (json.xml != null) {
      result._hasXml = true;
      result._xml = JsonToString.fromJson(json.xml);
    }
    if (json.revision != null) {
      result._hasRevision = true;
      result._revision = JsonToInt32.fromJson(json.revision);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasXml) {
      result.xml = JsonToString.toJson(this._xml);
    }
    if (this._hasRevision) {
      result.revision = JsonToInt32.toJson(this._revision);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get xml() {
    return this._hasXml ? this._xml : JsonToString.default;
  }
  get hasXml() {
    return this._hasXml;
  }
  setXml(path, value) {
    return {type: 'SET', path: path.concat(['xml']), value};
  }
  deleteXml(path) {
    return {type: 'DELETE', path: path.concat(['xml'])};
  }
  /**
   * @returns {number}
   */
  get revision() {
    return this._hasRevision ? this._revision : JsonToInt32.default;
  }
  get hasRevision() {
    return this._hasRevision;
  }
  setRevision(path, value) {
    return {type: 'SET', path: path.concat(['revision']), value};
  }
  deleteRevision(path) {
    return {type: 'DELETE', path: path.concat(['revision'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "xml": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UiDefinition(this);
              copy._hasXml = true;
              copy._xml = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasXml) {
                return this;
              }
              const copy = new UiDefinition(this);
              copy._hasXml = false;
              copy._xml = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "revision": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UiDefinition(this);
              copy._hasRevision = true;
              copy._revision = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRevision) {
                return this;
              }
              const copy = new UiDefinition(this);
              copy._hasRevision = false;
              copy._revision = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UiDefinition} other
   * @returns {UiDefinition}
   */
  merge(other) {
    const copy = new UiDefinition(this);
    if (other._hasXml) {
      copy._hasXml = true;
      copy._xml = other._xml;
    }
    if (other._hasRevision) {
      copy._hasRevision = true;
      copy._revision = other._revision;
    }
    return copy;
  }
}
UiDefinition.default = new UiDefinition();
class UiDefinition_Builder {
  constructor(value) {
    this._value = new UiDefinition(value);
  }
  build() {
    return new UiDefinition(this._value);
  }
  setXml(value) {
    this._value._hasXml = true;
    this._value._xml = value;
    return this;
  }
  deleteXml() {
    this._value._hasXml = false;
    this._value._xml = null;
    return this;
  }
  setRevision(value) {
    this._value._hasRevision = true;
    this._value._revision = value;
    return this;
  }
  deleteRevision() {
    this._value._hasRevision = false;
    this._value._revision = null;
    return this;
  }
}
UiDefinition.Builder = UiDefinition_Builder;
class UiDefinition_WithParent {
  /**
   * @param {UiDefinition} value
   * @param {UiDefinition_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UiDefinition.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasXml() {
    if (this._cachedHasXml === undefined) {
      if (this._value.hasXml) {
        this._cachedHasXml = true;
      } else {
        this._cachedHasXml = this._parent ? this._parent.hasXml : false;
      }
    }
    return this._cachedHasXml;
  }
  get xml() {
    if (this._cachedXml === undefined) {
      if (this._value.hasXml) {
        this._cachedXml = this._value.xml;
      } else {
        this._cachedXml = this._parent ? this._parent.xml : this._value.xml;
      }
    }
    return this._cachedXml;
  }
  get hasRevision() {
    if (this._cachedHasRevision === undefined) {
      if (this._value.hasRevision) {
        this._cachedHasRevision = true;
      } else {
        this._cachedHasRevision = this._parent ? this._parent.hasRevision : false;
      }
    }
    return this._cachedHasRevision;
  }
  get revision() {
    if (this._cachedRevision === undefined) {
      if (this._value.hasRevision) {
        this._cachedRevision = this._value.revision;
      } else {
        this._cachedRevision = this._parent ? this._parent.revision : this._value.revision;
      }
    }
    return this._cachedRevision;
  }
  update(current, parent) {
    const result = new UiDefinition_WithParent(current, parent);
    return result;
  }
}
UiDefinition_WithParent.default = new UiDefinition_WithParent(UiDefinition.default, null);
UiDefinition.WithParent = UiDefinition_WithParent;
class UiDefinition_Descriptor {
  get xml() {
    if (!this._xml) {
      this._xml = {
        name: "xml",
        Name: "Xml",
        number: 1,
        protoType: 9,
        protoName: "xml",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._xml;
  }
  get revision() {
    if (!this._revision) {
      this._revision = {
        name: "revision",
        Name: "Revision",
        number: 2,
        protoType: 5,
        protoName: "revision",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._revision;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.xml,
        this.revision,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForXml",
        Name: "DummyOneofForXml",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRevision",
        Name: "DummyOneofForRevision",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
UiDefinition.descriptor = new UiDefinition_Descriptor();
export class TriggerDefinition {
  get descriptor() {
    return TriggerDefinition.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasXml = false;
    this._xml = null;
  }
  isEmpty() {
    if (this._hasXml) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TriggerDefinition) {
      return value;
    }
    return TriggerDefinition.fromJson(value);
  }
  static fromJson(json) {
    const result = new TriggerDefinition();
    if (json.xml != null) {
      result._hasXml = true;
      result._xml = JsonToString.fromJson(json.xml);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasXml) {
      result.xml = JsonToString.toJson(this._xml);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get xml() {
    return this._hasXml ? this._xml : JsonToString.default;
  }
  get hasXml() {
    return this._hasXml;
  }
  setXml(path, value) {
    return {type: 'SET', path: path.concat(['xml']), value};
  }
  deleteXml(path) {
    return {type: 'DELETE', path: path.concat(['xml'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "xml": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TriggerDefinition(this);
              copy._hasXml = true;
              copy._xml = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasXml) {
                return this;
              }
              const copy = new TriggerDefinition(this);
              copy._hasXml = false;
              copy._xml = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TriggerDefinition} other
   * @returns {TriggerDefinition}
   */
  merge(other) {
    const copy = new TriggerDefinition(this);
    if (other._hasXml) {
      copy._hasXml = true;
      copy._xml = other._xml;
    }
    return copy;
  }
}
TriggerDefinition.default = new TriggerDefinition();
class TriggerDefinition_Builder {
  constructor(value) {
    this._value = new TriggerDefinition(value);
  }
  build() {
    return new TriggerDefinition(this._value);
  }
  setXml(value) {
    this._value._hasXml = true;
    this._value._xml = value;
    return this;
  }
  deleteXml() {
    this._value._hasXml = false;
    this._value._xml = null;
    return this;
  }
}
TriggerDefinition.Builder = TriggerDefinition_Builder;
class TriggerDefinition_WithParent {
  /**
   * @param {TriggerDefinition} value
   * @param {TriggerDefinition_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TriggerDefinition.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasXml() {
    if (this._cachedHasXml === undefined) {
      if (this._value.hasXml) {
        this._cachedHasXml = true;
      } else {
        this._cachedHasXml = this._parent ? this._parent.hasXml : false;
      }
    }
    return this._cachedHasXml;
  }
  get xml() {
    if (this._cachedXml === undefined) {
      if (this._value.hasXml) {
        this._cachedXml = this._value.xml;
      } else {
        this._cachedXml = this._parent ? this._parent.xml : this._value.xml;
      }
    }
    return this._cachedXml;
  }
  update(current, parent) {
    const result = new TriggerDefinition_WithParent(current, parent);
    return result;
  }
}
TriggerDefinition_WithParent.default = new TriggerDefinition_WithParent(TriggerDefinition.default, null);
TriggerDefinition.WithParent = TriggerDefinition_WithParent;
class TriggerDefinition_Descriptor {
  get xml() {
    if (!this._xml) {
      this._xml = {
        name: "xml",
        Name: "Xml",
        number: 1,
        protoType: 9,
        protoName: "xml",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._xml;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.xml,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForXml",
        Name: "DummyOneofForXml",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
TriggerDefinition.descriptor = new TriggerDefinition_Descriptor();
export class UnitPreviewData {
  get descriptor() {
    return UnitPreviewData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnitName = false;
    this._unitName = null;
  }
  isEmpty() {
    if (this._hasUnitName) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UnitPreviewData) {
      return value;
    }
    return UnitPreviewData.fromJson(value);
  }
  static fromJson(json) {
    const result = new UnitPreviewData();
    if (json.unitName != null) {
      result._hasUnitName = true;
      result._unitName = JsonToString.fromJson(json.unitName);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnitName) {
      result.unitName = JsonToString.toJson(this._unitName);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get unitName() {
    return this._hasUnitName ? this._unitName : JsonToString.default;
  }
  get hasUnitName() {
    return this._hasUnitName;
  }
  setUnitName(path, value) {
    return {type: 'SET', path: path.concat(['unitName']), value};
  }
  deleteUnitName(path) {
    return {type: 'DELETE', path: path.concat(['unitName'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unitName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitPreviewData(this);
              copy._hasUnitName = true;
              copy._unitName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitName) {
                return this;
              }
              const copy = new UnitPreviewData(this);
              copy._hasUnitName = false;
              copy._unitName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UnitPreviewData} other
   * @returns {UnitPreviewData}
   */
  merge(other) {
    const copy = new UnitPreviewData(this);
    if (other._hasUnitName) {
      copy._hasUnitName = true;
      copy._unitName = other._unitName;
    }
    return copy;
  }
}
UnitPreviewData.default = new UnitPreviewData();
class UnitPreviewData_Builder {
  constructor(value) {
    this._value = new UnitPreviewData(value);
  }
  build() {
    return new UnitPreviewData(this._value);
  }
  setUnitName(value) {
    this._value._hasUnitName = true;
    this._value._unitName = value;
    return this;
  }
  deleteUnitName() {
    this._value._hasUnitName = false;
    this._value._unitName = null;
    return this;
  }
}
UnitPreviewData.Builder = UnitPreviewData_Builder;
class UnitPreviewData_WithParent {
  /**
   * @param {UnitPreviewData} value
   * @param {UnitPreviewData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UnitPreviewData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnitName() {
    if (this._cachedHasUnitName === undefined) {
      if (this._value.hasUnitName) {
        this._cachedHasUnitName = true;
      } else {
        this._cachedHasUnitName = this._parent ? this._parent.hasUnitName : false;
      }
    }
    return this._cachedHasUnitName;
  }
  get unitName() {
    if (this._cachedUnitName === undefined) {
      if (this._value.hasUnitName) {
        this._cachedUnitName = this._value.unitName;
      } else {
        this._cachedUnitName = this._parent ? this._parent.unitName : this._value.unitName;
      }
    }
    return this._cachedUnitName;
  }
  update(current, parent) {
    const result = new UnitPreviewData_WithParent(current, parent);
    return result;
  }
}
UnitPreviewData_WithParent.default = new UnitPreviewData_WithParent(UnitPreviewData.default, null);
UnitPreviewData.WithParent = UnitPreviewData_WithParent;
class UnitPreviewData_Descriptor {
  get unitName() {
    if (!this._unitName) {
      this._unitName = {
        name: "unitName",
        Name: "UnitName",
        number: 1,
        protoType: 9,
        protoName: "unit_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitName;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unitName,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnitName",
        Name: "DummyOneofForUnitName",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
UnitPreviewData.descriptor = new UnitPreviewData_Descriptor();
export class UiPreviewData {
  get descriptor() {
    return UiPreviewData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasXml = false;
    this._xml = null;
    this._hasPinnedItem = false;
    this._pinnedItem = null;
  }
  isEmpty() {
    if (this._hasXml) return false;
    if (this._hasPinnedItem) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UiPreviewData) {
      return value;
    }
    return UiPreviewData.fromJson(value);
  }
  static fromJson(json) {
    const result = new UiPreviewData();
    if (json.xml != null) {
      result._hasXml = true;
      result._xml = JsonToString.fromJson(json.xml);
    }
    if (json.pinnedItem != null) {
      result._hasPinnedItem = true;
      result._pinnedItem = JsonToString.fromJson(json.pinnedItem);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasXml) {
      result.xml = JsonToString.toJson(this._xml);
    }
    if (this._hasPinnedItem) {
      result.pinnedItem = JsonToString.toJson(this._pinnedItem);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get xml() {
    return this._hasXml ? this._xml : JsonToString.default;
  }
  get hasXml() {
    return this._hasXml;
  }
  setXml(path, value) {
    return {type: 'SET', path: path.concat(['xml']), value};
  }
  deleteXml(path) {
    return {type: 'DELETE', path: path.concat(['xml'])};
  }
  /**
   * @returns {string}
   */
  get pinnedItem() {
    return this._hasPinnedItem ? this._pinnedItem : JsonToString.default;
  }
  get hasPinnedItem() {
    return this._hasPinnedItem;
  }
  setPinnedItem(path, value) {
    return {type: 'SET', path: path.concat(['pinnedItem']), value};
  }
  deletePinnedItem(path) {
    return {type: 'DELETE', path: path.concat(['pinnedItem'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "xml": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UiPreviewData(this);
              copy._hasXml = true;
              copy._xml = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasXml) {
                return this;
              }
              const copy = new UiPreviewData(this);
              copy._hasXml = false;
              copy._xml = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "pinnedItem": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UiPreviewData(this);
              copy._hasPinnedItem = true;
              copy._pinnedItem = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPinnedItem) {
                return this;
              }
              const copy = new UiPreviewData(this);
              copy._hasPinnedItem = false;
              copy._pinnedItem = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UiPreviewData} other
   * @returns {UiPreviewData}
   */
  merge(other) {
    const copy = new UiPreviewData(this);
    if (other._hasXml) {
      copy._hasXml = true;
      copy._xml = other._xml;
    }
    if (other._hasPinnedItem) {
      copy._hasPinnedItem = true;
      copy._pinnedItem = other._pinnedItem;
    }
    return copy;
  }
}
UiPreviewData.default = new UiPreviewData();
class UiPreviewData_Builder {
  constructor(value) {
    this._value = new UiPreviewData(value);
  }
  build() {
    return new UiPreviewData(this._value);
  }
  setXml(value) {
    this._value._hasXml = true;
    this._value._xml = value;
    return this;
  }
  deleteXml() {
    this._value._hasXml = false;
    this._value._xml = null;
    return this;
  }
  setPinnedItem(value) {
    this._value._hasPinnedItem = true;
    this._value._pinnedItem = value;
    return this;
  }
  deletePinnedItem() {
    this._value._hasPinnedItem = false;
    this._value._pinnedItem = null;
    return this;
  }
}
UiPreviewData.Builder = UiPreviewData_Builder;
class UiPreviewData_WithParent {
  /**
   * @param {UiPreviewData} value
   * @param {UiPreviewData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UiPreviewData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasXml() {
    if (this._cachedHasXml === undefined) {
      if (this._value.hasXml) {
        this._cachedHasXml = true;
      } else {
        this._cachedHasXml = this._parent ? this._parent.hasXml : false;
      }
    }
    return this._cachedHasXml;
  }
  get xml() {
    if (this._cachedXml === undefined) {
      if (this._value.hasXml) {
        this._cachedXml = this._value.xml;
      } else {
        this._cachedXml = this._parent ? this._parent.xml : this._value.xml;
      }
    }
    return this._cachedXml;
  }
  get hasPinnedItem() {
    if (this._cachedHasPinnedItem === undefined) {
      if (this._value.hasPinnedItem) {
        this._cachedHasPinnedItem = true;
      } else {
        this._cachedHasPinnedItem = this._parent ? this._parent.hasPinnedItem : false;
      }
    }
    return this._cachedHasPinnedItem;
  }
  get pinnedItem() {
    if (this._cachedPinnedItem === undefined) {
      if (this._value.hasPinnedItem) {
        this._cachedPinnedItem = this._value.pinnedItem;
      } else {
        this._cachedPinnedItem = this._parent ? this._parent.pinnedItem : this._value.pinnedItem;
      }
    }
    return this._cachedPinnedItem;
  }
  update(current, parent) {
    const result = new UiPreviewData_WithParent(current, parent);
    return result;
  }
}
UiPreviewData_WithParent.default = new UiPreviewData_WithParent(UiPreviewData.default, null);
UiPreviewData.WithParent = UiPreviewData_WithParent;
class UiPreviewData_Descriptor {
  get xml() {
    if (!this._xml) {
      this._xml = {
        name: "xml",
        Name: "Xml",
        number: 1,
        protoType: 9,
        protoName: "xml",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._xml;
  }
  get pinnedItem() {
    if (!this._pinnedItem) {
      this._pinnedItem = {
        name: "pinnedItem",
        Name: "PinnedItem",
        number: 2,
        protoType: 9,
        protoName: "pinned_item",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._pinnedItem;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.xml,
        this.pinnedItem,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForXml",
        Name: "DummyOneofForXml",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPinnedItem",
        Name: "DummyOneofForPinnedItem",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
UiPreviewData.descriptor = new UiPreviewData_Descriptor();
class AssetPreviewerData_PreviewerPanel_AnimationPreviewer {
  get descriptor() {
    return AssetPreviewerData_PreviewerPanel_AnimationPreviewer.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasAssetName = false;
    this._assetName = null;
    this._hasClipName = false;
    this._clipName = null;
    this._hasPlay = false;
    this._play = null;
    this._hasStop = false;
    this._stop = null;
  }
  isEmpty() {
    if (this._hasAssetName) return false;
    if (this._hasClipName) return false;
    if (this._hasPlay) return false;
    if (this._hasStop) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof AssetPreviewerData_PreviewerPanel_AnimationPreviewer) {
      return value;
    }
    return AssetPreviewerData_PreviewerPanel_AnimationPreviewer.fromJson(value);
  }
  static fromJson(json) {
    const result = new AssetPreviewerData_PreviewerPanel_AnimationPreviewer();
    if (json.assetName != null) {
      result._hasAssetName = true;
      result._assetName = JsonToString.fromJson(json.assetName);
    }
    if (json.clipName != null) {
      result._hasClipName = true;
      result._clipName = JsonToString.fromJson(json.clipName);
    }
    if (json.play != null) {
      result._hasPlay = true;
      result._play = JsonToInt32.fromJson(json.play);
    }
    if (json.stop != null) {
      result._hasStop = true;
      result._stop = JsonToInt32.fromJson(json.stop);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasAssetName) {
      result.assetName = JsonToString.toJson(this._assetName);
    }
    if (this._hasClipName) {
      result.clipName = JsonToString.toJson(this._clipName);
    }
    if (this._hasPlay) {
      result.play = JsonToInt32.toJson(this._play);
    }
    if (this._hasStop) {
      result.stop = JsonToInt32.toJson(this._stop);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get assetName() {
    return this._hasAssetName ? this._assetName : JsonToString.default;
  }
  get hasAssetName() {
    return this._hasAssetName;
  }
  setAssetName(path, value) {
    return {type: 'SET', path: path.concat(['assetName']), value};
  }
  deleteAssetName(path) {
    return {type: 'DELETE', path: path.concat(['assetName'])};
  }
  /**
   * @returns {string}
   */
  get clipName() {
    return this._hasClipName ? this._clipName : JsonToString.default;
  }
  get hasClipName() {
    return this._hasClipName;
  }
  setClipName(path, value) {
    return {type: 'SET', path: path.concat(['clipName']), value};
  }
  deleteClipName(path) {
    return {type: 'DELETE', path: path.concat(['clipName'])};
  }
  /**
   * @returns {number}
   */
  get play() {
    return this._hasPlay ? this._play : JsonToInt32.default;
  }
  get hasPlay() {
    return this._hasPlay;
  }
  setPlay(path, value) {
    return {type: 'SET', path: path.concat(['play']), value};
  }
  deletePlay(path) {
    return {type: 'DELETE', path: path.concat(['play'])};
  }
  /**
   * @returns {number}
   */
  get stop() {
    return this._hasStop ? this._stop : JsonToInt32.default;
  }
  get hasStop() {
    return this._hasStop;
  }
  setStop(path, value) {
    return {type: 'SET', path: path.concat(['stop']), value};
  }
  deleteStop(path) {
    return {type: 'DELETE', path: path.concat(['stop'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "assetName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel_AnimationPreviewer(this);
              copy._hasAssetName = true;
              copy._assetName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAssetName) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel_AnimationPreviewer(this);
              copy._hasAssetName = false;
              copy._assetName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "clipName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel_AnimationPreviewer(this);
              copy._hasClipName = true;
              copy._clipName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasClipName) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel_AnimationPreviewer(this);
              copy._hasClipName = false;
              copy._clipName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "play": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel_AnimationPreviewer(this);
              copy._hasPlay = true;
              copy._play = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlay) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel_AnimationPreviewer(this);
              copy._hasPlay = false;
              copy._play = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "stop": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel_AnimationPreviewer(this);
              copy._hasStop = true;
              copy._stop = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStop) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel_AnimationPreviewer(this);
              copy._hasStop = false;
              copy._stop = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {AssetPreviewerData_PreviewerPanel_AnimationPreviewer} other
   * @returns {AssetPreviewerData_PreviewerPanel_AnimationPreviewer}
   */
  merge(other) {
    const copy = new AssetPreviewerData_PreviewerPanel_AnimationPreviewer(this);
    if (other._hasAssetName) {
      copy._hasAssetName = true;
      copy._assetName = other._assetName;
    }
    if (other._hasClipName) {
      copy._hasClipName = true;
      copy._clipName = other._clipName;
    }
    if (other._hasPlay) {
      copy._hasPlay = true;
      copy._play = other._play;
    }
    if (other._hasStop) {
      copy._hasStop = true;
      copy._stop = other._stop;
    }
    return copy;
  }
}
AssetPreviewerData_PreviewerPanel_AnimationPreviewer.default = new AssetPreviewerData_PreviewerPanel_AnimationPreviewer();
class AssetPreviewerData_PreviewerPanel_AnimationPreviewer_Builder {
  constructor(value) {
    this._value = new AssetPreviewerData_PreviewerPanel_AnimationPreviewer(value);
  }
  build() {
    return new AssetPreviewerData_PreviewerPanel_AnimationPreviewer(this._value);
  }
  setAssetName(value) {
    this._value._hasAssetName = true;
    this._value._assetName = value;
    return this;
  }
  deleteAssetName() {
    this._value._hasAssetName = false;
    this._value._assetName = null;
    return this;
  }
  setClipName(value) {
    this._value._hasClipName = true;
    this._value._clipName = value;
    return this;
  }
  deleteClipName() {
    this._value._hasClipName = false;
    this._value._clipName = null;
    return this;
  }
  setPlay(value) {
    this._value._hasPlay = true;
    this._value._play = value;
    return this;
  }
  deletePlay() {
    this._value._hasPlay = false;
    this._value._play = null;
    return this;
  }
  setStop(value) {
    this._value._hasStop = true;
    this._value._stop = value;
    return this;
  }
  deleteStop() {
    this._value._hasStop = false;
    this._value._stop = null;
    return this;
  }
}
AssetPreviewerData_PreviewerPanel_AnimationPreviewer.Builder = AssetPreviewerData_PreviewerPanel_AnimationPreviewer_Builder;
class AssetPreviewerData_PreviewerPanel_AnimationPreviewer_WithParent {
  /**
   * @param {AssetPreviewerData_PreviewerPanel_AnimationPreviewer} value
   * @param {AssetPreviewerData_PreviewerPanel_AnimationPreviewer_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return AssetPreviewerData_PreviewerPanel_AnimationPreviewer.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasAssetName() {
    if (this._cachedHasAssetName === undefined) {
      if (this._value.hasAssetName) {
        this._cachedHasAssetName = true;
      } else {
        this._cachedHasAssetName = this._parent ? this._parent.hasAssetName : false;
      }
    }
    return this._cachedHasAssetName;
  }
  get assetName() {
    if (this._cachedAssetName === undefined) {
      if (this._value.hasAssetName) {
        this._cachedAssetName = this._value.assetName;
      } else {
        this._cachedAssetName = this._parent ? this._parent.assetName : this._value.assetName;
      }
    }
    return this._cachedAssetName;
  }
  get hasClipName() {
    if (this._cachedHasClipName === undefined) {
      if (this._value.hasClipName) {
        this._cachedHasClipName = true;
      } else {
        this._cachedHasClipName = this._parent ? this._parent.hasClipName : false;
      }
    }
    return this._cachedHasClipName;
  }
  get clipName() {
    if (this._cachedClipName === undefined) {
      if (this._value.hasClipName) {
        this._cachedClipName = this._value.clipName;
      } else {
        this._cachedClipName = this._parent ? this._parent.clipName : this._value.clipName;
      }
    }
    return this._cachedClipName;
  }
  get hasPlay() {
    if (this._cachedHasPlay === undefined) {
      if (this._value.hasPlay) {
        this._cachedHasPlay = true;
      } else {
        this._cachedHasPlay = this._parent ? this._parent.hasPlay : false;
      }
    }
    return this._cachedHasPlay;
  }
  get play() {
    if (this._cachedPlay === undefined) {
      if (this._value.hasPlay) {
        this._cachedPlay = this._value.play;
      } else {
        this._cachedPlay = this._parent ? this._parent.play : this._value.play;
      }
    }
    return this._cachedPlay;
  }
  get hasStop() {
    if (this._cachedHasStop === undefined) {
      if (this._value.hasStop) {
        this._cachedHasStop = true;
      } else {
        this._cachedHasStop = this._parent ? this._parent.hasStop : false;
      }
    }
    return this._cachedHasStop;
  }
  get stop() {
    if (this._cachedStop === undefined) {
      if (this._value.hasStop) {
        this._cachedStop = this._value.stop;
      } else {
        this._cachedStop = this._parent ? this._parent.stop : this._value.stop;
      }
    }
    return this._cachedStop;
  }
  update(current, parent) {
    const result = new AssetPreviewerData_PreviewerPanel_AnimationPreviewer_WithParent(current, parent);
    return result;
  }
}
AssetPreviewerData_PreviewerPanel_AnimationPreviewer_WithParent.default = new AssetPreviewerData_PreviewerPanel_AnimationPreviewer_WithParent(AssetPreviewerData_PreviewerPanel_AnimationPreviewer.default, null);
AssetPreviewerData_PreviewerPanel_AnimationPreviewer.WithParent = AssetPreviewerData_PreviewerPanel_AnimationPreviewer_WithParent;
class AssetPreviewerData_PreviewerPanel_AnimationPreviewer_Descriptor {
  get assetName() {
    if (!this._assetName) {
      this._assetName = {
        name: "assetName",
        Name: "AssetName",
        number: 1,
        protoType: 9,
        protoName: "asset_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._assetName;
  }
  get clipName() {
    if (!this._clipName) {
      this._clipName = {
        name: "clipName",
        Name: "ClipName",
        number: 2,
        protoType: 9,
        protoName: "clip_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._clipName;
  }
  get play() {
    if (!this._play) {
      this._play = {
        name: "play",
        Name: "Play",
        number: 3,
        protoType: 5,
        protoName: "play",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._play;
  }
  get stop() {
    if (!this._stop) {
      this._stop = {
        name: "stop",
        Name: "Stop",
        number: 4,
        protoType: 5,
        protoName: "stop",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stop;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.assetName,
        this.clipName,
        this.play,
        this.stop,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForAssetName",
        Name: "DummyOneofForAssetName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForClipName",
        Name: "DummyOneofForClipName",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPlay",
        Name: "DummyOneofForPlay",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStop",
        Name: "DummyOneofForStop",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
AssetPreviewerData_PreviewerPanel_AnimationPreviewer.descriptor = new AssetPreviewerData_PreviewerPanel_AnimationPreviewer_Descriptor();
class AssetPreviewerData_PreviewerPanel_EffectPreviewer {
  get descriptor() {
    return AssetPreviewerData_PreviewerPanel_EffectPreviewer.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasAssetName = false;
    this._assetName = null;
    this._hasPlay = false;
    this._play = null;
    this._hasStop = false;
    this._stop = null;
  }
  isEmpty() {
    if (this._hasAssetName) return false;
    if (this._hasPlay) return false;
    if (this._hasStop) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof AssetPreviewerData_PreviewerPanel_EffectPreviewer) {
      return value;
    }
    return AssetPreviewerData_PreviewerPanel_EffectPreviewer.fromJson(value);
  }
  static fromJson(json) {
    const result = new AssetPreviewerData_PreviewerPanel_EffectPreviewer();
    if (json.assetName != null) {
      result._hasAssetName = true;
      result._assetName = JsonToString.fromJson(json.assetName);
    }
    if (json.play != null) {
      result._hasPlay = true;
      result._play = JsonToInt32.fromJson(json.play);
    }
    if (json.stop != null) {
      result._hasStop = true;
      result._stop = JsonToInt32.fromJson(json.stop);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasAssetName) {
      result.assetName = JsonToString.toJson(this._assetName);
    }
    if (this._hasPlay) {
      result.play = JsonToInt32.toJson(this._play);
    }
    if (this._hasStop) {
      result.stop = JsonToInt32.toJson(this._stop);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get assetName() {
    return this._hasAssetName ? this._assetName : JsonToString.default;
  }
  get hasAssetName() {
    return this._hasAssetName;
  }
  setAssetName(path, value) {
    return {type: 'SET', path: path.concat(['assetName']), value};
  }
  deleteAssetName(path) {
    return {type: 'DELETE', path: path.concat(['assetName'])};
  }
  /**
   * @returns {number}
   */
  get play() {
    return this._hasPlay ? this._play : JsonToInt32.default;
  }
  get hasPlay() {
    return this._hasPlay;
  }
  setPlay(path, value) {
    return {type: 'SET', path: path.concat(['play']), value};
  }
  deletePlay(path) {
    return {type: 'DELETE', path: path.concat(['play'])};
  }
  /**
   * @returns {number}
   */
  get stop() {
    return this._hasStop ? this._stop : JsonToInt32.default;
  }
  get hasStop() {
    return this._hasStop;
  }
  setStop(path, value) {
    return {type: 'SET', path: path.concat(['stop']), value};
  }
  deleteStop(path) {
    return {type: 'DELETE', path: path.concat(['stop'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "assetName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel_EffectPreviewer(this);
              copy._hasAssetName = true;
              copy._assetName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAssetName) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel_EffectPreviewer(this);
              copy._hasAssetName = false;
              copy._assetName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "play": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel_EffectPreviewer(this);
              copy._hasPlay = true;
              copy._play = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlay) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel_EffectPreviewer(this);
              copy._hasPlay = false;
              copy._play = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "stop": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel_EffectPreviewer(this);
              copy._hasStop = true;
              copy._stop = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStop) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel_EffectPreviewer(this);
              copy._hasStop = false;
              copy._stop = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {AssetPreviewerData_PreviewerPanel_EffectPreviewer} other
   * @returns {AssetPreviewerData_PreviewerPanel_EffectPreviewer}
   */
  merge(other) {
    const copy = new AssetPreviewerData_PreviewerPanel_EffectPreviewer(this);
    if (other._hasAssetName) {
      copy._hasAssetName = true;
      copy._assetName = other._assetName;
    }
    if (other._hasPlay) {
      copy._hasPlay = true;
      copy._play = other._play;
    }
    if (other._hasStop) {
      copy._hasStop = true;
      copy._stop = other._stop;
    }
    return copy;
  }
}
AssetPreviewerData_PreviewerPanel_EffectPreviewer.default = new AssetPreviewerData_PreviewerPanel_EffectPreviewer();
class AssetPreviewerData_PreviewerPanel_EffectPreviewer_Builder {
  constructor(value) {
    this._value = new AssetPreviewerData_PreviewerPanel_EffectPreviewer(value);
  }
  build() {
    return new AssetPreviewerData_PreviewerPanel_EffectPreviewer(this._value);
  }
  setAssetName(value) {
    this._value._hasAssetName = true;
    this._value._assetName = value;
    return this;
  }
  deleteAssetName() {
    this._value._hasAssetName = false;
    this._value._assetName = null;
    return this;
  }
  setPlay(value) {
    this._value._hasPlay = true;
    this._value._play = value;
    return this;
  }
  deletePlay() {
    this._value._hasPlay = false;
    this._value._play = null;
    return this;
  }
  setStop(value) {
    this._value._hasStop = true;
    this._value._stop = value;
    return this;
  }
  deleteStop() {
    this._value._hasStop = false;
    this._value._stop = null;
    return this;
  }
}
AssetPreviewerData_PreviewerPanel_EffectPreviewer.Builder = AssetPreviewerData_PreviewerPanel_EffectPreviewer_Builder;
class AssetPreviewerData_PreviewerPanel_EffectPreviewer_WithParent {
  /**
   * @param {AssetPreviewerData_PreviewerPanel_EffectPreviewer} value
   * @param {AssetPreviewerData_PreviewerPanel_EffectPreviewer_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return AssetPreviewerData_PreviewerPanel_EffectPreviewer.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasAssetName() {
    if (this._cachedHasAssetName === undefined) {
      if (this._value.hasAssetName) {
        this._cachedHasAssetName = true;
      } else {
        this._cachedHasAssetName = this._parent ? this._parent.hasAssetName : false;
      }
    }
    return this._cachedHasAssetName;
  }
  get assetName() {
    if (this._cachedAssetName === undefined) {
      if (this._value.hasAssetName) {
        this._cachedAssetName = this._value.assetName;
      } else {
        this._cachedAssetName = this._parent ? this._parent.assetName : this._value.assetName;
      }
    }
    return this._cachedAssetName;
  }
  get hasPlay() {
    if (this._cachedHasPlay === undefined) {
      if (this._value.hasPlay) {
        this._cachedHasPlay = true;
      } else {
        this._cachedHasPlay = this._parent ? this._parent.hasPlay : false;
      }
    }
    return this._cachedHasPlay;
  }
  get play() {
    if (this._cachedPlay === undefined) {
      if (this._value.hasPlay) {
        this._cachedPlay = this._value.play;
      } else {
        this._cachedPlay = this._parent ? this._parent.play : this._value.play;
      }
    }
    return this._cachedPlay;
  }
  get hasStop() {
    if (this._cachedHasStop === undefined) {
      if (this._value.hasStop) {
        this._cachedHasStop = true;
      } else {
        this._cachedHasStop = this._parent ? this._parent.hasStop : false;
      }
    }
    return this._cachedHasStop;
  }
  get stop() {
    if (this._cachedStop === undefined) {
      if (this._value.hasStop) {
        this._cachedStop = this._value.stop;
      } else {
        this._cachedStop = this._parent ? this._parent.stop : this._value.stop;
      }
    }
    return this._cachedStop;
  }
  update(current, parent) {
    const result = new AssetPreviewerData_PreviewerPanel_EffectPreviewer_WithParent(current, parent);
    return result;
  }
}
AssetPreviewerData_PreviewerPanel_EffectPreviewer_WithParent.default = new AssetPreviewerData_PreviewerPanel_EffectPreviewer_WithParent(AssetPreviewerData_PreviewerPanel_EffectPreviewer.default, null);
AssetPreviewerData_PreviewerPanel_EffectPreviewer.WithParent = AssetPreviewerData_PreviewerPanel_EffectPreviewer_WithParent;
class AssetPreviewerData_PreviewerPanel_EffectPreviewer_Descriptor {
  get assetName() {
    if (!this._assetName) {
      this._assetName = {
        name: "assetName",
        Name: "AssetName",
        number: 1,
        protoType: 9,
        protoName: "asset_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._assetName;
  }
  get play() {
    if (!this._play) {
      this._play = {
        name: "play",
        Name: "Play",
        number: 3,
        protoType: 5,
        protoName: "play",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._play;
  }
  get stop() {
    if (!this._stop) {
      this._stop = {
        name: "stop",
        Name: "Stop",
        number: 4,
        protoType: 5,
        protoName: "stop",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stop;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.assetName,
        this.play,
        this.stop,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForAssetName",
        Name: "DummyOneofForAssetName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPlay",
        Name: "DummyOneofForPlay",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStop",
        Name: "DummyOneofForStop",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
AssetPreviewerData_PreviewerPanel_EffectPreviewer.descriptor = new AssetPreviewerData_PreviewerPanel_EffectPreviewer_Descriptor();
class AssetPreviewerData_PreviewerPanel_PropPreviewer {
  get descriptor() {
    return AssetPreviewerData_PreviewerPanel_PropPreviewer.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasAssetName = false;
    this._assetName = null;
  }
  isEmpty() {
    if (this._hasAssetName) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof AssetPreviewerData_PreviewerPanel_PropPreviewer) {
      return value;
    }
    return AssetPreviewerData_PreviewerPanel_PropPreviewer.fromJson(value);
  }
  static fromJson(json) {
    const result = new AssetPreviewerData_PreviewerPanel_PropPreviewer();
    if (json.assetName != null) {
      result._hasAssetName = true;
      result._assetName = JsonToString.fromJson(json.assetName);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasAssetName) {
      result.assetName = JsonToString.toJson(this._assetName);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get assetName() {
    return this._hasAssetName ? this._assetName : JsonToString.default;
  }
  get hasAssetName() {
    return this._hasAssetName;
  }
  setAssetName(path, value) {
    return {type: 'SET', path: path.concat(['assetName']), value};
  }
  deleteAssetName(path) {
    return {type: 'DELETE', path: path.concat(['assetName'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "assetName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel_PropPreviewer(this);
              copy._hasAssetName = true;
              copy._assetName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAssetName) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel_PropPreviewer(this);
              copy._hasAssetName = false;
              copy._assetName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {AssetPreviewerData_PreviewerPanel_PropPreviewer} other
   * @returns {AssetPreviewerData_PreviewerPanel_PropPreviewer}
   */
  merge(other) {
    const copy = new AssetPreviewerData_PreviewerPanel_PropPreviewer(this);
    if (other._hasAssetName) {
      copy._hasAssetName = true;
      copy._assetName = other._assetName;
    }
    return copy;
  }
}
AssetPreviewerData_PreviewerPanel_PropPreviewer.default = new AssetPreviewerData_PreviewerPanel_PropPreviewer();
class AssetPreviewerData_PreviewerPanel_PropPreviewer_Builder {
  constructor(value) {
    this._value = new AssetPreviewerData_PreviewerPanel_PropPreviewer(value);
  }
  build() {
    return new AssetPreviewerData_PreviewerPanel_PropPreviewer(this._value);
  }
  setAssetName(value) {
    this._value._hasAssetName = true;
    this._value._assetName = value;
    return this;
  }
  deleteAssetName() {
    this._value._hasAssetName = false;
    this._value._assetName = null;
    return this;
  }
}
AssetPreviewerData_PreviewerPanel_PropPreviewer.Builder = AssetPreviewerData_PreviewerPanel_PropPreviewer_Builder;
class AssetPreviewerData_PreviewerPanel_PropPreviewer_WithParent {
  /**
   * @param {AssetPreviewerData_PreviewerPanel_PropPreviewer} value
   * @param {AssetPreviewerData_PreviewerPanel_PropPreviewer_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return AssetPreviewerData_PreviewerPanel_PropPreviewer.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasAssetName() {
    if (this._cachedHasAssetName === undefined) {
      if (this._value.hasAssetName) {
        this._cachedHasAssetName = true;
      } else {
        this._cachedHasAssetName = this._parent ? this._parent.hasAssetName : false;
      }
    }
    return this._cachedHasAssetName;
  }
  get assetName() {
    if (this._cachedAssetName === undefined) {
      if (this._value.hasAssetName) {
        this._cachedAssetName = this._value.assetName;
      } else {
        this._cachedAssetName = this._parent ? this._parent.assetName : this._value.assetName;
      }
    }
    return this._cachedAssetName;
  }
  update(current, parent) {
    const result = new AssetPreviewerData_PreviewerPanel_PropPreviewer_WithParent(current, parent);
    return result;
  }
}
AssetPreviewerData_PreviewerPanel_PropPreviewer_WithParent.default = new AssetPreviewerData_PreviewerPanel_PropPreviewer_WithParent(AssetPreviewerData_PreviewerPanel_PropPreviewer.default, null);
AssetPreviewerData_PreviewerPanel_PropPreviewer.WithParent = AssetPreviewerData_PreviewerPanel_PropPreviewer_WithParent;
class AssetPreviewerData_PreviewerPanel_PropPreviewer_Descriptor {
  get assetName() {
    if (!this._assetName) {
      this._assetName = {
        name: "assetName",
        Name: "AssetName",
        number: 1,
        protoType: 9,
        protoName: "asset_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._assetName;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.assetName,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForAssetName",
        Name: "DummyOneofForAssetName",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
AssetPreviewerData_PreviewerPanel_PropPreviewer.descriptor = new AssetPreviewerData_PreviewerPanel_PropPreviewer_Descriptor();
class AssetPreviewerData_PreviewerPanel_SpritePreviewer {
  get descriptor() {
    return AssetPreviewerData_PreviewerPanel_SpritePreviewer.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasAssetName = false;
    this._assetName = null;
    this._hasAtlasName = false;
    this._atlasName = null;
    this._hasSavingPath = false;
    this._savingPath = null;
    this._hasSave = false;
    this._save = null;
  }
  isEmpty() {
    if (this._hasAssetName) return false;
    if (this._hasAtlasName) return false;
    if (this._hasSavingPath) return false;
    if (this._hasSave) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof AssetPreviewerData_PreviewerPanel_SpritePreviewer) {
      return value;
    }
    return AssetPreviewerData_PreviewerPanel_SpritePreviewer.fromJson(value);
  }
  static fromJson(json) {
    const result = new AssetPreviewerData_PreviewerPanel_SpritePreviewer();
    if (json.assetName != null) {
      result._hasAssetName = true;
      result._assetName = JsonToString.fromJson(json.assetName);
    }
    if (json.atlasName != null) {
      result._hasAtlasName = true;
      result._atlasName = JsonToString.fromJson(json.atlasName);
    }
    if (json.savingPath != null) {
      result._hasSavingPath = true;
      result._savingPath = JsonToString.fromJson(json.savingPath);
    }
    if (json.save != null) {
      result._hasSave = true;
      result._save = JsonToInt32.fromJson(json.save);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasAssetName) {
      result.assetName = JsonToString.toJson(this._assetName);
    }
    if (this._hasAtlasName) {
      result.atlasName = JsonToString.toJson(this._atlasName);
    }
    if (this._hasSavingPath) {
      result.savingPath = JsonToString.toJson(this._savingPath);
    }
    if (this._hasSave) {
      result.save = JsonToInt32.toJson(this._save);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get assetName() {
    return this._hasAssetName ? this._assetName : JsonToString.default;
  }
  get hasAssetName() {
    return this._hasAssetName;
  }
  setAssetName(path, value) {
    return {type: 'SET', path: path.concat(['assetName']), value};
  }
  deleteAssetName(path) {
    return {type: 'DELETE', path: path.concat(['assetName'])};
  }
  /**
   * @returns {string}
   */
  get atlasName() {
    return this._hasAtlasName ? this._atlasName : JsonToString.default;
  }
  get hasAtlasName() {
    return this._hasAtlasName;
  }
  setAtlasName(path, value) {
    return {type: 'SET', path: path.concat(['atlasName']), value};
  }
  deleteAtlasName(path) {
    return {type: 'DELETE', path: path.concat(['atlasName'])};
  }
  /**
   * @returns {string}
   */
  get savingPath() {
    return this._hasSavingPath ? this._savingPath : JsonToString.default;
  }
  get hasSavingPath() {
    return this._hasSavingPath;
  }
  setSavingPath(path, value) {
    return {type: 'SET', path: path.concat(['savingPath']), value};
  }
  deleteSavingPath(path) {
    return {type: 'DELETE', path: path.concat(['savingPath'])};
  }
  /**
   * @returns {number}
   */
  get save() {
    return this._hasSave ? this._save : JsonToInt32.default;
  }
  get hasSave() {
    return this._hasSave;
  }
  setSave(path, value) {
    return {type: 'SET', path: path.concat(['save']), value};
  }
  deleteSave(path) {
    return {type: 'DELETE', path: path.concat(['save'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "assetName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel_SpritePreviewer(this);
              copy._hasAssetName = true;
              copy._assetName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAssetName) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel_SpritePreviewer(this);
              copy._hasAssetName = false;
              copy._assetName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "atlasName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel_SpritePreviewer(this);
              copy._hasAtlasName = true;
              copy._atlasName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAtlasName) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel_SpritePreviewer(this);
              copy._hasAtlasName = false;
              copy._atlasName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "savingPath": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel_SpritePreviewer(this);
              copy._hasSavingPath = true;
              copy._savingPath = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSavingPath) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel_SpritePreviewer(this);
              copy._hasSavingPath = false;
              copy._savingPath = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "save": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel_SpritePreviewer(this);
              copy._hasSave = true;
              copy._save = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSave) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel_SpritePreviewer(this);
              copy._hasSave = false;
              copy._save = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {AssetPreviewerData_PreviewerPanel_SpritePreviewer} other
   * @returns {AssetPreviewerData_PreviewerPanel_SpritePreviewer}
   */
  merge(other) {
    const copy = new AssetPreviewerData_PreviewerPanel_SpritePreviewer(this);
    if (other._hasAssetName) {
      copy._hasAssetName = true;
      copy._assetName = other._assetName;
    }
    if (other._hasAtlasName) {
      copy._hasAtlasName = true;
      copy._atlasName = other._atlasName;
    }
    if (other._hasSavingPath) {
      copy._hasSavingPath = true;
      copy._savingPath = other._savingPath;
    }
    if (other._hasSave) {
      copy._hasSave = true;
      copy._save = other._save;
    }
    return copy;
  }
}
AssetPreviewerData_PreviewerPanel_SpritePreviewer.default = new AssetPreviewerData_PreviewerPanel_SpritePreviewer();
class AssetPreviewerData_PreviewerPanel_SpritePreviewer_Builder {
  constructor(value) {
    this._value = new AssetPreviewerData_PreviewerPanel_SpritePreviewer(value);
  }
  build() {
    return new AssetPreviewerData_PreviewerPanel_SpritePreviewer(this._value);
  }
  setAssetName(value) {
    this._value._hasAssetName = true;
    this._value._assetName = value;
    return this;
  }
  deleteAssetName() {
    this._value._hasAssetName = false;
    this._value._assetName = null;
    return this;
  }
  setAtlasName(value) {
    this._value._hasAtlasName = true;
    this._value._atlasName = value;
    return this;
  }
  deleteAtlasName() {
    this._value._hasAtlasName = false;
    this._value._atlasName = null;
    return this;
  }
  setSavingPath(value) {
    this._value._hasSavingPath = true;
    this._value._savingPath = value;
    return this;
  }
  deleteSavingPath() {
    this._value._hasSavingPath = false;
    this._value._savingPath = null;
    return this;
  }
  setSave(value) {
    this._value._hasSave = true;
    this._value._save = value;
    return this;
  }
  deleteSave() {
    this._value._hasSave = false;
    this._value._save = null;
    return this;
  }
}
AssetPreviewerData_PreviewerPanel_SpritePreviewer.Builder = AssetPreviewerData_PreviewerPanel_SpritePreviewer_Builder;
class AssetPreviewerData_PreviewerPanel_SpritePreviewer_WithParent {
  /**
   * @param {AssetPreviewerData_PreviewerPanel_SpritePreviewer} value
   * @param {AssetPreviewerData_PreviewerPanel_SpritePreviewer_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return AssetPreviewerData_PreviewerPanel_SpritePreviewer.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasAssetName() {
    if (this._cachedHasAssetName === undefined) {
      if (this._value.hasAssetName) {
        this._cachedHasAssetName = true;
      } else {
        this._cachedHasAssetName = this._parent ? this._parent.hasAssetName : false;
      }
    }
    return this._cachedHasAssetName;
  }
  get assetName() {
    if (this._cachedAssetName === undefined) {
      if (this._value.hasAssetName) {
        this._cachedAssetName = this._value.assetName;
      } else {
        this._cachedAssetName = this._parent ? this._parent.assetName : this._value.assetName;
      }
    }
    return this._cachedAssetName;
  }
  get hasAtlasName() {
    if (this._cachedHasAtlasName === undefined) {
      if (this._value.hasAtlasName) {
        this._cachedHasAtlasName = true;
      } else {
        this._cachedHasAtlasName = this._parent ? this._parent.hasAtlasName : false;
      }
    }
    return this._cachedHasAtlasName;
  }
  get atlasName() {
    if (this._cachedAtlasName === undefined) {
      if (this._value.hasAtlasName) {
        this._cachedAtlasName = this._value.atlasName;
      } else {
        this._cachedAtlasName = this._parent ? this._parent.atlasName : this._value.atlasName;
      }
    }
    return this._cachedAtlasName;
  }
  get hasSavingPath() {
    if (this._cachedHasSavingPath === undefined) {
      if (this._value.hasSavingPath) {
        this._cachedHasSavingPath = true;
      } else {
        this._cachedHasSavingPath = this._parent ? this._parent.hasSavingPath : false;
      }
    }
    return this._cachedHasSavingPath;
  }
  get savingPath() {
    if (this._cachedSavingPath === undefined) {
      if (this._value.hasSavingPath) {
        this._cachedSavingPath = this._value.savingPath;
      } else {
        this._cachedSavingPath = this._parent ? this._parent.savingPath : this._value.savingPath;
      }
    }
    return this._cachedSavingPath;
  }
  get hasSave() {
    if (this._cachedHasSave === undefined) {
      if (this._value.hasSave) {
        this._cachedHasSave = true;
      } else {
        this._cachedHasSave = this._parent ? this._parent.hasSave : false;
      }
    }
    return this._cachedHasSave;
  }
  get save() {
    if (this._cachedSave === undefined) {
      if (this._value.hasSave) {
        this._cachedSave = this._value.save;
      } else {
        this._cachedSave = this._parent ? this._parent.save : this._value.save;
      }
    }
    return this._cachedSave;
  }
  update(current, parent) {
    const result = new AssetPreviewerData_PreviewerPanel_SpritePreviewer_WithParent(current, parent);
    return result;
  }
}
AssetPreviewerData_PreviewerPanel_SpritePreviewer_WithParent.default = new AssetPreviewerData_PreviewerPanel_SpritePreviewer_WithParent(AssetPreviewerData_PreviewerPanel_SpritePreviewer.default, null);
AssetPreviewerData_PreviewerPanel_SpritePreviewer.WithParent = AssetPreviewerData_PreviewerPanel_SpritePreviewer_WithParent;
class AssetPreviewerData_PreviewerPanel_SpritePreviewer_Descriptor {
  get assetName() {
    if (!this._assetName) {
      this._assetName = {
        name: "assetName",
        Name: "AssetName",
        number: 1,
        protoType: 9,
        protoName: "asset_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._assetName;
  }
  get atlasName() {
    if (!this._atlasName) {
      this._atlasName = {
        name: "atlasName",
        Name: "AtlasName",
        number: 2,
        protoType: 9,
        protoName: "atlas_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._atlasName;
  }
  get savingPath() {
    if (!this._savingPath) {
      this._savingPath = {
        name: "savingPath",
        Name: "SavingPath",
        number: 3,
        protoType: 9,
        protoName: "saving_path",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._savingPath;
  }
  get save() {
    if (!this._save) {
      this._save = {
        name: "save",
        Name: "Save",
        number: 4,
        protoType: 5,
        protoName: "save",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._save;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.assetName,
        this.atlasName,
        this.savingPath,
        this.save,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForAssetName",
        Name: "DummyOneofForAssetName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAtlasName",
        Name: "DummyOneofForAtlasName",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSavingPath",
        Name: "DummyOneofForSavingPath",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSave",
        Name: "DummyOneofForSave",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
AssetPreviewerData_PreviewerPanel_SpritePreviewer.descriptor = new AssetPreviewerData_PreviewerPanel_SpritePreviewer_Descriptor();
class AssetPreviewerData_PreviewerPanel_SoundPreviewer {
  get descriptor() {
    return AssetPreviewerData_PreviewerPanel_SoundPreviewer.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasAssetName = false;
    this._assetName = null;
    this._hasPlay = false;
    this._play = null;
    this._hasStop = false;
    this._stop = null;
  }
  isEmpty() {
    if (this._hasAssetName) return false;
    if (this._hasPlay) return false;
    if (this._hasStop) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof AssetPreviewerData_PreviewerPanel_SoundPreviewer) {
      return value;
    }
    return AssetPreviewerData_PreviewerPanel_SoundPreviewer.fromJson(value);
  }
  static fromJson(json) {
    const result = new AssetPreviewerData_PreviewerPanel_SoundPreviewer();
    if (json.assetName != null) {
      result._hasAssetName = true;
      result._assetName = JsonToString.fromJson(json.assetName);
    }
    if (json.play != null) {
      result._hasPlay = true;
      result._play = JsonToInt32.fromJson(json.play);
    }
    if (json.stop != null) {
      result._hasStop = true;
      result._stop = JsonToInt32.fromJson(json.stop);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasAssetName) {
      result.assetName = JsonToString.toJson(this._assetName);
    }
    if (this._hasPlay) {
      result.play = JsonToInt32.toJson(this._play);
    }
    if (this._hasStop) {
      result.stop = JsonToInt32.toJson(this._stop);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get assetName() {
    return this._hasAssetName ? this._assetName : JsonToString.default;
  }
  get hasAssetName() {
    return this._hasAssetName;
  }
  setAssetName(path, value) {
    return {type: 'SET', path: path.concat(['assetName']), value};
  }
  deleteAssetName(path) {
    return {type: 'DELETE', path: path.concat(['assetName'])};
  }
  /**
   * @returns {number}
   */
  get play() {
    return this._hasPlay ? this._play : JsonToInt32.default;
  }
  get hasPlay() {
    return this._hasPlay;
  }
  setPlay(path, value) {
    return {type: 'SET', path: path.concat(['play']), value};
  }
  deletePlay(path) {
    return {type: 'DELETE', path: path.concat(['play'])};
  }
  /**
   * @returns {number}
   */
  get stop() {
    return this._hasStop ? this._stop : JsonToInt32.default;
  }
  get hasStop() {
    return this._hasStop;
  }
  setStop(path, value) {
    return {type: 'SET', path: path.concat(['stop']), value};
  }
  deleteStop(path) {
    return {type: 'DELETE', path: path.concat(['stop'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "assetName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel_SoundPreviewer(this);
              copy._hasAssetName = true;
              copy._assetName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAssetName) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel_SoundPreviewer(this);
              copy._hasAssetName = false;
              copy._assetName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "play": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel_SoundPreviewer(this);
              copy._hasPlay = true;
              copy._play = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlay) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel_SoundPreviewer(this);
              copy._hasPlay = false;
              copy._play = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "stop": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel_SoundPreviewer(this);
              copy._hasStop = true;
              copy._stop = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStop) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel_SoundPreviewer(this);
              copy._hasStop = false;
              copy._stop = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {AssetPreviewerData_PreviewerPanel_SoundPreviewer} other
   * @returns {AssetPreviewerData_PreviewerPanel_SoundPreviewer}
   */
  merge(other) {
    const copy = new AssetPreviewerData_PreviewerPanel_SoundPreviewer(this);
    if (other._hasAssetName) {
      copy._hasAssetName = true;
      copy._assetName = other._assetName;
    }
    if (other._hasPlay) {
      copy._hasPlay = true;
      copy._play = other._play;
    }
    if (other._hasStop) {
      copy._hasStop = true;
      copy._stop = other._stop;
    }
    return copy;
  }
}
AssetPreviewerData_PreviewerPanel_SoundPreviewer.default = new AssetPreviewerData_PreviewerPanel_SoundPreviewer();
class AssetPreviewerData_PreviewerPanel_SoundPreviewer_Builder {
  constructor(value) {
    this._value = new AssetPreviewerData_PreviewerPanel_SoundPreviewer(value);
  }
  build() {
    return new AssetPreviewerData_PreviewerPanel_SoundPreviewer(this._value);
  }
  setAssetName(value) {
    this._value._hasAssetName = true;
    this._value._assetName = value;
    return this;
  }
  deleteAssetName() {
    this._value._hasAssetName = false;
    this._value._assetName = null;
    return this;
  }
  setPlay(value) {
    this._value._hasPlay = true;
    this._value._play = value;
    return this;
  }
  deletePlay() {
    this._value._hasPlay = false;
    this._value._play = null;
    return this;
  }
  setStop(value) {
    this._value._hasStop = true;
    this._value._stop = value;
    return this;
  }
  deleteStop() {
    this._value._hasStop = false;
    this._value._stop = null;
    return this;
  }
}
AssetPreviewerData_PreviewerPanel_SoundPreviewer.Builder = AssetPreviewerData_PreviewerPanel_SoundPreviewer_Builder;
class AssetPreviewerData_PreviewerPanel_SoundPreviewer_WithParent {
  /**
   * @param {AssetPreviewerData_PreviewerPanel_SoundPreviewer} value
   * @param {AssetPreviewerData_PreviewerPanel_SoundPreviewer_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return AssetPreviewerData_PreviewerPanel_SoundPreviewer.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasAssetName() {
    if (this._cachedHasAssetName === undefined) {
      if (this._value.hasAssetName) {
        this._cachedHasAssetName = true;
      } else {
        this._cachedHasAssetName = this._parent ? this._parent.hasAssetName : false;
      }
    }
    return this._cachedHasAssetName;
  }
  get assetName() {
    if (this._cachedAssetName === undefined) {
      if (this._value.hasAssetName) {
        this._cachedAssetName = this._value.assetName;
      } else {
        this._cachedAssetName = this._parent ? this._parent.assetName : this._value.assetName;
      }
    }
    return this._cachedAssetName;
  }
  get hasPlay() {
    if (this._cachedHasPlay === undefined) {
      if (this._value.hasPlay) {
        this._cachedHasPlay = true;
      } else {
        this._cachedHasPlay = this._parent ? this._parent.hasPlay : false;
      }
    }
    return this._cachedHasPlay;
  }
  get play() {
    if (this._cachedPlay === undefined) {
      if (this._value.hasPlay) {
        this._cachedPlay = this._value.play;
      } else {
        this._cachedPlay = this._parent ? this._parent.play : this._value.play;
      }
    }
    return this._cachedPlay;
  }
  get hasStop() {
    if (this._cachedHasStop === undefined) {
      if (this._value.hasStop) {
        this._cachedHasStop = true;
      } else {
        this._cachedHasStop = this._parent ? this._parent.hasStop : false;
      }
    }
    return this._cachedHasStop;
  }
  get stop() {
    if (this._cachedStop === undefined) {
      if (this._value.hasStop) {
        this._cachedStop = this._value.stop;
      } else {
        this._cachedStop = this._parent ? this._parent.stop : this._value.stop;
      }
    }
    return this._cachedStop;
  }
  update(current, parent) {
    const result = new AssetPreviewerData_PreviewerPanel_SoundPreviewer_WithParent(current, parent);
    return result;
  }
}
AssetPreviewerData_PreviewerPanel_SoundPreviewer_WithParent.default = new AssetPreviewerData_PreviewerPanel_SoundPreviewer_WithParent(AssetPreviewerData_PreviewerPanel_SoundPreviewer.default, null);
AssetPreviewerData_PreviewerPanel_SoundPreviewer.WithParent = AssetPreviewerData_PreviewerPanel_SoundPreviewer_WithParent;
class AssetPreviewerData_PreviewerPanel_SoundPreviewer_Descriptor {
  get assetName() {
    if (!this._assetName) {
      this._assetName = {
        name: "assetName",
        Name: "AssetName",
        number: 1,
        protoType: 9,
        protoName: "asset_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._assetName;
  }
  get play() {
    if (!this._play) {
      this._play = {
        name: "play",
        Name: "Play",
        number: 3,
        protoType: 5,
        protoName: "play",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._play;
  }
  get stop() {
    if (!this._stop) {
      this._stop = {
        name: "stop",
        Name: "Stop",
        number: 4,
        protoType: 5,
        protoName: "stop",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stop;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.assetName,
        this.play,
        this.stop,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForAssetName",
        Name: "DummyOneofForAssetName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPlay",
        Name: "DummyOneofForPlay",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStop",
        Name: "DummyOneofForStop",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
AssetPreviewerData_PreviewerPanel_SoundPreviewer.descriptor = new AssetPreviewerData_PreviewerPanel_SoundPreviewer_Descriptor();
class AssetPreviewerData_PreviewerPanel_BeamPreviewer {
  get descriptor() {
    return AssetPreviewerData_PreviewerPanel_BeamPreviewer.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasAssetName = false;
    this._assetName = null;
    this._hasPlay = false;
    this._play = null;
    this._hasStop = false;
    this._stop = null;
  }
  isEmpty() {
    if (this._hasAssetName) return false;
    if (this._hasPlay) return false;
    if (this._hasStop) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof AssetPreviewerData_PreviewerPanel_BeamPreviewer) {
      return value;
    }
    return AssetPreviewerData_PreviewerPanel_BeamPreviewer.fromJson(value);
  }
  static fromJson(json) {
    const result = new AssetPreviewerData_PreviewerPanel_BeamPreviewer();
    if (json.assetName != null) {
      result._hasAssetName = true;
      result._assetName = JsonToString.fromJson(json.assetName);
    }
    if (json.play != null) {
      result._hasPlay = true;
      result._play = JsonToInt32.fromJson(json.play);
    }
    if (json.stop != null) {
      result._hasStop = true;
      result._stop = JsonToInt32.fromJson(json.stop);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasAssetName) {
      result.assetName = JsonToString.toJson(this._assetName);
    }
    if (this._hasPlay) {
      result.play = JsonToInt32.toJson(this._play);
    }
    if (this._hasStop) {
      result.stop = JsonToInt32.toJson(this._stop);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get assetName() {
    return this._hasAssetName ? this._assetName : JsonToString.default;
  }
  get hasAssetName() {
    return this._hasAssetName;
  }
  setAssetName(path, value) {
    return {type: 'SET', path: path.concat(['assetName']), value};
  }
  deleteAssetName(path) {
    return {type: 'DELETE', path: path.concat(['assetName'])};
  }
  /**
   * @returns {number}
   */
  get play() {
    return this._hasPlay ? this._play : JsonToInt32.default;
  }
  get hasPlay() {
    return this._hasPlay;
  }
  setPlay(path, value) {
    return {type: 'SET', path: path.concat(['play']), value};
  }
  deletePlay(path) {
    return {type: 'DELETE', path: path.concat(['play'])};
  }
  /**
   * @returns {number}
   */
  get stop() {
    return this._hasStop ? this._stop : JsonToInt32.default;
  }
  get hasStop() {
    return this._hasStop;
  }
  setStop(path, value) {
    return {type: 'SET', path: path.concat(['stop']), value};
  }
  deleteStop(path) {
    return {type: 'DELETE', path: path.concat(['stop'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "assetName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel_BeamPreviewer(this);
              copy._hasAssetName = true;
              copy._assetName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAssetName) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel_BeamPreviewer(this);
              copy._hasAssetName = false;
              copy._assetName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "play": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel_BeamPreviewer(this);
              copy._hasPlay = true;
              copy._play = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlay) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel_BeamPreviewer(this);
              copy._hasPlay = false;
              copy._play = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "stop": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel_BeamPreviewer(this);
              copy._hasStop = true;
              copy._stop = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStop) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel_BeamPreviewer(this);
              copy._hasStop = false;
              copy._stop = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {AssetPreviewerData_PreviewerPanel_BeamPreviewer} other
   * @returns {AssetPreviewerData_PreviewerPanel_BeamPreviewer}
   */
  merge(other) {
    const copy = new AssetPreviewerData_PreviewerPanel_BeamPreviewer(this);
    if (other._hasAssetName) {
      copy._hasAssetName = true;
      copy._assetName = other._assetName;
    }
    if (other._hasPlay) {
      copy._hasPlay = true;
      copy._play = other._play;
    }
    if (other._hasStop) {
      copy._hasStop = true;
      copy._stop = other._stop;
    }
    return copy;
  }
}
AssetPreviewerData_PreviewerPanel_BeamPreviewer.default = new AssetPreviewerData_PreviewerPanel_BeamPreviewer();
class AssetPreviewerData_PreviewerPanel_BeamPreviewer_Builder {
  constructor(value) {
    this._value = new AssetPreviewerData_PreviewerPanel_BeamPreviewer(value);
  }
  build() {
    return new AssetPreviewerData_PreviewerPanel_BeamPreviewer(this._value);
  }
  setAssetName(value) {
    this._value._hasAssetName = true;
    this._value._assetName = value;
    return this;
  }
  deleteAssetName() {
    this._value._hasAssetName = false;
    this._value._assetName = null;
    return this;
  }
  setPlay(value) {
    this._value._hasPlay = true;
    this._value._play = value;
    return this;
  }
  deletePlay() {
    this._value._hasPlay = false;
    this._value._play = null;
    return this;
  }
  setStop(value) {
    this._value._hasStop = true;
    this._value._stop = value;
    return this;
  }
  deleteStop() {
    this._value._hasStop = false;
    this._value._stop = null;
    return this;
  }
}
AssetPreviewerData_PreviewerPanel_BeamPreviewer.Builder = AssetPreviewerData_PreviewerPanel_BeamPreviewer_Builder;
class AssetPreviewerData_PreviewerPanel_BeamPreviewer_WithParent {
  /**
   * @param {AssetPreviewerData_PreviewerPanel_BeamPreviewer} value
   * @param {AssetPreviewerData_PreviewerPanel_BeamPreviewer_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return AssetPreviewerData_PreviewerPanel_BeamPreviewer.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasAssetName() {
    if (this._cachedHasAssetName === undefined) {
      if (this._value.hasAssetName) {
        this._cachedHasAssetName = true;
      } else {
        this._cachedHasAssetName = this._parent ? this._parent.hasAssetName : false;
      }
    }
    return this._cachedHasAssetName;
  }
  get assetName() {
    if (this._cachedAssetName === undefined) {
      if (this._value.hasAssetName) {
        this._cachedAssetName = this._value.assetName;
      } else {
        this._cachedAssetName = this._parent ? this._parent.assetName : this._value.assetName;
      }
    }
    return this._cachedAssetName;
  }
  get hasPlay() {
    if (this._cachedHasPlay === undefined) {
      if (this._value.hasPlay) {
        this._cachedHasPlay = true;
      } else {
        this._cachedHasPlay = this._parent ? this._parent.hasPlay : false;
      }
    }
    return this._cachedHasPlay;
  }
  get play() {
    if (this._cachedPlay === undefined) {
      if (this._value.hasPlay) {
        this._cachedPlay = this._value.play;
      } else {
        this._cachedPlay = this._parent ? this._parent.play : this._value.play;
      }
    }
    return this._cachedPlay;
  }
  get hasStop() {
    if (this._cachedHasStop === undefined) {
      if (this._value.hasStop) {
        this._cachedHasStop = true;
      } else {
        this._cachedHasStop = this._parent ? this._parent.hasStop : false;
      }
    }
    return this._cachedHasStop;
  }
  get stop() {
    if (this._cachedStop === undefined) {
      if (this._value.hasStop) {
        this._cachedStop = this._value.stop;
      } else {
        this._cachedStop = this._parent ? this._parent.stop : this._value.stop;
      }
    }
    return this._cachedStop;
  }
  update(current, parent) {
    const result = new AssetPreviewerData_PreviewerPanel_BeamPreviewer_WithParent(current, parent);
    return result;
  }
}
AssetPreviewerData_PreviewerPanel_BeamPreviewer_WithParent.default = new AssetPreviewerData_PreviewerPanel_BeamPreviewer_WithParent(AssetPreviewerData_PreviewerPanel_BeamPreviewer.default, null);
AssetPreviewerData_PreviewerPanel_BeamPreviewer.WithParent = AssetPreviewerData_PreviewerPanel_BeamPreviewer_WithParent;
class AssetPreviewerData_PreviewerPanel_BeamPreviewer_Descriptor {
  get assetName() {
    if (!this._assetName) {
      this._assetName = {
        name: "assetName",
        Name: "AssetName",
        number: 1,
        protoType: 9,
        protoName: "asset_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._assetName;
  }
  get play() {
    if (!this._play) {
      this._play = {
        name: "play",
        Name: "Play",
        number: 3,
        protoType: 5,
        protoName: "play",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._play;
  }
  get stop() {
    if (!this._stop) {
      this._stop = {
        name: "stop",
        Name: "Stop",
        number: 4,
        protoType: 5,
        protoName: "stop",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stop;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.assetName,
        this.play,
        this.stop,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForAssetName",
        Name: "DummyOneofForAssetName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPlay",
        Name: "DummyOneofForPlay",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStop",
        Name: "DummyOneofForStop",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
AssetPreviewerData_PreviewerPanel_BeamPreviewer.descriptor = new AssetPreviewerData_PreviewerPanel_BeamPreviewer_Descriptor();
class AssetPreviewerData_PreviewerPanel_PreviewerType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "ANIMTION": return 0;
        case "EFFECT": return 1;
        case "PROP": return 2;
        case "SPRITE": return 3;
        case "SOUND": return 4;
        case "BEAM": return 5;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return AssetPreviewerData_PreviewerPanel_PreviewerType.fromJson(value);
  }
  static fromReact(e) {
    return AssetPreviewerData_PreviewerPanel_PreviewerType.fromJson(e);
  }
}
AssetPreviewerData_PreviewerPanel_PreviewerType.ANIMTION = 0;
AssetPreviewerData_PreviewerPanel_PreviewerType.EFFECT = 1;
AssetPreviewerData_PreviewerPanel_PreviewerType.PROP = 2;
AssetPreviewerData_PreviewerPanel_PreviewerType.SPRITE = 3;
AssetPreviewerData_PreviewerPanel_PreviewerType.SOUND = 4;
AssetPreviewerData_PreviewerPanel_PreviewerType.BEAM = 5;
AssetPreviewerData_PreviewerPanel_PreviewerType.default = 0;
AssetPreviewerData_PreviewerPanel_PreviewerType.values = {
  ANIMTION: 0,
  EFFECT: 1,
  PROP: 2,
  SPRITE: 3,
  SOUND: 4,
  BEAM: 5,
};
AssetPreviewerData_PreviewerPanel_PreviewerType.names = {
  0: "ANIMTION",
  1: "EFFECT",
  2: "PROP",
  3: "SPRITE",
  4: "SOUND",
  5: "BEAM",
};
class AssetPreviewerData_PreviewerPanel {
  get descriptor() {
    return AssetPreviewerData_PreviewerPanel.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCurrentPreviewer = false;
    this._currentPreviewer = null;
    this._hasAnimationPreviewer = false;
    this._animationPreviewer = null;
    this._hasEffectPreviewer = false;
    this._effectPreviewer = null;
    this._hasPropPreviewer = false;
    this._propPreviewer = null;
    this._hasSpritePreviewer = false;
    this._spritePreviewer = null;
    this._hasSoundPreviewer = false;
    this._soundPreviewer = null;
    this._hasBeamPreviewer = false;
    this._beamPreviewer = null;
    this._hasResetCamera = false;
    this._resetCamera = null;
    this._hasHideGrid = false;
    this._hideGrid = null;
  }
  isEmpty() {
    if (this._hasCurrentPreviewer) return false;
    if (this._hasAnimationPreviewer && !this._animationPreviewer.isEmpty()) return false;
    if (this._hasEffectPreviewer && !this._effectPreviewer.isEmpty()) return false;
    if (this._hasPropPreviewer && !this._propPreviewer.isEmpty()) return false;
    if (this._hasSpritePreviewer && !this._spritePreviewer.isEmpty()) return false;
    if (this._hasSoundPreviewer && !this._soundPreviewer.isEmpty()) return false;
    if (this._hasBeamPreviewer && !this._beamPreviewer.isEmpty()) return false;
    if (this._hasResetCamera) return false;
    if (this._hasHideGrid) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof AssetPreviewerData_PreviewerPanel) {
      return value;
    }
    return AssetPreviewerData_PreviewerPanel.fromJson(value);
  }
  static fromJson(json) {
    const result = new AssetPreviewerData_PreviewerPanel();
    if (json.currentPreviewer != null) {
      result._hasCurrentPreviewer = true;
      result._currentPreviewer = AssetPreviewerData_PreviewerPanel_PreviewerType.fromJson(json.currentPreviewer);
    }
    if (json.animationPreviewer != null) {
      result._hasAnimationPreviewer = true;
      result._animationPreviewer = AssetPreviewerData_PreviewerPanel_AnimationPreviewer.fromJson(json.animationPreviewer);
    }
    if (json.effectPreviewer != null) {
      result._hasEffectPreviewer = true;
      result._effectPreviewer = AssetPreviewerData_PreviewerPanel_EffectPreviewer.fromJson(json.effectPreviewer);
    }
    if (json.propPreviewer != null) {
      result._hasPropPreviewer = true;
      result._propPreviewer = AssetPreviewerData_PreviewerPanel_PropPreviewer.fromJson(json.propPreviewer);
    }
    if (json.spritePreviewer != null) {
      result._hasSpritePreviewer = true;
      result._spritePreviewer = AssetPreviewerData_PreviewerPanel_SpritePreviewer.fromJson(json.spritePreviewer);
    }
    if (json.soundPreviewer != null) {
      result._hasSoundPreviewer = true;
      result._soundPreviewer = AssetPreviewerData_PreviewerPanel_SoundPreviewer.fromJson(json.soundPreviewer);
    }
    if (json.beamPreviewer != null) {
      result._hasBeamPreviewer = true;
      result._beamPreviewer = AssetPreviewerData_PreviewerPanel_BeamPreviewer.fromJson(json.beamPreviewer);
    }
    if (json.resetCamera != null) {
      result._hasResetCamera = true;
      result._resetCamera = JsonToInt32.fromJson(json.resetCamera);
    }
    if (json.hideGrid != null) {
      result._hasHideGrid = true;
      result._hideGrid = JsonToBoolean.fromJson(json.hideGrid);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCurrentPreviewer) {
      result.currentPreviewer = AssetPreviewerData_PreviewerPanel_PreviewerType.toJson(this._currentPreviewer);
    }
    if (this._hasAnimationPreviewer && !this._animationPreviewer.isEmpty()) {
      result.animationPreviewer = AssetPreviewerData_PreviewerPanel_AnimationPreviewer.toJson(this._animationPreviewer);
    }
    if (this._hasEffectPreviewer && !this._effectPreviewer.isEmpty()) {
      result.effectPreviewer = AssetPreviewerData_PreviewerPanel_EffectPreviewer.toJson(this._effectPreviewer);
    }
    if (this._hasPropPreviewer && !this._propPreviewer.isEmpty()) {
      result.propPreviewer = AssetPreviewerData_PreviewerPanel_PropPreviewer.toJson(this._propPreviewer);
    }
    if (this._hasSpritePreviewer && !this._spritePreviewer.isEmpty()) {
      result.spritePreviewer = AssetPreviewerData_PreviewerPanel_SpritePreviewer.toJson(this._spritePreviewer);
    }
    if (this._hasSoundPreviewer && !this._soundPreviewer.isEmpty()) {
      result.soundPreviewer = AssetPreviewerData_PreviewerPanel_SoundPreviewer.toJson(this._soundPreviewer);
    }
    if (this._hasBeamPreviewer && !this._beamPreviewer.isEmpty()) {
      result.beamPreviewer = AssetPreviewerData_PreviewerPanel_BeamPreviewer.toJson(this._beamPreviewer);
    }
    if (this._hasResetCamera) {
      result.resetCamera = JsonToInt32.toJson(this._resetCamera);
    }
    if (this._hasHideGrid) {
      result.hideGrid = JsonToBoolean.toJson(this._hideGrid);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get currentPreviewer() {
    return this._hasCurrentPreviewer ? this._currentPreviewer : AssetPreviewerData_PreviewerPanel_PreviewerType.default;
  }
  get hasCurrentPreviewer() {
    return this._hasCurrentPreviewer;
  }
  setCurrentPreviewer(path, value) {
    return {type: 'SET', path: path.concat(['currentPreviewer']), value};
  }
  deleteCurrentPreviewer(path) {
    return {type: 'DELETE', path: path.concat(['currentPreviewer'])};
  }
  /**
   * @returns {AssetPreviewerData_PreviewerPanel_AnimationPreviewer}
   */
  get animationPreviewer() {
    return this._hasAnimationPreviewer ? this._animationPreviewer : AssetPreviewerData_PreviewerPanel_AnimationPreviewer.default;
  }
  get hasAnimationPreviewer() {
    return this._hasAnimationPreviewer;
  }
  setAnimationPreviewer(path, value) {
    return {type: 'SET', path: path.concat(['animationPreviewer']), value: value.toJson()};
  }
  deleteAnimationPreviewer(path) {
    return {type: 'DELETE', path: path.concat(['animationPreviewer'])};
  }
  /**
   * @returns {AssetPreviewerData_PreviewerPanel_EffectPreviewer}
   */
  get effectPreviewer() {
    return this._hasEffectPreviewer ? this._effectPreviewer : AssetPreviewerData_PreviewerPanel_EffectPreviewer.default;
  }
  get hasEffectPreviewer() {
    return this._hasEffectPreviewer;
  }
  setEffectPreviewer(path, value) {
    return {type: 'SET', path: path.concat(['effectPreviewer']), value: value.toJson()};
  }
  deleteEffectPreviewer(path) {
    return {type: 'DELETE', path: path.concat(['effectPreviewer'])};
  }
  /**
   * @returns {AssetPreviewerData_PreviewerPanel_PropPreviewer}
   */
  get propPreviewer() {
    return this._hasPropPreviewer ? this._propPreviewer : AssetPreviewerData_PreviewerPanel_PropPreviewer.default;
  }
  get hasPropPreviewer() {
    return this._hasPropPreviewer;
  }
  setPropPreviewer(path, value) {
    return {type: 'SET', path: path.concat(['propPreviewer']), value: value.toJson()};
  }
  deletePropPreviewer(path) {
    return {type: 'DELETE', path: path.concat(['propPreviewer'])};
  }
  /**
   * @returns {AssetPreviewerData_PreviewerPanel_SpritePreviewer}
   */
  get spritePreviewer() {
    return this._hasSpritePreviewer ? this._spritePreviewer : AssetPreviewerData_PreviewerPanel_SpritePreviewer.default;
  }
  get hasSpritePreviewer() {
    return this._hasSpritePreviewer;
  }
  setSpritePreviewer(path, value) {
    return {type: 'SET', path: path.concat(['spritePreviewer']), value: value.toJson()};
  }
  deleteSpritePreviewer(path) {
    return {type: 'DELETE', path: path.concat(['spritePreviewer'])};
  }
  /**
   * @returns {AssetPreviewerData_PreviewerPanel_SoundPreviewer}
   */
  get soundPreviewer() {
    return this._hasSoundPreviewer ? this._soundPreviewer : AssetPreviewerData_PreviewerPanel_SoundPreviewer.default;
  }
  get hasSoundPreviewer() {
    return this._hasSoundPreviewer;
  }
  setSoundPreviewer(path, value) {
    return {type: 'SET', path: path.concat(['soundPreviewer']), value: value.toJson()};
  }
  deleteSoundPreviewer(path) {
    return {type: 'DELETE', path: path.concat(['soundPreviewer'])};
  }
  /**
   * @returns {AssetPreviewerData_PreviewerPanel_BeamPreviewer}
   */
  get beamPreviewer() {
    return this._hasBeamPreviewer ? this._beamPreviewer : AssetPreviewerData_PreviewerPanel_BeamPreviewer.default;
  }
  get hasBeamPreviewer() {
    return this._hasBeamPreviewer;
  }
  setBeamPreviewer(path, value) {
    return {type: 'SET', path: path.concat(['beamPreviewer']), value: value.toJson()};
  }
  deleteBeamPreviewer(path) {
    return {type: 'DELETE', path: path.concat(['beamPreviewer'])};
  }
  /**
   * @returns {number}
   */
  get resetCamera() {
    return this._hasResetCamera ? this._resetCamera : JsonToInt32.default;
  }
  get hasResetCamera() {
    return this._hasResetCamera;
  }
  setResetCamera(path, value) {
    return {type: 'SET', path: path.concat(['resetCamera']), value};
  }
  deleteResetCamera(path) {
    return {type: 'DELETE', path: path.concat(['resetCamera'])};
  }
  /**
   * @returns {boolean}
   */
  get hideGrid() {
    return this._hasHideGrid ? this._hideGrid : JsonToBoolean.default;
  }
  get hasHideGrid() {
    return this._hasHideGrid;
  }
  setHideGrid(path, value) {
    return {type: 'SET', path: path.concat(['hideGrid']), value};
  }
  deleteHideGrid(path) {
    return {type: 'DELETE', path: path.concat(['hideGrid'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "currentPreviewer": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel(this);
              copy._hasCurrentPreviewer = true;
              copy._currentPreviewer = AssetPreviewerData_PreviewerPanel_PreviewerType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentPreviewer) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel(this);
              copy._hasCurrentPreviewer = false;
              copy._currentPreviewer = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "animationPreviewer": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel(this);
              copy._hasAnimationPreviewer = true;
              copy._animationPreviewer = AssetPreviewerData_PreviewerPanel_AnimationPreviewer.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAnimationPreviewer) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel(this);
              copy._hasAnimationPreviewer = false;
              copy._animationPreviewer = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasAnimationPreviewer) {
            const copy = new AssetPreviewerData_PreviewerPanel(this);
            copy._hasAnimationPreviewer = true;
            copy._animationPreviewer = AssetPreviewerData_PreviewerPanel_AnimationPreviewer.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._animationPreviewer.apply(type, path.slice(1), value);
          if (newValue === this._animationPreviewer) {
            return this;
          }
          const copy = new AssetPreviewerData_PreviewerPanel(this);
          copy._animationPreviewer = copy._animationPreviewer.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "effectPreviewer": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel(this);
              copy._hasEffectPreviewer = true;
              copy._effectPreviewer = AssetPreviewerData_PreviewerPanel_EffectPreviewer.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEffectPreviewer) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel(this);
              copy._hasEffectPreviewer = false;
              copy._effectPreviewer = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasEffectPreviewer) {
            const copy = new AssetPreviewerData_PreviewerPanel(this);
            copy._hasEffectPreviewer = true;
            copy._effectPreviewer = AssetPreviewerData_PreviewerPanel_EffectPreviewer.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._effectPreviewer.apply(type, path.slice(1), value);
          if (newValue === this._effectPreviewer) {
            return this;
          }
          const copy = new AssetPreviewerData_PreviewerPanel(this);
          copy._effectPreviewer = copy._effectPreviewer.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "propPreviewer": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel(this);
              copy._hasPropPreviewer = true;
              copy._propPreviewer = AssetPreviewerData_PreviewerPanel_PropPreviewer.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPropPreviewer) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel(this);
              copy._hasPropPreviewer = false;
              copy._propPreviewer = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPropPreviewer) {
            const copy = new AssetPreviewerData_PreviewerPanel(this);
            copy._hasPropPreviewer = true;
            copy._propPreviewer = AssetPreviewerData_PreviewerPanel_PropPreviewer.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._propPreviewer.apply(type, path.slice(1), value);
          if (newValue === this._propPreviewer) {
            return this;
          }
          const copy = new AssetPreviewerData_PreviewerPanel(this);
          copy._propPreviewer = copy._propPreviewer.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "spritePreviewer": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel(this);
              copy._hasSpritePreviewer = true;
              copy._spritePreviewer = AssetPreviewerData_PreviewerPanel_SpritePreviewer.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSpritePreviewer) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel(this);
              copy._hasSpritePreviewer = false;
              copy._spritePreviewer = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasSpritePreviewer) {
            const copy = new AssetPreviewerData_PreviewerPanel(this);
            copy._hasSpritePreviewer = true;
            copy._spritePreviewer = AssetPreviewerData_PreviewerPanel_SpritePreviewer.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._spritePreviewer.apply(type, path.slice(1), value);
          if (newValue === this._spritePreviewer) {
            return this;
          }
          const copy = new AssetPreviewerData_PreviewerPanel(this);
          copy._spritePreviewer = copy._spritePreviewer.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "soundPreviewer": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel(this);
              copy._hasSoundPreviewer = true;
              copy._soundPreviewer = AssetPreviewerData_PreviewerPanel_SoundPreviewer.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSoundPreviewer) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel(this);
              copy._hasSoundPreviewer = false;
              copy._soundPreviewer = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasSoundPreviewer) {
            const copy = new AssetPreviewerData_PreviewerPanel(this);
            copy._hasSoundPreviewer = true;
            copy._soundPreviewer = AssetPreviewerData_PreviewerPanel_SoundPreviewer.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._soundPreviewer.apply(type, path.slice(1), value);
          if (newValue === this._soundPreviewer) {
            return this;
          }
          const copy = new AssetPreviewerData_PreviewerPanel(this);
          copy._soundPreviewer = copy._soundPreviewer.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "beamPreviewer": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel(this);
              copy._hasBeamPreviewer = true;
              copy._beamPreviewer = AssetPreviewerData_PreviewerPanel_BeamPreviewer.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBeamPreviewer) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel(this);
              copy._hasBeamPreviewer = false;
              copy._beamPreviewer = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasBeamPreviewer) {
            const copy = new AssetPreviewerData_PreviewerPanel(this);
            copy._hasBeamPreviewer = true;
            copy._beamPreviewer = AssetPreviewerData_PreviewerPanel_BeamPreviewer.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._beamPreviewer.apply(type, path.slice(1), value);
          if (newValue === this._beamPreviewer) {
            return this;
          }
          const copy = new AssetPreviewerData_PreviewerPanel(this);
          copy._beamPreviewer = copy._beamPreviewer.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "resetCamera": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel(this);
              copy._hasResetCamera = true;
              copy._resetCamera = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasResetCamera) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel(this);
              copy._hasResetCamera = false;
              copy._resetCamera = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "hideGrid": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData_PreviewerPanel(this);
              copy._hasHideGrid = true;
              copy._hideGrid = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHideGrid) {
                return this;
              }
              const copy = new AssetPreviewerData_PreviewerPanel(this);
              copy._hasHideGrid = false;
              copy._hideGrid = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {AssetPreviewerData_PreviewerPanel} other
   * @returns {AssetPreviewerData_PreviewerPanel}
   */
  merge(other) {
    const copy = new AssetPreviewerData_PreviewerPanel(this);
    if (other._hasCurrentPreviewer) {
      copy._hasCurrentPreviewer = true;
      copy._currentPreviewer = other._currentPreviewer;
    }
    if (other._hasAnimationPreviewer) {
      if (copy._hasAnimationPreviewer) {
        copy._animationPreviewer = copy.animationPreviewer.merge(other.animationPreviewer);
      } else {
        copy._animationPreviewer = other._animationPreviewer;
      }
      copy._hasAnimationPreviewer = true;
    }
    if (other._hasEffectPreviewer) {
      if (copy._hasEffectPreviewer) {
        copy._effectPreviewer = copy.effectPreviewer.merge(other.effectPreviewer);
      } else {
        copy._effectPreviewer = other._effectPreviewer;
      }
      copy._hasEffectPreviewer = true;
    }
    if (other._hasPropPreviewer) {
      if (copy._hasPropPreviewer) {
        copy._propPreviewer = copy.propPreviewer.merge(other.propPreviewer);
      } else {
        copy._propPreviewer = other._propPreviewer;
      }
      copy._hasPropPreviewer = true;
    }
    if (other._hasSpritePreviewer) {
      if (copy._hasSpritePreviewer) {
        copy._spritePreviewer = copy.spritePreviewer.merge(other.spritePreviewer);
      } else {
        copy._spritePreviewer = other._spritePreviewer;
      }
      copy._hasSpritePreviewer = true;
    }
    if (other._hasSoundPreviewer) {
      if (copy._hasSoundPreviewer) {
        copy._soundPreviewer = copy.soundPreviewer.merge(other.soundPreviewer);
      } else {
        copy._soundPreviewer = other._soundPreviewer;
      }
      copy._hasSoundPreviewer = true;
    }
    if (other._hasBeamPreviewer) {
      if (copy._hasBeamPreviewer) {
        copy._beamPreviewer = copy.beamPreviewer.merge(other.beamPreviewer);
      } else {
        copy._beamPreviewer = other._beamPreviewer;
      }
      copy._hasBeamPreviewer = true;
    }
    if (other._hasResetCamera) {
      copy._hasResetCamera = true;
      copy._resetCamera = other._resetCamera;
    }
    if (other._hasHideGrid) {
      copy._hasHideGrid = true;
      copy._hideGrid = other._hideGrid;
    }
    return copy;
  }
}
AssetPreviewerData_PreviewerPanel.default = new AssetPreviewerData_PreviewerPanel();
AssetPreviewerData_PreviewerPanel.AnimationPreviewer = AssetPreviewerData_PreviewerPanel_AnimationPreviewer;
AssetPreviewerData_PreviewerPanel.EffectPreviewer = AssetPreviewerData_PreviewerPanel_EffectPreviewer;
AssetPreviewerData_PreviewerPanel.PropPreviewer = AssetPreviewerData_PreviewerPanel_PropPreviewer;
AssetPreviewerData_PreviewerPanel.SpritePreviewer = AssetPreviewerData_PreviewerPanel_SpritePreviewer;
AssetPreviewerData_PreviewerPanel.SoundPreviewer = AssetPreviewerData_PreviewerPanel_SoundPreviewer;
AssetPreviewerData_PreviewerPanel.BeamPreviewer = AssetPreviewerData_PreviewerPanel_BeamPreviewer;
AssetPreviewerData_PreviewerPanel.PreviewerType = AssetPreviewerData_PreviewerPanel_PreviewerType;
class AssetPreviewerData_PreviewerPanel_Builder {
  constructor(value) {
    this._value = new AssetPreviewerData_PreviewerPanel(value);
  }
  build() {
    return new AssetPreviewerData_PreviewerPanel(this._value);
  }
  setCurrentPreviewer(value) {
    this._value._hasCurrentPreviewer = true;
    this._value._currentPreviewer = value;
    return this;
  }
  deleteCurrentPreviewer() {
    this._value._hasCurrentPreviewer = false;
    this._value._currentPreviewer = null;
    return this;
  }
  setAnimationPreviewer(value) {
    this._value._hasAnimationPreviewer = true;
    this._value._animationPreviewer = value;
    return this;
  }
  deleteAnimationPreviewer() {
    this._value._hasAnimationPreviewer = false;
    this._value._animationPreviewer = null;
    return this;
  }
  setEffectPreviewer(value) {
    this._value._hasEffectPreviewer = true;
    this._value._effectPreviewer = value;
    return this;
  }
  deleteEffectPreviewer() {
    this._value._hasEffectPreviewer = false;
    this._value._effectPreviewer = null;
    return this;
  }
  setPropPreviewer(value) {
    this._value._hasPropPreviewer = true;
    this._value._propPreviewer = value;
    return this;
  }
  deletePropPreviewer() {
    this._value._hasPropPreviewer = false;
    this._value._propPreviewer = null;
    return this;
  }
  setSpritePreviewer(value) {
    this._value._hasSpritePreviewer = true;
    this._value._spritePreviewer = value;
    return this;
  }
  deleteSpritePreviewer() {
    this._value._hasSpritePreviewer = false;
    this._value._spritePreviewer = null;
    return this;
  }
  setSoundPreviewer(value) {
    this._value._hasSoundPreviewer = true;
    this._value._soundPreviewer = value;
    return this;
  }
  deleteSoundPreviewer() {
    this._value._hasSoundPreviewer = false;
    this._value._soundPreviewer = null;
    return this;
  }
  setBeamPreviewer(value) {
    this._value._hasBeamPreviewer = true;
    this._value._beamPreviewer = value;
    return this;
  }
  deleteBeamPreviewer() {
    this._value._hasBeamPreviewer = false;
    this._value._beamPreviewer = null;
    return this;
  }
  setResetCamera(value) {
    this._value._hasResetCamera = true;
    this._value._resetCamera = value;
    return this;
  }
  deleteResetCamera() {
    this._value._hasResetCamera = false;
    this._value._resetCamera = null;
    return this;
  }
  setHideGrid(value) {
    this._value._hasHideGrid = true;
    this._value._hideGrid = value;
    return this;
  }
  deleteHideGrid() {
    this._value._hasHideGrid = false;
    this._value._hideGrid = null;
    return this;
  }
}
AssetPreviewerData_PreviewerPanel.Builder = AssetPreviewerData_PreviewerPanel_Builder;
class AssetPreviewerData_PreviewerPanel_WithParent {
  /**
   * @param {AssetPreviewerData_PreviewerPanel} value
   * @param {AssetPreviewerData_PreviewerPanel_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return AssetPreviewerData_PreviewerPanel.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCurrentPreviewer() {
    if (this._cachedHasCurrentPreviewer === undefined) {
      if (this._value.hasCurrentPreviewer) {
        this._cachedHasCurrentPreviewer = true;
      } else {
        this._cachedHasCurrentPreviewer = this._parent ? this._parent.hasCurrentPreviewer : false;
      }
    }
    return this._cachedHasCurrentPreviewer;
  }
  get currentPreviewer() {
    if (this._cachedCurrentPreviewer === undefined) {
      if (this._value.hasCurrentPreviewer) {
        this._cachedCurrentPreviewer = this._value.currentPreviewer;
      } else {
        this._cachedCurrentPreviewer = this._parent ? this._parent.currentPreviewer : this._value.currentPreviewer;
      }
    }
    return this._cachedCurrentPreviewer;
  }
  get hasAnimationPreviewer() {
    if (this._cachedHasAnimationPreviewer === undefined) {
      if (this._value.hasAnimationPreviewer) {
        this._cachedHasAnimationPreviewer = true;
      } else {
        this._cachedHasAnimationPreviewer = this._parent ? this._parent.hasAnimationPreviewer : false;
      }
    }
    return this._cachedHasAnimationPreviewer;
  }
  get animationPreviewer() {
    if (!this._cachedAnimationPreviewer) {
      if (this._value.hasAnimationPreviewer) {
        this._cachedAnimationPreviewer = new AssetPreviewerData_PreviewerPanel_AnimationPreviewer.WithParent(this._value.animationPreviewer, this._parent && this._parent.hasAnimationPreviewer ? this._parent.animationPreviewer : null);
      } else {
        this._cachedAnimationPreviewer = this._parent ? new AssetPreviewerData_PreviewerPanel_AnimationPreviewer.WithParent(AssetPreviewerData_PreviewerPanel_AnimationPreviewer.default, this._parent.animationPreviewer) : AssetPreviewerData_PreviewerPanel_AnimationPreviewer.WithParent.default;
      }
    }
    return this._cachedAnimationPreviewer;
  }
  get hasEffectPreviewer() {
    if (this._cachedHasEffectPreviewer === undefined) {
      if (this._value.hasEffectPreviewer) {
        this._cachedHasEffectPreviewer = true;
      } else {
        this._cachedHasEffectPreviewer = this._parent ? this._parent.hasEffectPreviewer : false;
      }
    }
    return this._cachedHasEffectPreviewer;
  }
  get effectPreviewer() {
    if (!this._cachedEffectPreviewer) {
      if (this._value.hasEffectPreviewer) {
        this._cachedEffectPreviewer = new AssetPreviewerData_PreviewerPanel_EffectPreviewer.WithParent(this._value.effectPreviewer, this._parent && this._parent.hasEffectPreviewer ? this._parent.effectPreviewer : null);
      } else {
        this._cachedEffectPreviewer = this._parent ? new AssetPreviewerData_PreviewerPanel_EffectPreviewer.WithParent(AssetPreviewerData_PreviewerPanel_EffectPreviewer.default, this._parent.effectPreviewer) : AssetPreviewerData_PreviewerPanel_EffectPreviewer.WithParent.default;
      }
    }
    return this._cachedEffectPreviewer;
  }
  get hasPropPreviewer() {
    if (this._cachedHasPropPreviewer === undefined) {
      if (this._value.hasPropPreviewer) {
        this._cachedHasPropPreviewer = true;
      } else {
        this._cachedHasPropPreviewer = this._parent ? this._parent.hasPropPreviewer : false;
      }
    }
    return this._cachedHasPropPreviewer;
  }
  get propPreviewer() {
    if (!this._cachedPropPreviewer) {
      if (this._value.hasPropPreviewer) {
        this._cachedPropPreviewer = new AssetPreviewerData_PreviewerPanel_PropPreviewer.WithParent(this._value.propPreviewer, this._parent && this._parent.hasPropPreviewer ? this._parent.propPreviewer : null);
      } else {
        this._cachedPropPreviewer = this._parent ? new AssetPreviewerData_PreviewerPanel_PropPreviewer.WithParent(AssetPreviewerData_PreviewerPanel_PropPreviewer.default, this._parent.propPreviewer) : AssetPreviewerData_PreviewerPanel_PropPreviewer.WithParent.default;
      }
    }
    return this._cachedPropPreviewer;
  }
  get hasSpritePreviewer() {
    if (this._cachedHasSpritePreviewer === undefined) {
      if (this._value.hasSpritePreviewer) {
        this._cachedHasSpritePreviewer = true;
      } else {
        this._cachedHasSpritePreviewer = this._parent ? this._parent.hasSpritePreviewer : false;
      }
    }
    return this._cachedHasSpritePreviewer;
  }
  get spritePreviewer() {
    if (!this._cachedSpritePreviewer) {
      if (this._value.hasSpritePreviewer) {
        this._cachedSpritePreviewer = new AssetPreviewerData_PreviewerPanel_SpritePreviewer.WithParent(this._value.spritePreviewer, this._parent && this._parent.hasSpritePreviewer ? this._parent.spritePreviewer : null);
      } else {
        this._cachedSpritePreviewer = this._parent ? new AssetPreviewerData_PreviewerPanel_SpritePreviewer.WithParent(AssetPreviewerData_PreviewerPanel_SpritePreviewer.default, this._parent.spritePreviewer) : AssetPreviewerData_PreviewerPanel_SpritePreviewer.WithParent.default;
      }
    }
    return this._cachedSpritePreviewer;
  }
  get hasSoundPreviewer() {
    if (this._cachedHasSoundPreviewer === undefined) {
      if (this._value.hasSoundPreviewer) {
        this._cachedHasSoundPreviewer = true;
      } else {
        this._cachedHasSoundPreviewer = this._parent ? this._parent.hasSoundPreviewer : false;
      }
    }
    return this._cachedHasSoundPreviewer;
  }
  get soundPreviewer() {
    if (!this._cachedSoundPreviewer) {
      if (this._value.hasSoundPreviewer) {
        this._cachedSoundPreviewer = new AssetPreviewerData_PreviewerPanel_SoundPreviewer.WithParent(this._value.soundPreviewer, this._parent && this._parent.hasSoundPreviewer ? this._parent.soundPreviewer : null);
      } else {
        this._cachedSoundPreviewer = this._parent ? new AssetPreviewerData_PreviewerPanel_SoundPreviewer.WithParent(AssetPreviewerData_PreviewerPanel_SoundPreviewer.default, this._parent.soundPreviewer) : AssetPreviewerData_PreviewerPanel_SoundPreviewer.WithParent.default;
      }
    }
    return this._cachedSoundPreviewer;
  }
  get hasBeamPreviewer() {
    if (this._cachedHasBeamPreviewer === undefined) {
      if (this._value.hasBeamPreviewer) {
        this._cachedHasBeamPreviewer = true;
      } else {
        this._cachedHasBeamPreviewer = this._parent ? this._parent.hasBeamPreviewer : false;
      }
    }
    return this._cachedHasBeamPreviewer;
  }
  get beamPreviewer() {
    if (!this._cachedBeamPreviewer) {
      if (this._value.hasBeamPreviewer) {
        this._cachedBeamPreviewer = new AssetPreviewerData_PreviewerPanel_BeamPreviewer.WithParent(this._value.beamPreviewer, this._parent && this._parent.hasBeamPreviewer ? this._parent.beamPreviewer : null);
      } else {
        this._cachedBeamPreviewer = this._parent ? new AssetPreviewerData_PreviewerPanel_BeamPreviewer.WithParent(AssetPreviewerData_PreviewerPanel_BeamPreviewer.default, this._parent.beamPreviewer) : AssetPreviewerData_PreviewerPanel_BeamPreviewer.WithParent.default;
      }
    }
    return this._cachedBeamPreviewer;
  }
  get hasResetCamera() {
    if (this._cachedHasResetCamera === undefined) {
      if (this._value.hasResetCamera) {
        this._cachedHasResetCamera = true;
      } else {
        this._cachedHasResetCamera = this._parent ? this._parent.hasResetCamera : false;
      }
    }
    return this._cachedHasResetCamera;
  }
  get resetCamera() {
    if (this._cachedResetCamera === undefined) {
      if (this._value.hasResetCamera) {
        this._cachedResetCamera = this._value.resetCamera;
      } else {
        this._cachedResetCamera = this._parent ? this._parent.resetCamera : this._value.resetCamera;
      }
    }
    return this._cachedResetCamera;
  }
  get hasHideGrid() {
    if (this._cachedHasHideGrid === undefined) {
      if (this._value.hasHideGrid) {
        this._cachedHasHideGrid = true;
      } else {
        this._cachedHasHideGrid = this._parent ? this._parent.hasHideGrid : false;
      }
    }
    return this._cachedHasHideGrid;
  }
  get hideGrid() {
    if (this._cachedHideGrid === undefined) {
      if (this._value.hasHideGrid) {
        this._cachedHideGrid = this._value.hideGrid;
      } else {
        this._cachedHideGrid = this._parent ? this._parent.hideGrid : this._value.hideGrid;
      }
    }
    return this._cachedHideGrid;
  }
  update(current, parent) {
    const result = new AssetPreviewerData_PreviewerPanel_WithParent(current, parent);
    if (this._cachedAnimationPreviewer && this._value.hasAnimationPreviewer && current.hasAnimationPreviewer) {
      if (this._value.animationPreviewer === current.animationPreviewer && this._parent === parent) {
        result._cachedAnimationPreviewer = this._cachedAnimationPreviewer;
      } else {
        result._cachedAnimationPreviewer = this._cachedAnimationPreviewer.update(current.animationPreviewer, parent && parent.hasAnimationPreviewer ? parent.animationPreviewer : null);
      }
    }
    if (this._cachedEffectPreviewer && this._value.hasEffectPreviewer && current.hasEffectPreviewer) {
      if (this._value.effectPreviewer === current.effectPreviewer && this._parent === parent) {
        result._cachedEffectPreviewer = this._cachedEffectPreviewer;
      } else {
        result._cachedEffectPreviewer = this._cachedEffectPreviewer.update(current.effectPreviewer, parent && parent.hasEffectPreviewer ? parent.effectPreviewer : null);
      }
    }
    if (this._cachedPropPreviewer && this._value.hasPropPreviewer && current.hasPropPreviewer) {
      if (this._value.propPreviewer === current.propPreviewer && this._parent === parent) {
        result._cachedPropPreviewer = this._cachedPropPreviewer;
      } else {
        result._cachedPropPreviewer = this._cachedPropPreviewer.update(current.propPreviewer, parent && parent.hasPropPreviewer ? parent.propPreviewer : null);
      }
    }
    if (this._cachedSpritePreviewer && this._value.hasSpritePreviewer && current.hasSpritePreviewer) {
      if (this._value.spritePreviewer === current.spritePreviewer && this._parent === parent) {
        result._cachedSpritePreviewer = this._cachedSpritePreviewer;
      } else {
        result._cachedSpritePreviewer = this._cachedSpritePreviewer.update(current.spritePreviewer, parent && parent.hasSpritePreviewer ? parent.spritePreviewer : null);
      }
    }
    if (this._cachedSoundPreviewer && this._value.hasSoundPreviewer && current.hasSoundPreviewer) {
      if (this._value.soundPreviewer === current.soundPreviewer && this._parent === parent) {
        result._cachedSoundPreviewer = this._cachedSoundPreviewer;
      } else {
        result._cachedSoundPreviewer = this._cachedSoundPreviewer.update(current.soundPreviewer, parent && parent.hasSoundPreviewer ? parent.soundPreviewer : null);
      }
    }
    if (this._cachedBeamPreviewer && this._value.hasBeamPreviewer && current.hasBeamPreviewer) {
      if (this._value.beamPreviewer === current.beamPreviewer && this._parent === parent) {
        result._cachedBeamPreviewer = this._cachedBeamPreviewer;
      } else {
        result._cachedBeamPreviewer = this._cachedBeamPreviewer.update(current.beamPreviewer, parent && parent.hasBeamPreviewer ? parent.beamPreviewer : null);
      }
    }
    return result;
  }
}
AssetPreviewerData_PreviewerPanel_WithParent.default = new AssetPreviewerData_PreviewerPanel_WithParent(AssetPreviewerData_PreviewerPanel.default, null);
AssetPreviewerData_PreviewerPanel.WithParent = AssetPreviewerData_PreviewerPanel_WithParent;
class AssetPreviewerData_PreviewerPanel_Descriptor {
  get currentPreviewer() {
    if (!this._currentPreviewer) {
      this._currentPreviewer = {
        name: "currentPreviewer",
        Name: "CurrentPreviewer",
        number: 1,
        protoType: 14,
        protoName: "current_previewer",
        type: AssetPreviewerData_PreviewerPanel_PreviewerType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentPreviewer;
  }
  get animationPreviewer() {
    if (!this._animationPreviewer) {
      this._animationPreviewer = {
        name: "animationPreviewer",
        Name: "AnimationPreviewer",
        number: 2,
        protoType: 11,
        protoName: "animation_previewer",
        type: AssetPreviewerData_PreviewerPanel_AnimationPreviewer,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._animationPreviewer;
  }
  get effectPreviewer() {
    if (!this._effectPreviewer) {
      this._effectPreviewer = {
        name: "effectPreviewer",
        Name: "EffectPreviewer",
        number: 3,
        protoType: 11,
        protoName: "effect_previewer",
        type: AssetPreviewerData_PreviewerPanel_EffectPreviewer,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._effectPreviewer;
  }
  get propPreviewer() {
    if (!this._propPreviewer) {
      this._propPreviewer = {
        name: "propPreviewer",
        Name: "PropPreviewer",
        number: 4,
        protoType: 11,
        protoName: "prop_previewer",
        type: AssetPreviewerData_PreviewerPanel_PropPreviewer,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._propPreviewer;
  }
  get spritePreviewer() {
    if (!this._spritePreviewer) {
      this._spritePreviewer = {
        name: "spritePreviewer",
        Name: "SpritePreviewer",
        number: 5,
        protoType: 11,
        protoName: "sprite_previewer",
        type: AssetPreviewerData_PreviewerPanel_SpritePreviewer,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._spritePreviewer;
  }
  get soundPreviewer() {
    if (!this._soundPreviewer) {
      this._soundPreviewer = {
        name: "soundPreviewer",
        Name: "SoundPreviewer",
        number: 6,
        protoType: 11,
        protoName: "sound_previewer",
        type: AssetPreviewerData_PreviewerPanel_SoundPreviewer,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._soundPreviewer;
  }
  get beamPreviewer() {
    if (!this._beamPreviewer) {
      this._beamPreviewer = {
        name: "beamPreviewer",
        Name: "BeamPreviewer",
        number: 7,
        protoType: 11,
        protoName: "beam_previewer",
        type: AssetPreviewerData_PreviewerPanel_BeamPreviewer,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._beamPreviewer;
  }
  get resetCamera() {
    if (!this._resetCamera) {
      this._resetCamera = {
        name: "resetCamera",
        Name: "ResetCamera",
        number: 11,
        protoType: 5,
        protoName: "reset_camera",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._resetCamera;
  }
  get hideGrid() {
    if (!this._hideGrid) {
      this._hideGrid = {
        name: "hideGrid",
        Name: "HideGrid",
        number: 12,
        protoType: 8,
        protoName: "hide_grid",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hideGrid;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.currentPreviewer,
        this.animationPreviewer,
        this.effectPreviewer,
        this.propPreviewer,
        this.spritePreviewer,
        this.soundPreviewer,
        this.beamPreviewer,
        this.resetCamera,
        this.hideGrid,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCurrentPreviewer",
        Name: "DummyOneofForCurrentPreviewer",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAnimationPreviewer",
        Name: "DummyOneofForAnimationPreviewer",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEffectPreviewer",
        Name: "DummyOneofForEffectPreviewer",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPropPreviewer",
        Name: "DummyOneofForPropPreviewer",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSpritePreviewer",
        Name: "DummyOneofForSpritePreviewer",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSoundPreviewer",
        Name: "DummyOneofForSoundPreviewer",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBeamPreviewer",
        Name: "DummyOneofForBeamPreviewer",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForResetCamera",
        Name: "DummyOneofForResetCamera",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHideGrid",
        Name: "DummyOneofForHideGrid",
        fields: [
          this.fields[8],
        ],
      });
    }
    return this._oneofs;
  }
}
AssetPreviewerData_PreviewerPanel.descriptor = new AssetPreviewerData_PreviewerPanel_Descriptor();
export class AssetPreviewerData {
  get descriptor() {
    return AssetPreviewerData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPreviewerPanel = false;
    this._previewerPanel = null;
  }
  isEmpty() {
    if (this._hasPreviewerPanel && !this._previewerPanel.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof AssetPreviewerData) {
      return value;
    }
    return AssetPreviewerData.fromJson(value);
  }
  static fromJson(json) {
    const result = new AssetPreviewerData();
    if (json.previewerPanel != null) {
      result._hasPreviewerPanel = true;
      result._previewerPanel = AssetPreviewerData_PreviewerPanel.fromJson(json.previewerPanel);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPreviewerPanel && !this._previewerPanel.isEmpty()) {
      result.previewerPanel = AssetPreviewerData_PreviewerPanel.toJson(this._previewerPanel);
    }
    return result;
  }
  /**
   * @returns {AssetPreviewerData_PreviewerPanel}
   */
  get previewerPanel() {
    return this._hasPreviewerPanel ? this._previewerPanel : AssetPreviewerData_PreviewerPanel.default;
  }
  get hasPreviewerPanel() {
    return this._hasPreviewerPanel;
  }
  setPreviewerPanel(path, value) {
    return {type: 'SET', path: path.concat(['previewerPanel']), value: value.toJson()};
  }
  deletePreviewerPanel(path) {
    return {type: 'DELETE', path: path.concat(['previewerPanel'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "previewerPanel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssetPreviewerData(this);
              copy._hasPreviewerPanel = true;
              copy._previewerPanel = AssetPreviewerData_PreviewerPanel.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPreviewerPanel) {
                return this;
              }
              const copy = new AssetPreviewerData(this);
              copy._hasPreviewerPanel = false;
              copy._previewerPanel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPreviewerPanel) {
            const copy = new AssetPreviewerData(this);
            copy._hasPreviewerPanel = true;
            copy._previewerPanel = AssetPreviewerData_PreviewerPanel.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._previewerPanel.apply(type, path.slice(1), value);
          if (newValue === this._previewerPanel) {
            return this;
          }
          const copy = new AssetPreviewerData(this);
          copy._previewerPanel = copy._previewerPanel.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {AssetPreviewerData} other
   * @returns {AssetPreviewerData}
   */
  merge(other) {
    const copy = new AssetPreviewerData(this);
    if (other._hasPreviewerPanel) {
      if (copy._hasPreviewerPanel) {
        copy._previewerPanel = copy.previewerPanel.merge(other.previewerPanel);
      } else {
        copy._previewerPanel = other._previewerPanel;
      }
      copy._hasPreviewerPanel = true;
    }
    return copy;
  }
}
AssetPreviewerData.default = new AssetPreviewerData();
AssetPreviewerData.PreviewerPanel = AssetPreviewerData_PreviewerPanel;
class AssetPreviewerData_Builder {
  constructor(value) {
    this._value = new AssetPreviewerData(value);
  }
  build() {
    return new AssetPreviewerData(this._value);
  }
  setPreviewerPanel(value) {
    this._value._hasPreviewerPanel = true;
    this._value._previewerPanel = value;
    return this;
  }
  deletePreviewerPanel() {
    this._value._hasPreviewerPanel = false;
    this._value._previewerPanel = null;
    return this;
  }
}
AssetPreviewerData.Builder = AssetPreviewerData_Builder;
class AssetPreviewerData_WithParent {
  /**
   * @param {AssetPreviewerData} value
   * @param {AssetPreviewerData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return AssetPreviewerData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPreviewerPanel() {
    if (this._cachedHasPreviewerPanel === undefined) {
      if (this._value.hasPreviewerPanel) {
        this._cachedHasPreviewerPanel = true;
      } else {
        this._cachedHasPreviewerPanel = this._parent ? this._parent.hasPreviewerPanel : false;
      }
    }
    return this._cachedHasPreviewerPanel;
  }
  get previewerPanel() {
    if (!this._cachedPreviewerPanel) {
      if (this._value.hasPreviewerPanel) {
        this._cachedPreviewerPanel = new AssetPreviewerData_PreviewerPanel.WithParent(this._value.previewerPanel, this._parent && this._parent.hasPreviewerPanel ? this._parent.previewerPanel : null);
      } else {
        this._cachedPreviewerPanel = this._parent ? new AssetPreviewerData_PreviewerPanel.WithParent(AssetPreviewerData_PreviewerPanel.default, this._parent.previewerPanel) : AssetPreviewerData_PreviewerPanel.WithParent.default;
      }
    }
    return this._cachedPreviewerPanel;
  }
  update(current, parent) {
    const result = new AssetPreviewerData_WithParent(current, parent);
    if (this._cachedPreviewerPanel && this._value.hasPreviewerPanel && current.hasPreviewerPanel) {
      if (this._value.previewerPanel === current.previewerPanel && this._parent === parent) {
        result._cachedPreviewerPanel = this._cachedPreviewerPanel;
      } else {
        result._cachedPreviewerPanel = this._cachedPreviewerPanel.update(current.previewerPanel, parent && parent.hasPreviewerPanel ? parent.previewerPanel : null);
      }
    }
    return result;
  }
}
AssetPreviewerData_WithParent.default = new AssetPreviewerData_WithParent(AssetPreviewerData.default, null);
AssetPreviewerData.WithParent = AssetPreviewerData_WithParent;
class AssetPreviewerData_Descriptor {
  get previewerPanel() {
    if (!this._previewerPanel) {
      this._previewerPanel = {
        name: "previewerPanel",
        Name: "PreviewerPanel",
        number: 1,
        protoType: 11,
        protoName: "previewer_panel",
        type: AssetPreviewerData_PreviewerPanel,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._previewerPanel;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.previewerPanel,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPreviewerPanel",
        Name: "DummyOneofForPreviewerPanel",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
AssetPreviewerData.descriptor = new AssetPreviewerData_Descriptor();
class TerrainEditorData_EditorPanel_TileEditor_MapSize {
  get descriptor() {
    return TerrainEditorData_EditorPanel_TileEditor_MapSize.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasMapWidth = false;
    this._mapWidth = null;
    this._hasMapHeight = false;
    this._mapHeight = null;
  }
  isEmpty() {
    if (this._hasMapWidth) return false;
    if (this._hasMapHeight) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TerrainEditorData_EditorPanel_TileEditor_MapSize) {
      return value;
    }
    return TerrainEditorData_EditorPanel_TileEditor_MapSize.fromJson(value);
  }
  static fromJson(json) {
    const result = new TerrainEditorData_EditorPanel_TileEditor_MapSize();
    if (json.mapWidth != null) {
      result._hasMapWidth = true;
      result._mapWidth = JsonToInt32.fromJson(json.mapWidth);
    }
    if (json.mapHeight != null) {
      result._hasMapHeight = true;
      result._mapHeight = JsonToInt32.fromJson(json.mapHeight);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasMapWidth) {
      result.mapWidth = JsonToInt32.toJson(this._mapWidth);
    }
    if (this._hasMapHeight) {
      result.mapHeight = JsonToInt32.toJson(this._mapHeight);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get mapWidth() {
    return this._hasMapWidth ? this._mapWidth : JsonToInt32.default;
  }
  get hasMapWidth() {
    return this._hasMapWidth;
  }
  setMapWidth(path, value) {
    return {type: 'SET', path: path.concat(['mapWidth']), value};
  }
  deleteMapWidth(path) {
    return {type: 'DELETE', path: path.concat(['mapWidth'])};
  }
  /**
   * @returns {number}
   */
  get mapHeight() {
    return this._hasMapHeight ? this._mapHeight : JsonToInt32.default;
  }
  get hasMapHeight() {
    return this._hasMapHeight;
  }
  setMapHeight(path, value) {
    return {type: 'SET', path: path.concat(['mapHeight']), value};
  }
  deleteMapHeight(path) {
    return {type: 'DELETE', path: path.concat(['mapHeight'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "mapWidth": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor_MapSize(this);
              copy._hasMapWidth = true;
              copy._mapWidth = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMapWidth) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_TileEditor_MapSize(this);
              copy._hasMapWidth = false;
              copy._mapWidth = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "mapHeight": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor_MapSize(this);
              copy._hasMapHeight = true;
              copy._mapHeight = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMapHeight) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_TileEditor_MapSize(this);
              copy._hasMapHeight = false;
              copy._mapHeight = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TerrainEditorData_EditorPanel_TileEditor_MapSize} other
   * @returns {TerrainEditorData_EditorPanel_TileEditor_MapSize}
   */
  merge(other) {
    const copy = new TerrainEditorData_EditorPanel_TileEditor_MapSize(this);
    if (other._hasMapWidth) {
      copy._hasMapWidth = true;
      copy._mapWidth = other._mapWidth;
    }
    if (other._hasMapHeight) {
      copy._hasMapHeight = true;
      copy._mapHeight = other._mapHeight;
    }
    return copy;
  }
}
TerrainEditorData_EditorPanel_TileEditor_MapSize.default = new TerrainEditorData_EditorPanel_TileEditor_MapSize();
class TerrainEditorData_EditorPanel_TileEditor_MapSize_Builder {
  constructor(value) {
    this._value = new TerrainEditorData_EditorPanel_TileEditor_MapSize(value);
  }
  build() {
    return new TerrainEditorData_EditorPanel_TileEditor_MapSize(this._value);
  }
  setMapWidth(value) {
    this._value._hasMapWidth = true;
    this._value._mapWidth = value;
    return this;
  }
  deleteMapWidth() {
    this._value._hasMapWidth = false;
    this._value._mapWidth = null;
    return this;
  }
  setMapHeight(value) {
    this._value._hasMapHeight = true;
    this._value._mapHeight = value;
    return this;
  }
  deleteMapHeight() {
    this._value._hasMapHeight = false;
    this._value._mapHeight = null;
    return this;
  }
}
TerrainEditorData_EditorPanel_TileEditor_MapSize.Builder = TerrainEditorData_EditorPanel_TileEditor_MapSize_Builder;
class TerrainEditorData_EditorPanel_TileEditor_MapSize_WithParent {
  /**
   * @param {TerrainEditorData_EditorPanel_TileEditor_MapSize} value
   * @param {TerrainEditorData_EditorPanel_TileEditor_MapSize_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TerrainEditorData_EditorPanel_TileEditor_MapSize.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasMapWidth() {
    if (this._cachedHasMapWidth === undefined) {
      if (this._value.hasMapWidth) {
        this._cachedHasMapWidth = true;
      } else {
        this._cachedHasMapWidth = this._parent ? this._parent.hasMapWidth : false;
      }
    }
    return this._cachedHasMapWidth;
  }
  get mapWidth() {
    if (this._cachedMapWidth === undefined) {
      if (this._value.hasMapWidth) {
        this._cachedMapWidth = this._value.mapWidth;
      } else {
        this._cachedMapWidth = this._parent ? this._parent.mapWidth : this._value.mapWidth;
      }
    }
    return this._cachedMapWidth;
  }
  get hasMapHeight() {
    if (this._cachedHasMapHeight === undefined) {
      if (this._value.hasMapHeight) {
        this._cachedHasMapHeight = true;
      } else {
        this._cachedHasMapHeight = this._parent ? this._parent.hasMapHeight : false;
      }
    }
    return this._cachedHasMapHeight;
  }
  get mapHeight() {
    if (this._cachedMapHeight === undefined) {
      if (this._value.hasMapHeight) {
        this._cachedMapHeight = this._value.mapHeight;
      } else {
        this._cachedMapHeight = this._parent ? this._parent.mapHeight : this._value.mapHeight;
      }
    }
    return this._cachedMapHeight;
  }
  update(current, parent) {
    const result = new TerrainEditorData_EditorPanel_TileEditor_MapSize_WithParent(current, parent);
    return result;
  }
}
TerrainEditorData_EditorPanel_TileEditor_MapSize_WithParent.default = new TerrainEditorData_EditorPanel_TileEditor_MapSize_WithParent(TerrainEditorData_EditorPanel_TileEditor_MapSize.default, null);
TerrainEditorData_EditorPanel_TileEditor_MapSize.WithParent = TerrainEditorData_EditorPanel_TileEditor_MapSize_WithParent;
class TerrainEditorData_EditorPanel_TileEditor_MapSize_Descriptor {
  get mapWidth() {
    if (!this._mapWidth) {
      this._mapWidth = {
        name: "mapWidth",
        Name: "MapWidth",
        number: 1,
        protoType: 5,
        protoName: "map_width",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapWidth;
  }
  get mapHeight() {
    if (!this._mapHeight) {
      this._mapHeight = {
        name: "mapHeight",
        Name: "MapHeight",
        number: 2,
        protoType: 5,
        protoName: "map_height",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapHeight;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.mapWidth,
        this.mapHeight,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForMapWidth",
        Name: "DummyOneofForMapWidth",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMapHeight",
        Name: "DummyOneofForMapHeight",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
TerrainEditorData_EditorPanel_TileEditor_MapSize.descriptor = new TerrainEditorData_EditorPanel_TileEditor_MapSize_Descriptor();
class TerrainEditorData_EditorPanel_TileEditor_BrushType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "TEXTURE_BRUSH": return 0;
        case "CLIFF_BRUSH": return 1;
        case "BORDER_BRUSH": return 2;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return TerrainEditorData_EditorPanel_TileEditor_BrushType.fromJson(value);
  }
  static fromReact(e) {
    return TerrainEditorData_EditorPanel_TileEditor_BrushType.fromJson(e);
  }
}
TerrainEditorData_EditorPanel_TileEditor_BrushType.TEXTURE_BRUSH = 0;
TerrainEditorData_EditorPanel_TileEditor_BrushType.CLIFF_BRUSH = 1;
TerrainEditorData_EditorPanel_TileEditor_BrushType.BORDER_BRUSH = 2;
TerrainEditorData_EditorPanel_TileEditor_BrushType.default = 0;
TerrainEditorData_EditorPanel_TileEditor_BrushType.values = {
  TEXTURE_BRUSH: 0,
  CLIFF_BRUSH: 1,
  BORDER_BRUSH: 2,
};
TerrainEditorData_EditorPanel_TileEditor_BrushType.names = {
  0: "TEXTURE_BRUSH",
  1: "CLIFF_BRUSH",
  2: "BORDER_BRUSH",
};
class TerrainEditorData_EditorPanel_TileEditor {
  get descriptor() {
    return TerrainEditorData_EditorPanel_TileEditor.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCurrentBrush = false;
    this._currentBrush = null;
    this._hasCliffHeight = false;
    this._cliffHeight = null;
    this._hasTextureChannel = false;
    this._textureChannel = null;
    this._hasTexturePaint = false;
    this._texturePaint = null;
    this._hasBorderPaint = false;
    this._borderPaint = null;
    this._hasBrushSize = false;
    this._brushSize = null;
    this._presets = [];
    this._hasCurrentPresetId = false;
    this._currentPresetId = null;
    this._hasMapSize = false;
    this._mapSize = null;
    this._hasCurrentPostEffect = false;
    this._currentPostEffect = null;
    this._hasShowNavmesh = false;
    this._showNavmesh = null;
    this._hasScanStatus = false;
    this._scanStatus = null;
    this._currentTileTexturePaths = [];
    this._hasCliffClamp = false;
    this._cliffClamp = null;
    this._hasDisableBorder = false;
    this._disableBorder = null;
    this._hasHideGrid = false;
    this._hideGrid = null;
    this._hasReset = false;
    this._reset = null;
  }
  isEmpty() {
    if (this._hasCurrentBrush) return false;
    if (this._hasCliffHeight) return false;
    if (this._hasTextureChannel) return false;
    if (this._hasTexturePaint) return false;
    if (this._hasBorderPaint) return false;
    if (this._hasBrushSize) return false;
    if (this._presets.length > 0) return false;
    if (this._hasCurrentPresetId) return false;
    if (this._hasMapSize && !this._mapSize.isEmpty()) return false;
    if (this._hasCurrentPostEffect) return false;
    if (this._hasShowNavmesh) return false;
    if (this._hasScanStatus) return false;
    if (this._currentTileTexturePaths.length > 0) return false;
    if (this._hasCliffClamp) return false;
    if (this._hasDisableBorder) return false;
    if (this._hasHideGrid) return false;
    if (this._hasReset) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TerrainEditorData_EditorPanel_TileEditor) {
      return value;
    }
    return TerrainEditorData_EditorPanel_TileEditor.fromJson(value);
  }
  static fromJson(json) {
    const result = new TerrainEditorData_EditorPanel_TileEditor();
    if (json.currentBrush != null) {
      result._hasCurrentBrush = true;
      result._currentBrush = TerrainEditorData_EditorPanel_TileEditor_BrushType.fromJson(json.currentBrush);
    }
    if (json.cliffHeight != null) {
      result._hasCliffHeight = true;
      result._cliffHeight = JsonToInt32.fromJson(json.cliffHeight);
    }
    if (json.textureChannel != null) {
      result._hasTextureChannel = true;
      result._textureChannel = JsonToInt32.fromJson(json.textureChannel);
    }
    if (json.texturePaint != null) {
      result._hasTexturePaint = true;
      result._texturePaint = JsonToBoolean.fromJson(json.texturePaint);
    }
    if (json.borderPaint != null) {
      result._hasBorderPaint = true;
      result._borderPaint = JsonToBoolean.fromJson(json.borderPaint);
    }
    if (json.brushSize != null) {
      result._hasBrushSize = true;
      result._brushSize = JsonToInt32.fromJson(json.brushSize);
    }
    result._presets = JsonToList(json.presets, JsonToString);
    if (json.currentPresetId != null) {
      result._hasCurrentPresetId = true;
      result._currentPresetId = JsonToInt32.fromJson(json.currentPresetId);
    }
    if (json.mapSize != null) {
      result._hasMapSize = true;
      result._mapSize = TerrainEditorData_EditorPanel_TileEditor_MapSize.fromJson(json.mapSize);
    }
    if (json.currentPostEffect != null) {
      result._hasCurrentPostEffect = true;
      result._currentPostEffect = JsonToString.fromJson(json.currentPostEffect);
    }
    if (json.showNavmesh != null) {
      result._hasShowNavmesh = true;
      result._showNavmesh = JsonToBoolean.fromJson(json.showNavmesh);
    }
    if (json.scanStatus != null) {
      result._hasScanStatus = true;
      result._scanStatus = JsonToBoolean.fromJson(json.scanStatus);
    }
    result._currentTileTexturePaths = JsonToList(json.currentTileTexturePaths, JsonToString);
    if (json.cliffClamp != null) {
      result._hasCliffClamp = true;
      result._cliffClamp = JsonToBoolean.fromJson(json.cliffClamp);
    }
    if (json.disableBorder != null) {
      result._hasDisableBorder = true;
      result._disableBorder = JsonToBoolean.fromJson(json.disableBorder);
    }
    if (json.hideGrid != null) {
      result._hasHideGrid = true;
      result._hideGrid = JsonToBoolean.fromJson(json.hideGrid);
    }
    if (json.reset != null) {
      result._hasReset = true;
      result._reset = JsonToBoolean.fromJson(json.reset);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCurrentBrush) {
      result.currentBrush = TerrainEditorData_EditorPanel_TileEditor_BrushType.toJson(this._currentBrush);
    }
    if (this._hasCliffHeight) {
      result.cliffHeight = JsonToInt32.toJson(this._cliffHeight);
    }
    if (this._hasTextureChannel) {
      result.textureChannel = JsonToInt32.toJson(this._textureChannel);
    }
    if (this._hasTexturePaint) {
      result.texturePaint = JsonToBoolean.toJson(this._texturePaint);
    }
    if (this._hasBorderPaint) {
      result.borderPaint = JsonToBoolean.toJson(this._borderPaint);
    }
    if (this._hasBrushSize) {
      result.brushSize = JsonToInt32.toJson(this._brushSize);
    }
    if (this._presets.length > 0) {
      result.presets = ArrayToJson(this._presets, JsonToString);
    }
    if (this._hasCurrentPresetId) {
      result.currentPresetId = JsonToInt32.toJson(this._currentPresetId);
    }
    if (this._hasMapSize && !this._mapSize.isEmpty()) {
      result.mapSize = TerrainEditorData_EditorPanel_TileEditor_MapSize.toJson(this._mapSize);
    }
    if (this._hasCurrentPostEffect) {
      result.currentPostEffect = JsonToString.toJson(this._currentPostEffect);
    }
    if (this._hasShowNavmesh) {
      result.showNavmesh = JsonToBoolean.toJson(this._showNavmesh);
    }
    if (this._hasScanStatus) {
      result.scanStatus = JsonToBoolean.toJson(this._scanStatus);
    }
    if (this._currentTileTexturePaths.length > 0) {
      result.currentTileTexturePaths = ArrayToJson(this._currentTileTexturePaths, JsonToString);
    }
    if (this._hasCliffClamp) {
      result.cliffClamp = JsonToBoolean.toJson(this._cliffClamp);
    }
    if (this._hasDisableBorder) {
      result.disableBorder = JsonToBoolean.toJson(this._disableBorder);
    }
    if (this._hasHideGrid) {
      result.hideGrid = JsonToBoolean.toJson(this._hideGrid);
    }
    if (this._hasReset) {
      result.reset = JsonToBoolean.toJson(this._reset);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get currentBrush() {
    return this._hasCurrentBrush ? this._currentBrush : TerrainEditorData_EditorPanel_TileEditor_BrushType.default;
  }
  get hasCurrentBrush() {
    return this._hasCurrentBrush;
  }
  setCurrentBrush(path, value) {
    return {type: 'SET', path: path.concat(['currentBrush']), value};
  }
  deleteCurrentBrush(path) {
    return {type: 'DELETE', path: path.concat(['currentBrush'])};
  }
  /**
   * @returns {number}
   */
  get cliffHeight() {
    return this._hasCliffHeight ? this._cliffHeight : JsonToInt32.default;
  }
  get hasCliffHeight() {
    return this._hasCliffHeight;
  }
  setCliffHeight(path, value) {
    return {type: 'SET', path: path.concat(['cliffHeight']), value};
  }
  deleteCliffHeight(path) {
    return {type: 'DELETE', path: path.concat(['cliffHeight'])};
  }
  /**
   * @returns {number}
   */
  get textureChannel() {
    return this._hasTextureChannel ? this._textureChannel : JsonToInt32.default;
  }
  get hasTextureChannel() {
    return this._hasTextureChannel;
  }
  setTextureChannel(path, value) {
    return {type: 'SET', path: path.concat(['textureChannel']), value};
  }
  deleteTextureChannel(path) {
    return {type: 'DELETE', path: path.concat(['textureChannel'])};
  }
  /**
   * @returns {boolean}
   */
  get texturePaint() {
    return this._hasTexturePaint ? this._texturePaint : JsonToBoolean.default;
  }
  get hasTexturePaint() {
    return this._hasTexturePaint;
  }
  setTexturePaint(path, value) {
    return {type: 'SET', path: path.concat(['texturePaint']), value};
  }
  deleteTexturePaint(path) {
    return {type: 'DELETE', path: path.concat(['texturePaint'])};
  }
  /**
   * @returns {boolean}
   */
  get borderPaint() {
    return this._hasBorderPaint ? this._borderPaint : JsonToBoolean.default;
  }
  get hasBorderPaint() {
    return this._hasBorderPaint;
  }
  setBorderPaint(path, value) {
    return {type: 'SET', path: path.concat(['borderPaint']), value};
  }
  deleteBorderPaint(path) {
    return {type: 'DELETE', path: path.concat(['borderPaint'])};
  }
  /**
   * @returns {number}
   */
  get brushSize() {
    return this._hasBrushSize ? this._brushSize : JsonToInt32.default;
  }
  get hasBrushSize() {
    return this._hasBrushSize;
  }
  setBrushSize(path, value) {
    return {type: 'SET', path: path.concat(['brushSize']), value};
  }
  deleteBrushSize(path) {
    return {type: 'DELETE', path: path.concat(['brushSize'])};
  }
  /**
   * @returns {string[]}
   */
  get presets() {
    return this._presets;
  }
  addPresets(path, value) {
    return {type: 'ADD', path: path.concat(['presets']), value};
  }
  setPresets(path, value) {
    return {type: 'SET', path: path.concat(['presets']), value: ArrayToJson(value, JsonToString)};
  }
  setPresetsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['presets', key]), value};
  }
  deletePresets(path) {
    return {type: 'DELETE', path: path.concat(['presets'])};
  }
  deletePresetsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['presets', key])};
  }
  /**
   * @returns {number}
   */
  get currentPresetId() {
    return this._hasCurrentPresetId ? this._currentPresetId : JsonToInt32.default;
  }
  get hasCurrentPresetId() {
    return this._hasCurrentPresetId;
  }
  setCurrentPresetId(path, value) {
    return {type: 'SET', path: path.concat(['currentPresetId']), value};
  }
  deleteCurrentPresetId(path) {
    return {type: 'DELETE', path: path.concat(['currentPresetId'])};
  }
  /**
   * @returns {TerrainEditorData_EditorPanel_TileEditor_MapSize}
   */
  get mapSize() {
    return this._hasMapSize ? this._mapSize : TerrainEditorData_EditorPanel_TileEditor_MapSize.default;
  }
  get hasMapSize() {
    return this._hasMapSize;
  }
  setMapSize(path, value) {
    return {type: 'SET', path: path.concat(['mapSize']), value: value.toJson()};
  }
  deleteMapSize(path) {
    return {type: 'DELETE', path: path.concat(['mapSize'])};
  }
  /**
   * @returns {string}
   */
  get currentPostEffect() {
    return this._hasCurrentPostEffect ? this._currentPostEffect : JsonToString.default;
  }
  get hasCurrentPostEffect() {
    return this._hasCurrentPostEffect;
  }
  setCurrentPostEffect(path, value) {
    return {type: 'SET', path: path.concat(['currentPostEffect']), value};
  }
  deleteCurrentPostEffect(path) {
    return {type: 'DELETE', path: path.concat(['currentPostEffect'])};
  }
  /**
   * @returns {boolean}
   */
  get showNavmesh() {
    return this._hasShowNavmesh ? this._showNavmesh : JsonToBoolean.default;
  }
  get hasShowNavmesh() {
    return this._hasShowNavmesh;
  }
  setShowNavmesh(path, value) {
    return {type: 'SET', path: path.concat(['showNavmesh']), value};
  }
  deleteShowNavmesh(path) {
    return {type: 'DELETE', path: path.concat(['showNavmesh'])};
  }
  /**
   * @returns {boolean}
   */
  get scanStatus() {
    return this._hasScanStatus ? this._scanStatus : JsonToBoolean.default;
  }
  get hasScanStatus() {
    return this._hasScanStatus;
  }
  setScanStatus(path, value) {
    return {type: 'SET', path: path.concat(['scanStatus']), value};
  }
  deleteScanStatus(path) {
    return {type: 'DELETE', path: path.concat(['scanStatus'])};
  }
  /**
   * @returns {string[]}
   */
  get currentTileTexturePaths() {
    return this._currentTileTexturePaths;
  }
  addCurrentTileTexturePaths(path, value) {
    return {type: 'ADD', path: path.concat(['currentTileTexturePaths']), value};
  }
  setCurrentTileTexturePaths(path, value) {
    return {type: 'SET', path: path.concat(['currentTileTexturePaths']), value: ArrayToJson(value, JsonToString)};
  }
  setCurrentTileTexturePathsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['currentTileTexturePaths', key]), value};
  }
  deleteCurrentTileTexturePaths(path) {
    return {type: 'DELETE', path: path.concat(['currentTileTexturePaths'])};
  }
  deleteCurrentTileTexturePathsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['currentTileTexturePaths', key])};
  }
  /**
   * @returns {boolean}
   */
  get cliffClamp() {
    return this._hasCliffClamp ? this._cliffClamp : JsonToBoolean.default;
  }
  get hasCliffClamp() {
    return this._hasCliffClamp;
  }
  setCliffClamp(path, value) {
    return {type: 'SET', path: path.concat(['cliffClamp']), value};
  }
  deleteCliffClamp(path) {
    return {type: 'DELETE', path: path.concat(['cliffClamp'])};
  }
  /**
   * @returns {boolean}
   */
  get disableBorder() {
    return this._hasDisableBorder ? this._disableBorder : JsonToBoolean.default;
  }
  get hasDisableBorder() {
    return this._hasDisableBorder;
  }
  setDisableBorder(path, value) {
    return {type: 'SET', path: path.concat(['disableBorder']), value};
  }
  deleteDisableBorder(path) {
    return {type: 'DELETE', path: path.concat(['disableBorder'])};
  }
  /**
   * @returns {boolean}
   */
  get hideGrid() {
    return this._hasHideGrid ? this._hideGrid : JsonToBoolean.default;
  }
  get hasHideGrid() {
    return this._hasHideGrid;
  }
  setHideGrid(path, value) {
    return {type: 'SET', path: path.concat(['hideGrid']), value};
  }
  deleteHideGrid(path) {
    return {type: 'DELETE', path: path.concat(['hideGrid'])};
  }
  /**
   * @returns {boolean}
   */
  get reset() {
    return this._hasReset ? this._reset : JsonToBoolean.default;
  }
  get hasReset() {
    return this._hasReset;
  }
  setReset(path, value) {
    return {type: 'SET', path: path.concat(['reset']), value};
  }
  deleteReset(path) {
    return {type: 'DELETE', path: path.concat(['reset'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "currentBrush": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasCurrentBrush = true;
              copy._currentBrush = TerrainEditorData_EditorPanel_TileEditor_BrushType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentBrush) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasCurrentBrush = false;
              copy._currentBrush = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cliffHeight": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasCliffHeight = true;
              copy._cliffHeight = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCliffHeight) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasCliffHeight = false;
              copy._cliffHeight = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "textureChannel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasTextureChannel = true;
              copy._textureChannel = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTextureChannel) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasTextureChannel = false;
              copy._textureChannel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "texturePaint": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasTexturePaint = true;
              copy._texturePaint = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTexturePaint) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasTexturePaint = false;
              copy._texturePaint = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "borderPaint": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasBorderPaint = true;
              copy._borderPaint = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBorderPaint) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasBorderPaint = false;
              copy._borderPaint = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "brushSize": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasBrushSize = true;
              copy._brushSize = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBrushSize) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasBrushSize = false;
              copy._brushSize = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "presets": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._presets = [];        for (let i of value) {
                copy._presets.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._presets = copy._presets.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._presets.length === 0) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._presets = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._presets.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._presets = copy._presets.slice();
              copy._presets[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._presets = copy._presets.slice(0, path[1]).concat(copy._presets.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._presets.length) {
            return this;
          }
          const oldValue = this._presets[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
          copy._presets = copy._presets.slice();
          copy._presets[key] = newValue;
          return copy;
        }
      }
      case "currentPresetId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasCurrentPresetId = true;
              copy._currentPresetId = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentPresetId) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasCurrentPresetId = false;
              copy._currentPresetId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "mapSize": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasMapSize = true;
              copy._mapSize = TerrainEditorData_EditorPanel_TileEditor_MapSize.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMapSize) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasMapSize = false;
              copy._mapSize = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasMapSize) {
            const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
            copy._hasMapSize = true;
            copy._mapSize = TerrainEditorData_EditorPanel_TileEditor_MapSize.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._mapSize.apply(type, path.slice(1), value);
          if (newValue === this._mapSize) {
            return this;
          }
          const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
          copy._mapSize = copy._mapSize.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "currentPostEffect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasCurrentPostEffect = true;
              copy._currentPostEffect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentPostEffect) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasCurrentPostEffect = false;
              copy._currentPostEffect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "showNavmesh": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasShowNavmesh = true;
              copy._showNavmesh = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShowNavmesh) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasShowNavmesh = false;
              copy._showNavmesh = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "scanStatus": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasScanStatus = true;
              copy._scanStatus = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasScanStatus) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasScanStatus = false;
              copy._scanStatus = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currentTileTexturePaths": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._currentTileTexturePaths = [];        for (let i of value) {
                copy._currentTileTexturePaths.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._currentTileTexturePaths = copy._currentTileTexturePaths.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._currentTileTexturePaths.length === 0) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._currentTileTexturePaths = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._currentTileTexturePaths.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._currentTileTexturePaths = copy._currentTileTexturePaths.slice();
              copy._currentTileTexturePaths[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._currentTileTexturePaths = copy._currentTileTexturePaths.slice(0, path[1]).concat(copy._currentTileTexturePaths.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._currentTileTexturePaths.length) {
            return this;
          }
          const oldValue = this._currentTileTexturePaths[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
          copy._currentTileTexturePaths = copy._currentTileTexturePaths.slice();
          copy._currentTileTexturePaths[key] = newValue;
          return copy;
        }
      }
      case "cliffClamp": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasCliffClamp = true;
              copy._cliffClamp = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCliffClamp) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasCliffClamp = false;
              copy._cliffClamp = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "disableBorder": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasDisableBorder = true;
              copy._disableBorder = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisableBorder) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasDisableBorder = false;
              copy._disableBorder = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "hideGrid": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasHideGrid = true;
              copy._hideGrid = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHideGrid) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasHideGrid = false;
              copy._hideGrid = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "reset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasReset = true;
              copy._reset = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasReset) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
              copy._hasReset = false;
              copy._reset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TerrainEditorData_EditorPanel_TileEditor} other
   * @returns {TerrainEditorData_EditorPanel_TileEditor}
   */
  merge(other) {
    const copy = new TerrainEditorData_EditorPanel_TileEditor(this);
    if (other._hasCurrentBrush) {
      copy._hasCurrentBrush = true;
      copy._currentBrush = other._currentBrush;
    }
    if (other._hasCliffHeight) {
      copy._hasCliffHeight = true;
      copy._cliffHeight = other._cliffHeight;
    }
    if (other._hasTextureChannel) {
      copy._hasTextureChannel = true;
      copy._textureChannel = other._textureChannel;
    }
    if (other._hasTexturePaint) {
      copy._hasTexturePaint = true;
      copy._texturePaint = other._texturePaint;
    }
    if (other._hasBorderPaint) {
      copy._hasBorderPaint = true;
      copy._borderPaint = other._borderPaint;
    }
    if (other._hasBrushSize) {
      copy._hasBrushSize = true;
      copy._brushSize = other._brushSize;
    }
    copy._presets = this._presets.concat(other._presets);
    if (other._hasCurrentPresetId) {
      copy._hasCurrentPresetId = true;
      copy._currentPresetId = other._currentPresetId;
    }
    if (other._hasMapSize) {
      if (copy._hasMapSize) {
        copy._mapSize = copy.mapSize.merge(other.mapSize);
      } else {
        copy._mapSize = other._mapSize;
      }
      copy._hasMapSize = true;
    }
    if (other._hasCurrentPostEffect) {
      copy._hasCurrentPostEffect = true;
      copy._currentPostEffect = other._currentPostEffect;
    }
    if (other._hasShowNavmesh) {
      copy._hasShowNavmesh = true;
      copy._showNavmesh = other._showNavmesh;
    }
    if (other._hasScanStatus) {
      copy._hasScanStatus = true;
      copy._scanStatus = other._scanStatus;
    }
    copy._currentTileTexturePaths = this._currentTileTexturePaths.concat(other._currentTileTexturePaths);
    if (other._hasCliffClamp) {
      copy._hasCliffClamp = true;
      copy._cliffClamp = other._cliffClamp;
    }
    if (other._hasDisableBorder) {
      copy._hasDisableBorder = true;
      copy._disableBorder = other._disableBorder;
    }
    if (other._hasHideGrid) {
      copy._hasHideGrid = true;
      copy._hideGrid = other._hideGrid;
    }
    if (other._hasReset) {
      copy._hasReset = true;
      copy._reset = other._reset;
    }
    return copy;
  }
}
TerrainEditorData_EditorPanel_TileEditor.default = new TerrainEditorData_EditorPanel_TileEditor();
TerrainEditorData_EditorPanel_TileEditor.MapSize = TerrainEditorData_EditorPanel_TileEditor_MapSize;
TerrainEditorData_EditorPanel_TileEditor.BrushType = TerrainEditorData_EditorPanel_TileEditor_BrushType;
class TerrainEditorData_EditorPanel_TileEditor_Builder {
  constructor(value) {
    this._value = new TerrainEditorData_EditorPanel_TileEditor(value);
  }
  build() {
    return new TerrainEditorData_EditorPanel_TileEditor(this._value);
  }
  setCurrentBrush(value) {
    this._value._hasCurrentBrush = true;
    this._value._currentBrush = value;
    return this;
  }
  deleteCurrentBrush() {
    this._value._hasCurrentBrush = false;
    this._value._currentBrush = null;
    return this;
  }
  setCliffHeight(value) {
    this._value._hasCliffHeight = true;
    this._value._cliffHeight = value;
    return this;
  }
  deleteCliffHeight() {
    this._value._hasCliffHeight = false;
    this._value._cliffHeight = null;
    return this;
  }
  setTextureChannel(value) {
    this._value._hasTextureChannel = true;
    this._value._textureChannel = value;
    return this;
  }
  deleteTextureChannel() {
    this._value._hasTextureChannel = false;
    this._value._textureChannel = null;
    return this;
  }
  setTexturePaint(value) {
    this._value._hasTexturePaint = true;
    this._value._texturePaint = value;
    return this;
  }
  deleteTexturePaint() {
    this._value._hasTexturePaint = false;
    this._value._texturePaint = null;
    return this;
  }
  setBorderPaint(value) {
    this._value._hasBorderPaint = true;
    this._value._borderPaint = value;
    return this;
  }
  deleteBorderPaint() {
    this._value._hasBorderPaint = false;
    this._value._borderPaint = null;
    return this;
  }
  setBrushSize(value) {
    this._value._hasBrushSize = true;
    this._value._brushSize = value;
    return this;
  }
  deleteBrushSize() {
    this._value._hasBrushSize = false;
    this._value._brushSize = null;
    return this;
  }
  addAllPresets(values) {
    this._value._presets = this._value._presets.concat(values);
    return this;
  }
  addPresets(value) {
    this._value._presets = this._value._presets.concat([value]);
    return this;
  }
  setPresets(index, value) {
    this._value._presets = this._value._presets.concat();
    this._value._presets[index] = value;
    return this;
  }
  clearPresets() {
    this._value._presets = [];
    return this;
  }
  setCurrentPresetId(value) {
    this._value._hasCurrentPresetId = true;
    this._value._currentPresetId = value;
    return this;
  }
  deleteCurrentPresetId() {
    this._value._hasCurrentPresetId = false;
    this._value._currentPresetId = null;
    return this;
  }
  setMapSize(value) {
    this._value._hasMapSize = true;
    this._value._mapSize = value;
    return this;
  }
  deleteMapSize() {
    this._value._hasMapSize = false;
    this._value._mapSize = null;
    return this;
  }
  setCurrentPostEffect(value) {
    this._value._hasCurrentPostEffect = true;
    this._value._currentPostEffect = value;
    return this;
  }
  deleteCurrentPostEffect() {
    this._value._hasCurrentPostEffect = false;
    this._value._currentPostEffect = null;
    return this;
  }
  setShowNavmesh(value) {
    this._value._hasShowNavmesh = true;
    this._value._showNavmesh = value;
    return this;
  }
  deleteShowNavmesh() {
    this._value._hasShowNavmesh = false;
    this._value._showNavmesh = null;
    return this;
  }
  setScanStatus(value) {
    this._value._hasScanStatus = true;
    this._value._scanStatus = value;
    return this;
  }
  deleteScanStatus() {
    this._value._hasScanStatus = false;
    this._value._scanStatus = null;
    return this;
  }
  addAllCurrentTileTexturePaths(values) {
    this._value._currentTileTexturePaths = this._value._currentTileTexturePaths.concat(values);
    return this;
  }
  addCurrentTileTexturePaths(value) {
    this._value._currentTileTexturePaths = this._value._currentTileTexturePaths.concat([value]);
    return this;
  }
  setCurrentTileTexturePaths(index, value) {
    this._value._currentTileTexturePaths = this._value._currentTileTexturePaths.concat();
    this._value._currentTileTexturePaths[index] = value;
    return this;
  }
  clearCurrentTileTexturePaths() {
    this._value._currentTileTexturePaths = [];
    return this;
  }
  setCliffClamp(value) {
    this._value._hasCliffClamp = true;
    this._value._cliffClamp = value;
    return this;
  }
  deleteCliffClamp() {
    this._value._hasCliffClamp = false;
    this._value._cliffClamp = null;
    return this;
  }
  setDisableBorder(value) {
    this._value._hasDisableBorder = true;
    this._value._disableBorder = value;
    return this;
  }
  deleteDisableBorder() {
    this._value._hasDisableBorder = false;
    this._value._disableBorder = null;
    return this;
  }
  setHideGrid(value) {
    this._value._hasHideGrid = true;
    this._value._hideGrid = value;
    return this;
  }
  deleteHideGrid() {
    this._value._hasHideGrid = false;
    this._value._hideGrid = null;
    return this;
  }
  setReset(value) {
    this._value._hasReset = true;
    this._value._reset = value;
    return this;
  }
  deleteReset() {
    this._value._hasReset = false;
    this._value._reset = null;
    return this;
  }
}
TerrainEditorData_EditorPanel_TileEditor.Builder = TerrainEditorData_EditorPanel_TileEditor_Builder;
class TerrainEditorData_EditorPanel_TileEditor_WithParent {
  /**
   * @param {TerrainEditorData_EditorPanel_TileEditor} value
   * @param {TerrainEditorData_EditorPanel_TileEditor_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TerrainEditorData_EditorPanel_TileEditor.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCurrentBrush() {
    if (this._cachedHasCurrentBrush === undefined) {
      if (this._value.hasCurrentBrush) {
        this._cachedHasCurrentBrush = true;
      } else {
        this._cachedHasCurrentBrush = this._parent ? this._parent.hasCurrentBrush : false;
      }
    }
    return this._cachedHasCurrentBrush;
  }
  get currentBrush() {
    if (this._cachedCurrentBrush === undefined) {
      if (this._value.hasCurrentBrush) {
        this._cachedCurrentBrush = this._value.currentBrush;
      } else {
        this._cachedCurrentBrush = this._parent ? this._parent.currentBrush : this._value.currentBrush;
      }
    }
    return this._cachedCurrentBrush;
  }
  get hasCliffHeight() {
    if (this._cachedHasCliffHeight === undefined) {
      if (this._value.hasCliffHeight) {
        this._cachedHasCliffHeight = true;
      } else {
        this._cachedHasCliffHeight = this._parent ? this._parent.hasCliffHeight : false;
      }
    }
    return this._cachedHasCliffHeight;
  }
  get cliffHeight() {
    if (this._cachedCliffHeight === undefined) {
      if (this._value.hasCliffHeight) {
        this._cachedCliffHeight = this._value.cliffHeight;
      } else {
        this._cachedCliffHeight = this._parent ? this._parent.cliffHeight : this._value.cliffHeight;
      }
    }
    return this._cachedCliffHeight;
  }
  get hasTextureChannel() {
    if (this._cachedHasTextureChannel === undefined) {
      if (this._value.hasTextureChannel) {
        this._cachedHasTextureChannel = true;
      } else {
        this._cachedHasTextureChannel = this._parent ? this._parent.hasTextureChannel : false;
      }
    }
    return this._cachedHasTextureChannel;
  }
  get textureChannel() {
    if (this._cachedTextureChannel === undefined) {
      if (this._value.hasTextureChannel) {
        this._cachedTextureChannel = this._value.textureChannel;
      } else {
        this._cachedTextureChannel = this._parent ? this._parent.textureChannel : this._value.textureChannel;
      }
    }
    return this._cachedTextureChannel;
  }
  get hasTexturePaint() {
    if (this._cachedHasTexturePaint === undefined) {
      if (this._value.hasTexturePaint) {
        this._cachedHasTexturePaint = true;
      } else {
        this._cachedHasTexturePaint = this._parent ? this._parent.hasTexturePaint : false;
      }
    }
    return this._cachedHasTexturePaint;
  }
  get texturePaint() {
    if (this._cachedTexturePaint === undefined) {
      if (this._value.hasTexturePaint) {
        this._cachedTexturePaint = this._value.texturePaint;
      } else {
        this._cachedTexturePaint = this._parent ? this._parent.texturePaint : this._value.texturePaint;
      }
    }
    return this._cachedTexturePaint;
  }
  get hasBorderPaint() {
    if (this._cachedHasBorderPaint === undefined) {
      if (this._value.hasBorderPaint) {
        this._cachedHasBorderPaint = true;
      } else {
        this._cachedHasBorderPaint = this._parent ? this._parent.hasBorderPaint : false;
      }
    }
    return this._cachedHasBorderPaint;
  }
  get borderPaint() {
    if (this._cachedBorderPaint === undefined) {
      if (this._value.hasBorderPaint) {
        this._cachedBorderPaint = this._value.borderPaint;
      } else {
        this._cachedBorderPaint = this._parent ? this._parent.borderPaint : this._value.borderPaint;
      }
    }
    return this._cachedBorderPaint;
  }
  get hasBrushSize() {
    if (this._cachedHasBrushSize === undefined) {
      if (this._value.hasBrushSize) {
        this._cachedHasBrushSize = true;
      } else {
        this._cachedHasBrushSize = this._parent ? this._parent.hasBrushSize : false;
      }
    }
    return this._cachedHasBrushSize;
  }
  get brushSize() {
    if (this._cachedBrushSize === undefined) {
      if (this._value.hasBrushSize) {
        this._cachedBrushSize = this._value.brushSize;
      } else {
        this._cachedBrushSize = this._parent ? this._parent.brushSize : this._value.brushSize;
      }
    }
    return this._cachedBrushSize;
  }
  get selfPresets() {
    return this._value.presets;
  }
  get inherentPresets() {
    if (!this._inherentPresets) {
      this._inherentPresets = this._parent ? this._parent.presets : [];
    }
    return this._inherentPresets;
  }
  get presets() {
    if (!this._allPresets) {
      this._allPresets = this._parent ? this._parent.presets.concat(this.selfPresets) : this.selfPresets;
    }
    return this._allPresets;
  }
  get hasCurrentPresetId() {
    if (this._cachedHasCurrentPresetId === undefined) {
      if (this._value.hasCurrentPresetId) {
        this._cachedHasCurrentPresetId = true;
      } else {
        this._cachedHasCurrentPresetId = this._parent ? this._parent.hasCurrentPresetId : false;
      }
    }
    return this._cachedHasCurrentPresetId;
  }
  get currentPresetId() {
    if (this._cachedCurrentPresetId === undefined) {
      if (this._value.hasCurrentPresetId) {
        this._cachedCurrentPresetId = this._value.currentPresetId;
      } else {
        this._cachedCurrentPresetId = this._parent ? this._parent.currentPresetId : this._value.currentPresetId;
      }
    }
    return this._cachedCurrentPresetId;
  }
  get hasMapSize() {
    if (this._cachedHasMapSize === undefined) {
      if (this._value.hasMapSize) {
        this._cachedHasMapSize = true;
      } else {
        this._cachedHasMapSize = this._parent ? this._parent.hasMapSize : false;
      }
    }
    return this._cachedHasMapSize;
  }
  get mapSize() {
    if (!this._cachedMapSize) {
      if (this._value.hasMapSize) {
        this._cachedMapSize = new TerrainEditorData_EditorPanel_TileEditor_MapSize.WithParent(this._value.mapSize, this._parent && this._parent.hasMapSize ? this._parent.mapSize : null);
      } else {
        this._cachedMapSize = this._parent ? new TerrainEditorData_EditorPanel_TileEditor_MapSize.WithParent(TerrainEditorData_EditorPanel_TileEditor_MapSize.default, this._parent.mapSize) : TerrainEditorData_EditorPanel_TileEditor_MapSize.WithParent.default;
      }
    }
    return this._cachedMapSize;
  }
  get hasCurrentPostEffect() {
    if (this._cachedHasCurrentPostEffect === undefined) {
      if (this._value.hasCurrentPostEffect) {
        this._cachedHasCurrentPostEffect = true;
      } else {
        this._cachedHasCurrentPostEffect = this._parent ? this._parent.hasCurrentPostEffect : false;
      }
    }
    return this._cachedHasCurrentPostEffect;
  }
  get currentPostEffect() {
    if (this._cachedCurrentPostEffect === undefined) {
      if (this._value.hasCurrentPostEffect) {
        this._cachedCurrentPostEffect = this._value.currentPostEffect;
      } else {
        this._cachedCurrentPostEffect = this._parent ? this._parent.currentPostEffect : this._value.currentPostEffect;
      }
    }
    return this._cachedCurrentPostEffect;
  }
  get hasShowNavmesh() {
    if (this._cachedHasShowNavmesh === undefined) {
      if (this._value.hasShowNavmesh) {
        this._cachedHasShowNavmesh = true;
      } else {
        this._cachedHasShowNavmesh = this._parent ? this._parent.hasShowNavmesh : false;
      }
    }
    return this._cachedHasShowNavmesh;
  }
  get showNavmesh() {
    if (this._cachedShowNavmesh === undefined) {
      if (this._value.hasShowNavmesh) {
        this._cachedShowNavmesh = this._value.showNavmesh;
      } else {
        this._cachedShowNavmesh = this._parent ? this._parent.showNavmesh : this._value.showNavmesh;
      }
    }
    return this._cachedShowNavmesh;
  }
  get hasScanStatus() {
    if (this._cachedHasScanStatus === undefined) {
      if (this._value.hasScanStatus) {
        this._cachedHasScanStatus = true;
      } else {
        this._cachedHasScanStatus = this._parent ? this._parent.hasScanStatus : false;
      }
    }
    return this._cachedHasScanStatus;
  }
  get scanStatus() {
    if (this._cachedScanStatus === undefined) {
      if (this._value.hasScanStatus) {
        this._cachedScanStatus = this._value.scanStatus;
      } else {
        this._cachedScanStatus = this._parent ? this._parent.scanStatus : this._value.scanStatus;
      }
    }
    return this._cachedScanStatus;
  }
  get selfCurrentTileTexturePaths() {
    return this._value.currentTileTexturePaths;
  }
  get inherentCurrentTileTexturePaths() {
    if (!this._inherentCurrentTileTexturePaths) {
      this._inherentCurrentTileTexturePaths = this._parent ? this._parent.currentTileTexturePaths : [];
    }
    return this._inherentCurrentTileTexturePaths;
  }
  get currentTileTexturePaths() {
    if (!this._allCurrentTileTexturePaths) {
      this._allCurrentTileTexturePaths = this._parent ? this._parent.currentTileTexturePaths.concat(this.selfCurrentTileTexturePaths) : this.selfCurrentTileTexturePaths;
    }
    return this._allCurrentTileTexturePaths;
  }
  get hasCliffClamp() {
    if (this._cachedHasCliffClamp === undefined) {
      if (this._value.hasCliffClamp) {
        this._cachedHasCliffClamp = true;
      } else {
        this._cachedHasCliffClamp = this._parent ? this._parent.hasCliffClamp : false;
      }
    }
    return this._cachedHasCliffClamp;
  }
  get cliffClamp() {
    if (this._cachedCliffClamp === undefined) {
      if (this._value.hasCliffClamp) {
        this._cachedCliffClamp = this._value.cliffClamp;
      } else {
        this._cachedCliffClamp = this._parent ? this._parent.cliffClamp : this._value.cliffClamp;
      }
    }
    return this._cachedCliffClamp;
  }
  get hasDisableBorder() {
    if (this._cachedHasDisableBorder === undefined) {
      if (this._value.hasDisableBorder) {
        this._cachedHasDisableBorder = true;
      } else {
        this._cachedHasDisableBorder = this._parent ? this._parent.hasDisableBorder : false;
      }
    }
    return this._cachedHasDisableBorder;
  }
  get disableBorder() {
    if (this._cachedDisableBorder === undefined) {
      if (this._value.hasDisableBorder) {
        this._cachedDisableBorder = this._value.disableBorder;
      } else {
        this._cachedDisableBorder = this._parent ? this._parent.disableBorder : this._value.disableBorder;
      }
    }
    return this._cachedDisableBorder;
  }
  get hasHideGrid() {
    if (this._cachedHasHideGrid === undefined) {
      if (this._value.hasHideGrid) {
        this._cachedHasHideGrid = true;
      } else {
        this._cachedHasHideGrid = this._parent ? this._parent.hasHideGrid : false;
      }
    }
    return this._cachedHasHideGrid;
  }
  get hideGrid() {
    if (this._cachedHideGrid === undefined) {
      if (this._value.hasHideGrid) {
        this._cachedHideGrid = this._value.hideGrid;
      } else {
        this._cachedHideGrid = this._parent ? this._parent.hideGrid : this._value.hideGrid;
      }
    }
    return this._cachedHideGrid;
  }
  get hasReset() {
    if (this._cachedHasReset === undefined) {
      if (this._value.hasReset) {
        this._cachedHasReset = true;
      } else {
        this._cachedHasReset = this._parent ? this._parent.hasReset : false;
      }
    }
    return this._cachedHasReset;
  }
  get reset() {
    if (this._cachedReset === undefined) {
      if (this._value.hasReset) {
        this._cachedReset = this._value.reset;
      } else {
        this._cachedReset = this._parent ? this._parent.reset : this._value.reset;
      }
    }
    return this._cachedReset;
  }
  update(current, parent) {
    const result = new TerrainEditorData_EditorPanel_TileEditor_WithParent(current, parent);
    if (this._cachedMapSize && this._value.hasMapSize && current.hasMapSize) {
      if (this._value.mapSize === current.mapSize && this._parent === parent) {
        result._cachedMapSize = this._cachedMapSize;
      } else {
        result._cachedMapSize = this._cachedMapSize.update(current.mapSize, parent && parent.hasMapSize ? parent.mapSize : null);
      }
    }
    return result;
  }
}
TerrainEditorData_EditorPanel_TileEditor_WithParent.default = new TerrainEditorData_EditorPanel_TileEditor_WithParent(TerrainEditorData_EditorPanel_TileEditor.default, null);
TerrainEditorData_EditorPanel_TileEditor.WithParent = TerrainEditorData_EditorPanel_TileEditor_WithParent;
class TerrainEditorData_EditorPanel_TileEditor_Descriptor {
  get currentBrush() {
    if (!this._currentBrush) {
      this._currentBrush = {
        name: "currentBrush",
        Name: "CurrentBrush",
        number: 1,
        protoType: 14,
        protoName: "current_brush",
        type: TerrainEditorData_EditorPanel_TileEditor_BrushType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentBrush;
  }
  get cliffHeight() {
    if (!this._cliffHeight) {
      this._cliffHeight = {
        name: "cliffHeight",
        Name: "CliffHeight",
        number: 2,
        protoType: 5,
        protoName: "cliff_height",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cliffHeight;
  }
  get textureChannel() {
    if (!this._textureChannel) {
      this._textureChannel = {
        name: "textureChannel",
        Name: "TextureChannel",
        number: 3,
        protoType: 5,
        protoName: "texture_channel",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._textureChannel;
  }
  get texturePaint() {
    if (!this._texturePaint) {
      this._texturePaint = {
        name: "texturePaint",
        Name: "TexturePaint",
        number: 4,
        protoType: 8,
        protoName: "texture_paint",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._texturePaint;
  }
  get borderPaint() {
    if (!this._borderPaint) {
      this._borderPaint = {
        name: "borderPaint",
        Name: "BorderPaint",
        number: 5,
        protoType: 8,
        protoName: "border_paint",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._borderPaint;
  }
  get brushSize() {
    if (!this._brushSize) {
      this._brushSize = {
        name: "brushSize",
        Name: "BrushSize",
        number: 6,
        protoType: 5,
        protoName: "brush_size",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._brushSize;
  }
  get presets() {
    if (!this._presets) {
      this._presets = {
        name: "presets",
        Name: "Presets",
        number: 7,
        protoType: 9,
        protoName: "presets",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._presets;
  }
  get currentPresetId() {
    if (!this._currentPresetId) {
      this._currentPresetId = {
        name: "currentPresetId",
        Name: "CurrentPresetId",
        number: 8,
        protoType: 5,
        protoName: "current_preset_id",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentPresetId;
  }
  get mapSize() {
    if (!this._mapSize) {
      this._mapSize = {
        name: "mapSize",
        Name: "MapSize",
        number: 9,
        protoType: 11,
        protoName: "map_size",
        type: TerrainEditorData_EditorPanel_TileEditor_MapSize,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapSize;
  }
  get currentPostEffect() {
    if (!this._currentPostEffect) {
      this._currentPostEffect = {
        name: "currentPostEffect",
        Name: "CurrentPostEffect",
        number: 10,
        protoType: 9,
        protoName: "current_post_effect",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentPostEffect;
  }
  get showNavmesh() {
    if (!this._showNavmesh) {
      this._showNavmesh = {
        name: "showNavmesh",
        Name: "ShowNavmesh",
        number: 11,
        protoType: 8,
        protoName: "show_navmesh",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._showNavmesh;
  }
  get scanStatus() {
    if (!this._scanStatus) {
      this._scanStatus = {
        name: "scanStatus",
        Name: "ScanStatus",
        number: 12,
        protoType: 8,
        protoName: "scan_status",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._scanStatus;
  }
  get currentTileTexturePaths() {
    if (!this._currentTileTexturePaths) {
      this._currentTileTexturePaths = {
        name: "currentTileTexturePaths",
        Name: "CurrentTileTexturePaths",
        number: 13,
        protoType: 9,
        protoName: "current_tile_texture_paths",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentTileTexturePaths;
  }
  get cliffClamp() {
    if (!this._cliffClamp) {
      this._cliffClamp = {
        name: "cliffClamp",
        Name: "CliffClamp",
        number: 14,
        protoType: 8,
        protoName: "cliff_clamp",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cliffClamp;
  }
  get disableBorder() {
    if (!this._disableBorder) {
      this._disableBorder = {
        name: "disableBorder",
        Name: "DisableBorder",
        number: 21,
        protoType: 8,
        protoName: "disable_border",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._disableBorder;
  }
  get hideGrid() {
    if (!this._hideGrid) {
      this._hideGrid = {
        name: "hideGrid",
        Name: "HideGrid",
        number: 22,
        protoType: 8,
        protoName: "hide_grid",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hideGrid;
  }
  get reset() {
    if (!this._reset) {
      this._reset = {
        name: "reset",
        Name: "Reset",
        number: 99,
        protoType: 8,
        protoName: "reset",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._reset;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.currentBrush,
        this.cliffHeight,
        this.textureChannel,
        this.texturePaint,
        this.borderPaint,
        this.brushSize,
        this.presets,
        this.currentPresetId,
        this.mapSize,
        this.currentPostEffect,
        this.showNavmesh,
        this.scanStatus,
        this.currentTileTexturePaths,
        this.cliffClamp,
        this.disableBorder,
        this.hideGrid,
        this.reset,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCurrentBrush",
        Name: "DummyOneofForCurrentBrush",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCliffHeight",
        Name: "DummyOneofForCliffHeight",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTextureChannel",
        Name: "DummyOneofForTextureChannel",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTexturePaint",
        Name: "DummyOneofForTexturePaint",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBorderPaint",
        Name: "DummyOneofForBorderPaint",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBrushSize",
        Name: "DummyOneofForBrushSize",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrentPresetId",
        Name: "DummyOneofForCurrentPresetId",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMapSize",
        Name: "DummyOneofForMapSize",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrentPostEffect",
        Name: "DummyOneofForCurrentPostEffect",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShowNavmesh",
        Name: "DummyOneofForShowNavmesh",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForScanStatus",
        Name: "DummyOneofForScanStatus",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCliffClamp",
        Name: "DummyOneofForCliffClamp",
        fields: [
          this.fields[13],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisableBorder",
        Name: "DummyOneofForDisableBorder",
        fields: [
          this.fields[14],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHideGrid",
        Name: "DummyOneofForHideGrid",
        fields: [
          this.fields[15],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForReset",
        Name: "DummyOneofForReset",
        fields: [
          this.fields[16],
        ],
      });
    }
    return this._oneofs;
  }
}
TerrainEditorData_EditorPanel_TileEditor.descriptor = new TerrainEditorData_EditorPanel_TileEditor_Descriptor();
class TerrainEditorData_EditorPanel_RoadEditor {
  get descriptor() {
    return TerrainEditorData_EditorPanel_RoadEditor.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasNodeSize = false;
    this._nodeSize = null;
    this._hasNodeCurvature = false;
    this._nodeCurvature = null;
    this._hasCurrentNodeId = false;
    this._currentNodeId = null;
    this._hasReset = false;
    this._reset = null;
  }
  isEmpty() {
    if (this._hasNodeSize) return false;
    if (this._hasNodeCurvature) return false;
    if (this._hasCurrentNodeId) return false;
    if (this._hasReset) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TerrainEditorData_EditorPanel_RoadEditor) {
      return value;
    }
    return TerrainEditorData_EditorPanel_RoadEditor.fromJson(value);
  }
  static fromJson(json) {
    const result = new TerrainEditorData_EditorPanel_RoadEditor();
    if (json.nodeSize != null) {
      result._hasNodeSize = true;
      result._nodeSize = JsonToDouble.fromJson(json.nodeSize);
    }
    if (json.nodeCurvature != null) {
      result._hasNodeCurvature = true;
      result._nodeCurvature = JsonToDouble.fromJson(json.nodeCurvature);
    }
    if (json.currentNodeId != null) {
      result._hasCurrentNodeId = true;
      result._currentNodeId = JsonToString.fromJson(json.currentNodeId);
    }
    if (json.reset != null) {
      result._hasReset = true;
      result._reset = JsonToBoolean.fromJson(json.reset);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasNodeSize) {
      result.nodeSize = JsonToDouble.toJson(this._nodeSize);
    }
    if (this._hasNodeCurvature) {
      result.nodeCurvature = JsonToDouble.toJson(this._nodeCurvature);
    }
    if (this._hasCurrentNodeId) {
      result.currentNodeId = JsonToString.toJson(this._currentNodeId);
    }
    if (this._hasReset) {
      result.reset = JsonToBoolean.toJson(this._reset);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get nodeSize() {
    return this._hasNodeSize ? this._nodeSize : JsonToDouble.default;
  }
  get hasNodeSize() {
    return this._hasNodeSize;
  }
  setNodeSize(path, value) {
    return {type: 'SET', path: path.concat(['nodeSize']), value};
  }
  deleteNodeSize(path) {
    return {type: 'DELETE', path: path.concat(['nodeSize'])};
  }
  /**
   * @returns {number}
   */
  get nodeCurvature() {
    return this._hasNodeCurvature ? this._nodeCurvature : JsonToDouble.default;
  }
  get hasNodeCurvature() {
    return this._hasNodeCurvature;
  }
  setNodeCurvature(path, value) {
    return {type: 'SET', path: path.concat(['nodeCurvature']), value};
  }
  deleteNodeCurvature(path) {
    return {type: 'DELETE', path: path.concat(['nodeCurvature'])};
  }
  /**
   * @returns {string}
   */
  get currentNodeId() {
    return this._hasCurrentNodeId ? this._currentNodeId : JsonToString.default;
  }
  get hasCurrentNodeId() {
    return this._hasCurrentNodeId;
  }
  setCurrentNodeId(path, value) {
    return {type: 'SET', path: path.concat(['currentNodeId']), value};
  }
  deleteCurrentNodeId(path) {
    return {type: 'DELETE', path: path.concat(['currentNodeId'])};
  }
  /**
   * @returns {boolean}
   */
  get reset() {
    return this._hasReset ? this._reset : JsonToBoolean.default;
  }
  get hasReset() {
    return this._hasReset;
  }
  setReset(path, value) {
    return {type: 'SET', path: path.concat(['reset']), value};
  }
  deleteReset(path) {
    return {type: 'DELETE', path: path.concat(['reset'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "nodeSize": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_RoadEditor(this);
              copy._hasNodeSize = true;
              copy._nodeSize = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasNodeSize) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_RoadEditor(this);
              copy._hasNodeSize = false;
              copy._nodeSize = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "nodeCurvature": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_RoadEditor(this);
              copy._hasNodeCurvature = true;
              copy._nodeCurvature = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasNodeCurvature) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_RoadEditor(this);
              copy._hasNodeCurvature = false;
              copy._nodeCurvature = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currentNodeId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_RoadEditor(this);
              copy._hasCurrentNodeId = true;
              copy._currentNodeId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentNodeId) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_RoadEditor(this);
              copy._hasCurrentNodeId = false;
              copy._currentNodeId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "reset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_RoadEditor(this);
              copy._hasReset = true;
              copy._reset = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasReset) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_RoadEditor(this);
              copy._hasReset = false;
              copy._reset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TerrainEditorData_EditorPanel_RoadEditor} other
   * @returns {TerrainEditorData_EditorPanel_RoadEditor}
   */
  merge(other) {
    const copy = new TerrainEditorData_EditorPanel_RoadEditor(this);
    if (other._hasNodeSize) {
      copy._hasNodeSize = true;
      copy._nodeSize = other._nodeSize;
    }
    if (other._hasNodeCurvature) {
      copy._hasNodeCurvature = true;
      copy._nodeCurvature = other._nodeCurvature;
    }
    if (other._hasCurrentNodeId) {
      copy._hasCurrentNodeId = true;
      copy._currentNodeId = other._currentNodeId;
    }
    if (other._hasReset) {
      copy._hasReset = true;
      copy._reset = other._reset;
    }
    return copy;
  }
}
TerrainEditorData_EditorPanel_RoadEditor.default = new TerrainEditorData_EditorPanel_RoadEditor();
class TerrainEditorData_EditorPanel_RoadEditor_Builder {
  constructor(value) {
    this._value = new TerrainEditorData_EditorPanel_RoadEditor(value);
  }
  build() {
    return new TerrainEditorData_EditorPanel_RoadEditor(this._value);
  }
  setNodeSize(value) {
    this._value._hasNodeSize = true;
    this._value._nodeSize = value;
    return this;
  }
  deleteNodeSize() {
    this._value._hasNodeSize = false;
    this._value._nodeSize = null;
    return this;
  }
  setNodeCurvature(value) {
    this._value._hasNodeCurvature = true;
    this._value._nodeCurvature = value;
    return this;
  }
  deleteNodeCurvature() {
    this._value._hasNodeCurvature = false;
    this._value._nodeCurvature = null;
    return this;
  }
  setCurrentNodeId(value) {
    this._value._hasCurrentNodeId = true;
    this._value._currentNodeId = value;
    return this;
  }
  deleteCurrentNodeId() {
    this._value._hasCurrentNodeId = false;
    this._value._currentNodeId = null;
    return this;
  }
  setReset(value) {
    this._value._hasReset = true;
    this._value._reset = value;
    return this;
  }
  deleteReset() {
    this._value._hasReset = false;
    this._value._reset = null;
    return this;
  }
}
TerrainEditorData_EditorPanel_RoadEditor.Builder = TerrainEditorData_EditorPanel_RoadEditor_Builder;
class TerrainEditorData_EditorPanel_RoadEditor_WithParent {
  /**
   * @param {TerrainEditorData_EditorPanel_RoadEditor} value
   * @param {TerrainEditorData_EditorPanel_RoadEditor_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TerrainEditorData_EditorPanel_RoadEditor.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasNodeSize() {
    if (this._cachedHasNodeSize === undefined) {
      if (this._value.hasNodeSize) {
        this._cachedHasNodeSize = true;
      } else {
        this._cachedHasNodeSize = this._parent ? this._parent.hasNodeSize : false;
      }
    }
    return this._cachedHasNodeSize;
  }
  get nodeSize() {
    if (this._cachedNodeSize === undefined) {
      if (this._value.hasNodeSize) {
        this._cachedNodeSize = this._value.nodeSize;
      } else {
        this._cachedNodeSize = this._parent ? this._parent.nodeSize : this._value.nodeSize;
      }
    }
    return this._cachedNodeSize;
  }
  get hasNodeCurvature() {
    if (this._cachedHasNodeCurvature === undefined) {
      if (this._value.hasNodeCurvature) {
        this._cachedHasNodeCurvature = true;
      } else {
        this._cachedHasNodeCurvature = this._parent ? this._parent.hasNodeCurvature : false;
      }
    }
    return this._cachedHasNodeCurvature;
  }
  get nodeCurvature() {
    if (this._cachedNodeCurvature === undefined) {
      if (this._value.hasNodeCurvature) {
        this._cachedNodeCurvature = this._value.nodeCurvature;
      } else {
        this._cachedNodeCurvature = this._parent ? this._parent.nodeCurvature : this._value.nodeCurvature;
      }
    }
    return this._cachedNodeCurvature;
  }
  get hasCurrentNodeId() {
    if (this._cachedHasCurrentNodeId === undefined) {
      if (this._value.hasCurrentNodeId) {
        this._cachedHasCurrentNodeId = true;
      } else {
        this._cachedHasCurrentNodeId = this._parent ? this._parent.hasCurrentNodeId : false;
      }
    }
    return this._cachedHasCurrentNodeId;
  }
  get currentNodeId() {
    if (this._cachedCurrentNodeId === undefined) {
      if (this._value.hasCurrentNodeId) {
        this._cachedCurrentNodeId = this._value.currentNodeId;
      } else {
        this._cachedCurrentNodeId = this._parent ? this._parent.currentNodeId : this._value.currentNodeId;
      }
    }
    return this._cachedCurrentNodeId;
  }
  get hasReset() {
    if (this._cachedHasReset === undefined) {
      if (this._value.hasReset) {
        this._cachedHasReset = true;
      } else {
        this._cachedHasReset = this._parent ? this._parent.hasReset : false;
      }
    }
    return this._cachedHasReset;
  }
  get reset() {
    if (this._cachedReset === undefined) {
      if (this._value.hasReset) {
        this._cachedReset = this._value.reset;
      } else {
        this._cachedReset = this._parent ? this._parent.reset : this._value.reset;
      }
    }
    return this._cachedReset;
  }
  update(current, parent) {
    const result = new TerrainEditorData_EditorPanel_RoadEditor_WithParent(current, parent);
    return result;
  }
}
TerrainEditorData_EditorPanel_RoadEditor_WithParent.default = new TerrainEditorData_EditorPanel_RoadEditor_WithParent(TerrainEditorData_EditorPanel_RoadEditor.default, null);
TerrainEditorData_EditorPanel_RoadEditor.WithParent = TerrainEditorData_EditorPanel_RoadEditor_WithParent;
class TerrainEditorData_EditorPanel_RoadEditor_Descriptor {
  get nodeSize() {
    if (!this._nodeSize) {
      this._nodeSize = {
        name: "nodeSize",
        Name: "NodeSize",
        number: 1,
        protoType: 1,
        protoName: "node_size",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._nodeSize;
  }
  get nodeCurvature() {
    if (!this._nodeCurvature) {
      this._nodeCurvature = {
        name: "nodeCurvature",
        Name: "NodeCurvature",
        number: 2,
        protoType: 1,
        protoName: "node_curvature",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._nodeCurvature;
  }
  get currentNodeId() {
    if (!this._currentNodeId) {
      this._currentNodeId = {
        name: "currentNodeId",
        Name: "CurrentNodeId",
        number: 3,
        protoType: 9,
        protoName: "current_node_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentNodeId;
  }
  get reset() {
    if (!this._reset) {
      this._reset = {
        name: "reset",
        Name: "Reset",
        number: 99,
        protoType: 8,
        protoName: "reset",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._reset;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.nodeSize,
        this.nodeCurvature,
        this.currentNodeId,
        this.reset,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForNodeSize",
        Name: "DummyOneofForNodeSize",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForNodeCurvature",
        Name: "DummyOneofForNodeCurvature",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrentNodeId",
        Name: "DummyOneofForCurrentNodeId",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForReset",
        Name: "DummyOneofForReset",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
TerrainEditorData_EditorPanel_RoadEditor.descriptor = new TerrainEditorData_EditorPanel_RoadEditor_Descriptor();
class TerrainEditorData_EditorPanel_PropEditor {
  get descriptor() {
    return TerrainEditorData_EditorPanel_PropEditor.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCurrentBrush = false;
    this._currentBrush = null;
    this._hasInitialScale = false;
    this._initialScale = null;
    this._hasInitialRotation = false;
    this._initialRotation = null;
    this._hasHeightOffset = false;
    this._heightOffset = null;
    this._hasCurrentPrefabPath = false;
    this._currentPrefabPath = null;
    this._hasCurrentHandleTool = false;
    this._currentHandleTool = null;
    this._hasSnapToGrid = false;
    this._snapToGrid = null;
    this._hasGridSize = false;
    this._gridSize = null;
    this._hasDisableCollider = false;
    this._disableCollider = null;
    this._hasUseRandomRotation = false;
    this._useRandomRotation = null;
    this._hasUseRandomScale = false;
    this._useRandomScale = null;
    this._hasRandomRotationMin = false;
    this._randomRotationMin = null;
    this._hasRandomRotationMax = false;
    this._randomRotationMax = null;
    this._hasRandomScaleMin = false;
    this._randomScaleMin = null;
    this._hasRandomScaleMax = false;
    this._randomScaleMax = null;
    this._hasCurrentSelectedPropId = false;
    this._currentSelectedPropId = null;
    this._hasShowPropColliders = false;
    this._showPropColliders = null;
    this._hasCurrentColliderScale = false;
    this._currentColliderScale = null;
    this._hasCurrentPropLayer = false;
    this._currentPropLayer = null;
    this._hasCurrentPropGroup = false;
    this._currentPropGroup = null;
    this._hasPastePropsMode = false;
    this._pastePropsMode = null;
    this._hasCopyPropGroup = false;
    this._copyPropGroup = null;
    this._hasReset = false;
    this._reset = null;
  }
  isEmpty() {
    if (this._hasCurrentBrush) return false;
    if (this._hasInitialScale) return false;
    if (this._hasInitialRotation) return false;
    if (this._hasHeightOffset) return false;
    if (this._hasCurrentPrefabPath) return false;
    if (this._hasCurrentHandleTool) return false;
    if (this._hasSnapToGrid) return false;
    if (this._hasGridSize) return false;
    if (this._hasDisableCollider) return false;
    if (this._hasUseRandomRotation) return false;
    if (this._hasUseRandomScale) return false;
    if (this._hasRandomRotationMin) return false;
    if (this._hasRandomRotationMax) return false;
    if (this._hasRandomScaleMin) return false;
    if (this._hasRandomScaleMax) return false;
    if (this._hasCurrentSelectedPropId) return false;
    if (this._hasShowPropColliders) return false;
    if (this._hasCurrentColliderScale) return false;
    if (this._hasCurrentPropLayer) return false;
    if (this._hasCurrentPropGroup && !this._currentPropGroup.isEmpty()) return false;
    if (this._hasPastePropsMode) return false;
    if (this._hasCopyPropGroup && !this._copyPropGroup.isEmpty()) return false;
    if (this._hasReset) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TerrainEditorData_EditorPanel_PropEditor) {
      return value;
    }
    return TerrainEditorData_EditorPanel_PropEditor.fromJson(value);
  }
  static fromJson(json) {
    const result = new TerrainEditorData_EditorPanel_PropEditor();
    if (json.currentBrush != null) {
      result._hasCurrentBrush = true;
      result._currentBrush = TerrainEditorData_EditorPanel_BrushMode.fromJson(json.currentBrush);
    }
    if (json.initialScale != null) {
      result._hasInitialScale = true;
      result._initialScale = JsonToDouble.fromJson(json.initialScale);
    }
    if (json.initialRotation != null) {
      result._hasInitialRotation = true;
      result._initialRotation = JsonToDouble.fromJson(json.initialRotation);
    }
    if (json.heightOffset != null) {
      result._hasHeightOffset = true;
      result._heightOffset = JsonToDouble.fromJson(json.heightOffset);
    }
    if (json.currentPrefabPath != null) {
      result._hasCurrentPrefabPath = true;
      result._currentPrefabPath = JsonToString.fromJson(json.currentPrefabPath);
    }
    if (json.currentHandleTool != null) {
      result._hasCurrentHandleTool = true;
      result._currentHandleTool = TerrainEditorData_EditorPanel_HandleTool.fromJson(json.currentHandleTool);
    }
    if (json.snapToGrid != null) {
      result._hasSnapToGrid = true;
      result._snapToGrid = JsonToBoolean.fromJson(json.snapToGrid);
    }
    if (json.gridSize != null) {
      result._hasGridSize = true;
      result._gridSize = JsonToDouble.fromJson(json.gridSize);
    }
    if (json.disableCollider != null) {
      result._hasDisableCollider = true;
      result._disableCollider = JsonToBoolean.fromJson(json.disableCollider);
    }
    if (json.useRandomRotation != null) {
      result._hasUseRandomRotation = true;
      result._useRandomRotation = JsonToBoolean.fromJson(json.useRandomRotation);
    }
    if (json.useRandomScale != null) {
      result._hasUseRandomScale = true;
      result._useRandomScale = JsonToBoolean.fromJson(json.useRandomScale);
    }
    if (json.randomRotationMin != null) {
      result._hasRandomRotationMin = true;
      result._randomRotationMin = JsonToDouble.fromJson(json.randomRotationMin);
    }
    if (json.randomRotationMax != null) {
      result._hasRandomRotationMax = true;
      result._randomRotationMax = JsonToDouble.fromJson(json.randomRotationMax);
    }
    if (json.randomScaleMin != null) {
      result._hasRandomScaleMin = true;
      result._randomScaleMin = JsonToDouble.fromJson(json.randomScaleMin);
    }
    if (json.randomScaleMax != null) {
      result._hasRandomScaleMax = true;
      result._randomScaleMax = JsonToDouble.fromJson(json.randomScaleMax);
    }
    if (json.currentSelectedPropId != null) {
      result._hasCurrentSelectedPropId = true;
      result._currentSelectedPropId = JsonToString.fromJson(json.currentSelectedPropId);
    }
    if (json.showPropColliders != null) {
      result._hasShowPropColliders = true;
      result._showPropColliders = JsonToBoolean.fromJson(json.showPropColliders);
    }
    if (json.currentColliderScale != null) {
      result._hasCurrentColliderScale = true;
      result._currentColliderScale = JsonToDouble.fromJson(json.currentColliderScale);
    }
    if (json.currentPropLayer != null) {
      result._hasCurrentPropLayer = true;
      result._currentPropLayer = JsonToInt32.fromJson(json.currentPropLayer);
    }
    if (json.currentPropGroup != null) {
      result._hasCurrentPropGroup = true;
      result._currentPropGroup = dcei_editor_terrain_proto.UndoablePropsGroup.fromJson(json.currentPropGroup);
    }
    if (json.pastePropsMode != null) {
      result._hasPastePropsMode = true;
      result._pastePropsMode = JsonToBoolean.fromJson(json.pastePropsMode);
    }
    if (json.copyPropGroup != null) {
      result._hasCopyPropGroup = true;
      result._copyPropGroup = dcei_editor_terrain_proto.UndoablePropsGroup.fromJson(json.copyPropGroup);
    }
    if (json.reset != null) {
      result._hasReset = true;
      result._reset = JsonToBoolean.fromJson(json.reset);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCurrentBrush) {
      result.currentBrush = TerrainEditorData_EditorPanel_BrushMode.toJson(this._currentBrush);
    }
    if (this._hasInitialScale) {
      result.initialScale = JsonToDouble.toJson(this._initialScale);
    }
    if (this._hasInitialRotation) {
      result.initialRotation = JsonToDouble.toJson(this._initialRotation);
    }
    if (this._hasHeightOffset) {
      result.heightOffset = JsonToDouble.toJson(this._heightOffset);
    }
    if (this._hasCurrentPrefabPath) {
      result.currentPrefabPath = JsonToString.toJson(this._currentPrefabPath);
    }
    if (this._hasCurrentHandleTool) {
      result.currentHandleTool = TerrainEditorData_EditorPanel_HandleTool.toJson(this._currentHandleTool);
    }
    if (this._hasSnapToGrid) {
      result.snapToGrid = JsonToBoolean.toJson(this._snapToGrid);
    }
    if (this._hasGridSize) {
      result.gridSize = JsonToDouble.toJson(this._gridSize);
    }
    if (this._hasDisableCollider) {
      result.disableCollider = JsonToBoolean.toJson(this._disableCollider);
    }
    if (this._hasUseRandomRotation) {
      result.useRandomRotation = JsonToBoolean.toJson(this._useRandomRotation);
    }
    if (this._hasUseRandomScale) {
      result.useRandomScale = JsonToBoolean.toJson(this._useRandomScale);
    }
    if (this._hasRandomRotationMin) {
      result.randomRotationMin = JsonToDouble.toJson(this._randomRotationMin);
    }
    if (this._hasRandomRotationMax) {
      result.randomRotationMax = JsonToDouble.toJson(this._randomRotationMax);
    }
    if (this._hasRandomScaleMin) {
      result.randomScaleMin = JsonToDouble.toJson(this._randomScaleMin);
    }
    if (this._hasRandomScaleMax) {
      result.randomScaleMax = JsonToDouble.toJson(this._randomScaleMax);
    }
    if (this._hasCurrentSelectedPropId) {
      result.currentSelectedPropId = JsonToString.toJson(this._currentSelectedPropId);
    }
    if (this._hasShowPropColliders) {
      result.showPropColliders = JsonToBoolean.toJson(this._showPropColliders);
    }
    if (this._hasCurrentColliderScale) {
      result.currentColliderScale = JsonToDouble.toJson(this._currentColliderScale);
    }
    if (this._hasCurrentPropLayer) {
      result.currentPropLayer = JsonToInt32.toJson(this._currentPropLayer);
    }
    if (this._hasCurrentPropGroup && !this._currentPropGroup.isEmpty()) {
      result.currentPropGroup = dcei_editor_terrain_proto.UndoablePropsGroup.toJson(this._currentPropGroup);
    }
    if (this._hasPastePropsMode) {
      result.pastePropsMode = JsonToBoolean.toJson(this._pastePropsMode);
    }
    if (this._hasCopyPropGroup && !this._copyPropGroup.isEmpty()) {
      result.copyPropGroup = dcei_editor_terrain_proto.UndoablePropsGroup.toJson(this._copyPropGroup);
    }
    if (this._hasReset) {
      result.reset = JsonToBoolean.toJson(this._reset);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get currentBrush() {
    return this._hasCurrentBrush ? this._currentBrush : TerrainEditorData_EditorPanel_BrushMode.default;
  }
  get hasCurrentBrush() {
    return this._hasCurrentBrush;
  }
  setCurrentBrush(path, value) {
    return {type: 'SET', path: path.concat(['currentBrush']), value};
  }
  deleteCurrentBrush(path) {
    return {type: 'DELETE', path: path.concat(['currentBrush'])};
  }
  /**
   * @returns {number}
   */
  get initialScale() {
    return this._hasInitialScale ? this._initialScale : JsonToDouble.default;
  }
  get hasInitialScale() {
    return this._hasInitialScale;
  }
  setInitialScale(path, value) {
    return {type: 'SET', path: path.concat(['initialScale']), value};
  }
  deleteInitialScale(path) {
    return {type: 'DELETE', path: path.concat(['initialScale'])};
  }
  /**
   * @returns {number}
   */
  get initialRotation() {
    return this._hasInitialRotation ? this._initialRotation : JsonToDouble.default;
  }
  get hasInitialRotation() {
    return this._hasInitialRotation;
  }
  setInitialRotation(path, value) {
    return {type: 'SET', path: path.concat(['initialRotation']), value};
  }
  deleteInitialRotation(path) {
    return {type: 'DELETE', path: path.concat(['initialRotation'])};
  }
  /**
   * @returns {number}
   */
  get heightOffset() {
    return this._hasHeightOffset ? this._heightOffset : JsonToDouble.default;
  }
  get hasHeightOffset() {
    return this._hasHeightOffset;
  }
  setHeightOffset(path, value) {
    return {type: 'SET', path: path.concat(['heightOffset']), value};
  }
  deleteHeightOffset(path) {
    return {type: 'DELETE', path: path.concat(['heightOffset'])};
  }
  /**
   * @returns {string}
   */
  get currentPrefabPath() {
    return this._hasCurrentPrefabPath ? this._currentPrefabPath : JsonToString.default;
  }
  get hasCurrentPrefabPath() {
    return this._hasCurrentPrefabPath;
  }
  setCurrentPrefabPath(path, value) {
    return {type: 'SET', path: path.concat(['currentPrefabPath']), value};
  }
  deleteCurrentPrefabPath(path) {
    return {type: 'DELETE', path: path.concat(['currentPrefabPath'])};
  }
  /**
   * @returns {number}
   */
  get currentHandleTool() {
    return this._hasCurrentHandleTool ? this._currentHandleTool : TerrainEditorData_EditorPanel_HandleTool.default;
  }
  get hasCurrentHandleTool() {
    return this._hasCurrentHandleTool;
  }
  setCurrentHandleTool(path, value) {
    return {type: 'SET', path: path.concat(['currentHandleTool']), value};
  }
  deleteCurrentHandleTool(path) {
    return {type: 'DELETE', path: path.concat(['currentHandleTool'])};
  }
  /**
   * @returns {boolean}
   */
  get snapToGrid() {
    return this._hasSnapToGrid ? this._snapToGrid : JsonToBoolean.default;
  }
  get hasSnapToGrid() {
    return this._hasSnapToGrid;
  }
  setSnapToGrid(path, value) {
    return {type: 'SET', path: path.concat(['snapToGrid']), value};
  }
  deleteSnapToGrid(path) {
    return {type: 'DELETE', path: path.concat(['snapToGrid'])};
  }
  /**
   * @returns {number}
   */
  get gridSize() {
    return this._hasGridSize ? this._gridSize : JsonToDouble.default;
  }
  get hasGridSize() {
    return this._hasGridSize;
  }
  setGridSize(path, value) {
    return {type: 'SET', path: path.concat(['gridSize']), value};
  }
  deleteGridSize(path) {
    return {type: 'DELETE', path: path.concat(['gridSize'])};
  }
  /**
   * @returns {boolean}
   */
  get disableCollider() {
    return this._hasDisableCollider ? this._disableCollider : JsonToBoolean.default;
  }
  get hasDisableCollider() {
    return this._hasDisableCollider;
  }
  setDisableCollider(path, value) {
    return {type: 'SET', path: path.concat(['disableCollider']), value};
  }
  deleteDisableCollider(path) {
    return {type: 'DELETE', path: path.concat(['disableCollider'])};
  }
  /**
   * @returns {boolean}
   */
  get useRandomRotation() {
    return this._hasUseRandomRotation ? this._useRandomRotation : JsonToBoolean.default;
  }
  get hasUseRandomRotation() {
    return this._hasUseRandomRotation;
  }
  setUseRandomRotation(path, value) {
    return {type: 'SET', path: path.concat(['useRandomRotation']), value};
  }
  deleteUseRandomRotation(path) {
    return {type: 'DELETE', path: path.concat(['useRandomRotation'])};
  }
  /**
   * @returns {boolean}
   */
  get useRandomScale() {
    return this._hasUseRandomScale ? this._useRandomScale : JsonToBoolean.default;
  }
  get hasUseRandomScale() {
    return this._hasUseRandomScale;
  }
  setUseRandomScale(path, value) {
    return {type: 'SET', path: path.concat(['useRandomScale']), value};
  }
  deleteUseRandomScale(path) {
    return {type: 'DELETE', path: path.concat(['useRandomScale'])};
  }
  /**
   * @returns {number}
   */
  get randomRotationMin() {
    return this._hasRandomRotationMin ? this._randomRotationMin : JsonToDouble.default;
  }
  get hasRandomRotationMin() {
    return this._hasRandomRotationMin;
  }
  setRandomRotationMin(path, value) {
    return {type: 'SET', path: path.concat(['randomRotationMin']), value};
  }
  deleteRandomRotationMin(path) {
    return {type: 'DELETE', path: path.concat(['randomRotationMin'])};
  }
  /**
   * @returns {number}
   */
  get randomRotationMax() {
    return this._hasRandomRotationMax ? this._randomRotationMax : JsonToDouble.default;
  }
  get hasRandomRotationMax() {
    return this._hasRandomRotationMax;
  }
  setRandomRotationMax(path, value) {
    return {type: 'SET', path: path.concat(['randomRotationMax']), value};
  }
  deleteRandomRotationMax(path) {
    return {type: 'DELETE', path: path.concat(['randomRotationMax'])};
  }
  /**
   * @returns {number}
   */
  get randomScaleMin() {
    return this._hasRandomScaleMin ? this._randomScaleMin : JsonToDouble.default;
  }
  get hasRandomScaleMin() {
    return this._hasRandomScaleMin;
  }
  setRandomScaleMin(path, value) {
    return {type: 'SET', path: path.concat(['randomScaleMin']), value};
  }
  deleteRandomScaleMin(path) {
    return {type: 'DELETE', path: path.concat(['randomScaleMin'])};
  }
  /**
   * @returns {number}
   */
  get randomScaleMax() {
    return this._hasRandomScaleMax ? this._randomScaleMax : JsonToDouble.default;
  }
  get hasRandomScaleMax() {
    return this._hasRandomScaleMax;
  }
  setRandomScaleMax(path, value) {
    return {type: 'SET', path: path.concat(['randomScaleMax']), value};
  }
  deleteRandomScaleMax(path) {
    return {type: 'DELETE', path: path.concat(['randomScaleMax'])};
  }
  /**
   * @returns {string}
   */
  get currentSelectedPropId() {
    return this._hasCurrentSelectedPropId ? this._currentSelectedPropId : JsonToString.default;
  }
  get hasCurrentSelectedPropId() {
    return this._hasCurrentSelectedPropId;
  }
  setCurrentSelectedPropId(path, value) {
    return {type: 'SET', path: path.concat(['currentSelectedPropId']), value};
  }
  deleteCurrentSelectedPropId(path) {
    return {type: 'DELETE', path: path.concat(['currentSelectedPropId'])};
  }
  /**
   * @returns {boolean}
   */
  get showPropColliders() {
    return this._hasShowPropColliders ? this._showPropColliders : JsonToBoolean.default;
  }
  get hasShowPropColliders() {
    return this._hasShowPropColliders;
  }
  setShowPropColliders(path, value) {
    return {type: 'SET', path: path.concat(['showPropColliders']), value};
  }
  deleteShowPropColliders(path) {
    return {type: 'DELETE', path: path.concat(['showPropColliders'])};
  }
  /**
   * @returns {number}
   */
  get currentColliderScale() {
    return this._hasCurrentColliderScale ? this._currentColliderScale : JsonToDouble.default;
  }
  get hasCurrentColliderScale() {
    return this._hasCurrentColliderScale;
  }
  setCurrentColliderScale(path, value) {
    return {type: 'SET', path: path.concat(['currentColliderScale']), value};
  }
  deleteCurrentColliderScale(path) {
    return {type: 'DELETE', path: path.concat(['currentColliderScale'])};
  }
  /**
   * @returns {number}
   */
  get currentPropLayer() {
    return this._hasCurrentPropLayer ? this._currentPropLayer : JsonToInt32.default;
  }
  get hasCurrentPropLayer() {
    return this._hasCurrentPropLayer;
  }
  setCurrentPropLayer(path, value) {
    return {type: 'SET', path: path.concat(['currentPropLayer']), value};
  }
  deleteCurrentPropLayer(path) {
    return {type: 'DELETE', path: path.concat(['currentPropLayer'])};
  }
  /**
   * @returns {dcei_editor_terrain_proto.UndoablePropsGroup}
   */
  get currentPropGroup() {
    return this._hasCurrentPropGroup ? this._currentPropGroup : dcei_editor_terrain_proto.UndoablePropsGroup.default;
  }
  get hasCurrentPropGroup() {
    return this._hasCurrentPropGroup;
  }
  setCurrentPropGroup(path, value) {
    return {type: 'SET', path: path.concat(['currentPropGroup']), value: value.toJson()};
  }
  deleteCurrentPropGroup(path) {
    return {type: 'DELETE', path: path.concat(['currentPropGroup'])};
  }
  /**
   * @returns {boolean}
   */
  get pastePropsMode() {
    return this._hasPastePropsMode ? this._pastePropsMode : JsonToBoolean.default;
  }
  get hasPastePropsMode() {
    return this._hasPastePropsMode;
  }
  setPastePropsMode(path, value) {
    return {type: 'SET', path: path.concat(['pastePropsMode']), value};
  }
  deletePastePropsMode(path) {
    return {type: 'DELETE', path: path.concat(['pastePropsMode'])};
  }
  /**
   * @returns {dcei_editor_terrain_proto.UndoablePropsGroup}
   */
  get copyPropGroup() {
    return this._hasCopyPropGroup ? this._copyPropGroup : dcei_editor_terrain_proto.UndoablePropsGroup.default;
  }
  get hasCopyPropGroup() {
    return this._hasCopyPropGroup;
  }
  setCopyPropGroup(path, value) {
    return {type: 'SET', path: path.concat(['copyPropGroup']), value: value.toJson()};
  }
  deleteCopyPropGroup(path) {
    return {type: 'DELETE', path: path.concat(['copyPropGroup'])};
  }
  /**
   * @returns {boolean}
   */
  get reset() {
    return this._hasReset ? this._reset : JsonToBoolean.default;
  }
  get hasReset() {
    return this._hasReset;
  }
  setReset(path, value) {
    return {type: 'SET', path: path.concat(['reset']), value};
  }
  deleteReset(path) {
    return {type: 'DELETE', path: path.concat(['reset'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "currentBrush": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasCurrentBrush = true;
              copy._currentBrush = TerrainEditorData_EditorPanel_BrushMode.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentBrush) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasCurrentBrush = false;
              copy._currentBrush = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "initialScale": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasInitialScale = true;
              copy._initialScale = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasInitialScale) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasInitialScale = false;
              copy._initialScale = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "initialRotation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasInitialRotation = true;
              copy._initialRotation = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasInitialRotation) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasInitialRotation = false;
              copy._initialRotation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "heightOffset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasHeightOffset = true;
              copy._heightOffset = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHeightOffset) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasHeightOffset = false;
              copy._heightOffset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currentPrefabPath": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasCurrentPrefabPath = true;
              copy._currentPrefabPath = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentPrefabPath) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasCurrentPrefabPath = false;
              copy._currentPrefabPath = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currentHandleTool": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasCurrentHandleTool = true;
              copy._currentHandleTool = TerrainEditorData_EditorPanel_HandleTool.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentHandleTool) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasCurrentHandleTool = false;
              copy._currentHandleTool = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "snapToGrid": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasSnapToGrid = true;
              copy._snapToGrid = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSnapToGrid) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasSnapToGrid = false;
              copy._snapToGrid = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "gridSize": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasGridSize = true;
              copy._gridSize = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGridSize) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasGridSize = false;
              copy._gridSize = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "disableCollider": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasDisableCollider = true;
              copy._disableCollider = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisableCollider) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasDisableCollider = false;
              copy._disableCollider = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "useRandomRotation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasUseRandomRotation = true;
              copy._useRandomRotation = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUseRandomRotation) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasUseRandomRotation = false;
              copy._useRandomRotation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "useRandomScale": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasUseRandomScale = true;
              copy._useRandomScale = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUseRandomScale) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasUseRandomScale = false;
              copy._useRandomScale = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "randomRotationMin": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasRandomRotationMin = true;
              copy._randomRotationMin = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRandomRotationMin) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasRandomRotationMin = false;
              copy._randomRotationMin = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "randomRotationMax": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasRandomRotationMax = true;
              copy._randomRotationMax = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRandomRotationMax) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasRandomRotationMax = false;
              copy._randomRotationMax = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "randomScaleMin": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasRandomScaleMin = true;
              copy._randomScaleMin = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRandomScaleMin) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasRandomScaleMin = false;
              copy._randomScaleMin = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "randomScaleMax": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasRandomScaleMax = true;
              copy._randomScaleMax = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRandomScaleMax) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasRandomScaleMax = false;
              copy._randomScaleMax = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currentSelectedPropId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasCurrentSelectedPropId = true;
              copy._currentSelectedPropId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentSelectedPropId) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasCurrentSelectedPropId = false;
              copy._currentSelectedPropId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "showPropColliders": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasShowPropColliders = true;
              copy._showPropColliders = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShowPropColliders) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasShowPropColliders = false;
              copy._showPropColliders = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currentColliderScale": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasCurrentColliderScale = true;
              copy._currentColliderScale = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentColliderScale) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasCurrentColliderScale = false;
              copy._currentColliderScale = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currentPropLayer": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasCurrentPropLayer = true;
              copy._currentPropLayer = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentPropLayer) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasCurrentPropLayer = false;
              copy._currentPropLayer = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currentPropGroup": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasCurrentPropGroup = true;
              copy._currentPropGroup = dcei_editor_terrain_proto.UndoablePropsGroup.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentPropGroup) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasCurrentPropGroup = false;
              copy._currentPropGroup = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCurrentPropGroup) {
            const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
            copy._hasCurrentPropGroup = true;
            copy._currentPropGroup = dcei_editor_terrain_proto.UndoablePropsGroup.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._currentPropGroup.apply(type, path.slice(1), value);
          if (newValue === this._currentPropGroup) {
            return this;
          }
          const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
          copy._currentPropGroup = copy._currentPropGroup.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "pastePropsMode": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasPastePropsMode = true;
              copy._pastePropsMode = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPastePropsMode) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasPastePropsMode = false;
              copy._pastePropsMode = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "copyPropGroup": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasCopyPropGroup = true;
              copy._copyPropGroup = dcei_editor_terrain_proto.UndoablePropsGroup.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCopyPropGroup) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasCopyPropGroup = false;
              copy._copyPropGroup = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCopyPropGroup) {
            const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
            copy._hasCopyPropGroup = true;
            copy._copyPropGroup = dcei_editor_terrain_proto.UndoablePropsGroup.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._copyPropGroup.apply(type, path.slice(1), value);
          if (newValue === this._copyPropGroup) {
            return this;
          }
          const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
          copy._copyPropGroup = copy._copyPropGroup.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "reset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasReset = true;
              copy._reset = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasReset) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
              copy._hasReset = false;
              copy._reset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TerrainEditorData_EditorPanel_PropEditor} other
   * @returns {TerrainEditorData_EditorPanel_PropEditor}
   */
  merge(other) {
    const copy = new TerrainEditorData_EditorPanel_PropEditor(this);
    if (other._hasCurrentBrush) {
      copy._hasCurrentBrush = true;
      copy._currentBrush = other._currentBrush;
    }
    if (other._hasInitialScale) {
      copy._hasInitialScale = true;
      copy._initialScale = other._initialScale;
    }
    if (other._hasInitialRotation) {
      copy._hasInitialRotation = true;
      copy._initialRotation = other._initialRotation;
    }
    if (other._hasHeightOffset) {
      copy._hasHeightOffset = true;
      copy._heightOffset = other._heightOffset;
    }
    if (other._hasCurrentPrefabPath) {
      copy._hasCurrentPrefabPath = true;
      copy._currentPrefabPath = other._currentPrefabPath;
    }
    if (other._hasCurrentHandleTool) {
      copy._hasCurrentHandleTool = true;
      copy._currentHandleTool = other._currentHandleTool;
    }
    if (other._hasSnapToGrid) {
      copy._hasSnapToGrid = true;
      copy._snapToGrid = other._snapToGrid;
    }
    if (other._hasGridSize) {
      copy._hasGridSize = true;
      copy._gridSize = other._gridSize;
    }
    if (other._hasDisableCollider) {
      copy._hasDisableCollider = true;
      copy._disableCollider = other._disableCollider;
    }
    if (other._hasUseRandomRotation) {
      copy._hasUseRandomRotation = true;
      copy._useRandomRotation = other._useRandomRotation;
    }
    if (other._hasUseRandomScale) {
      copy._hasUseRandomScale = true;
      copy._useRandomScale = other._useRandomScale;
    }
    if (other._hasRandomRotationMin) {
      copy._hasRandomRotationMin = true;
      copy._randomRotationMin = other._randomRotationMin;
    }
    if (other._hasRandomRotationMax) {
      copy._hasRandomRotationMax = true;
      copy._randomRotationMax = other._randomRotationMax;
    }
    if (other._hasRandomScaleMin) {
      copy._hasRandomScaleMin = true;
      copy._randomScaleMin = other._randomScaleMin;
    }
    if (other._hasRandomScaleMax) {
      copy._hasRandomScaleMax = true;
      copy._randomScaleMax = other._randomScaleMax;
    }
    if (other._hasCurrentSelectedPropId) {
      copy._hasCurrentSelectedPropId = true;
      copy._currentSelectedPropId = other._currentSelectedPropId;
    }
    if (other._hasShowPropColliders) {
      copy._hasShowPropColliders = true;
      copy._showPropColliders = other._showPropColliders;
    }
    if (other._hasCurrentColliderScale) {
      copy._hasCurrentColliderScale = true;
      copy._currentColliderScale = other._currentColliderScale;
    }
    if (other._hasCurrentPropLayer) {
      copy._hasCurrentPropLayer = true;
      copy._currentPropLayer = other._currentPropLayer;
    }
    if (other._hasCurrentPropGroup) {
      if (copy._hasCurrentPropGroup) {
        copy._currentPropGroup = copy.currentPropGroup.merge(other.currentPropGroup);
      } else {
        copy._currentPropGroup = other._currentPropGroup;
      }
      copy._hasCurrentPropGroup = true;
    }
    if (other._hasPastePropsMode) {
      copy._hasPastePropsMode = true;
      copy._pastePropsMode = other._pastePropsMode;
    }
    if (other._hasCopyPropGroup) {
      if (copy._hasCopyPropGroup) {
        copy._copyPropGroup = copy.copyPropGroup.merge(other.copyPropGroup);
      } else {
        copy._copyPropGroup = other._copyPropGroup;
      }
      copy._hasCopyPropGroup = true;
    }
    if (other._hasReset) {
      copy._hasReset = true;
      copy._reset = other._reset;
    }
    return copy;
  }
}
TerrainEditorData_EditorPanel_PropEditor.default = new TerrainEditorData_EditorPanel_PropEditor();
class TerrainEditorData_EditorPanel_PropEditor_Builder {
  constructor(value) {
    this._value = new TerrainEditorData_EditorPanel_PropEditor(value);
  }
  build() {
    return new TerrainEditorData_EditorPanel_PropEditor(this._value);
  }
  setCurrentBrush(value) {
    this._value._hasCurrentBrush = true;
    this._value._currentBrush = value;
    return this;
  }
  deleteCurrentBrush() {
    this._value._hasCurrentBrush = false;
    this._value._currentBrush = null;
    return this;
  }
  setInitialScale(value) {
    this._value._hasInitialScale = true;
    this._value._initialScale = value;
    return this;
  }
  deleteInitialScale() {
    this._value._hasInitialScale = false;
    this._value._initialScale = null;
    return this;
  }
  setInitialRotation(value) {
    this._value._hasInitialRotation = true;
    this._value._initialRotation = value;
    return this;
  }
  deleteInitialRotation() {
    this._value._hasInitialRotation = false;
    this._value._initialRotation = null;
    return this;
  }
  setHeightOffset(value) {
    this._value._hasHeightOffset = true;
    this._value._heightOffset = value;
    return this;
  }
  deleteHeightOffset() {
    this._value._hasHeightOffset = false;
    this._value._heightOffset = null;
    return this;
  }
  setCurrentPrefabPath(value) {
    this._value._hasCurrentPrefabPath = true;
    this._value._currentPrefabPath = value;
    return this;
  }
  deleteCurrentPrefabPath() {
    this._value._hasCurrentPrefabPath = false;
    this._value._currentPrefabPath = null;
    return this;
  }
  setCurrentHandleTool(value) {
    this._value._hasCurrentHandleTool = true;
    this._value._currentHandleTool = value;
    return this;
  }
  deleteCurrentHandleTool() {
    this._value._hasCurrentHandleTool = false;
    this._value._currentHandleTool = null;
    return this;
  }
  setSnapToGrid(value) {
    this._value._hasSnapToGrid = true;
    this._value._snapToGrid = value;
    return this;
  }
  deleteSnapToGrid() {
    this._value._hasSnapToGrid = false;
    this._value._snapToGrid = null;
    return this;
  }
  setGridSize(value) {
    this._value._hasGridSize = true;
    this._value._gridSize = value;
    return this;
  }
  deleteGridSize() {
    this._value._hasGridSize = false;
    this._value._gridSize = null;
    return this;
  }
  setDisableCollider(value) {
    this._value._hasDisableCollider = true;
    this._value._disableCollider = value;
    return this;
  }
  deleteDisableCollider() {
    this._value._hasDisableCollider = false;
    this._value._disableCollider = null;
    return this;
  }
  setUseRandomRotation(value) {
    this._value._hasUseRandomRotation = true;
    this._value._useRandomRotation = value;
    return this;
  }
  deleteUseRandomRotation() {
    this._value._hasUseRandomRotation = false;
    this._value._useRandomRotation = null;
    return this;
  }
  setUseRandomScale(value) {
    this._value._hasUseRandomScale = true;
    this._value._useRandomScale = value;
    return this;
  }
  deleteUseRandomScale() {
    this._value._hasUseRandomScale = false;
    this._value._useRandomScale = null;
    return this;
  }
  setRandomRotationMin(value) {
    this._value._hasRandomRotationMin = true;
    this._value._randomRotationMin = value;
    return this;
  }
  deleteRandomRotationMin() {
    this._value._hasRandomRotationMin = false;
    this._value._randomRotationMin = null;
    return this;
  }
  setRandomRotationMax(value) {
    this._value._hasRandomRotationMax = true;
    this._value._randomRotationMax = value;
    return this;
  }
  deleteRandomRotationMax() {
    this._value._hasRandomRotationMax = false;
    this._value._randomRotationMax = null;
    return this;
  }
  setRandomScaleMin(value) {
    this._value._hasRandomScaleMin = true;
    this._value._randomScaleMin = value;
    return this;
  }
  deleteRandomScaleMin() {
    this._value._hasRandomScaleMin = false;
    this._value._randomScaleMin = null;
    return this;
  }
  setRandomScaleMax(value) {
    this._value._hasRandomScaleMax = true;
    this._value._randomScaleMax = value;
    return this;
  }
  deleteRandomScaleMax() {
    this._value._hasRandomScaleMax = false;
    this._value._randomScaleMax = null;
    return this;
  }
  setCurrentSelectedPropId(value) {
    this._value._hasCurrentSelectedPropId = true;
    this._value._currentSelectedPropId = value;
    return this;
  }
  deleteCurrentSelectedPropId() {
    this._value._hasCurrentSelectedPropId = false;
    this._value._currentSelectedPropId = null;
    return this;
  }
  setShowPropColliders(value) {
    this._value._hasShowPropColliders = true;
    this._value._showPropColliders = value;
    return this;
  }
  deleteShowPropColliders() {
    this._value._hasShowPropColliders = false;
    this._value._showPropColliders = null;
    return this;
  }
  setCurrentColliderScale(value) {
    this._value._hasCurrentColliderScale = true;
    this._value._currentColliderScale = value;
    return this;
  }
  deleteCurrentColliderScale() {
    this._value._hasCurrentColliderScale = false;
    this._value._currentColliderScale = null;
    return this;
  }
  setCurrentPropLayer(value) {
    this._value._hasCurrentPropLayer = true;
    this._value._currentPropLayer = value;
    return this;
  }
  deleteCurrentPropLayer() {
    this._value._hasCurrentPropLayer = false;
    this._value._currentPropLayer = null;
    return this;
  }
  setCurrentPropGroup(value) {
    this._value._hasCurrentPropGroup = true;
    this._value._currentPropGroup = value;
    return this;
  }
  deleteCurrentPropGroup() {
    this._value._hasCurrentPropGroup = false;
    this._value._currentPropGroup = null;
    return this;
  }
  setPastePropsMode(value) {
    this._value._hasPastePropsMode = true;
    this._value._pastePropsMode = value;
    return this;
  }
  deletePastePropsMode() {
    this._value._hasPastePropsMode = false;
    this._value._pastePropsMode = null;
    return this;
  }
  setCopyPropGroup(value) {
    this._value._hasCopyPropGroup = true;
    this._value._copyPropGroup = value;
    return this;
  }
  deleteCopyPropGroup() {
    this._value._hasCopyPropGroup = false;
    this._value._copyPropGroup = null;
    return this;
  }
  setReset(value) {
    this._value._hasReset = true;
    this._value._reset = value;
    return this;
  }
  deleteReset() {
    this._value._hasReset = false;
    this._value._reset = null;
    return this;
  }
}
TerrainEditorData_EditorPanel_PropEditor.Builder = TerrainEditorData_EditorPanel_PropEditor_Builder;
class TerrainEditorData_EditorPanel_PropEditor_WithParent {
  /**
   * @param {TerrainEditorData_EditorPanel_PropEditor} value
   * @param {TerrainEditorData_EditorPanel_PropEditor_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TerrainEditorData_EditorPanel_PropEditor.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCurrentBrush() {
    if (this._cachedHasCurrentBrush === undefined) {
      if (this._value.hasCurrentBrush) {
        this._cachedHasCurrentBrush = true;
      } else {
        this._cachedHasCurrentBrush = this._parent ? this._parent.hasCurrentBrush : false;
      }
    }
    return this._cachedHasCurrentBrush;
  }
  get currentBrush() {
    if (this._cachedCurrentBrush === undefined) {
      if (this._value.hasCurrentBrush) {
        this._cachedCurrentBrush = this._value.currentBrush;
      } else {
        this._cachedCurrentBrush = this._parent ? this._parent.currentBrush : this._value.currentBrush;
      }
    }
    return this._cachedCurrentBrush;
  }
  get hasInitialScale() {
    if (this._cachedHasInitialScale === undefined) {
      if (this._value.hasInitialScale) {
        this._cachedHasInitialScale = true;
      } else {
        this._cachedHasInitialScale = this._parent ? this._parent.hasInitialScale : false;
      }
    }
    return this._cachedHasInitialScale;
  }
  get initialScale() {
    if (this._cachedInitialScale === undefined) {
      if (this._value.hasInitialScale) {
        this._cachedInitialScale = this._value.initialScale;
      } else {
        this._cachedInitialScale = this._parent ? this._parent.initialScale : this._value.initialScale;
      }
    }
    return this._cachedInitialScale;
  }
  get hasInitialRotation() {
    if (this._cachedHasInitialRotation === undefined) {
      if (this._value.hasInitialRotation) {
        this._cachedHasInitialRotation = true;
      } else {
        this._cachedHasInitialRotation = this._parent ? this._parent.hasInitialRotation : false;
      }
    }
    return this._cachedHasInitialRotation;
  }
  get initialRotation() {
    if (this._cachedInitialRotation === undefined) {
      if (this._value.hasInitialRotation) {
        this._cachedInitialRotation = this._value.initialRotation;
      } else {
        this._cachedInitialRotation = this._parent ? this._parent.initialRotation : this._value.initialRotation;
      }
    }
    return this._cachedInitialRotation;
  }
  get hasHeightOffset() {
    if (this._cachedHasHeightOffset === undefined) {
      if (this._value.hasHeightOffset) {
        this._cachedHasHeightOffset = true;
      } else {
        this._cachedHasHeightOffset = this._parent ? this._parent.hasHeightOffset : false;
      }
    }
    return this._cachedHasHeightOffset;
  }
  get heightOffset() {
    if (this._cachedHeightOffset === undefined) {
      if (this._value.hasHeightOffset) {
        this._cachedHeightOffset = this._value.heightOffset;
      } else {
        this._cachedHeightOffset = this._parent ? this._parent.heightOffset : this._value.heightOffset;
      }
    }
    return this._cachedHeightOffset;
  }
  get hasCurrentPrefabPath() {
    if (this._cachedHasCurrentPrefabPath === undefined) {
      if (this._value.hasCurrentPrefabPath) {
        this._cachedHasCurrentPrefabPath = true;
      } else {
        this._cachedHasCurrentPrefabPath = this._parent ? this._parent.hasCurrentPrefabPath : false;
      }
    }
    return this._cachedHasCurrentPrefabPath;
  }
  get currentPrefabPath() {
    if (this._cachedCurrentPrefabPath === undefined) {
      if (this._value.hasCurrentPrefabPath) {
        this._cachedCurrentPrefabPath = this._value.currentPrefabPath;
      } else {
        this._cachedCurrentPrefabPath = this._parent ? this._parent.currentPrefabPath : this._value.currentPrefabPath;
      }
    }
    return this._cachedCurrentPrefabPath;
  }
  get hasCurrentHandleTool() {
    if (this._cachedHasCurrentHandleTool === undefined) {
      if (this._value.hasCurrentHandleTool) {
        this._cachedHasCurrentHandleTool = true;
      } else {
        this._cachedHasCurrentHandleTool = this._parent ? this._parent.hasCurrentHandleTool : false;
      }
    }
    return this._cachedHasCurrentHandleTool;
  }
  get currentHandleTool() {
    if (this._cachedCurrentHandleTool === undefined) {
      if (this._value.hasCurrentHandleTool) {
        this._cachedCurrentHandleTool = this._value.currentHandleTool;
      } else {
        this._cachedCurrentHandleTool = this._parent ? this._parent.currentHandleTool : this._value.currentHandleTool;
      }
    }
    return this._cachedCurrentHandleTool;
  }
  get hasSnapToGrid() {
    if (this._cachedHasSnapToGrid === undefined) {
      if (this._value.hasSnapToGrid) {
        this._cachedHasSnapToGrid = true;
      } else {
        this._cachedHasSnapToGrid = this._parent ? this._parent.hasSnapToGrid : false;
      }
    }
    return this._cachedHasSnapToGrid;
  }
  get snapToGrid() {
    if (this._cachedSnapToGrid === undefined) {
      if (this._value.hasSnapToGrid) {
        this._cachedSnapToGrid = this._value.snapToGrid;
      } else {
        this._cachedSnapToGrid = this._parent ? this._parent.snapToGrid : this._value.snapToGrid;
      }
    }
    return this._cachedSnapToGrid;
  }
  get hasGridSize() {
    if (this._cachedHasGridSize === undefined) {
      if (this._value.hasGridSize) {
        this._cachedHasGridSize = true;
      } else {
        this._cachedHasGridSize = this._parent ? this._parent.hasGridSize : false;
      }
    }
    return this._cachedHasGridSize;
  }
  get gridSize() {
    if (this._cachedGridSize === undefined) {
      if (this._value.hasGridSize) {
        this._cachedGridSize = this._value.gridSize;
      } else {
        this._cachedGridSize = this._parent ? this._parent.gridSize : this._value.gridSize;
      }
    }
    return this._cachedGridSize;
  }
  get hasDisableCollider() {
    if (this._cachedHasDisableCollider === undefined) {
      if (this._value.hasDisableCollider) {
        this._cachedHasDisableCollider = true;
      } else {
        this._cachedHasDisableCollider = this._parent ? this._parent.hasDisableCollider : false;
      }
    }
    return this._cachedHasDisableCollider;
  }
  get disableCollider() {
    if (this._cachedDisableCollider === undefined) {
      if (this._value.hasDisableCollider) {
        this._cachedDisableCollider = this._value.disableCollider;
      } else {
        this._cachedDisableCollider = this._parent ? this._parent.disableCollider : this._value.disableCollider;
      }
    }
    return this._cachedDisableCollider;
  }
  get hasUseRandomRotation() {
    if (this._cachedHasUseRandomRotation === undefined) {
      if (this._value.hasUseRandomRotation) {
        this._cachedHasUseRandomRotation = true;
      } else {
        this._cachedHasUseRandomRotation = this._parent ? this._parent.hasUseRandomRotation : false;
      }
    }
    return this._cachedHasUseRandomRotation;
  }
  get useRandomRotation() {
    if (this._cachedUseRandomRotation === undefined) {
      if (this._value.hasUseRandomRotation) {
        this._cachedUseRandomRotation = this._value.useRandomRotation;
      } else {
        this._cachedUseRandomRotation = this._parent ? this._parent.useRandomRotation : this._value.useRandomRotation;
      }
    }
    return this._cachedUseRandomRotation;
  }
  get hasUseRandomScale() {
    if (this._cachedHasUseRandomScale === undefined) {
      if (this._value.hasUseRandomScale) {
        this._cachedHasUseRandomScale = true;
      } else {
        this._cachedHasUseRandomScale = this._parent ? this._parent.hasUseRandomScale : false;
      }
    }
    return this._cachedHasUseRandomScale;
  }
  get useRandomScale() {
    if (this._cachedUseRandomScale === undefined) {
      if (this._value.hasUseRandomScale) {
        this._cachedUseRandomScale = this._value.useRandomScale;
      } else {
        this._cachedUseRandomScale = this._parent ? this._parent.useRandomScale : this._value.useRandomScale;
      }
    }
    return this._cachedUseRandomScale;
  }
  get hasRandomRotationMin() {
    if (this._cachedHasRandomRotationMin === undefined) {
      if (this._value.hasRandomRotationMin) {
        this._cachedHasRandomRotationMin = true;
      } else {
        this._cachedHasRandomRotationMin = this._parent ? this._parent.hasRandomRotationMin : false;
      }
    }
    return this._cachedHasRandomRotationMin;
  }
  get randomRotationMin() {
    if (this._cachedRandomRotationMin === undefined) {
      if (this._value.hasRandomRotationMin) {
        this._cachedRandomRotationMin = this._value.randomRotationMin;
      } else {
        this._cachedRandomRotationMin = this._parent ? this._parent.randomRotationMin : this._value.randomRotationMin;
      }
    }
    return this._cachedRandomRotationMin;
  }
  get hasRandomRotationMax() {
    if (this._cachedHasRandomRotationMax === undefined) {
      if (this._value.hasRandomRotationMax) {
        this._cachedHasRandomRotationMax = true;
      } else {
        this._cachedHasRandomRotationMax = this._parent ? this._parent.hasRandomRotationMax : false;
      }
    }
    return this._cachedHasRandomRotationMax;
  }
  get randomRotationMax() {
    if (this._cachedRandomRotationMax === undefined) {
      if (this._value.hasRandomRotationMax) {
        this._cachedRandomRotationMax = this._value.randomRotationMax;
      } else {
        this._cachedRandomRotationMax = this._parent ? this._parent.randomRotationMax : this._value.randomRotationMax;
      }
    }
    return this._cachedRandomRotationMax;
  }
  get hasRandomScaleMin() {
    if (this._cachedHasRandomScaleMin === undefined) {
      if (this._value.hasRandomScaleMin) {
        this._cachedHasRandomScaleMin = true;
      } else {
        this._cachedHasRandomScaleMin = this._parent ? this._parent.hasRandomScaleMin : false;
      }
    }
    return this._cachedHasRandomScaleMin;
  }
  get randomScaleMin() {
    if (this._cachedRandomScaleMin === undefined) {
      if (this._value.hasRandomScaleMin) {
        this._cachedRandomScaleMin = this._value.randomScaleMin;
      } else {
        this._cachedRandomScaleMin = this._parent ? this._parent.randomScaleMin : this._value.randomScaleMin;
      }
    }
    return this._cachedRandomScaleMin;
  }
  get hasRandomScaleMax() {
    if (this._cachedHasRandomScaleMax === undefined) {
      if (this._value.hasRandomScaleMax) {
        this._cachedHasRandomScaleMax = true;
      } else {
        this._cachedHasRandomScaleMax = this._parent ? this._parent.hasRandomScaleMax : false;
      }
    }
    return this._cachedHasRandomScaleMax;
  }
  get randomScaleMax() {
    if (this._cachedRandomScaleMax === undefined) {
      if (this._value.hasRandomScaleMax) {
        this._cachedRandomScaleMax = this._value.randomScaleMax;
      } else {
        this._cachedRandomScaleMax = this._parent ? this._parent.randomScaleMax : this._value.randomScaleMax;
      }
    }
    return this._cachedRandomScaleMax;
  }
  get hasCurrentSelectedPropId() {
    if (this._cachedHasCurrentSelectedPropId === undefined) {
      if (this._value.hasCurrentSelectedPropId) {
        this._cachedHasCurrentSelectedPropId = true;
      } else {
        this._cachedHasCurrentSelectedPropId = this._parent ? this._parent.hasCurrentSelectedPropId : false;
      }
    }
    return this._cachedHasCurrentSelectedPropId;
  }
  get currentSelectedPropId() {
    if (this._cachedCurrentSelectedPropId === undefined) {
      if (this._value.hasCurrentSelectedPropId) {
        this._cachedCurrentSelectedPropId = this._value.currentSelectedPropId;
      } else {
        this._cachedCurrentSelectedPropId = this._parent ? this._parent.currentSelectedPropId : this._value.currentSelectedPropId;
      }
    }
    return this._cachedCurrentSelectedPropId;
  }
  get hasShowPropColliders() {
    if (this._cachedHasShowPropColliders === undefined) {
      if (this._value.hasShowPropColliders) {
        this._cachedHasShowPropColliders = true;
      } else {
        this._cachedHasShowPropColliders = this._parent ? this._parent.hasShowPropColliders : false;
      }
    }
    return this._cachedHasShowPropColliders;
  }
  get showPropColliders() {
    if (this._cachedShowPropColliders === undefined) {
      if (this._value.hasShowPropColliders) {
        this._cachedShowPropColliders = this._value.showPropColliders;
      } else {
        this._cachedShowPropColliders = this._parent ? this._parent.showPropColliders : this._value.showPropColliders;
      }
    }
    return this._cachedShowPropColliders;
  }
  get hasCurrentColliderScale() {
    if (this._cachedHasCurrentColliderScale === undefined) {
      if (this._value.hasCurrentColliderScale) {
        this._cachedHasCurrentColliderScale = true;
      } else {
        this._cachedHasCurrentColliderScale = this._parent ? this._parent.hasCurrentColliderScale : false;
      }
    }
    return this._cachedHasCurrentColliderScale;
  }
  get currentColliderScale() {
    if (this._cachedCurrentColliderScale === undefined) {
      if (this._value.hasCurrentColliderScale) {
        this._cachedCurrentColliderScale = this._value.currentColliderScale;
      } else {
        this._cachedCurrentColliderScale = this._parent ? this._parent.currentColliderScale : this._value.currentColliderScale;
      }
    }
    return this._cachedCurrentColliderScale;
  }
  get hasCurrentPropLayer() {
    if (this._cachedHasCurrentPropLayer === undefined) {
      if (this._value.hasCurrentPropLayer) {
        this._cachedHasCurrentPropLayer = true;
      } else {
        this._cachedHasCurrentPropLayer = this._parent ? this._parent.hasCurrentPropLayer : false;
      }
    }
    return this._cachedHasCurrentPropLayer;
  }
  get currentPropLayer() {
    if (this._cachedCurrentPropLayer === undefined) {
      if (this._value.hasCurrentPropLayer) {
        this._cachedCurrentPropLayer = this._value.currentPropLayer;
      } else {
        this._cachedCurrentPropLayer = this._parent ? this._parent.currentPropLayer : this._value.currentPropLayer;
      }
    }
    return this._cachedCurrentPropLayer;
  }
  get hasCurrentPropGroup() {
    if (this._cachedHasCurrentPropGroup === undefined) {
      if (this._value.hasCurrentPropGroup) {
        this._cachedHasCurrentPropGroup = true;
      } else {
        this._cachedHasCurrentPropGroup = this._parent ? this._parent.hasCurrentPropGroup : false;
      }
    }
    return this._cachedHasCurrentPropGroup;
  }
  get currentPropGroup() {
    if (!this._cachedCurrentPropGroup) {
      if (this._value.hasCurrentPropGroup) {
        this._cachedCurrentPropGroup = new dcei_editor_terrain_proto.UndoablePropsGroup.WithParent(this._value.currentPropGroup, this._parent && this._parent.hasCurrentPropGroup ? this._parent.currentPropGroup : null);
      } else {
        this._cachedCurrentPropGroup = this._parent ? new dcei_editor_terrain_proto.UndoablePropsGroup.WithParent(dcei_editor_terrain_proto.UndoablePropsGroup.default, this._parent.currentPropGroup) : dcei_editor_terrain_proto.UndoablePropsGroup.WithParent.default;
      }
    }
    return this._cachedCurrentPropGroup;
  }
  get hasPastePropsMode() {
    if (this._cachedHasPastePropsMode === undefined) {
      if (this._value.hasPastePropsMode) {
        this._cachedHasPastePropsMode = true;
      } else {
        this._cachedHasPastePropsMode = this._parent ? this._parent.hasPastePropsMode : false;
      }
    }
    return this._cachedHasPastePropsMode;
  }
  get pastePropsMode() {
    if (this._cachedPastePropsMode === undefined) {
      if (this._value.hasPastePropsMode) {
        this._cachedPastePropsMode = this._value.pastePropsMode;
      } else {
        this._cachedPastePropsMode = this._parent ? this._parent.pastePropsMode : this._value.pastePropsMode;
      }
    }
    return this._cachedPastePropsMode;
  }
  get hasCopyPropGroup() {
    if (this._cachedHasCopyPropGroup === undefined) {
      if (this._value.hasCopyPropGroup) {
        this._cachedHasCopyPropGroup = true;
      } else {
        this._cachedHasCopyPropGroup = this._parent ? this._parent.hasCopyPropGroup : false;
      }
    }
    return this._cachedHasCopyPropGroup;
  }
  get copyPropGroup() {
    if (!this._cachedCopyPropGroup) {
      if (this._value.hasCopyPropGroup) {
        this._cachedCopyPropGroup = new dcei_editor_terrain_proto.UndoablePropsGroup.WithParent(this._value.copyPropGroup, this._parent && this._parent.hasCopyPropGroup ? this._parent.copyPropGroup : null);
      } else {
        this._cachedCopyPropGroup = this._parent ? new dcei_editor_terrain_proto.UndoablePropsGroup.WithParent(dcei_editor_terrain_proto.UndoablePropsGroup.default, this._parent.copyPropGroup) : dcei_editor_terrain_proto.UndoablePropsGroup.WithParent.default;
      }
    }
    return this._cachedCopyPropGroup;
  }
  get hasReset() {
    if (this._cachedHasReset === undefined) {
      if (this._value.hasReset) {
        this._cachedHasReset = true;
      } else {
        this._cachedHasReset = this._parent ? this._parent.hasReset : false;
      }
    }
    return this._cachedHasReset;
  }
  get reset() {
    if (this._cachedReset === undefined) {
      if (this._value.hasReset) {
        this._cachedReset = this._value.reset;
      } else {
        this._cachedReset = this._parent ? this._parent.reset : this._value.reset;
      }
    }
    return this._cachedReset;
  }
  update(current, parent) {
    const result = new TerrainEditorData_EditorPanel_PropEditor_WithParent(current, parent);
    if (this._cachedCurrentPropGroup && this._value.hasCurrentPropGroup && current.hasCurrentPropGroup) {
      if (this._value.currentPropGroup === current.currentPropGroup && this._parent === parent) {
        result._cachedCurrentPropGroup = this._cachedCurrentPropGroup;
      } else {
        result._cachedCurrentPropGroup = this._cachedCurrentPropGroup.update(current.currentPropGroup, parent && parent.hasCurrentPropGroup ? parent.currentPropGroup : null);
      }
    }
    if (this._cachedCopyPropGroup && this._value.hasCopyPropGroup && current.hasCopyPropGroup) {
      if (this._value.copyPropGroup === current.copyPropGroup && this._parent === parent) {
        result._cachedCopyPropGroup = this._cachedCopyPropGroup;
      } else {
        result._cachedCopyPropGroup = this._cachedCopyPropGroup.update(current.copyPropGroup, parent && parent.hasCopyPropGroup ? parent.copyPropGroup : null);
      }
    }
    return result;
  }
}
TerrainEditorData_EditorPanel_PropEditor_WithParent.default = new TerrainEditorData_EditorPanel_PropEditor_WithParent(TerrainEditorData_EditorPanel_PropEditor.default, null);
TerrainEditorData_EditorPanel_PropEditor.WithParent = TerrainEditorData_EditorPanel_PropEditor_WithParent;
class TerrainEditorData_EditorPanel_PropEditor_Descriptor {
  get currentBrush() {
    if (!this._currentBrush) {
      this._currentBrush = {
        name: "currentBrush",
        Name: "CurrentBrush",
        number: 1,
        protoType: 14,
        protoName: "current_brush",
        type: TerrainEditorData_EditorPanel_BrushMode,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentBrush;
  }
  get initialScale() {
    if (!this._initialScale) {
      this._initialScale = {
        name: "initialScale",
        Name: "InitialScale",
        number: 2,
        protoType: 1,
        protoName: "initial_scale",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._initialScale;
  }
  get initialRotation() {
    if (!this._initialRotation) {
      this._initialRotation = {
        name: "initialRotation",
        Name: "InitialRotation",
        number: 3,
        protoType: 1,
        protoName: "initial_rotation",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._initialRotation;
  }
  get heightOffset() {
    if (!this._heightOffset) {
      this._heightOffset = {
        name: "heightOffset",
        Name: "HeightOffset",
        number: 50,
        protoType: 1,
        protoName: "height_offset",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._heightOffset;
  }
  get currentPrefabPath() {
    if (!this._currentPrefabPath) {
      this._currentPrefabPath = {
        name: "currentPrefabPath",
        Name: "CurrentPrefabPath",
        number: 4,
        protoType: 9,
        protoName: "current_prefab_path",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentPrefabPath;
  }
  get currentHandleTool() {
    if (!this._currentHandleTool) {
      this._currentHandleTool = {
        name: "currentHandleTool",
        Name: "CurrentHandleTool",
        number: 5,
        protoType: 14,
        protoName: "current_handle_tool",
        type: TerrainEditorData_EditorPanel_HandleTool,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentHandleTool;
  }
  get snapToGrid() {
    if (!this._snapToGrid) {
      this._snapToGrid = {
        name: "snapToGrid",
        Name: "SnapToGrid",
        number: 6,
        protoType: 8,
        protoName: "snap_to_grid",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._snapToGrid;
  }
  get gridSize() {
    if (!this._gridSize) {
      this._gridSize = {
        name: "gridSize",
        Name: "GridSize",
        number: 16,
        protoType: 1,
        protoName: "grid_size",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gridSize;
  }
  get disableCollider() {
    if (!this._disableCollider) {
      this._disableCollider = {
        name: "disableCollider",
        Name: "DisableCollider",
        number: 7,
        protoType: 8,
        protoName: "disable_collider",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._disableCollider;
  }
  get useRandomRotation() {
    if (!this._useRandomRotation) {
      this._useRandomRotation = {
        name: "useRandomRotation",
        Name: "UseRandomRotation",
        number: 8,
        protoType: 8,
        protoName: "use_random_rotation",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._useRandomRotation;
  }
  get useRandomScale() {
    if (!this._useRandomScale) {
      this._useRandomScale = {
        name: "useRandomScale",
        Name: "UseRandomScale",
        number: 9,
        protoType: 8,
        protoName: "use_random_scale",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._useRandomScale;
  }
  get randomRotationMin() {
    if (!this._randomRotationMin) {
      this._randomRotationMin = {
        name: "randomRotationMin",
        Name: "RandomRotationMin",
        number: 10,
        protoType: 1,
        protoName: "random_rotation_min",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._randomRotationMin;
  }
  get randomRotationMax() {
    if (!this._randomRotationMax) {
      this._randomRotationMax = {
        name: "randomRotationMax",
        Name: "RandomRotationMax",
        number: 11,
        protoType: 1,
        protoName: "random_rotation_max",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._randomRotationMax;
  }
  get randomScaleMin() {
    if (!this._randomScaleMin) {
      this._randomScaleMin = {
        name: "randomScaleMin",
        Name: "RandomScaleMin",
        number: 12,
        protoType: 1,
        protoName: "random_scale_min",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._randomScaleMin;
  }
  get randomScaleMax() {
    if (!this._randomScaleMax) {
      this._randomScaleMax = {
        name: "randomScaleMax",
        Name: "RandomScaleMax",
        number: 13,
        protoType: 1,
        protoName: "random_scale_max",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._randomScaleMax;
  }
  get currentSelectedPropId() {
    if (!this._currentSelectedPropId) {
      this._currentSelectedPropId = {
        name: "currentSelectedPropId",
        Name: "CurrentSelectedPropId",
        number: 14,
        protoType: 9,
        protoName: "current_selected_prop_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentSelectedPropId;
  }
  get showPropColliders() {
    if (!this._showPropColliders) {
      this._showPropColliders = {
        name: "showPropColliders",
        Name: "ShowPropColliders",
        number: 15,
        protoType: 8,
        protoName: "show_prop_colliders",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._showPropColliders;
  }
  get currentColliderScale() {
    if (!this._currentColliderScale) {
      this._currentColliderScale = {
        name: "currentColliderScale",
        Name: "CurrentColliderScale",
        number: 17,
        protoType: 1,
        protoName: "current_collider_scale",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentColliderScale;
  }
  get currentPropLayer() {
    if (!this._currentPropLayer) {
      this._currentPropLayer = {
        name: "currentPropLayer",
        Name: "CurrentPropLayer",
        number: 18,
        protoType: 5,
        protoName: "current_prop_layer",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentPropLayer;
  }
  get currentPropGroup() {
    if (!this._currentPropGroup) {
      this._currentPropGroup = {
        name: "currentPropGroup",
        Name: "CurrentPropGroup",
        number: 30,
        protoType: 11,
        protoName: "current_prop_group",
        type: dcei_editor_terrain_proto.UndoablePropsGroup,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentPropGroup;
  }
  get pastePropsMode() {
    if (!this._pastePropsMode) {
      this._pastePropsMode = {
        name: "pastePropsMode",
        Name: "PastePropsMode",
        number: 31,
        protoType: 8,
        protoName: "paste_props_mode",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._pastePropsMode;
  }
  get copyPropGroup() {
    if (!this._copyPropGroup) {
      this._copyPropGroup = {
        name: "copyPropGroup",
        Name: "CopyPropGroup",
        number: 32,
        protoType: 11,
        protoName: "copy_prop_group",
        type: dcei_editor_terrain_proto.UndoablePropsGroup,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._copyPropGroup;
  }
  get reset() {
    if (!this._reset) {
      this._reset = {
        name: "reset",
        Name: "Reset",
        number: 99,
        protoType: 8,
        protoName: "reset",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._reset;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.currentBrush,
        this.initialScale,
        this.initialRotation,
        this.heightOffset,
        this.currentPrefabPath,
        this.currentHandleTool,
        this.snapToGrid,
        this.gridSize,
        this.disableCollider,
        this.useRandomRotation,
        this.useRandomScale,
        this.randomRotationMin,
        this.randomRotationMax,
        this.randomScaleMin,
        this.randomScaleMax,
        this.currentSelectedPropId,
        this.showPropColliders,
        this.currentColliderScale,
        this.currentPropLayer,
        this.currentPropGroup,
        this.pastePropsMode,
        this.copyPropGroup,
        this.reset,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCurrentBrush",
        Name: "DummyOneofForCurrentBrush",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForInitialScale",
        Name: "DummyOneofForInitialScale",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForInitialRotation",
        Name: "DummyOneofForInitialRotation",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHeightOffset",
        Name: "DummyOneofForHeightOffset",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrentPrefabPath",
        Name: "DummyOneofForCurrentPrefabPath",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrentHandleTool",
        Name: "DummyOneofForCurrentHandleTool",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSnapToGrid",
        Name: "DummyOneofForSnapToGrid",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGridSize",
        Name: "DummyOneofForGridSize",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisableCollider",
        Name: "DummyOneofForDisableCollider",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUseRandomRotation",
        Name: "DummyOneofForUseRandomRotation",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUseRandomScale",
        Name: "DummyOneofForUseRandomScale",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRandomRotationMin",
        Name: "DummyOneofForRandomRotationMin",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRandomRotationMax",
        Name: "DummyOneofForRandomRotationMax",
        fields: [
          this.fields[12],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRandomScaleMin",
        Name: "DummyOneofForRandomScaleMin",
        fields: [
          this.fields[13],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRandomScaleMax",
        Name: "DummyOneofForRandomScaleMax",
        fields: [
          this.fields[14],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrentSelectedPropId",
        Name: "DummyOneofForCurrentSelectedPropId",
        fields: [
          this.fields[15],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShowPropColliders",
        Name: "DummyOneofForShowPropColliders",
        fields: [
          this.fields[16],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrentColliderScale",
        Name: "DummyOneofForCurrentColliderScale",
        fields: [
          this.fields[17],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrentPropLayer",
        Name: "DummyOneofForCurrentPropLayer",
        fields: [
          this.fields[18],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrentPropGroup",
        Name: "DummyOneofForCurrentPropGroup",
        fields: [
          this.fields[19],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPastePropsMode",
        Name: "DummyOneofForPastePropsMode",
        fields: [
          this.fields[20],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCopyPropGroup",
        Name: "DummyOneofForCopyPropGroup",
        fields: [
          this.fields[21],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForReset",
        Name: "DummyOneofForReset",
        fields: [
          this.fields[22],
        ],
      });
    }
    return this._oneofs;
  }
}
TerrainEditorData_EditorPanel_PropEditor.descriptor = new TerrainEditorData_EditorPanel_PropEditor_Descriptor();
class TerrainEditorData_EditorPanel_WaterEditor {
  get descriptor() {
    return TerrainEditorData_EditorPanel_WaterEditor.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCurrentBrush = false;
    this._currentBrush = null;
    this._hasWaterLevel = false;
    this._waterLevel = null;
    this._hasReset = false;
    this._reset = null;
  }
  isEmpty() {
    if (this._hasCurrentBrush) return false;
    if (this._hasWaterLevel) return false;
    if (this._hasReset) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TerrainEditorData_EditorPanel_WaterEditor) {
      return value;
    }
    return TerrainEditorData_EditorPanel_WaterEditor.fromJson(value);
  }
  static fromJson(json) {
    const result = new TerrainEditorData_EditorPanel_WaterEditor();
    if (json.currentBrush != null) {
      result._hasCurrentBrush = true;
      result._currentBrush = TerrainEditorData_EditorPanel_BrushMode.fromJson(json.currentBrush);
    }
    if (json.waterLevel != null) {
      result._hasWaterLevel = true;
      result._waterLevel = JsonToDouble.fromJson(json.waterLevel);
    }
    if (json.reset != null) {
      result._hasReset = true;
      result._reset = JsonToBoolean.fromJson(json.reset);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCurrentBrush) {
      result.currentBrush = TerrainEditorData_EditorPanel_BrushMode.toJson(this._currentBrush);
    }
    if (this._hasWaterLevel) {
      result.waterLevel = JsonToDouble.toJson(this._waterLevel);
    }
    if (this._hasReset) {
      result.reset = JsonToBoolean.toJson(this._reset);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get currentBrush() {
    return this._hasCurrentBrush ? this._currentBrush : TerrainEditorData_EditorPanel_BrushMode.default;
  }
  get hasCurrentBrush() {
    return this._hasCurrentBrush;
  }
  setCurrentBrush(path, value) {
    return {type: 'SET', path: path.concat(['currentBrush']), value};
  }
  deleteCurrentBrush(path) {
    return {type: 'DELETE', path: path.concat(['currentBrush'])};
  }
  /**
   * @returns {number}
   */
  get waterLevel() {
    return this._hasWaterLevel ? this._waterLevel : JsonToDouble.default;
  }
  get hasWaterLevel() {
    return this._hasWaterLevel;
  }
  setWaterLevel(path, value) {
    return {type: 'SET', path: path.concat(['waterLevel']), value};
  }
  deleteWaterLevel(path) {
    return {type: 'DELETE', path: path.concat(['waterLevel'])};
  }
  /**
   * @returns {boolean}
   */
  get reset() {
    return this._hasReset ? this._reset : JsonToBoolean.default;
  }
  get hasReset() {
    return this._hasReset;
  }
  setReset(path, value) {
    return {type: 'SET', path: path.concat(['reset']), value};
  }
  deleteReset(path) {
    return {type: 'DELETE', path: path.concat(['reset'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "currentBrush": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_WaterEditor(this);
              copy._hasCurrentBrush = true;
              copy._currentBrush = TerrainEditorData_EditorPanel_BrushMode.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentBrush) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_WaterEditor(this);
              copy._hasCurrentBrush = false;
              copy._currentBrush = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "waterLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_WaterEditor(this);
              copy._hasWaterLevel = true;
              copy._waterLevel = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWaterLevel) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_WaterEditor(this);
              copy._hasWaterLevel = false;
              copy._waterLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "reset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_WaterEditor(this);
              copy._hasReset = true;
              copy._reset = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasReset) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_WaterEditor(this);
              copy._hasReset = false;
              copy._reset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TerrainEditorData_EditorPanel_WaterEditor} other
   * @returns {TerrainEditorData_EditorPanel_WaterEditor}
   */
  merge(other) {
    const copy = new TerrainEditorData_EditorPanel_WaterEditor(this);
    if (other._hasCurrentBrush) {
      copy._hasCurrentBrush = true;
      copy._currentBrush = other._currentBrush;
    }
    if (other._hasWaterLevel) {
      copy._hasWaterLevel = true;
      copy._waterLevel = other._waterLevel;
    }
    if (other._hasReset) {
      copy._hasReset = true;
      copy._reset = other._reset;
    }
    return copy;
  }
}
TerrainEditorData_EditorPanel_WaterEditor.default = new TerrainEditorData_EditorPanel_WaterEditor();
class TerrainEditorData_EditorPanel_WaterEditor_Builder {
  constructor(value) {
    this._value = new TerrainEditorData_EditorPanel_WaterEditor(value);
  }
  build() {
    return new TerrainEditorData_EditorPanel_WaterEditor(this._value);
  }
  setCurrentBrush(value) {
    this._value._hasCurrentBrush = true;
    this._value._currentBrush = value;
    return this;
  }
  deleteCurrentBrush() {
    this._value._hasCurrentBrush = false;
    this._value._currentBrush = null;
    return this;
  }
  setWaterLevel(value) {
    this._value._hasWaterLevel = true;
    this._value._waterLevel = value;
    return this;
  }
  deleteWaterLevel() {
    this._value._hasWaterLevel = false;
    this._value._waterLevel = null;
    return this;
  }
  setReset(value) {
    this._value._hasReset = true;
    this._value._reset = value;
    return this;
  }
  deleteReset() {
    this._value._hasReset = false;
    this._value._reset = null;
    return this;
  }
}
TerrainEditorData_EditorPanel_WaterEditor.Builder = TerrainEditorData_EditorPanel_WaterEditor_Builder;
class TerrainEditorData_EditorPanel_WaterEditor_WithParent {
  /**
   * @param {TerrainEditorData_EditorPanel_WaterEditor} value
   * @param {TerrainEditorData_EditorPanel_WaterEditor_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TerrainEditorData_EditorPanel_WaterEditor.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCurrentBrush() {
    if (this._cachedHasCurrentBrush === undefined) {
      if (this._value.hasCurrentBrush) {
        this._cachedHasCurrentBrush = true;
      } else {
        this._cachedHasCurrentBrush = this._parent ? this._parent.hasCurrentBrush : false;
      }
    }
    return this._cachedHasCurrentBrush;
  }
  get currentBrush() {
    if (this._cachedCurrentBrush === undefined) {
      if (this._value.hasCurrentBrush) {
        this._cachedCurrentBrush = this._value.currentBrush;
      } else {
        this._cachedCurrentBrush = this._parent ? this._parent.currentBrush : this._value.currentBrush;
      }
    }
    return this._cachedCurrentBrush;
  }
  get hasWaterLevel() {
    if (this._cachedHasWaterLevel === undefined) {
      if (this._value.hasWaterLevel) {
        this._cachedHasWaterLevel = true;
      } else {
        this._cachedHasWaterLevel = this._parent ? this._parent.hasWaterLevel : false;
      }
    }
    return this._cachedHasWaterLevel;
  }
  get waterLevel() {
    if (this._cachedWaterLevel === undefined) {
      if (this._value.hasWaterLevel) {
        this._cachedWaterLevel = this._value.waterLevel;
      } else {
        this._cachedWaterLevel = this._parent ? this._parent.waterLevel : this._value.waterLevel;
      }
    }
    return this._cachedWaterLevel;
  }
  get hasReset() {
    if (this._cachedHasReset === undefined) {
      if (this._value.hasReset) {
        this._cachedHasReset = true;
      } else {
        this._cachedHasReset = this._parent ? this._parent.hasReset : false;
      }
    }
    return this._cachedHasReset;
  }
  get reset() {
    if (this._cachedReset === undefined) {
      if (this._value.hasReset) {
        this._cachedReset = this._value.reset;
      } else {
        this._cachedReset = this._parent ? this._parent.reset : this._value.reset;
      }
    }
    return this._cachedReset;
  }
  update(current, parent) {
    const result = new TerrainEditorData_EditorPanel_WaterEditor_WithParent(current, parent);
    return result;
  }
}
TerrainEditorData_EditorPanel_WaterEditor_WithParent.default = new TerrainEditorData_EditorPanel_WaterEditor_WithParent(TerrainEditorData_EditorPanel_WaterEditor.default, null);
TerrainEditorData_EditorPanel_WaterEditor.WithParent = TerrainEditorData_EditorPanel_WaterEditor_WithParent;
class TerrainEditorData_EditorPanel_WaterEditor_Descriptor {
  get currentBrush() {
    if (!this._currentBrush) {
      this._currentBrush = {
        name: "currentBrush",
        Name: "CurrentBrush",
        number: 1,
        protoType: 14,
        protoName: "current_brush",
        type: TerrainEditorData_EditorPanel_BrushMode,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentBrush;
  }
  get waterLevel() {
    if (!this._waterLevel) {
      this._waterLevel = {
        name: "waterLevel",
        Name: "WaterLevel",
        number: 2,
        protoType: 1,
        protoName: "water_level",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._waterLevel;
  }
  get reset() {
    if (!this._reset) {
      this._reset = {
        name: "reset",
        Name: "Reset",
        number: 99,
        protoType: 8,
        protoName: "reset",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._reset;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.currentBrush,
        this.waterLevel,
        this.reset,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCurrentBrush",
        Name: "DummyOneofForCurrentBrush",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWaterLevel",
        Name: "DummyOneofForWaterLevel",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForReset",
        Name: "DummyOneofForReset",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
TerrainEditorData_EditorPanel_WaterEditor.descriptor = new TerrainEditorData_EditorPanel_WaterEditor_Descriptor();
class TerrainEditorData_EditorPanel_WayPointsEditor {
  get descriptor() {
    return TerrainEditorData_EditorPanel_WayPointsEditor.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCurrentBrush = false;
    this._currentBrush = null;
    this._hasNodeSize = false;
    this._nodeSize = null;
    this._hasNodeCurvature = false;
    this._nodeCurvature = null;
    this._hasCurrentPathId = false;
    this._currentPathId = null;
    this._hasCurrentSelectedNodeId = false;
    this._currentSelectedNodeId = null;
    this._hasReset = false;
    this._reset = null;
  }
  isEmpty() {
    if (this._hasCurrentBrush) return false;
    if (this._hasNodeSize) return false;
    if (this._hasNodeCurvature) return false;
    if (this._hasCurrentPathId) return false;
    if (this._hasCurrentSelectedNodeId) return false;
    if (this._hasReset) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TerrainEditorData_EditorPanel_WayPointsEditor) {
      return value;
    }
    return TerrainEditorData_EditorPanel_WayPointsEditor.fromJson(value);
  }
  static fromJson(json) {
    const result = new TerrainEditorData_EditorPanel_WayPointsEditor();
    if (json.currentBrush != null) {
      result._hasCurrentBrush = true;
      result._currentBrush = TerrainEditorData_EditorPanel_BrushMode.fromJson(json.currentBrush);
    }
    if (json.nodeSize != null) {
      result._hasNodeSize = true;
      result._nodeSize = JsonToDouble.fromJson(json.nodeSize);
    }
    if (json.nodeCurvature != null) {
      result._hasNodeCurvature = true;
      result._nodeCurvature = JsonToDouble.fromJson(json.nodeCurvature);
    }
    if (json.currentPathId != null) {
      result._hasCurrentPathId = true;
      result._currentPathId = JsonToString.fromJson(json.currentPathId);
    }
    if (json.currentSelectedNodeId != null) {
      result._hasCurrentSelectedNodeId = true;
      result._currentSelectedNodeId = JsonToString.fromJson(json.currentSelectedNodeId);
    }
    if (json.reset != null) {
      result._hasReset = true;
      result._reset = JsonToBoolean.fromJson(json.reset);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCurrentBrush) {
      result.currentBrush = TerrainEditorData_EditorPanel_BrushMode.toJson(this._currentBrush);
    }
    if (this._hasNodeSize) {
      result.nodeSize = JsonToDouble.toJson(this._nodeSize);
    }
    if (this._hasNodeCurvature) {
      result.nodeCurvature = JsonToDouble.toJson(this._nodeCurvature);
    }
    if (this._hasCurrentPathId) {
      result.currentPathId = JsonToString.toJson(this._currentPathId);
    }
    if (this._hasCurrentSelectedNodeId) {
      result.currentSelectedNodeId = JsonToString.toJson(this._currentSelectedNodeId);
    }
    if (this._hasReset) {
      result.reset = JsonToBoolean.toJson(this._reset);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get currentBrush() {
    return this._hasCurrentBrush ? this._currentBrush : TerrainEditorData_EditorPanel_BrushMode.default;
  }
  get hasCurrentBrush() {
    return this._hasCurrentBrush;
  }
  setCurrentBrush(path, value) {
    return {type: 'SET', path: path.concat(['currentBrush']), value};
  }
  deleteCurrentBrush(path) {
    return {type: 'DELETE', path: path.concat(['currentBrush'])};
  }
  /**
   * @returns {number}
   */
  get nodeSize() {
    return this._hasNodeSize ? this._nodeSize : JsonToDouble.default;
  }
  get hasNodeSize() {
    return this._hasNodeSize;
  }
  setNodeSize(path, value) {
    return {type: 'SET', path: path.concat(['nodeSize']), value};
  }
  deleteNodeSize(path) {
    return {type: 'DELETE', path: path.concat(['nodeSize'])};
  }
  /**
   * @returns {number}
   */
  get nodeCurvature() {
    return this._hasNodeCurvature ? this._nodeCurvature : JsonToDouble.default;
  }
  get hasNodeCurvature() {
    return this._hasNodeCurvature;
  }
  setNodeCurvature(path, value) {
    return {type: 'SET', path: path.concat(['nodeCurvature']), value};
  }
  deleteNodeCurvature(path) {
    return {type: 'DELETE', path: path.concat(['nodeCurvature'])};
  }
  /**
   * @returns {string}
   */
  get currentPathId() {
    return this._hasCurrentPathId ? this._currentPathId : JsonToString.default;
  }
  get hasCurrentPathId() {
    return this._hasCurrentPathId;
  }
  setCurrentPathId(path, value) {
    return {type: 'SET', path: path.concat(['currentPathId']), value};
  }
  deleteCurrentPathId(path) {
    return {type: 'DELETE', path: path.concat(['currentPathId'])};
  }
  /**
   * @returns {string}
   */
  get currentSelectedNodeId() {
    return this._hasCurrentSelectedNodeId ? this._currentSelectedNodeId : JsonToString.default;
  }
  get hasCurrentSelectedNodeId() {
    return this._hasCurrentSelectedNodeId;
  }
  setCurrentSelectedNodeId(path, value) {
    return {type: 'SET', path: path.concat(['currentSelectedNodeId']), value};
  }
  deleteCurrentSelectedNodeId(path) {
    return {type: 'DELETE', path: path.concat(['currentSelectedNodeId'])};
  }
  /**
   * @returns {boolean}
   */
  get reset() {
    return this._hasReset ? this._reset : JsonToBoolean.default;
  }
  get hasReset() {
    return this._hasReset;
  }
  setReset(path, value) {
    return {type: 'SET', path: path.concat(['reset']), value};
  }
  deleteReset(path) {
    return {type: 'DELETE', path: path.concat(['reset'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "currentBrush": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_WayPointsEditor(this);
              copy._hasCurrentBrush = true;
              copy._currentBrush = TerrainEditorData_EditorPanel_BrushMode.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentBrush) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_WayPointsEditor(this);
              copy._hasCurrentBrush = false;
              copy._currentBrush = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "nodeSize": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_WayPointsEditor(this);
              copy._hasNodeSize = true;
              copy._nodeSize = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasNodeSize) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_WayPointsEditor(this);
              copy._hasNodeSize = false;
              copy._nodeSize = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "nodeCurvature": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_WayPointsEditor(this);
              copy._hasNodeCurvature = true;
              copy._nodeCurvature = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasNodeCurvature) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_WayPointsEditor(this);
              copy._hasNodeCurvature = false;
              copy._nodeCurvature = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currentPathId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_WayPointsEditor(this);
              copy._hasCurrentPathId = true;
              copy._currentPathId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentPathId) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_WayPointsEditor(this);
              copy._hasCurrentPathId = false;
              copy._currentPathId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currentSelectedNodeId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_WayPointsEditor(this);
              copy._hasCurrentSelectedNodeId = true;
              copy._currentSelectedNodeId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentSelectedNodeId) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_WayPointsEditor(this);
              copy._hasCurrentSelectedNodeId = false;
              copy._currentSelectedNodeId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "reset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_WayPointsEditor(this);
              copy._hasReset = true;
              copy._reset = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasReset) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_WayPointsEditor(this);
              copy._hasReset = false;
              copy._reset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TerrainEditorData_EditorPanel_WayPointsEditor} other
   * @returns {TerrainEditorData_EditorPanel_WayPointsEditor}
   */
  merge(other) {
    const copy = new TerrainEditorData_EditorPanel_WayPointsEditor(this);
    if (other._hasCurrentBrush) {
      copy._hasCurrentBrush = true;
      copy._currentBrush = other._currentBrush;
    }
    if (other._hasNodeSize) {
      copy._hasNodeSize = true;
      copy._nodeSize = other._nodeSize;
    }
    if (other._hasNodeCurvature) {
      copy._hasNodeCurvature = true;
      copy._nodeCurvature = other._nodeCurvature;
    }
    if (other._hasCurrentPathId) {
      copy._hasCurrentPathId = true;
      copy._currentPathId = other._currentPathId;
    }
    if (other._hasCurrentSelectedNodeId) {
      copy._hasCurrentSelectedNodeId = true;
      copy._currentSelectedNodeId = other._currentSelectedNodeId;
    }
    if (other._hasReset) {
      copy._hasReset = true;
      copy._reset = other._reset;
    }
    return copy;
  }
}
TerrainEditorData_EditorPanel_WayPointsEditor.default = new TerrainEditorData_EditorPanel_WayPointsEditor();
class TerrainEditorData_EditorPanel_WayPointsEditor_Builder {
  constructor(value) {
    this._value = new TerrainEditorData_EditorPanel_WayPointsEditor(value);
  }
  build() {
    return new TerrainEditorData_EditorPanel_WayPointsEditor(this._value);
  }
  setCurrentBrush(value) {
    this._value._hasCurrentBrush = true;
    this._value._currentBrush = value;
    return this;
  }
  deleteCurrentBrush() {
    this._value._hasCurrentBrush = false;
    this._value._currentBrush = null;
    return this;
  }
  setNodeSize(value) {
    this._value._hasNodeSize = true;
    this._value._nodeSize = value;
    return this;
  }
  deleteNodeSize() {
    this._value._hasNodeSize = false;
    this._value._nodeSize = null;
    return this;
  }
  setNodeCurvature(value) {
    this._value._hasNodeCurvature = true;
    this._value._nodeCurvature = value;
    return this;
  }
  deleteNodeCurvature() {
    this._value._hasNodeCurvature = false;
    this._value._nodeCurvature = null;
    return this;
  }
  setCurrentPathId(value) {
    this._value._hasCurrentPathId = true;
    this._value._currentPathId = value;
    return this;
  }
  deleteCurrentPathId() {
    this._value._hasCurrentPathId = false;
    this._value._currentPathId = null;
    return this;
  }
  setCurrentSelectedNodeId(value) {
    this._value._hasCurrentSelectedNodeId = true;
    this._value._currentSelectedNodeId = value;
    return this;
  }
  deleteCurrentSelectedNodeId() {
    this._value._hasCurrentSelectedNodeId = false;
    this._value._currentSelectedNodeId = null;
    return this;
  }
  setReset(value) {
    this._value._hasReset = true;
    this._value._reset = value;
    return this;
  }
  deleteReset() {
    this._value._hasReset = false;
    this._value._reset = null;
    return this;
  }
}
TerrainEditorData_EditorPanel_WayPointsEditor.Builder = TerrainEditorData_EditorPanel_WayPointsEditor_Builder;
class TerrainEditorData_EditorPanel_WayPointsEditor_WithParent {
  /**
   * @param {TerrainEditorData_EditorPanel_WayPointsEditor} value
   * @param {TerrainEditorData_EditorPanel_WayPointsEditor_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TerrainEditorData_EditorPanel_WayPointsEditor.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCurrentBrush() {
    if (this._cachedHasCurrentBrush === undefined) {
      if (this._value.hasCurrentBrush) {
        this._cachedHasCurrentBrush = true;
      } else {
        this._cachedHasCurrentBrush = this._parent ? this._parent.hasCurrentBrush : false;
      }
    }
    return this._cachedHasCurrentBrush;
  }
  get currentBrush() {
    if (this._cachedCurrentBrush === undefined) {
      if (this._value.hasCurrentBrush) {
        this._cachedCurrentBrush = this._value.currentBrush;
      } else {
        this._cachedCurrentBrush = this._parent ? this._parent.currentBrush : this._value.currentBrush;
      }
    }
    return this._cachedCurrentBrush;
  }
  get hasNodeSize() {
    if (this._cachedHasNodeSize === undefined) {
      if (this._value.hasNodeSize) {
        this._cachedHasNodeSize = true;
      } else {
        this._cachedHasNodeSize = this._parent ? this._parent.hasNodeSize : false;
      }
    }
    return this._cachedHasNodeSize;
  }
  get nodeSize() {
    if (this._cachedNodeSize === undefined) {
      if (this._value.hasNodeSize) {
        this._cachedNodeSize = this._value.nodeSize;
      } else {
        this._cachedNodeSize = this._parent ? this._parent.nodeSize : this._value.nodeSize;
      }
    }
    return this._cachedNodeSize;
  }
  get hasNodeCurvature() {
    if (this._cachedHasNodeCurvature === undefined) {
      if (this._value.hasNodeCurvature) {
        this._cachedHasNodeCurvature = true;
      } else {
        this._cachedHasNodeCurvature = this._parent ? this._parent.hasNodeCurvature : false;
      }
    }
    return this._cachedHasNodeCurvature;
  }
  get nodeCurvature() {
    if (this._cachedNodeCurvature === undefined) {
      if (this._value.hasNodeCurvature) {
        this._cachedNodeCurvature = this._value.nodeCurvature;
      } else {
        this._cachedNodeCurvature = this._parent ? this._parent.nodeCurvature : this._value.nodeCurvature;
      }
    }
    return this._cachedNodeCurvature;
  }
  get hasCurrentPathId() {
    if (this._cachedHasCurrentPathId === undefined) {
      if (this._value.hasCurrentPathId) {
        this._cachedHasCurrentPathId = true;
      } else {
        this._cachedHasCurrentPathId = this._parent ? this._parent.hasCurrentPathId : false;
      }
    }
    return this._cachedHasCurrentPathId;
  }
  get currentPathId() {
    if (this._cachedCurrentPathId === undefined) {
      if (this._value.hasCurrentPathId) {
        this._cachedCurrentPathId = this._value.currentPathId;
      } else {
        this._cachedCurrentPathId = this._parent ? this._parent.currentPathId : this._value.currentPathId;
      }
    }
    return this._cachedCurrentPathId;
  }
  get hasCurrentSelectedNodeId() {
    if (this._cachedHasCurrentSelectedNodeId === undefined) {
      if (this._value.hasCurrentSelectedNodeId) {
        this._cachedHasCurrentSelectedNodeId = true;
      } else {
        this._cachedHasCurrentSelectedNodeId = this._parent ? this._parent.hasCurrentSelectedNodeId : false;
      }
    }
    return this._cachedHasCurrentSelectedNodeId;
  }
  get currentSelectedNodeId() {
    if (this._cachedCurrentSelectedNodeId === undefined) {
      if (this._value.hasCurrentSelectedNodeId) {
        this._cachedCurrentSelectedNodeId = this._value.currentSelectedNodeId;
      } else {
        this._cachedCurrentSelectedNodeId = this._parent ? this._parent.currentSelectedNodeId : this._value.currentSelectedNodeId;
      }
    }
    return this._cachedCurrentSelectedNodeId;
  }
  get hasReset() {
    if (this._cachedHasReset === undefined) {
      if (this._value.hasReset) {
        this._cachedHasReset = true;
      } else {
        this._cachedHasReset = this._parent ? this._parent.hasReset : false;
      }
    }
    return this._cachedHasReset;
  }
  get reset() {
    if (this._cachedReset === undefined) {
      if (this._value.hasReset) {
        this._cachedReset = this._value.reset;
      } else {
        this._cachedReset = this._parent ? this._parent.reset : this._value.reset;
      }
    }
    return this._cachedReset;
  }
  update(current, parent) {
    const result = new TerrainEditorData_EditorPanel_WayPointsEditor_WithParent(current, parent);
    return result;
  }
}
TerrainEditorData_EditorPanel_WayPointsEditor_WithParent.default = new TerrainEditorData_EditorPanel_WayPointsEditor_WithParent(TerrainEditorData_EditorPanel_WayPointsEditor.default, null);
TerrainEditorData_EditorPanel_WayPointsEditor.WithParent = TerrainEditorData_EditorPanel_WayPointsEditor_WithParent;
class TerrainEditorData_EditorPanel_WayPointsEditor_Descriptor {
  get currentBrush() {
    if (!this._currentBrush) {
      this._currentBrush = {
        name: "currentBrush",
        Name: "CurrentBrush",
        number: 1,
        protoType: 14,
        protoName: "current_brush",
        type: TerrainEditorData_EditorPanel_BrushMode,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentBrush;
  }
  get nodeSize() {
    if (!this._nodeSize) {
      this._nodeSize = {
        name: "nodeSize",
        Name: "NodeSize",
        number: 2,
        protoType: 1,
        protoName: "node_size",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._nodeSize;
  }
  get nodeCurvature() {
    if (!this._nodeCurvature) {
      this._nodeCurvature = {
        name: "nodeCurvature",
        Name: "NodeCurvature",
        number: 3,
        protoType: 1,
        protoName: "node_curvature",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._nodeCurvature;
  }
  get currentPathId() {
    if (!this._currentPathId) {
      this._currentPathId = {
        name: "currentPathId",
        Name: "CurrentPathId",
        number: 4,
        protoType: 9,
        protoName: "current_path_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentPathId;
  }
  get currentSelectedNodeId() {
    if (!this._currentSelectedNodeId) {
      this._currentSelectedNodeId = {
        name: "currentSelectedNodeId",
        Name: "CurrentSelectedNodeId",
        number: 5,
        protoType: 9,
        protoName: "current_selected_node_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentSelectedNodeId;
  }
  get reset() {
    if (!this._reset) {
      this._reset = {
        name: "reset",
        Name: "Reset",
        number: 99,
        protoType: 8,
        protoName: "reset",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._reset;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.currentBrush,
        this.nodeSize,
        this.nodeCurvature,
        this.currentPathId,
        this.currentSelectedNodeId,
        this.reset,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCurrentBrush",
        Name: "DummyOneofForCurrentBrush",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForNodeSize",
        Name: "DummyOneofForNodeSize",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForNodeCurvature",
        Name: "DummyOneofForNodeCurvature",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrentPathId",
        Name: "DummyOneofForCurrentPathId",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrentSelectedNodeId",
        Name: "DummyOneofForCurrentSelectedNodeId",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForReset",
        Name: "DummyOneofForReset",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
TerrainEditorData_EditorPanel_WayPointsEditor.descriptor = new TerrainEditorData_EditorPanel_WayPointsEditor_Descriptor();
class TerrainEditorData_EditorPanel_UnitsEditor {
  get descriptor() {
    return TerrainEditorData_EditorPanel_UnitsEditor.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCurrentBrush = false;
    this._currentBrush = null;
    this._hasInitialRotation = false;
    this._initialRotation = null;
    this._hasCurrentUnit = false;
    this._currentUnit = null;
    this._hasCurrentHandleTool = false;
    this._currentHandleTool = null;
    this._hasSnapToGrid = false;
    this._snapToGrid = null;
    this._hasCurrentSelectedUnitId = false;
    this._currentSelectedUnitId = null;
    this._hasUseRandomRotation = false;
    this._useRandomRotation = null;
    this._hasRandomRotationMin = false;
    this._randomRotationMin = null;
    this._hasRandomRotationMax = false;
    this._randomRotationMax = null;
    this._hasGridSize = false;
    this._gridSize = null;
    this._hasCurrentTeam = false;
    this._currentTeam = null;
    this._hasCurrentPlayer = false;
    this._currentPlayer = null;
    this._hasRangeIndicatorDisplay = false;
    this._rangeIndicatorDisplay = null;
    this._hasRangeIndicatorSize = false;
    this._rangeIndicatorSize = null;
    this._hasDisableCollider = false;
    this._disableCollider = null;
    this._hasShowUnitColliders = false;
    this._showUnitColliders = null;
    this._hasShowWeaponScanRange = false;
    this._showWeaponScanRange = null;
    this._hasShowWeaponRange = false;
    this._showWeaponRange = null;
    this._hasShowUnitEngageRange = false;
    this._showUnitEngageRange = null;
    this._hasShowDefenseRadius = false;
    this._showDefenseRadius = null;
    this._hasShowResetRadius = false;
    this._showResetRadius = null;
    this._hasShowUnitRadius = false;
    this._showUnitRadius = null;
    this._hasShowUnitBoundingSphere = false;
    this._showUnitBoundingSphere = null;
    this._hasCurrentUnitsGroup = false;
    this._currentUnitsGroup = null;
    this._hasReset = false;
    this._reset = null;
  }
  isEmpty() {
    if (this._hasCurrentBrush) return false;
    if (this._hasInitialRotation) return false;
    if (this._hasCurrentUnit) return false;
    if (this._hasCurrentHandleTool) return false;
    if (this._hasSnapToGrid) return false;
    if (this._hasCurrentSelectedUnitId) return false;
    if (this._hasUseRandomRotation) return false;
    if (this._hasRandomRotationMin) return false;
    if (this._hasRandomRotationMax) return false;
    if (this._hasGridSize) return false;
    if (this._hasCurrentTeam) return false;
    if (this._hasCurrentPlayer) return false;
    if (this._hasRangeIndicatorDisplay) return false;
    if (this._hasRangeIndicatorSize) return false;
    if (this._hasDisableCollider) return false;
    if (this._hasShowUnitColliders) return false;
    if (this._hasShowWeaponScanRange) return false;
    if (this._hasShowWeaponRange) return false;
    if (this._hasShowUnitEngageRange) return false;
    if (this._hasShowDefenseRadius) return false;
    if (this._hasShowResetRadius) return false;
    if (this._hasShowUnitRadius) return false;
    if (this._hasShowUnitBoundingSphere) return false;
    if (this._hasCurrentUnitsGroup && !this._currentUnitsGroup.isEmpty()) return false;
    if (this._hasReset) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TerrainEditorData_EditorPanel_UnitsEditor) {
      return value;
    }
    return TerrainEditorData_EditorPanel_UnitsEditor.fromJson(value);
  }
  static fromJson(json) {
    const result = new TerrainEditorData_EditorPanel_UnitsEditor();
    if (json.currentBrush != null) {
      result._hasCurrentBrush = true;
      result._currentBrush = TerrainEditorData_EditorPanel_BrushMode.fromJson(json.currentBrush);
    }
    if (json.initialRotation != null) {
      result._hasInitialRotation = true;
      result._initialRotation = JsonToDouble.fromJson(json.initialRotation);
    }
    if (json.currentUnit != null) {
      result._hasCurrentUnit = true;
      result._currentUnit = JsonToString.fromJson(json.currentUnit);
    }
    if (json.currentHandleTool != null) {
      result._hasCurrentHandleTool = true;
      result._currentHandleTool = TerrainEditorData_EditorPanel_HandleTool.fromJson(json.currentHandleTool);
    }
    if (json.snapToGrid != null) {
      result._hasSnapToGrid = true;
      result._snapToGrid = JsonToBoolean.fromJson(json.snapToGrid);
    }
    if (json.currentSelectedUnitId != null) {
      result._hasCurrentSelectedUnitId = true;
      result._currentSelectedUnitId = JsonToString.fromJson(json.currentSelectedUnitId);
    }
    if (json.useRandomRotation != null) {
      result._hasUseRandomRotation = true;
      result._useRandomRotation = JsonToBoolean.fromJson(json.useRandomRotation);
    }
    if (json.randomRotationMin != null) {
      result._hasRandomRotationMin = true;
      result._randomRotationMin = JsonToDouble.fromJson(json.randomRotationMin);
    }
    if (json.randomRotationMax != null) {
      result._hasRandomRotationMax = true;
      result._randomRotationMax = JsonToDouble.fromJson(json.randomRotationMax);
    }
    if (json.gridSize != null) {
      result._hasGridSize = true;
      result._gridSize = JsonToDouble.fromJson(json.gridSize);
    }
    if (json.currentTeam != null) {
      result._hasCurrentTeam = true;
      result._currentTeam = dcei_editor_terrain_proto.Team.fromJson(json.currentTeam);
    }
    if (json.currentPlayer != null) {
      result._hasCurrentPlayer = true;
      result._currentPlayer = JsonToInt32.fromJson(json.currentPlayer);
    }
    if (json.rangeIndicatorDisplay != null) {
      result._hasRangeIndicatorDisplay = true;
      result._rangeIndicatorDisplay = JsonToBoolean.fromJson(json.rangeIndicatorDisplay);
    }
    if (json.rangeIndicatorSize != null) {
      result._hasRangeIndicatorSize = true;
      result._rangeIndicatorSize = JsonToDouble.fromJson(json.rangeIndicatorSize);
    }
    if (json.disableCollider != null) {
      result._hasDisableCollider = true;
      result._disableCollider = JsonToBoolean.fromJson(json.disableCollider);
    }
    if (json.showUnitColliders != null) {
      result._hasShowUnitColliders = true;
      result._showUnitColliders = JsonToBoolean.fromJson(json.showUnitColliders);
    }
    if (json.showWeaponScanRange != null) {
      result._hasShowWeaponScanRange = true;
      result._showWeaponScanRange = JsonToBoolean.fromJson(json.showWeaponScanRange);
    }
    if (json.showWeaponRange != null) {
      result._hasShowWeaponRange = true;
      result._showWeaponRange = JsonToBoolean.fromJson(json.showWeaponRange);
    }
    if (json.showUnitEngageRange != null) {
      result._hasShowUnitEngageRange = true;
      result._showUnitEngageRange = JsonToBoolean.fromJson(json.showUnitEngageRange);
    }
    if (json.showDefenseRadius != null) {
      result._hasShowDefenseRadius = true;
      result._showDefenseRadius = JsonToBoolean.fromJson(json.showDefenseRadius);
    }
    if (json.showResetRadius != null) {
      result._hasShowResetRadius = true;
      result._showResetRadius = JsonToBoolean.fromJson(json.showResetRadius);
    }
    if (json.showUnitRadius != null) {
      result._hasShowUnitRadius = true;
      result._showUnitRadius = JsonToBoolean.fromJson(json.showUnitRadius);
    }
    if (json.showUnitBoundingSphere != null) {
      result._hasShowUnitBoundingSphere = true;
      result._showUnitBoundingSphere = JsonToBoolean.fromJson(json.showUnitBoundingSphere);
    }
    if (json.currentUnitsGroup != null) {
      result._hasCurrentUnitsGroup = true;
      result._currentUnitsGroup = dcei_editor_terrain_proto.UndoableUnitsGroup.fromJson(json.currentUnitsGroup);
    }
    if (json.reset != null) {
      result._hasReset = true;
      result._reset = JsonToBoolean.fromJson(json.reset);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCurrentBrush) {
      result.currentBrush = TerrainEditorData_EditorPanel_BrushMode.toJson(this._currentBrush);
    }
    if (this._hasInitialRotation) {
      result.initialRotation = JsonToDouble.toJson(this._initialRotation);
    }
    if (this._hasCurrentUnit) {
      result.currentUnit = JsonToString.toJson(this._currentUnit);
    }
    if (this._hasCurrentHandleTool) {
      result.currentHandleTool = TerrainEditorData_EditorPanel_HandleTool.toJson(this._currentHandleTool);
    }
    if (this._hasSnapToGrid) {
      result.snapToGrid = JsonToBoolean.toJson(this._snapToGrid);
    }
    if (this._hasCurrentSelectedUnitId) {
      result.currentSelectedUnitId = JsonToString.toJson(this._currentSelectedUnitId);
    }
    if (this._hasUseRandomRotation) {
      result.useRandomRotation = JsonToBoolean.toJson(this._useRandomRotation);
    }
    if (this._hasRandomRotationMin) {
      result.randomRotationMin = JsonToDouble.toJson(this._randomRotationMin);
    }
    if (this._hasRandomRotationMax) {
      result.randomRotationMax = JsonToDouble.toJson(this._randomRotationMax);
    }
    if (this._hasGridSize) {
      result.gridSize = JsonToDouble.toJson(this._gridSize);
    }
    if (this._hasCurrentTeam) {
      result.currentTeam = dcei_editor_terrain_proto.Team.toJson(this._currentTeam);
    }
    if (this._hasCurrentPlayer) {
      result.currentPlayer = JsonToInt32.toJson(this._currentPlayer);
    }
    if (this._hasRangeIndicatorDisplay) {
      result.rangeIndicatorDisplay = JsonToBoolean.toJson(this._rangeIndicatorDisplay);
    }
    if (this._hasRangeIndicatorSize) {
      result.rangeIndicatorSize = JsonToDouble.toJson(this._rangeIndicatorSize);
    }
    if (this._hasDisableCollider) {
      result.disableCollider = JsonToBoolean.toJson(this._disableCollider);
    }
    if (this._hasShowUnitColliders) {
      result.showUnitColliders = JsonToBoolean.toJson(this._showUnitColliders);
    }
    if (this._hasShowWeaponScanRange) {
      result.showWeaponScanRange = JsonToBoolean.toJson(this._showWeaponScanRange);
    }
    if (this._hasShowWeaponRange) {
      result.showWeaponRange = JsonToBoolean.toJson(this._showWeaponRange);
    }
    if (this._hasShowUnitEngageRange) {
      result.showUnitEngageRange = JsonToBoolean.toJson(this._showUnitEngageRange);
    }
    if (this._hasShowDefenseRadius) {
      result.showDefenseRadius = JsonToBoolean.toJson(this._showDefenseRadius);
    }
    if (this._hasShowResetRadius) {
      result.showResetRadius = JsonToBoolean.toJson(this._showResetRadius);
    }
    if (this._hasShowUnitRadius) {
      result.showUnitRadius = JsonToBoolean.toJson(this._showUnitRadius);
    }
    if (this._hasShowUnitBoundingSphere) {
      result.showUnitBoundingSphere = JsonToBoolean.toJson(this._showUnitBoundingSphere);
    }
    if (this._hasCurrentUnitsGroup && !this._currentUnitsGroup.isEmpty()) {
      result.currentUnitsGroup = dcei_editor_terrain_proto.UndoableUnitsGroup.toJson(this._currentUnitsGroup);
    }
    if (this._hasReset) {
      result.reset = JsonToBoolean.toJson(this._reset);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get currentBrush() {
    return this._hasCurrentBrush ? this._currentBrush : TerrainEditorData_EditorPanel_BrushMode.default;
  }
  get hasCurrentBrush() {
    return this._hasCurrentBrush;
  }
  setCurrentBrush(path, value) {
    return {type: 'SET', path: path.concat(['currentBrush']), value};
  }
  deleteCurrentBrush(path) {
    return {type: 'DELETE', path: path.concat(['currentBrush'])};
  }
  /**
   * @returns {number}
   */
  get initialRotation() {
    return this._hasInitialRotation ? this._initialRotation : JsonToDouble.default;
  }
  get hasInitialRotation() {
    return this._hasInitialRotation;
  }
  setInitialRotation(path, value) {
    return {type: 'SET', path: path.concat(['initialRotation']), value};
  }
  deleteInitialRotation(path) {
    return {type: 'DELETE', path: path.concat(['initialRotation'])};
  }
  /**
   * @returns {string}
   */
  get currentUnit() {
    return this._hasCurrentUnit ? this._currentUnit : JsonToString.default;
  }
  get hasCurrentUnit() {
    return this._hasCurrentUnit;
  }
  setCurrentUnit(path, value) {
    return {type: 'SET', path: path.concat(['currentUnit']), value};
  }
  deleteCurrentUnit(path) {
    return {type: 'DELETE', path: path.concat(['currentUnit'])};
  }
  /**
   * @returns {number}
   */
  get currentHandleTool() {
    return this._hasCurrentHandleTool ? this._currentHandleTool : TerrainEditorData_EditorPanel_HandleTool.default;
  }
  get hasCurrentHandleTool() {
    return this._hasCurrentHandleTool;
  }
  setCurrentHandleTool(path, value) {
    return {type: 'SET', path: path.concat(['currentHandleTool']), value};
  }
  deleteCurrentHandleTool(path) {
    return {type: 'DELETE', path: path.concat(['currentHandleTool'])};
  }
  /**
   * @returns {boolean}
   */
  get snapToGrid() {
    return this._hasSnapToGrid ? this._snapToGrid : JsonToBoolean.default;
  }
  get hasSnapToGrid() {
    return this._hasSnapToGrid;
  }
  setSnapToGrid(path, value) {
    return {type: 'SET', path: path.concat(['snapToGrid']), value};
  }
  deleteSnapToGrid(path) {
    return {type: 'DELETE', path: path.concat(['snapToGrid'])};
  }
  /**
   * @returns {string}
   */
  get currentSelectedUnitId() {
    return this._hasCurrentSelectedUnitId ? this._currentSelectedUnitId : JsonToString.default;
  }
  get hasCurrentSelectedUnitId() {
    return this._hasCurrentSelectedUnitId;
  }
  setCurrentSelectedUnitId(path, value) {
    return {type: 'SET', path: path.concat(['currentSelectedUnitId']), value};
  }
  deleteCurrentSelectedUnitId(path) {
    return {type: 'DELETE', path: path.concat(['currentSelectedUnitId'])};
  }
  /**
   * @returns {boolean}
   */
  get useRandomRotation() {
    return this._hasUseRandomRotation ? this._useRandomRotation : JsonToBoolean.default;
  }
  get hasUseRandomRotation() {
    return this._hasUseRandomRotation;
  }
  setUseRandomRotation(path, value) {
    return {type: 'SET', path: path.concat(['useRandomRotation']), value};
  }
  deleteUseRandomRotation(path) {
    return {type: 'DELETE', path: path.concat(['useRandomRotation'])};
  }
  /**
   * @returns {number}
   */
  get randomRotationMin() {
    return this._hasRandomRotationMin ? this._randomRotationMin : JsonToDouble.default;
  }
  get hasRandomRotationMin() {
    return this._hasRandomRotationMin;
  }
  setRandomRotationMin(path, value) {
    return {type: 'SET', path: path.concat(['randomRotationMin']), value};
  }
  deleteRandomRotationMin(path) {
    return {type: 'DELETE', path: path.concat(['randomRotationMin'])};
  }
  /**
   * @returns {number}
   */
  get randomRotationMax() {
    return this._hasRandomRotationMax ? this._randomRotationMax : JsonToDouble.default;
  }
  get hasRandomRotationMax() {
    return this._hasRandomRotationMax;
  }
  setRandomRotationMax(path, value) {
    return {type: 'SET', path: path.concat(['randomRotationMax']), value};
  }
  deleteRandomRotationMax(path) {
    return {type: 'DELETE', path: path.concat(['randomRotationMax'])};
  }
  /**
   * @returns {number}
   */
  get gridSize() {
    return this._hasGridSize ? this._gridSize : JsonToDouble.default;
  }
  get hasGridSize() {
    return this._hasGridSize;
  }
  setGridSize(path, value) {
    return {type: 'SET', path: path.concat(['gridSize']), value};
  }
  deleteGridSize(path) {
    return {type: 'DELETE', path: path.concat(['gridSize'])};
  }
  /**
   * @returns {number}
   */
  get currentTeam() {
    return this._hasCurrentTeam ? this._currentTeam : dcei_editor_terrain_proto.Team.default;
  }
  get hasCurrentTeam() {
    return this._hasCurrentTeam;
  }
  setCurrentTeam(path, value) {
    return {type: 'SET', path: path.concat(['currentTeam']), value};
  }
  deleteCurrentTeam(path) {
    return {type: 'DELETE', path: path.concat(['currentTeam'])};
  }
  /**
   * @returns {number}
   */
  get currentPlayer() {
    return this._hasCurrentPlayer ? this._currentPlayer : JsonToInt32.default;
  }
  get hasCurrentPlayer() {
    return this._hasCurrentPlayer;
  }
  setCurrentPlayer(path, value) {
    return {type: 'SET', path: path.concat(['currentPlayer']), value};
  }
  deleteCurrentPlayer(path) {
    return {type: 'DELETE', path: path.concat(['currentPlayer'])};
  }
  /**
   * @returns {boolean}
   */
  get rangeIndicatorDisplay() {
    return this._hasRangeIndicatorDisplay ? this._rangeIndicatorDisplay : JsonToBoolean.default;
  }
  get hasRangeIndicatorDisplay() {
    return this._hasRangeIndicatorDisplay;
  }
  setRangeIndicatorDisplay(path, value) {
    return {type: 'SET', path: path.concat(['rangeIndicatorDisplay']), value};
  }
  deleteRangeIndicatorDisplay(path) {
    return {type: 'DELETE', path: path.concat(['rangeIndicatorDisplay'])};
  }
  /**
   * @returns {number}
   */
  get rangeIndicatorSize() {
    return this._hasRangeIndicatorSize ? this._rangeIndicatorSize : JsonToDouble.default;
  }
  get hasRangeIndicatorSize() {
    return this._hasRangeIndicatorSize;
  }
  setRangeIndicatorSize(path, value) {
    return {type: 'SET', path: path.concat(['rangeIndicatorSize']), value};
  }
  deleteRangeIndicatorSize(path) {
    return {type: 'DELETE', path: path.concat(['rangeIndicatorSize'])};
  }
  /**
   * @returns {boolean}
   */
  get disableCollider() {
    return this._hasDisableCollider ? this._disableCollider : JsonToBoolean.default;
  }
  get hasDisableCollider() {
    return this._hasDisableCollider;
  }
  setDisableCollider(path, value) {
    return {type: 'SET', path: path.concat(['disableCollider']), value};
  }
  deleteDisableCollider(path) {
    return {type: 'DELETE', path: path.concat(['disableCollider'])};
  }
  /**
   * @returns {boolean}
   */
  get showUnitColliders() {
    return this._hasShowUnitColliders ? this._showUnitColliders : JsonToBoolean.default;
  }
  get hasShowUnitColliders() {
    return this._hasShowUnitColliders;
  }
  setShowUnitColliders(path, value) {
    return {type: 'SET', path: path.concat(['showUnitColliders']), value};
  }
  deleteShowUnitColliders(path) {
    return {type: 'DELETE', path: path.concat(['showUnitColliders'])};
  }
  /**
   * @returns {boolean}
   */
  get showWeaponScanRange() {
    return this._hasShowWeaponScanRange ? this._showWeaponScanRange : JsonToBoolean.default;
  }
  get hasShowWeaponScanRange() {
    return this._hasShowWeaponScanRange;
  }
  setShowWeaponScanRange(path, value) {
    return {type: 'SET', path: path.concat(['showWeaponScanRange']), value};
  }
  deleteShowWeaponScanRange(path) {
    return {type: 'DELETE', path: path.concat(['showWeaponScanRange'])};
  }
  /**
   * @returns {boolean}
   */
  get showWeaponRange() {
    return this._hasShowWeaponRange ? this._showWeaponRange : JsonToBoolean.default;
  }
  get hasShowWeaponRange() {
    return this._hasShowWeaponRange;
  }
  setShowWeaponRange(path, value) {
    return {type: 'SET', path: path.concat(['showWeaponRange']), value};
  }
  deleteShowWeaponRange(path) {
    return {type: 'DELETE', path: path.concat(['showWeaponRange'])};
  }
  /**
   * @returns {boolean}
   */
  get showUnitEngageRange() {
    return this._hasShowUnitEngageRange ? this._showUnitEngageRange : JsonToBoolean.default;
  }
  get hasShowUnitEngageRange() {
    return this._hasShowUnitEngageRange;
  }
  setShowUnitEngageRange(path, value) {
    return {type: 'SET', path: path.concat(['showUnitEngageRange']), value};
  }
  deleteShowUnitEngageRange(path) {
    return {type: 'DELETE', path: path.concat(['showUnitEngageRange'])};
  }
  /**
   * @returns {boolean}
   */
  get showDefenseRadius() {
    return this._hasShowDefenseRadius ? this._showDefenseRadius : JsonToBoolean.default;
  }
  get hasShowDefenseRadius() {
    return this._hasShowDefenseRadius;
  }
  setShowDefenseRadius(path, value) {
    return {type: 'SET', path: path.concat(['showDefenseRadius']), value};
  }
  deleteShowDefenseRadius(path) {
    return {type: 'DELETE', path: path.concat(['showDefenseRadius'])};
  }
  /**
   * @returns {boolean}
   */
  get showResetRadius() {
    return this._hasShowResetRadius ? this._showResetRadius : JsonToBoolean.default;
  }
  get hasShowResetRadius() {
    return this._hasShowResetRadius;
  }
  setShowResetRadius(path, value) {
    return {type: 'SET', path: path.concat(['showResetRadius']), value};
  }
  deleteShowResetRadius(path) {
    return {type: 'DELETE', path: path.concat(['showResetRadius'])};
  }
  /**
   * @returns {boolean}
   */
  get showUnitRadius() {
    return this._hasShowUnitRadius ? this._showUnitRadius : JsonToBoolean.default;
  }
  get hasShowUnitRadius() {
    return this._hasShowUnitRadius;
  }
  setShowUnitRadius(path, value) {
    return {type: 'SET', path: path.concat(['showUnitRadius']), value};
  }
  deleteShowUnitRadius(path) {
    return {type: 'DELETE', path: path.concat(['showUnitRadius'])};
  }
  /**
   * @returns {boolean}
   */
  get showUnitBoundingSphere() {
    return this._hasShowUnitBoundingSphere ? this._showUnitBoundingSphere : JsonToBoolean.default;
  }
  get hasShowUnitBoundingSphere() {
    return this._hasShowUnitBoundingSphere;
  }
  setShowUnitBoundingSphere(path, value) {
    return {type: 'SET', path: path.concat(['showUnitBoundingSphere']), value};
  }
  deleteShowUnitBoundingSphere(path) {
    return {type: 'DELETE', path: path.concat(['showUnitBoundingSphere'])};
  }
  /**
   * @returns {dcei_editor_terrain_proto.UndoableUnitsGroup}
   */
  get currentUnitsGroup() {
    return this._hasCurrentUnitsGroup ? this._currentUnitsGroup : dcei_editor_terrain_proto.UndoableUnitsGroup.default;
  }
  get hasCurrentUnitsGroup() {
    return this._hasCurrentUnitsGroup;
  }
  setCurrentUnitsGroup(path, value) {
    return {type: 'SET', path: path.concat(['currentUnitsGroup']), value: value.toJson()};
  }
  deleteCurrentUnitsGroup(path) {
    return {type: 'DELETE', path: path.concat(['currentUnitsGroup'])};
  }
  /**
   * @returns {boolean}
   */
  get reset() {
    return this._hasReset ? this._reset : JsonToBoolean.default;
  }
  get hasReset() {
    return this._hasReset;
  }
  setReset(path, value) {
    return {type: 'SET', path: path.concat(['reset']), value};
  }
  deleteReset(path) {
    return {type: 'DELETE', path: path.concat(['reset'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "currentBrush": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasCurrentBrush = true;
              copy._currentBrush = TerrainEditorData_EditorPanel_BrushMode.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentBrush) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasCurrentBrush = false;
              copy._currentBrush = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "initialRotation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasInitialRotation = true;
              copy._initialRotation = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasInitialRotation) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasInitialRotation = false;
              copy._initialRotation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currentUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasCurrentUnit = true;
              copy._currentUnit = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentUnit) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasCurrentUnit = false;
              copy._currentUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currentHandleTool": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasCurrentHandleTool = true;
              copy._currentHandleTool = TerrainEditorData_EditorPanel_HandleTool.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentHandleTool) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasCurrentHandleTool = false;
              copy._currentHandleTool = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "snapToGrid": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasSnapToGrid = true;
              copy._snapToGrid = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSnapToGrid) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasSnapToGrid = false;
              copy._snapToGrid = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currentSelectedUnitId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasCurrentSelectedUnitId = true;
              copy._currentSelectedUnitId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentSelectedUnitId) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasCurrentSelectedUnitId = false;
              copy._currentSelectedUnitId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "useRandomRotation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasUseRandomRotation = true;
              copy._useRandomRotation = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUseRandomRotation) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasUseRandomRotation = false;
              copy._useRandomRotation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "randomRotationMin": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasRandomRotationMin = true;
              copy._randomRotationMin = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRandomRotationMin) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasRandomRotationMin = false;
              copy._randomRotationMin = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "randomRotationMax": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasRandomRotationMax = true;
              copy._randomRotationMax = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRandomRotationMax) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasRandomRotationMax = false;
              copy._randomRotationMax = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "gridSize": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasGridSize = true;
              copy._gridSize = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGridSize) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasGridSize = false;
              copy._gridSize = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currentTeam": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasCurrentTeam = true;
              copy._currentTeam = dcei_editor_terrain_proto.Team.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentTeam) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasCurrentTeam = false;
              copy._currentTeam = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currentPlayer": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasCurrentPlayer = true;
              copy._currentPlayer = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentPlayer) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasCurrentPlayer = false;
              copy._currentPlayer = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "rangeIndicatorDisplay": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasRangeIndicatorDisplay = true;
              copy._rangeIndicatorDisplay = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRangeIndicatorDisplay) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasRangeIndicatorDisplay = false;
              copy._rangeIndicatorDisplay = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "rangeIndicatorSize": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasRangeIndicatorSize = true;
              copy._rangeIndicatorSize = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRangeIndicatorSize) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasRangeIndicatorSize = false;
              copy._rangeIndicatorSize = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "disableCollider": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasDisableCollider = true;
              copy._disableCollider = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisableCollider) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasDisableCollider = false;
              copy._disableCollider = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "showUnitColliders": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasShowUnitColliders = true;
              copy._showUnitColliders = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShowUnitColliders) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasShowUnitColliders = false;
              copy._showUnitColliders = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "showWeaponScanRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasShowWeaponScanRange = true;
              copy._showWeaponScanRange = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShowWeaponScanRange) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasShowWeaponScanRange = false;
              copy._showWeaponScanRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "showWeaponRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasShowWeaponRange = true;
              copy._showWeaponRange = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShowWeaponRange) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasShowWeaponRange = false;
              copy._showWeaponRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "showUnitEngageRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasShowUnitEngageRange = true;
              copy._showUnitEngageRange = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShowUnitEngageRange) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasShowUnitEngageRange = false;
              copy._showUnitEngageRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "showDefenseRadius": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasShowDefenseRadius = true;
              copy._showDefenseRadius = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShowDefenseRadius) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasShowDefenseRadius = false;
              copy._showDefenseRadius = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "showResetRadius": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasShowResetRadius = true;
              copy._showResetRadius = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShowResetRadius) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasShowResetRadius = false;
              copy._showResetRadius = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "showUnitRadius": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasShowUnitRadius = true;
              copy._showUnitRadius = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShowUnitRadius) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasShowUnitRadius = false;
              copy._showUnitRadius = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "showUnitBoundingSphere": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasShowUnitBoundingSphere = true;
              copy._showUnitBoundingSphere = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShowUnitBoundingSphere) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasShowUnitBoundingSphere = false;
              copy._showUnitBoundingSphere = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currentUnitsGroup": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasCurrentUnitsGroup = true;
              copy._currentUnitsGroup = dcei_editor_terrain_proto.UndoableUnitsGroup.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentUnitsGroup) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasCurrentUnitsGroup = false;
              copy._currentUnitsGroup = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCurrentUnitsGroup) {
            const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
            copy._hasCurrentUnitsGroup = true;
            copy._currentUnitsGroup = dcei_editor_terrain_proto.UndoableUnitsGroup.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._currentUnitsGroup.apply(type, path.slice(1), value);
          if (newValue === this._currentUnitsGroup) {
            return this;
          }
          const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
          copy._currentUnitsGroup = copy._currentUnitsGroup.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "reset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasReset = true;
              copy._reset = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasReset) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
              copy._hasReset = false;
              copy._reset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TerrainEditorData_EditorPanel_UnitsEditor} other
   * @returns {TerrainEditorData_EditorPanel_UnitsEditor}
   */
  merge(other) {
    const copy = new TerrainEditorData_EditorPanel_UnitsEditor(this);
    if (other._hasCurrentBrush) {
      copy._hasCurrentBrush = true;
      copy._currentBrush = other._currentBrush;
    }
    if (other._hasInitialRotation) {
      copy._hasInitialRotation = true;
      copy._initialRotation = other._initialRotation;
    }
    if (other._hasCurrentUnit) {
      copy._hasCurrentUnit = true;
      copy._currentUnit = other._currentUnit;
    }
    if (other._hasCurrentHandleTool) {
      copy._hasCurrentHandleTool = true;
      copy._currentHandleTool = other._currentHandleTool;
    }
    if (other._hasSnapToGrid) {
      copy._hasSnapToGrid = true;
      copy._snapToGrid = other._snapToGrid;
    }
    if (other._hasCurrentSelectedUnitId) {
      copy._hasCurrentSelectedUnitId = true;
      copy._currentSelectedUnitId = other._currentSelectedUnitId;
    }
    if (other._hasUseRandomRotation) {
      copy._hasUseRandomRotation = true;
      copy._useRandomRotation = other._useRandomRotation;
    }
    if (other._hasRandomRotationMin) {
      copy._hasRandomRotationMin = true;
      copy._randomRotationMin = other._randomRotationMin;
    }
    if (other._hasRandomRotationMax) {
      copy._hasRandomRotationMax = true;
      copy._randomRotationMax = other._randomRotationMax;
    }
    if (other._hasGridSize) {
      copy._hasGridSize = true;
      copy._gridSize = other._gridSize;
    }
    if (other._hasCurrentTeam) {
      copy._hasCurrentTeam = true;
      copy._currentTeam = other._currentTeam;
    }
    if (other._hasCurrentPlayer) {
      copy._hasCurrentPlayer = true;
      copy._currentPlayer = other._currentPlayer;
    }
    if (other._hasRangeIndicatorDisplay) {
      copy._hasRangeIndicatorDisplay = true;
      copy._rangeIndicatorDisplay = other._rangeIndicatorDisplay;
    }
    if (other._hasRangeIndicatorSize) {
      copy._hasRangeIndicatorSize = true;
      copy._rangeIndicatorSize = other._rangeIndicatorSize;
    }
    if (other._hasDisableCollider) {
      copy._hasDisableCollider = true;
      copy._disableCollider = other._disableCollider;
    }
    if (other._hasShowUnitColliders) {
      copy._hasShowUnitColliders = true;
      copy._showUnitColliders = other._showUnitColliders;
    }
    if (other._hasShowWeaponScanRange) {
      copy._hasShowWeaponScanRange = true;
      copy._showWeaponScanRange = other._showWeaponScanRange;
    }
    if (other._hasShowWeaponRange) {
      copy._hasShowWeaponRange = true;
      copy._showWeaponRange = other._showWeaponRange;
    }
    if (other._hasShowUnitEngageRange) {
      copy._hasShowUnitEngageRange = true;
      copy._showUnitEngageRange = other._showUnitEngageRange;
    }
    if (other._hasShowDefenseRadius) {
      copy._hasShowDefenseRadius = true;
      copy._showDefenseRadius = other._showDefenseRadius;
    }
    if (other._hasShowResetRadius) {
      copy._hasShowResetRadius = true;
      copy._showResetRadius = other._showResetRadius;
    }
    if (other._hasShowUnitRadius) {
      copy._hasShowUnitRadius = true;
      copy._showUnitRadius = other._showUnitRadius;
    }
    if (other._hasShowUnitBoundingSphere) {
      copy._hasShowUnitBoundingSphere = true;
      copy._showUnitBoundingSphere = other._showUnitBoundingSphere;
    }
    if (other._hasCurrentUnitsGroup) {
      if (copy._hasCurrentUnitsGroup) {
        copy._currentUnitsGroup = copy.currentUnitsGroup.merge(other.currentUnitsGroup);
      } else {
        copy._currentUnitsGroup = other._currentUnitsGroup;
      }
      copy._hasCurrentUnitsGroup = true;
    }
    if (other._hasReset) {
      copy._hasReset = true;
      copy._reset = other._reset;
    }
    return copy;
  }
}
TerrainEditorData_EditorPanel_UnitsEditor.default = new TerrainEditorData_EditorPanel_UnitsEditor();
class TerrainEditorData_EditorPanel_UnitsEditor_Builder {
  constructor(value) {
    this._value = new TerrainEditorData_EditorPanel_UnitsEditor(value);
  }
  build() {
    return new TerrainEditorData_EditorPanel_UnitsEditor(this._value);
  }
  setCurrentBrush(value) {
    this._value._hasCurrentBrush = true;
    this._value._currentBrush = value;
    return this;
  }
  deleteCurrentBrush() {
    this._value._hasCurrentBrush = false;
    this._value._currentBrush = null;
    return this;
  }
  setInitialRotation(value) {
    this._value._hasInitialRotation = true;
    this._value._initialRotation = value;
    return this;
  }
  deleteInitialRotation() {
    this._value._hasInitialRotation = false;
    this._value._initialRotation = null;
    return this;
  }
  setCurrentUnit(value) {
    this._value._hasCurrentUnit = true;
    this._value._currentUnit = value;
    return this;
  }
  deleteCurrentUnit() {
    this._value._hasCurrentUnit = false;
    this._value._currentUnit = null;
    return this;
  }
  setCurrentHandleTool(value) {
    this._value._hasCurrentHandleTool = true;
    this._value._currentHandleTool = value;
    return this;
  }
  deleteCurrentHandleTool() {
    this._value._hasCurrentHandleTool = false;
    this._value._currentHandleTool = null;
    return this;
  }
  setSnapToGrid(value) {
    this._value._hasSnapToGrid = true;
    this._value._snapToGrid = value;
    return this;
  }
  deleteSnapToGrid() {
    this._value._hasSnapToGrid = false;
    this._value._snapToGrid = null;
    return this;
  }
  setCurrentSelectedUnitId(value) {
    this._value._hasCurrentSelectedUnitId = true;
    this._value._currentSelectedUnitId = value;
    return this;
  }
  deleteCurrentSelectedUnitId() {
    this._value._hasCurrentSelectedUnitId = false;
    this._value._currentSelectedUnitId = null;
    return this;
  }
  setUseRandomRotation(value) {
    this._value._hasUseRandomRotation = true;
    this._value._useRandomRotation = value;
    return this;
  }
  deleteUseRandomRotation() {
    this._value._hasUseRandomRotation = false;
    this._value._useRandomRotation = null;
    return this;
  }
  setRandomRotationMin(value) {
    this._value._hasRandomRotationMin = true;
    this._value._randomRotationMin = value;
    return this;
  }
  deleteRandomRotationMin() {
    this._value._hasRandomRotationMin = false;
    this._value._randomRotationMin = null;
    return this;
  }
  setRandomRotationMax(value) {
    this._value._hasRandomRotationMax = true;
    this._value._randomRotationMax = value;
    return this;
  }
  deleteRandomRotationMax() {
    this._value._hasRandomRotationMax = false;
    this._value._randomRotationMax = null;
    return this;
  }
  setGridSize(value) {
    this._value._hasGridSize = true;
    this._value._gridSize = value;
    return this;
  }
  deleteGridSize() {
    this._value._hasGridSize = false;
    this._value._gridSize = null;
    return this;
  }
  setCurrentTeam(value) {
    this._value._hasCurrentTeam = true;
    this._value._currentTeam = value;
    return this;
  }
  deleteCurrentTeam() {
    this._value._hasCurrentTeam = false;
    this._value._currentTeam = null;
    return this;
  }
  setCurrentPlayer(value) {
    this._value._hasCurrentPlayer = true;
    this._value._currentPlayer = value;
    return this;
  }
  deleteCurrentPlayer() {
    this._value._hasCurrentPlayer = false;
    this._value._currentPlayer = null;
    return this;
  }
  setRangeIndicatorDisplay(value) {
    this._value._hasRangeIndicatorDisplay = true;
    this._value._rangeIndicatorDisplay = value;
    return this;
  }
  deleteRangeIndicatorDisplay() {
    this._value._hasRangeIndicatorDisplay = false;
    this._value._rangeIndicatorDisplay = null;
    return this;
  }
  setRangeIndicatorSize(value) {
    this._value._hasRangeIndicatorSize = true;
    this._value._rangeIndicatorSize = value;
    return this;
  }
  deleteRangeIndicatorSize() {
    this._value._hasRangeIndicatorSize = false;
    this._value._rangeIndicatorSize = null;
    return this;
  }
  setDisableCollider(value) {
    this._value._hasDisableCollider = true;
    this._value._disableCollider = value;
    return this;
  }
  deleteDisableCollider() {
    this._value._hasDisableCollider = false;
    this._value._disableCollider = null;
    return this;
  }
  setShowUnitColliders(value) {
    this._value._hasShowUnitColliders = true;
    this._value._showUnitColliders = value;
    return this;
  }
  deleteShowUnitColliders() {
    this._value._hasShowUnitColliders = false;
    this._value._showUnitColliders = null;
    return this;
  }
  setShowWeaponScanRange(value) {
    this._value._hasShowWeaponScanRange = true;
    this._value._showWeaponScanRange = value;
    return this;
  }
  deleteShowWeaponScanRange() {
    this._value._hasShowWeaponScanRange = false;
    this._value._showWeaponScanRange = null;
    return this;
  }
  setShowWeaponRange(value) {
    this._value._hasShowWeaponRange = true;
    this._value._showWeaponRange = value;
    return this;
  }
  deleteShowWeaponRange() {
    this._value._hasShowWeaponRange = false;
    this._value._showWeaponRange = null;
    return this;
  }
  setShowUnitEngageRange(value) {
    this._value._hasShowUnitEngageRange = true;
    this._value._showUnitEngageRange = value;
    return this;
  }
  deleteShowUnitEngageRange() {
    this._value._hasShowUnitEngageRange = false;
    this._value._showUnitEngageRange = null;
    return this;
  }
  setShowDefenseRadius(value) {
    this._value._hasShowDefenseRadius = true;
    this._value._showDefenseRadius = value;
    return this;
  }
  deleteShowDefenseRadius() {
    this._value._hasShowDefenseRadius = false;
    this._value._showDefenseRadius = null;
    return this;
  }
  setShowResetRadius(value) {
    this._value._hasShowResetRadius = true;
    this._value._showResetRadius = value;
    return this;
  }
  deleteShowResetRadius() {
    this._value._hasShowResetRadius = false;
    this._value._showResetRadius = null;
    return this;
  }
  setShowUnitRadius(value) {
    this._value._hasShowUnitRadius = true;
    this._value._showUnitRadius = value;
    return this;
  }
  deleteShowUnitRadius() {
    this._value._hasShowUnitRadius = false;
    this._value._showUnitRadius = null;
    return this;
  }
  setShowUnitBoundingSphere(value) {
    this._value._hasShowUnitBoundingSphere = true;
    this._value._showUnitBoundingSphere = value;
    return this;
  }
  deleteShowUnitBoundingSphere() {
    this._value._hasShowUnitBoundingSphere = false;
    this._value._showUnitBoundingSphere = null;
    return this;
  }
  setCurrentUnitsGroup(value) {
    this._value._hasCurrentUnitsGroup = true;
    this._value._currentUnitsGroup = value;
    return this;
  }
  deleteCurrentUnitsGroup() {
    this._value._hasCurrentUnitsGroup = false;
    this._value._currentUnitsGroup = null;
    return this;
  }
  setReset(value) {
    this._value._hasReset = true;
    this._value._reset = value;
    return this;
  }
  deleteReset() {
    this._value._hasReset = false;
    this._value._reset = null;
    return this;
  }
}
TerrainEditorData_EditorPanel_UnitsEditor.Builder = TerrainEditorData_EditorPanel_UnitsEditor_Builder;
class TerrainEditorData_EditorPanel_UnitsEditor_WithParent {
  /**
   * @param {TerrainEditorData_EditorPanel_UnitsEditor} value
   * @param {TerrainEditorData_EditorPanel_UnitsEditor_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TerrainEditorData_EditorPanel_UnitsEditor.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCurrentBrush() {
    if (this._cachedHasCurrentBrush === undefined) {
      if (this._value.hasCurrentBrush) {
        this._cachedHasCurrentBrush = true;
      } else {
        this._cachedHasCurrentBrush = this._parent ? this._parent.hasCurrentBrush : false;
      }
    }
    return this._cachedHasCurrentBrush;
  }
  get currentBrush() {
    if (this._cachedCurrentBrush === undefined) {
      if (this._value.hasCurrentBrush) {
        this._cachedCurrentBrush = this._value.currentBrush;
      } else {
        this._cachedCurrentBrush = this._parent ? this._parent.currentBrush : this._value.currentBrush;
      }
    }
    return this._cachedCurrentBrush;
  }
  get hasInitialRotation() {
    if (this._cachedHasInitialRotation === undefined) {
      if (this._value.hasInitialRotation) {
        this._cachedHasInitialRotation = true;
      } else {
        this._cachedHasInitialRotation = this._parent ? this._parent.hasInitialRotation : false;
      }
    }
    return this._cachedHasInitialRotation;
  }
  get initialRotation() {
    if (this._cachedInitialRotation === undefined) {
      if (this._value.hasInitialRotation) {
        this._cachedInitialRotation = this._value.initialRotation;
      } else {
        this._cachedInitialRotation = this._parent ? this._parent.initialRotation : this._value.initialRotation;
      }
    }
    return this._cachedInitialRotation;
  }
  get hasCurrentUnit() {
    if (this._cachedHasCurrentUnit === undefined) {
      if (this._value.hasCurrentUnit) {
        this._cachedHasCurrentUnit = true;
      } else {
        this._cachedHasCurrentUnit = this._parent ? this._parent.hasCurrentUnit : false;
      }
    }
    return this._cachedHasCurrentUnit;
  }
  get currentUnit() {
    if (this._cachedCurrentUnit === undefined) {
      if (this._value.hasCurrentUnit) {
        this._cachedCurrentUnit = this._value.currentUnit;
      } else {
        this._cachedCurrentUnit = this._parent ? this._parent.currentUnit : this._value.currentUnit;
      }
    }
    return this._cachedCurrentUnit;
  }
  get hasCurrentHandleTool() {
    if (this._cachedHasCurrentHandleTool === undefined) {
      if (this._value.hasCurrentHandleTool) {
        this._cachedHasCurrentHandleTool = true;
      } else {
        this._cachedHasCurrentHandleTool = this._parent ? this._parent.hasCurrentHandleTool : false;
      }
    }
    return this._cachedHasCurrentHandleTool;
  }
  get currentHandleTool() {
    if (this._cachedCurrentHandleTool === undefined) {
      if (this._value.hasCurrentHandleTool) {
        this._cachedCurrentHandleTool = this._value.currentHandleTool;
      } else {
        this._cachedCurrentHandleTool = this._parent ? this._parent.currentHandleTool : this._value.currentHandleTool;
      }
    }
    return this._cachedCurrentHandleTool;
  }
  get hasSnapToGrid() {
    if (this._cachedHasSnapToGrid === undefined) {
      if (this._value.hasSnapToGrid) {
        this._cachedHasSnapToGrid = true;
      } else {
        this._cachedHasSnapToGrid = this._parent ? this._parent.hasSnapToGrid : false;
      }
    }
    return this._cachedHasSnapToGrid;
  }
  get snapToGrid() {
    if (this._cachedSnapToGrid === undefined) {
      if (this._value.hasSnapToGrid) {
        this._cachedSnapToGrid = this._value.snapToGrid;
      } else {
        this._cachedSnapToGrid = this._parent ? this._parent.snapToGrid : this._value.snapToGrid;
      }
    }
    return this._cachedSnapToGrid;
  }
  get hasCurrentSelectedUnitId() {
    if (this._cachedHasCurrentSelectedUnitId === undefined) {
      if (this._value.hasCurrentSelectedUnitId) {
        this._cachedHasCurrentSelectedUnitId = true;
      } else {
        this._cachedHasCurrentSelectedUnitId = this._parent ? this._parent.hasCurrentSelectedUnitId : false;
      }
    }
    return this._cachedHasCurrentSelectedUnitId;
  }
  get currentSelectedUnitId() {
    if (this._cachedCurrentSelectedUnitId === undefined) {
      if (this._value.hasCurrentSelectedUnitId) {
        this._cachedCurrentSelectedUnitId = this._value.currentSelectedUnitId;
      } else {
        this._cachedCurrentSelectedUnitId = this._parent ? this._parent.currentSelectedUnitId : this._value.currentSelectedUnitId;
      }
    }
    return this._cachedCurrentSelectedUnitId;
  }
  get hasUseRandomRotation() {
    if (this._cachedHasUseRandomRotation === undefined) {
      if (this._value.hasUseRandomRotation) {
        this._cachedHasUseRandomRotation = true;
      } else {
        this._cachedHasUseRandomRotation = this._parent ? this._parent.hasUseRandomRotation : false;
      }
    }
    return this._cachedHasUseRandomRotation;
  }
  get useRandomRotation() {
    if (this._cachedUseRandomRotation === undefined) {
      if (this._value.hasUseRandomRotation) {
        this._cachedUseRandomRotation = this._value.useRandomRotation;
      } else {
        this._cachedUseRandomRotation = this._parent ? this._parent.useRandomRotation : this._value.useRandomRotation;
      }
    }
    return this._cachedUseRandomRotation;
  }
  get hasRandomRotationMin() {
    if (this._cachedHasRandomRotationMin === undefined) {
      if (this._value.hasRandomRotationMin) {
        this._cachedHasRandomRotationMin = true;
      } else {
        this._cachedHasRandomRotationMin = this._parent ? this._parent.hasRandomRotationMin : false;
      }
    }
    return this._cachedHasRandomRotationMin;
  }
  get randomRotationMin() {
    if (this._cachedRandomRotationMin === undefined) {
      if (this._value.hasRandomRotationMin) {
        this._cachedRandomRotationMin = this._value.randomRotationMin;
      } else {
        this._cachedRandomRotationMin = this._parent ? this._parent.randomRotationMin : this._value.randomRotationMin;
      }
    }
    return this._cachedRandomRotationMin;
  }
  get hasRandomRotationMax() {
    if (this._cachedHasRandomRotationMax === undefined) {
      if (this._value.hasRandomRotationMax) {
        this._cachedHasRandomRotationMax = true;
      } else {
        this._cachedHasRandomRotationMax = this._parent ? this._parent.hasRandomRotationMax : false;
      }
    }
    return this._cachedHasRandomRotationMax;
  }
  get randomRotationMax() {
    if (this._cachedRandomRotationMax === undefined) {
      if (this._value.hasRandomRotationMax) {
        this._cachedRandomRotationMax = this._value.randomRotationMax;
      } else {
        this._cachedRandomRotationMax = this._parent ? this._parent.randomRotationMax : this._value.randomRotationMax;
      }
    }
    return this._cachedRandomRotationMax;
  }
  get hasGridSize() {
    if (this._cachedHasGridSize === undefined) {
      if (this._value.hasGridSize) {
        this._cachedHasGridSize = true;
      } else {
        this._cachedHasGridSize = this._parent ? this._parent.hasGridSize : false;
      }
    }
    return this._cachedHasGridSize;
  }
  get gridSize() {
    if (this._cachedGridSize === undefined) {
      if (this._value.hasGridSize) {
        this._cachedGridSize = this._value.gridSize;
      } else {
        this._cachedGridSize = this._parent ? this._parent.gridSize : this._value.gridSize;
      }
    }
    return this._cachedGridSize;
  }
  get hasCurrentTeam() {
    if (this._cachedHasCurrentTeam === undefined) {
      if (this._value.hasCurrentTeam) {
        this._cachedHasCurrentTeam = true;
      } else {
        this._cachedHasCurrentTeam = this._parent ? this._parent.hasCurrentTeam : false;
      }
    }
    return this._cachedHasCurrentTeam;
  }
  get currentTeam() {
    if (this._cachedCurrentTeam === undefined) {
      if (this._value.hasCurrentTeam) {
        this._cachedCurrentTeam = this._value.currentTeam;
      } else {
        this._cachedCurrentTeam = this._parent ? this._parent.currentTeam : this._value.currentTeam;
      }
    }
    return this._cachedCurrentTeam;
  }
  get hasCurrentPlayer() {
    if (this._cachedHasCurrentPlayer === undefined) {
      if (this._value.hasCurrentPlayer) {
        this._cachedHasCurrentPlayer = true;
      } else {
        this._cachedHasCurrentPlayer = this._parent ? this._parent.hasCurrentPlayer : false;
      }
    }
    return this._cachedHasCurrentPlayer;
  }
  get currentPlayer() {
    if (this._cachedCurrentPlayer === undefined) {
      if (this._value.hasCurrentPlayer) {
        this._cachedCurrentPlayer = this._value.currentPlayer;
      } else {
        this._cachedCurrentPlayer = this._parent ? this._parent.currentPlayer : this._value.currentPlayer;
      }
    }
    return this._cachedCurrentPlayer;
  }
  get hasRangeIndicatorDisplay() {
    if (this._cachedHasRangeIndicatorDisplay === undefined) {
      if (this._value.hasRangeIndicatorDisplay) {
        this._cachedHasRangeIndicatorDisplay = true;
      } else {
        this._cachedHasRangeIndicatorDisplay = this._parent ? this._parent.hasRangeIndicatorDisplay : false;
      }
    }
    return this._cachedHasRangeIndicatorDisplay;
  }
  get rangeIndicatorDisplay() {
    if (this._cachedRangeIndicatorDisplay === undefined) {
      if (this._value.hasRangeIndicatorDisplay) {
        this._cachedRangeIndicatorDisplay = this._value.rangeIndicatorDisplay;
      } else {
        this._cachedRangeIndicatorDisplay = this._parent ? this._parent.rangeIndicatorDisplay : this._value.rangeIndicatorDisplay;
      }
    }
    return this._cachedRangeIndicatorDisplay;
  }
  get hasRangeIndicatorSize() {
    if (this._cachedHasRangeIndicatorSize === undefined) {
      if (this._value.hasRangeIndicatorSize) {
        this._cachedHasRangeIndicatorSize = true;
      } else {
        this._cachedHasRangeIndicatorSize = this._parent ? this._parent.hasRangeIndicatorSize : false;
      }
    }
    return this._cachedHasRangeIndicatorSize;
  }
  get rangeIndicatorSize() {
    if (this._cachedRangeIndicatorSize === undefined) {
      if (this._value.hasRangeIndicatorSize) {
        this._cachedRangeIndicatorSize = this._value.rangeIndicatorSize;
      } else {
        this._cachedRangeIndicatorSize = this._parent ? this._parent.rangeIndicatorSize : this._value.rangeIndicatorSize;
      }
    }
    return this._cachedRangeIndicatorSize;
  }
  get hasDisableCollider() {
    if (this._cachedHasDisableCollider === undefined) {
      if (this._value.hasDisableCollider) {
        this._cachedHasDisableCollider = true;
      } else {
        this._cachedHasDisableCollider = this._parent ? this._parent.hasDisableCollider : false;
      }
    }
    return this._cachedHasDisableCollider;
  }
  get disableCollider() {
    if (this._cachedDisableCollider === undefined) {
      if (this._value.hasDisableCollider) {
        this._cachedDisableCollider = this._value.disableCollider;
      } else {
        this._cachedDisableCollider = this._parent ? this._parent.disableCollider : this._value.disableCollider;
      }
    }
    return this._cachedDisableCollider;
  }
  get hasShowUnitColliders() {
    if (this._cachedHasShowUnitColliders === undefined) {
      if (this._value.hasShowUnitColliders) {
        this._cachedHasShowUnitColliders = true;
      } else {
        this._cachedHasShowUnitColliders = this._parent ? this._parent.hasShowUnitColliders : false;
      }
    }
    return this._cachedHasShowUnitColliders;
  }
  get showUnitColliders() {
    if (this._cachedShowUnitColliders === undefined) {
      if (this._value.hasShowUnitColliders) {
        this._cachedShowUnitColliders = this._value.showUnitColliders;
      } else {
        this._cachedShowUnitColliders = this._parent ? this._parent.showUnitColliders : this._value.showUnitColliders;
      }
    }
    return this._cachedShowUnitColliders;
  }
  get hasShowWeaponScanRange() {
    if (this._cachedHasShowWeaponScanRange === undefined) {
      if (this._value.hasShowWeaponScanRange) {
        this._cachedHasShowWeaponScanRange = true;
      } else {
        this._cachedHasShowWeaponScanRange = this._parent ? this._parent.hasShowWeaponScanRange : false;
      }
    }
    return this._cachedHasShowWeaponScanRange;
  }
  get showWeaponScanRange() {
    if (this._cachedShowWeaponScanRange === undefined) {
      if (this._value.hasShowWeaponScanRange) {
        this._cachedShowWeaponScanRange = this._value.showWeaponScanRange;
      } else {
        this._cachedShowWeaponScanRange = this._parent ? this._parent.showWeaponScanRange : this._value.showWeaponScanRange;
      }
    }
    return this._cachedShowWeaponScanRange;
  }
  get hasShowWeaponRange() {
    if (this._cachedHasShowWeaponRange === undefined) {
      if (this._value.hasShowWeaponRange) {
        this._cachedHasShowWeaponRange = true;
      } else {
        this._cachedHasShowWeaponRange = this._parent ? this._parent.hasShowWeaponRange : false;
      }
    }
    return this._cachedHasShowWeaponRange;
  }
  get showWeaponRange() {
    if (this._cachedShowWeaponRange === undefined) {
      if (this._value.hasShowWeaponRange) {
        this._cachedShowWeaponRange = this._value.showWeaponRange;
      } else {
        this._cachedShowWeaponRange = this._parent ? this._parent.showWeaponRange : this._value.showWeaponRange;
      }
    }
    return this._cachedShowWeaponRange;
  }
  get hasShowUnitEngageRange() {
    if (this._cachedHasShowUnitEngageRange === undefined) {
      if (this._value.hasShowUnitEngageRange) {
        this._cachedHasShowUnitEngageRange = true;
      } else {
        this._cachedHasShowUnitEngageRange = this._parent ? this._parent.hasShowUnitEngageRange : false;
      }
    }
    return this._cachedHasShowUnitEngageRange;
  }
  get showUnitEngageRange() {
    if (this._cachedShowUnitEngageRange === undefined) {
      if (this._value.hasShowUnitEngageRange) {
        this._cachedShowUnitEngageRange = this._value.showUnitEngageRange;
      } else {
        this._cachedShowUnitEngageRange = this._parent ? this._parent.showUnitEngageRange : this._value.showUnitEngageRange;
      }
    }
    return this._cachedShowUnitEngageRange;
  }
  get hasShowDefenseRadius() {
    if (this._cachedHasShowDefenseRadius === undefined) {
      if (this._value.hasShowDefenseRadius) {
        this._cachedHasShowDefenseRadius = true;
      } else {
        this._cachedHasShowDefenseRadius = this._parent ? this._parent.hasShowDefenseRadius : false;
      }
    }
    return this._cachedHasShowDefenseRadius;
  }
  get showDefenseRadius() {
    if (this._cachedShowDefenseRadius === undefined) {
      if (this._value.hasShowDefenseRadius) {
        this._cachedShowDefenseRadius = this._value.showDefenseRadius;
      } else {
        this._cachedShowDefenseRadius = this._parent ? this._parent.showDefenseRadius : this._value.showDefenseRadius;
      }
    }
    return this._cachedShowDefenseRadius;
  }
  get hasShowResetRadius() {
    if (this._cachedHasShowResetRadius === undefined) {
      if (this._value.hasShowResetRadius) {
        this._cachedHasShowResetRadius = true;
      } else {
        this._cachedHasShowResetRadius = this._parent ? this._parent.hasShowResetRadius : false;
      }
    }
    return this._cachedHasShowResetRadius;
  }
  get showResetRadius() {
    if (this._cachedShowResetRadius === undefined) {
      if (this._value.hasShowResetRadius) {
        this._cachedShowResetRadius = this._value.showResetRadius;
      } else {
        this._cachedShowResetRadius = this._parent ? this._parent.showResetRadius : this._value.showResetRadius;
      }
    }
    return this._cachedShowResetRadius;
  }
  get hasShowUnitRadius() {
    if (this._cachedHasShowUnitRadius === undefined) {
      if (this._value.hasShowUnitRadius) {
        this._cachedHasShowUnitRadius = true;
      } else {
        this._cachedHasShowUnitRadius = this._parent ? this._parent.hasShowUnitRadius : false;
      }
    }
    return this._cachedHasShowUnitRadius;
  }
  get showUnitRadius() {
    if (this._cachedShowUnitRadius === undefined) {
      if (this._value.hasShowUnitRadius) {
        this._cachedShowUnitRadius = this._value.showUnitRadius;
      } else {
        this._cachedShowUnitRadius = this._parent ? this._parent.showUnitRadius : this._value.showUnitRadius;
      }
    }
    return this._cachedShowUnitRadius;
  }
  get hasShowUnitBoundingSphere() {
    if (this._cachedHasShowUnitBoundingSphere === undefined) {
      if (this._value.hasShowUnitBoundingSphere) {
        this._cachedHasShowUnitBoundingSphere = true;
      } else {
        this._cachedHasShowUnitBoundingSphere = this._parent ? this._parent.hasShowUnitBoundingSphere : false;
      }
    }
    return this._cachedHasShowUnitBoundingSphere;
  }
  get showUnitBoundingSphere() {
    if (this._cachedShowUnitBoundingSphere === undefined) {
      if (this._value.hasShowUnitBoundingSphere) {
        this._cachedShowUnitBoundingSphere = this._value.showUnitBoundingSphere;
      } else {
        this._cachedShowUnitBoundingSphere = this._parent ? this._parent.showUnitBoundingSphere : this._value.showUnitBoundingSphere;
      }
    }
    return this._cachedShowUnitBoundingSphere;
  }
  get hasCurrentUnitsGroup() {
    if (this._cachedHasCurrentUnitsGroup === undefined) {
      if (this._value.hasCurrentUnitsGroup) {
        this._cachedHasCurrentUnitsGroup = true;
      } else {
        this._cachedHasCurrentUnitsGroup = this._parent ? this._parent.hasCurrentUnitsGroup : false;
      }
    }
    return this._cachedHasCurrentUnitsGroup;
  }
  get currentUnitsGroup() {
    if (!this._cachedCurrentUnitsGroup) {
      if (this._value.hasCurrentUnitsGroup) {
        this._cachedCurrentUnitsGroup = new dcei_editor_terrain_proto.UndoableUnitsGroup.WithParent(this._value.currentUnitsGroup, this._parent && this._parent.hasCurrentUnitsGroup ? this._parent.currentUnitsGroup : null);
      } else {
        this._cachedCurrentUnitsGroup = this._parent ? new dcei_editor_terrain_proto.UndoableUnitsGroup.WithParent(dcei_editor_terrain_proto.UndoableUnitsGroup.default, this._parent.currentUnitsGroup) : dcei_editor_terrain_proto.UndoableUnitsGroup.WithParent.default;
      }
    }
    return this._cachedCurrentUnitsGroup;
  }
  get hasReset() {
    if (this._cachedHasReset === undefined) {
      if (this._value.hasReset) {
        this._cachedHasReset = true;
      } else {
        this._cachedHasReset = this._parent ? this._parent.hasReset : false;
      }
    }
    return this._cachedHasReset;
  }
  get reset() {
    if (this._cachedReset === undefined) {
      if (this._value.hasReset) {
        this._cachedReset = this._value.reset;
      } else {
        this._cachedReset = this._parent ? this._parent.reset : this._value.reset;
      }
    }
    return this._cachedReset;
  }
  update(current, parent) {
    const result = new TerrainEditorData_EditorPanel_UnitsEditor_WithParent(current, parent);
    if (this._cachedCurrentUnitsGroup && this._value.hasCurrentUnitsGroup && current.hasCurrentUnitsGroup) {
      if (this._value.currentUnitsGroup === current.currentUnitsGroup && this._parent === parent) {
        result._cachedCurrentUnitsGroup = this._cachedCurrentUnitsGroup;
      } else {
        result._cachedCurrentUnitsGroup = this._cachedCurrentUnitsGroup.update(current.currentUnitsGroup, parent && parent.hasCurrentUnitsGroup ? parent.currentUnitsGroup : null);
      }
    }
    return result;
  }
}
TerrainEditorData_EditorPanel_UnitsEditor_WithParent.default = new TerrainEditorData_EditorPanel_UnitsEditor_WithParent(TerrainEditorData_EditorPanel_UnitsEditor.default, null);
TerrainEditorData_EditorPanel_UnitsEditor.WithParent = TerrainEditorData_EditorPanel_UnitsEditor_WithParent;
class TerrainEditorData_EditorPanel_UnitsEditor_Descriptor {
  get currentBrush() {
    if (!this._currentBrush) {
      this._currentBrush = {
        name: "currentBrush",
        Name: "CurrentBrush",
        number: 1,
        protoType: 14,
        protoName: "current_brush",
        type: TerrainEditorData_EditorPanel_BrushMode,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentBrush;
  }
  get initialRotation() {
    if (!this._initialRotation) {
      this._initialRotation = {
        name: "initialRotation",
        Name: "InitialRotation",
        number: 3,
        protoType: 1,
        protoName: "initial_rotation",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._initialRotation;
  }
  get currentUnit() {
    if (!this._currentUnit) {
      this._currentUnit = {
        name: "currentUnit",
        Name: "CurrentUnit",
        number: 4,
        protoType: 9,
        protoName: "current_unit",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentUnit;
  }
  get currentHandleTool() {
    if (!this._currentHandleTool) {
      this._currentHandleTool = {
        name: "currentHandleTool",
        Name: "CurrentHandleTool",
        number: 5,
        protoType: 14,
        protoName: "current_handle_tool",
        type: TerrainEditorData_EditorPanel_HandleTool,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentHandleTool;
  }
  get snapToGrid() {
    if (!this._snapToGrid) {
      this._snapToGrid = {
        name: "snapToGrid",
        Name: "SnapToGrid",
        number: 6,
        protoType: 8,
        protoName: "snap_to_grid",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._snapToGrid;
  }
  get currentSelectedUnitId() {
    if (!this._currentSelectedUnitId) {
      this._currentSelectedUnitId = {
        name: "currentSelectedUnitId",
        Name: "CurrentSelectedUnitId",
        number: 7,
        protoType: 9,
        protoName: "current_selected_unit_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentSelectedUnitId;
  }
  get useRandomRotation() {
    if (!this._useRandomRotation) {
      this._useRandomRotation = {
        name: "useRandomRotation",
        Name: "UseRandomRotation",
        number: 8,
        protoType: 8,
        protoName: "use_random_rotation",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._useRandomRotation;
  }
  get randomRotationMin() {
    if (!this._randomRotationMin) {
      this._randomRotationMin = {
        name: "randomRotationMin",
        Name: "RandomRotationMin",
        number: 10,
        protoType: 1,
        protoName: "random_rotation_min",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._randomRotationMin;
  }
  get randomRotationMax() {
    if (!this._randomRotationMax) {
      this._randomRotationMax = {
        name: "randomRotationMax",
        Name: "RandomRotationMax",
        number: 11,
        protoType: 1,
        protoName: "random_rotation_max",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._randomRotationMax;
  }
  get gridSize() {
    if (!this._gridSize) {
      this._gridSize = {
        name: "gridSize",
        Name: "GridSize",
        number: 16,
        protoType: 1,
        protoName: "grid_size",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gridSize;
  }
  get currentTeam() {
    if (!this._currentTeam) {
      this._currentTeam = {
        name: "currentTeam",
        Name: "CurrentTeam",
        number: 17,
        protoType: 14,
        protoName: "current_team",
        type: dcei_editor_terrain_proto.Team,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentTeam;
  }
  get currentPlayer() {
    if (!this._currentPlayer) {
      this._currentPlayer = {
        name: "currentPlayer",
        Name: "CurrentPlayer",
        number: 18,
        protoType: 5,
        protoName: "current_player",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentPlayer;
  }
  get rangeIndicatorDisplay() {
    if (!this._rangeIndicatorDisplay) {
      this._rangeIndicatorDisplay = {
        name: "rangeIndicatorDisplay",
        Name: "RangeIndicatorDisplay",
        number: 20,
        protoType: 8,
        protoName: "range_indicator_display",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rangeIndicatorDisplay;
  }
  get rangeIndicatorSize() {
    if (!this._rangeIndicatorSize) {
      this._rangeIndicatorSize = {
        name: "rangeIndicatorSize",
        Name: "RangeIndicatorSize",
        number: 21,
        protoType: 1,
        protoName: "range_indicator_size",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rangeIndicatorSize;
  }
  get disableCollider() {
    if (!this._disableCollider) {
      this._disableCollider = {
        name: "disableCollider",
        Name: "DisableCollider",
        number: 22,
        protoType: 8,
        protoName: "disable_collider",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._disableCollider;
  }
  get showUnitColliders() {
    if (!this._showUnitColliders) {
      this._showUnitColliders = {
        name: "showUnitColliders",
        Name: "ShowUnitColliders",
        number: 23,
        protoType: 8,
        protoName: "show_unit_colliders",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._showUnitColliders;
  }
  get showWeaponScanRange() {
    if (!this._showWeaponScanRange) {
      this._showWeaponScanRange = {
        name: "showWeaponScanRange",
        Name: "ShowWeaponScanRange",
        number: 24,
        protoType: 8,
        protoName: "show_weapon_scan_range",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._showWeaponScanRange;
  }
  get showWeaponRange() {
    if (!this._showWeaponRange) {
      this._showWeaponRange = {
        name: "showWeaponRange",
        Name: "ShowWeaponRange",
        number: 25,
        protoType: 8,
        protoName: "show_weapon_range",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._showWeaponRange;
  }
  get showUnitEngageRange() {
    if (!this._showUnitEngageRange) {
      this._showUnitEngageRange = {
        name: "showUnitEngageRange",
        Name: "ShowUnitEngageRange",
        number: 26,
        protoType: 8,
        protoName: "show_unit_engage_range",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._showUnitEngageRange;
  }
  get showDefenseRadius() {
    if (!this._showDefenseRadius) {
      this._showDefenseRadius = {
        name: "showDefenseRadius",
        Name: "ShowDefenseRadius",
        number: 27,
        protoType: 8,
        protoName: "show_defense_radius",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._showDefenseRadius;
  }
  get showResetRadius() {
    if (!this._showResetRadius) {
      this._showResetRadius = {
        name: "showResetRadius",
        Name: "ShowResetRadius",
        number: 28,
        protoType: 8,
        protoName: "show_reset_radius",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._showResetRadius;
  }
  get showUnitRadius() {
    if (!this._showUnitRadius) {
      this._showUnitRadius = {
        name: "showUnitRadius",
        Name: "ShowUnitRadius",
        number: 29,
        protoType: 8,
        protoName: "show_unit_radius",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._showUnitRadius;
  }
  get showUnitBoundingSphere() {
    if (!this._showUnitBoundingSphere) {
      this._showUnitBoundingSphere = {
        name: "showUnitBoundingSphere",
        Name: "ShowUnitBoundingSphere",
        number: 30,
        protoType: 8,
        protoName: "show_unit_bounding_sphere",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._showUnitBoundingSphere;
  }
  get currentUnitsGroup() {
    if (!this._currentUnitsGroup) {
      this._currentUnitsGroup = {
        name: "currentUnitsGroup",
        Name: "CurrentUnitsGroup",
        number: 50,
        protoType: 11,
        protoName: "current_units_group",
        type: dcei_editor_terrain_proto.UndoableUnitsGroup,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentUnitsGroup;
  }
  get reset() {
    if (!this._reset) {
      this._reset = {
        name: "reset",
        Name: "Reset",
        number: 99,
        protoType: 8,
        protoName: "reset",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._reset;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.currentBrush,
        this.initialRotation,
        this.currentUnit,
        this.currentHandleTool,
        this.snapToGrid,
        this.currentSelectedUnitId,
        this.useRandomRotation,
        this.randomRotationMin,
        this.randomRotationMax,
        this.gridSize,
        this.currentTeam,
        this.currentPlayer,
        this.rangeIndicatorDisplay,
        this.rangeIndicatorSize,
        this.disableCollider,
        this.showUnitColliders,
        this.showWeaponScanRange,
        this.showWeaponRange,
        this.showUnitEngageRange,
        this.showDefenseRadius,
        this.showResetRadius,
        this.showUnitRadius,
        this.showUnitBoundingSphere,
        this.currentUnitsGroup,
        this.reset,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCurrentBrush",
        Name: "DummyOneofForCurrentBrush",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForInitialRotation",
        Name: "DummyOneofForInitialRotation",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrentUnit",
        Name: "DummyOneofForCurrentUnit",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrentHandleTool",
        Name: "DummyOneofForCurrentHandleTool",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSnapToGrid",
        Name: "DummyOneofForSnapToGrid",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrentSelectedUnitId",
        Name: "DummyOneofForCurrentSelectedUnitId",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUseRandomRotation",
        Name: "DummyOneofForUseRandomRotation",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRandomRotationMin",
        Name: "DummyOneofForRandomRotationMin",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRandomRotationMax",
        Name: "DummyOneofForRandomRotationMax",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGridSize",
        Name: "DummyOneofForGridSize",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrentTeam",
        Name: "DummyOneofForCurrentTeam",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrentPlayer",
        Name: "DummyOneofForCurrentPlayer",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRangeIndicatorDisplay",
        Name: "DummyOneofForRangeIndicatorDisplay",
        fields: [
          this.fields[12],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRangeIndicatorSize",
        Name: "DummyOneofForRangeIndicatorSize",
        fields: [
          this.fields[13],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisableCollider",
        Name: "DummyOneofForDisableCollider",
        fields: [
          this.fields[14],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShowUnitColliders",
        Name: "DummyOneofForShowUnitColliders",
        fields: [
          this.fields[15],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShowWeaponScanRange",
        Name: "DummyOneofForShowWeaponScanRange",
        fields: [
          this.fields[16],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShowWeaponRange",
        Name: "DummyOneofForShowWeaponRange",
        fields: [
          this.fields[17],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShowUnitEngageRange",
        Name: "DummyOneofForShowUnitEngageRange",
        fields: [
          this.fields[18],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShowDefenseRadius",
        Name: "DummyOneofForShowDefenseRadius",
        fields: [
          this.fields[19],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShowResetRadius",
        Name: "DummyOneofForShowResetRadius",
        fields: [
          this.fields[20],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShowUnitRadius",
        Name: "DummyOneofForShowUnitRadius",
        fields: [
          this.fields[21],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShowUnitBoundingSphere",
        Name: "DummyOneofForShowUnitBoundingSphere",
        fields: [
          this.fields[22],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrentUnitsGroup",
        Name: "DummyOneofForCurrentUnitsGroup",
        fields: [
          this.fields[23],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForReset",
        Name: "DummyOneofForReset",
        fields: [
          this.fields[24],
        ],
      });
    }
    return this._oneofs;
  }
}
TerrainEditorData_EditorPanel_UnitsEditor.descriptor = new TerrainEditorData_EditorPanel_UnitsEditor_Descriptor();
class TerrainEditorData_EditorPanel_CameraEditor {
  get descriptor() {
    return TerrainEditorData_EditorPanel_CameraEditor.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasShowGameCamera = false;
    this._showGameCamera = null;
    this._hasShowBoundary = false;
    this._showBoundary = null;
    this._hasMaxZoom = false;
    this._maxZoom = null;
  }
  isEmpty() {
    if (this._hasShowGameCamera) return false;
    if (this._hasShowBoundary) return false;
    if (this._hasMaxZoom) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TerrainEditorData_EditorPanel_CameraEditor) {
      return value;
    }
    return TerrainEditorData_EditorPanel_CameraEditor.fromJson(value);
  }
  static fromJson(json) {
    const result = new TerrainEditorData_EditorPanel_CameraEditor();
    if (json.showGameCamera != null) {
      result._hasShowGameCamera = true;
      result._showGameCamera = JsonToBoolean.fromJson(json.showGameCamera);
    }
    if (json.showBoundary != null) {
      result._hasShowBoundary = true;
      result._showBoundary = JsonToBoolean.fromJson(json.showBoundary);
    }
    if (json.maxZoom != null) {
      result._hasMaxZoom = true;
      result._maxZoom = JsonToBoolean.fromJson(json.maxZoom);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasShowGameCamera) {
      result.showGameCamera = JsonToBoolean.toJson(this._showGameCamera);
    }
    if (this._hasShowBoundary) {
      result.showBoundary = JsonToBoolean.toJson(this._showBoundary);
    }
    if (this._hasMaxZoom) {
      result.maxZoom = JsonToBoolean.toJson(this._maxZoom);
    }
    return result;
  }
  /**
   * @returns {boolean}
   */
  get showGameCamera() {
    return this._hasShowGameCamera ? this._showGameCamera : JsonToBoolean.default;
  }
  get hasShowGameCamera() {
    return this._hasShowGameCamera;
  }
  setShowGameCamera(path, value) {
    return {type: 'SET', path: path.concat(['showGameCamera']), value};
  }
  deleteShowGameCamera(path) {
    return {type: 'DELETE', path: path.concat(['showGameCamera'])};
  }
  /**
   * @returns {boolean}
   */
  get showBoundary() {
    return this._hasShowBoundary ? this._showBoundary : JsonToBoolean.default;
  }
  get hasShowBoundary() {
    return this._hasShowBoundary;
  }
  setShowBoundary(path, value) {
    return {type: 'SET', path: path.concat(['showBoundary']), value};
  }
  deleteShowBoundary(path) {
    return {type: 'DELETE', path: path.concat(['showBoundary'])};
  }
  /**
   * @returns {boolean}
   */
  get maxZoom() {
    return this._hasMaxZoom ? this._maxZoom : JsonToBoolean.default;
  }
  get hasMaxZoom() {
    return this._hasMaxZoom;
  }
  setMaxZoom(path, value) {
    return {type: 'SET', path: path.concat(['maxZoom']), value};
  }
  deleteMaxZoom(path) {
    return {type: 'DELETE', path: path.concat(['maxZoom'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "showGameCamera": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_CameraEditor(this);
              copy._hasShowGameCamera = true;
              copy._showGameCamera = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShowGameCamera) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_CameraEditor(this);
              copy._hasShowGameCamera = false;
              copy._showGameCamera = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "showBoundary": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_CameraEditor(this);
              copy._hasShowBoundary = true;
              copy._showBoundary = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShowBoundary) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_CameraEditor(this);
              copy._hasShowBoundary = false;
              copy._showBoundary = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "maxZoom": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_CameraEditor(this);
              copy._hasMaxZoom = true;
              copy._maxZoom = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxZoom) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_CameraEditor(this);
              copy._hasMaxZoom = false;
              copy._maxZoom = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TerrainEditorData_EditorPanel_CameraEditor} other
   * @returns {TerrainEditorData_EditorPanel_CameraEditor}
   */
  merge(other) {
    const copy = new TerrainEditorData_EditorPanel_CameraEditor(this);
    if (other._hasShowGameCamera) {
      copy._hasShowGameCamera = true;
      copy._showGameCamera = other._showGameCamera;
    }
    if (other._hasShowBoundary) {
      copy._hasShowBoundary = true;
      copy._showBoundary = other._showBoundary;
    }
    if (other._hasMaxZoom) {
      copy._hasMaxZoom = true;
      copy._maxZoom = other._maxZoom;
    }
    return copy;
  }
}
TerrainEditorData_EditorPanel_CameraEditor.default = new TerrainEditorData_EditorPanel_CameraEditor();
class TerrainEditorData_EditorPanel_CameraEditor_Builder {
  constructor(value) {
    this._value = new TerrainEditorData_EditorPanel_CameraEditor(value);
  }
  build() {
    return new TerrainEditorData_EditorPanel_CameraEditor(this._value);
  }
  setShowGameCamera(value) {
    this._value._hasShowGameCamera = true;
    this._value._showGameCamera = value;
    return this;
  }
  deleteShowGameCamera() {
    this._value._hasShowGameCamera = false;
    this._value._showGameCamera = null;
    return this;
  }
  setShowBoundary(value) {
    this._value._hasShowBoundary = true;
    this._value._showBoundary = value;
    return this;
  }
  deleteShowBoundary() {
    this._value._hasShowBoundary = false;
    this._value._showBoundary = null;
    return this;
  }
  setMaxZoom(value) {
    this._value._hasMaxZoom = true;
    this._value._maxZoom = value;
    return this;
  }
  deleteMaxZoom() {
    this._value._hasMaxZoom = false;
    this._value._maxZoom = null;
    return this;
  }
}
TerrainEditorData_EditorPanel_CameraEditor.Builder = TerrainEditorData_EditorPanel_CameraEditor_Builder;
class TerrainEditorData_EditorPanel_CameraEditor_WithParent {
  /**
   * @param {TerrainEditorData_EditorPanel_CameraEditor} value
   * @param {TerrainEditorData_EditorPanel_CameraEditor_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TerrainEditorData_EditorPanel_CameraEditor.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasShowGameCamera() {
    if (this._cachedHasShowGameCamera === undefined) {
      if (this._value.hasShowGameCamera) {
        this._cachedHasShowGameCamera = true;
      } else {
        this._cachedHasShowGameCamera = this._parent ? this._parent.hasShowGameCamera : false;
      }
    }
    return this._cachedHasShowGameCamera;
  }
  get showGameCamera() {
    if (this._cachedShowGameCamera === undefined) {
      if (this._value.hasShowGameCamera) {
        this._cachedShowGameCamera = this._value.showGameCamera;
      } else {
        this._cachedShowGameCamera = this._parent ? this._parent.showGameCamera : this._value.showGameCamera;
      }
    }
    return this._cachedShowGameCamera;
  }
  get hasShowBoundary() {
    if (this._cachedHasShowBoundary === undefined) {
      if (this._value.hasShowBoundary) {
        this._cachedHasShowBoundary = true;
      } else {
        this._cachedHasShowBoundary = this._parent ? this._parent.hasShowBoundary : false;
      }
    }
    return this._cachedHasShowBoundary;
  }
  get showBoundary() {
    if (this._cachedShowBoundary === undefined) {
      if (this._value.hasShowBoundary) {
        this._cachedShowBoundary = this._value.showBoundary;
      } else {
        this._cachedShowBoundary = this._parent ? this._parent.showBoundary : this._value.showBoundary;
      }
    }
    return this._cachedShowBoundary;
  }
  get hasMaxZoom() {
    if (this._cachedHasMaxZoom === undefined) {
      if (this._value.hasMaxZoom) {
        this._cachedHasMaxZoom = true;
      } else {
        this._cachedHasMaxZoom = this._parent ? this._parent.hasMaxZoom : false;
      }
    }
    return this._cachedHasMaxZoom;
  }
  get maxZoom() {
    if (this._cachedMaxZoom === undefined) {
      if (this._value.hasMaxZoom) {
        this._cachedMaxZoom = this._value.maxZoom;
      } else {
        this._cachedMaxZoom = this._parent ? this._parent.maxZoom : this._value.maxZoom;
      }
    }
    return this._cachedMaxZoom;
  }
  update(current, parent) {
    const result = new TerrainEditorData_EditorPanel_CameraEditor_WithParent(current, parent);
    return result;
  }
}
TerrainEditorData_EditorPanel_CameraEditor_WithParent.default = new TerrainEditorData_EditorPanel_CameraEditor_WithParent(TerrainEditorData_EditorPanel_CameraEditor.default, null);
TerrainEditorData_EditorPanel_CameraEditor.WithParent = TerrainEditorData_EditorPanel_CameraEditor_WithParent;
class TerrainEditorData_EditorPanel_CameraEditor_Descriptor {
  get showGameCamera() {
    if (!this._showGameCamera) {
      this._showGameCamera = {
        name: "showGameCamera",
        Name: "ShowGameCamera",
        number: 1,
        protoType: 8,
        protoName: "show_game_camera",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._showGameCamera;
  }
  get showBoundary() {
    if (!this._showBoundary) {
      this._showBoundary = {
        name: "showBoundary",
        Name: "ShowBoundary",
        number: 2,
        protoType: 8,
        protoName: "show_boundary",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._showBoundary;
  }
  get maxZoom() {
    if (!this._maxZoom) {
      this._maxZoom = {
        name: "maxZoom",
        Name: "MaxZoom",
        number: 3,
        protoType: 8,
        protoName: "max_zoom",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxZoom;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.showGameCamera,
        this.showBoundary,
        this.maxZoom,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForShowGameCamera",
        Name: "DummyOneofForShowGameCamera",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShowBoundary",
        Name: "DummyOneofForShowBoundary",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMaxZoom",
        Name: "DummyOneofForMaxZoom",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
TerrainEditorData_EditorPanel_CameraEditor.descriptor = new TerrainEditorData_EditorPanel_CameraEditor_Descriptor();
class TerrainEditorData_EditorPanel_RegionEditor {
  get descriptor() {
    return TerrainEditorData_EditorPanel_RegionEditor.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCurrentBrush = false;
    this._currentBrush = null;
    this._hasCurrentSelectedRegionId = false;
    this._currentSelectedRegionId = null;
    this._hasCurrentHandleTool = false;
    this._currentHandleTool = null;
    this._hasRegionDisplay = false;
    this._regionDisplay = null;
    this._hasReset = false;
    this._reset = null;
  }
  isEmpty() {
    if (this._hasCurrentBrush) return false;
    if (this._hasCurrentSelectedRegionId) return false;
    if (this._hasCurrentHandleTool) return false;
    if (this._hasRegionDisplay) return false;
    if (this._hasReset) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TerrainEditorData_EditorPanel_RegionEditor) {
      return value;
    }
    return TerrainEditorData_EditorPanel_RegionEditor.fromJson(value);
  }
  static fromJson(json) {
    const result = new TerrainEditorData_EditorPanel_RegionEditor();
    if (json.currentBrush != null) {
      result._hasCurrentBrush = true;
      result._currentBrush = TerrainEditorData_EditorPanel_BrushMode.fromJson(json.currentBrush);
    }
    if (json.currentSelectedRegionId != null) {
      result._hasCurrentSelectedRegionId = true;
      result._currentSelectedRegionId = JsonToString.fromJson(json.currentSelectedRegionId);
    }
    if (json.currentHandleTool != null) {
      result._hasCurrentHandleTool = true;
      result._currentHandleTool = TerrainEditorData_EditorPanel_HandleTool.fromJson(json.currentHandleTool);
    }
    if (json.regionDisplay != null) {
      result._hasRegionDisplay = true;
      result._regionDisplay = JsonToBoolean.fromJson(json.regionDisplay);
    }
    if (json.reset != null) {
      result._hasReset = true;
      result._reset = JsonToBoolean.fromJson(json.reset);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCurrentBrush) {
      result.currentBrush = TerrainEditorData_EditorPanel_BrushMode.toJson(this._currentBrush);
    }
    if (this._hasCurrentSelectedRegionId) {
      result.currentSelectedRegionId = JsonToString.toJson(this._currentSelectedRegionId);
    }
    if (this._hasCurrentHandleTool) {
      result.currentHandleTool = TerrainEditorData_EditorPanel_HandleTool.toJson(this._currentHandleTool);
    }
    if (this._hasRegionDisplay) {
      result.regionDisplay = JsonToBoolean.toJson(this._regionDisplay);
    }
    if (this._hasReset) {
      result.reset = JsonToBoolean.toJson(this._reset);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get currentBrush() {
    return this._hasCurrentBrush ? this._currentBrush : TerrainEditorData_EditorPanel_BrushMode.default;
  }
  get hasCurrentBrush() {
    return this._hasCurrentBrush;
  }
  setCurrentBrush(path, value) {
    return {type: 'SET', path: path.concat(['currentBrush']), value};
  }
  deleteCurrentBrush(path) {
    return {type: 'DELETE', path: path.concat(['currentBrush'])};
  }
  /**
   * @returns {string}
   */
  get currentSelectedRegionId() {
    return this._hasCurrentSelectedRegionId ? this._currentSelectedRegionId : JsonToString.default;
  }
  get hasCurrentSelectedRegionId() {
    return this._hasCurrentSelectedRegionId;
  }
  setCurrentSelectedRegionId(path, value) {
    return {type: 'SET', path: path.concat(['currentSelectedRegionId']), value};
  }
  deleteCurrentSelectedRegionId(path) {
    return {type: 'DELETE', path: path.concat(['currentSelectedRegionId'])};
  }
  /**
   * @returns {number}
   */
  get currentHandleTool() {
    return this._hasCurrentHandleTool ? this._currentHandleTool : TerrainEditorData_EditorPanel_HandleTool.default;
  }
  get hasCurrentHandleTool() {
    return this._hasCurrentHandleTool;
  }
  setCurrentHandleTool(path, value) {
    return {type: 'SET', path: path.concat(['currentHandleTool']), value};
  }
  deleteCurrentHandleTool(path) {
    return {type: 'DELETE', path: path.concat(['currentHandleTool'])};
  }
  /**
   * @returns {boolean}
   */
  get regionDisplay() {
    return this._hasRegionDisplay ? this._regionDisplay : JsonToBoolean.default;
  }
  get hasRegionDisplay() {
    return this._hasRegionDisplay;
  }
  setRegionDisplay(path, value) {
    return {type: 'SET', path: path.concat(['regionDisplay']), value};
  }
  deleteRegionDisplay(path) {
    return {type: 'DELETE', path: path.concat(['regionDisplay'])};
  }
  /**
   * @returns {boolean}
   */
  get reset() {
    return this._hasReset ? this._reset : JsonToBoolean.default;
  }
  get hasReset() {
    return this._hasReset;
  }
  setReset(path, value) {
    return {type: 'SET', path: path.concat(['reset']), value};
  }
  deleteReset(path) {
    return {type: 'DELETE', path: path.concat(['reset'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "currentBrush": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_RegionEditor(this);
              copy._hasCurrentBrush = true;
              copy._currentBrush = TerrainEditorData_EditorPanel_BrushMode.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentBrush) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_RegionEditor(this);
              copy._hasCurrentBrush = false;
              copy._currentBrush = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currentSelectedRegionId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_RegionEditor(this);
              copy._hasCurrentSelectedRegionId = true;
              copy._currentSelectedRegionId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentSelectedRegionId) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_RegionEditor(this);
              copy._hasCurrentSelectedRegionId = false;
              copy._currentSelectedRegionId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currentHandleTool": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_RegionEditor(this);
              copy._hasCurrentHandleTool = true;
              copy._currentHandleTool = TerrainEditorData_EditorPanel_HandleTool.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentHandleTool) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_RegionEditor(this);
              copy._hasCurrentHandleTool = false;
              copy._currentHandleTool = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "regionDisplay": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_RegionEditor(this);
              copy._hasRegionDisplay = true;
              copy._regionDisplay = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRegionDisplay) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_RegionEditor(this);
              copy._hasRegionDisplay = false;
              copy._regionDisplay = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "reset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_RegionEditor(this);
              copy._hasReset = true;
              copy._reset = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasReset) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_RegionEditor(this);
              copy._hasReset = false;
              copy._reset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TerrainEditorData_EditorPanel_RegionEditor} other
   * @returns {TerrainEditorData_EditorPanel_RegionEditor}
   */
  merge(other) {
    const copy = new TerrainEditorData_EditorPanel_RegionEditor(this);
    if (other._hasCurrentBrush) {
      copy._hasCurrentBrush = true;
      copy._currentBrush = other._currentBrush;
    }
    if (other._hasCurrentSelectedRegionId) {
      copy._hasCurrentSelectedRegionId = true;
      copy._currentSelectedRegionId = other._currentSelectedRegionId;
    }
    if (other._hasCurrentHandleTool) {
      copy._hasCurrentHandleTool = true;
      copy._currentHandleTool = other._currentHandleTool;
    }
    if (other._hasRegionDisplay) {
      copy._hasRegionDisplay = true;
      copy._regionDisplay = other._regionDisplay;
    }
    if (other._hasReset) {
      copy._hasReset = true;
      copy._reset = other._reset;
    }
    return copy;
  }
}
TerrainEditorData_EditorPanel_RegionEditor.default = new TerrainEditorData_EditorPanel_RegionEditor();
class TerrainEditorData_EditorPanel_RegionEditor_Builder {
  constructor(value) {
    this._value = new TerrainEditorData_EditorPanel_RegionEditor(value);
  }
  build() {
    return new TerrainEditorData_EditorPanel_RegionEditor(this._value);
  }
  setCurrentBrush(value) {
    this._value._hasCurrentBrush = true;
    this._value._currentBrush = value;
    return this;
  }
  deleteCurrentBrush() {
    this._value._hasCurrentBrush = false;
    this._value._currentBrush = null;
    return this;
  }
  setCurrentSelectedRegionId(value) {
    this._value._hasCurrentSelectedRegionId = true;
    this._value._currentSelectedRegionId = value;
    return this;
  }
  deleteCurrentSelectedRegionId() {
    this._value._hasCurrentSelectedRegionId = false;
    this._value._currentSelectedRegionId = null;
    return this;
  }
  setCurrentHandleTool(value) {
    this._value._hasCurrentHandleTool = true;
    this._value._currentHandleTool = value;
    return this;
  }
  deleteCurrentHandleTool() {
    this._value._hasCurrentHandleTool = false;
    this._value._currentHandleTool = null;
    return this;
  }
  setRegionDisplay(value) {
    this._value._hasRegionDisplay = true;
    this._value._regionDisplay = value;
    return this;
  }
  deleteRegionDisplay() {
    this._value._hasRegionDisplay = false;
    this._value._regionDisplay = null;
    return this;
  }
  setReset(value) {
    this._value._hasReset = true;
    this._value._reset = value;
    return this;
  }
  deleteReset() {
    this._value._hasReset = false;
    this._value._reset = null;
    return this;
  }
}
TerrainEditorData_EditorPanel_RegionEditor.Builder = TerrainEditorData_EditorPanel_RegionEditor_Builder;
class TerrainEditorData_EditorPanel_RegionEditor_WithParent {
  /**
   * @param {TerrainEditorData_EditorPanel_RegionEditor} value
   * @param {TerrainEditorData_EditorPanel_RegionEditor_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TerrainEditorData_EditorPanel_RegionEditor.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCurrentBrush() {
    if (this._cachedHasCurrentBrush === undefined) {
      if (this._value.hasCurrentBrush) {
        this._cachedHasCurrentBrush = true;
      } else {
        this._cachedHasCurrentBrush = this._parent ? this._parent.hasCurrentBrush : false;
      }
    }
    return this._cachedHasCurrentBrush;
  }
  get currentBrush() {
    if (this._cachedCurrentBrush === undefined) {
      if (this._value.hasCurrentBrush) {
        this._cachedCurrentBrush = this._value.currentBrush;
      } else {
        this._cachedCurrentBrush = this._parent ? this._parent.currentBrush : this._value.currentBrush;
      }
    }
    return this._cachedCurrentBrush;
  }
  get hasCurrentSelectedRegionId() {
    if (this._cachedHasCurrentSelectedRegionId === undefined) {
      if (this._value.hasCurrentSelectedRegionId) {
        this._cachedHasCurrentSelectedRegionId = true;
      } else {
        this._cachedHasCurrentSelectedRegionId = this._parent ? this._parent.hasCurrentSelectedRegionId : false;
      }
    }
    return this._cachedHasCurrentSelectedRegionId;
  }
  get currentSelectedRegionId() {
    if (this._cachedCurrentSelectedRegionId === undefined) {
      if (this._value.hasCurrentSelectedRegionId) {
        this._cachedCurrentSelectedRegionId = this._value.currentSelectedRegionId;
      } else {
        this._cachedCurrentSelectedRegionId = this._parent ? this._parent.currentSelectedRegionId : this._value.currentSelectedRegionId;
      }
    }
    return this._cachedCurrentSelectedRegionId;
  }
  get hasCurrentHandleTool() {
    if (this._cachedHasCurrentHandleTool === undefined) {
      if (this._value.hasCurrentHandleTool) {
        this._cachedHasCurrentHandleTool = true;
      } else {
        this._cachedHasCurrentHandleTool = this._parent ? this._parent.hasCurrentHandleTool : false;
      }
    }
    return this._cachedHasCurrentHandleTool;
  }
  get currentHandleTool() {
    if (this._cachedCurrentHandleTool === undefined) {
      if (this._value.hasCurrentHandleTool) {
        this._cachedCurrentHandleTool = this._value.currentHandleTool;
      } else {
        this._cachedCurrentHandleTool = this._parent ? this._parent.currentHandleTool : this._value.currentHandleTool;
      }
    }
    return this._cachedCurrentHandleTool;
  }
  get hasRegionDisplay() {
    if (this._cachedHasRegionDisplay === undefined) {
      if (this._value.hasRegionDisplay) {
        this._cachedHasRegionDisplay = true;
      } else {
        this._cachedHasRegionDisplay = this._parent ? this._parent.hasRegionDisplay : false;
      }
    }
    return this._cachedHasRegionDisplay;
  }
  get regionDisplay() {
    if (this._cachedRegionDisplay === undefined) {
      if (this._value.hasRegionDisplay) {
        this._cachedRegionDisplay = this._value.regionDisplay;
      } else {
        this._cachedRegionDisplay = this._parent ? this._parent.regionDisplay : this._value.regionDisplay;
      }
    }
    return this._cachedRegionDisplay;
  }
  get hasReset() {
    if (this._cachedHasReset === undefined) {
      if (this._value.hasReset) {
        this._cachedHasReset = true;
      } else {
        this._cachedHasReset = this._parent ? this._parent.hasReset : false;
      }
    }
    return this._cachedHasReset;
  }
  get reset() {
    if (this._cachedReset === undefined) {
      if (this._value.hasReset) {
        this._cachedReset = this._value.reset;
      } else {
        this._cachedReset = this._parent ? this._parent.reset : this._value.reset;
      }
    }
    return this._cachedReset;
  }
  update(current, parent) {
    const result = new TerrainEditorData_EditorPanel_RegionEditor_WithParent(current, parent);
    return result;
  }
}
TerrainEditorData_EditorPanel_RegionEditor_WithParent.default = new TerrainEditorData_EditorPanel_RegionEditor_WithParent(TerrainEditorData_EditorPanel_RegionEditor.default, null);
TerrainEditorData_EditorPanel_RegionEditor.WithParent = TerrainEditorData_EditorPanel_RegionEditor_WithParent;
class TerrainEditorData_EditorPanel_RegionEditor_Descriptor {
  get currentBrush() {
    if (!this._currentBrush) {
      this._currentBrush = {
        name: "currentBrush",
        Name: "CurrentBrush",
        number: 1,
        protoType: 14,
        protoName: "current_brush",
        type: TerrainEditorData_EditorPanel_BrushMode,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentBrush;
  }
  get currentSelectedRegionId() {
    if (!this._currentSelectedRegionId) {
      this._currentSelectedRegionId = {
        name: "currentSelectedRegionId",
        Name: "CurrentSelectedRegionId",
        number: 2,
        protoType: 9,
        protoName: "current_selected_region_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentSelectedRegionId;
  }
  get currentHandleTool() {
    if (!this._currentHandleTool) {
      this._currentHandleTool = {
        name: "currentHandleTool",
        Name: "CurrentHandleTool",
        number: 5,
        protoType: 14,
        protoName: "current_handle_tool",
        type: TerrainEditorData_EditorPanel_HandleTool,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentHandleTool;
  }
  get regionDisplay() {
    if (!this._regionDisplay) {
      this._regionDisplay = {
        name: "regionDisplay",
        Name: "RegionDisplay",
        number: 9,
        protoType: 8,
        protoName: "region_display",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._regionDisplay;
  }
  get reset() {
    if (!this._reset) {
      this._reset = {
        name: "reset",
        Name: "Reset",
        number: 99,
        protoType: 8,
        protoName: "reset",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._reset;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.currentBrush,
        this.currentSelectedRegionId,
        this.currentHandleTool,
        this.regionDisplay,
        this.reset,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCurrentBrush",
        Name: "DummyOneofForCurrentBrush",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrentSelectedRegionId",
        Name: "DummyOneofForCurrentSelectedRegionId",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrentHandleTool",
        Name: "DummyOneofForCurrentHandleTool",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRegionDisplay",
        Name: "DummyOneofForRegionDisplay",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForReset",
        Name: "DummyOneofForReset",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
TerrainEditorData_EditorPanel_RegionEditor.descriptor = new TerrainEditorData_EditorPanel_RegionEditor_Descriptor();
class TerrainEditorData_EditorPanel_ChunkEditor {
  get descriptor() {
    return TerrainEditorData_EditorPanel_ChunkEditor.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCurrentBrush = false;
    this._currentBrush = null;
    this._hasCurrentSelectedChunkId = false;
    this._currentSelectedChunkId = null;
    this._hasCurrentHandleTool = false;
    this._currentHandleTool = null;
    this._hasChunkDisplay = false;
    this._chunkDisplay = null;
    this._hasReset = false;
    this._reset = null;
  }
  isEmpty() {
    if (this._hasCurrentBrush) return false;
    if (this._hasCurrentSelectedChunkId) return false;
    if (this._hasCurrentHandleTool) return false;
    if (this._hasChunkDisplay) return false;
    if (this._hasReset) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TerrainEditorData_EditorPanel_ChunkEditor) {
      return value;
    }
    return TerrainEditorData_EditorPanel_ChunkEditor.fromJson(value);
  }
  static fromJson(json) {
    const result = new TerrainEditorData_EditorPanel_ChunkEditor();
    if (json.currentBrush != null) {
      result._hasCurrentBrush = true;
      result._currentBrush = TerrainEditorData_EditorPanel_BrushMode.fromJson(json.currentBrush);
    }
    if (json.currentSelectedChunkId != null) {
      result._hasCurrentSelectedChunkId = true;
      result._currentSelectedChunkId = JsonToString.fromJson(json.currentSelectedChunkId);
    }
    if (json.currentHandleTool != null) {
      result._hasCurrentHandleTool = true;
      result._currentHandleTool = TerrainEditorData_EditorPanel_HandleTool.fromJson(json.currentHandleTool);
    }
    if (json.chunkDisplay != null) {
      result._hasChunkDisplay = true;
      result._chunkDisplay = JsonToBoolean.fromJson(json.chunkDisplay);
    }
    if (json.reset != null) {
      result._hasReset = true;
      result._reset = JsonToBoolean.fromJson(json.reset);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCurrentBrush) {
      result.currentBrush = TerrainEditorData_EditorPanel_BrushMode.toJson(this._currentBrush);
    }
    if (this._hasCurrentSelectedChunkId) {
      result.currentSelectedChunkId = JsonToString.toJson(this._currentSelectedChunkId);
    }
    if (this._hasCurrentHandleTool) {
      result.currentHandleTool = TerrainEditorData_EditorPanel_HandleTool.toJson(this._currentHandleTool);
    }
    if (this._hasChunkDisplay) {
      result.chunkDisplay = JsonToBoolean.toJson(this._chunkDisplay);
    }
    if (this._hasReset) {
      result.reset = JsonToBoolean.toJson(this._reset);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get currentBrush() {
    return this._hasCurrentBrush ? this._currentBrush : TerrainEditorData_EditorPanel_BrushMode.default;
  }
  get hasCurrentBrush() {
    return this._hasCurrentBrush;
  }
  setCurrentBrush(path, value) {
    return {type: 'SET', path: path.concat(['currentBrush']), value};
  }
  deleteCurrentBrush(path) {
    return {type: 'DELETE', path: path.concat(['currentBrush'])};
  }
  /**
   * @returns {string}
   */
  get currentSelectedChunkId() {
    return this._hasCurrentSelectedChunkId ? this._currentSelectedChunkId : JsonToString.default;
  }
  get hasCurrentSelectedChunkId() {
    return this._hasCurrentSelectedChunkId;
  }
  setCurrentSelectedChunkId(path, value) {
    return {type: 'SET', path: path.concat(['currentSelectedChunkId']), value};
  }
  deleteCurrentSelectedChunkId(path) {
    return {type: 'DELETE', path: path.concat(['currentSelectedChunkId'])};
  }
  /**
   * @returns {number}
   */
  get currentHandleTool() {
    return this._hasCurrentHandleTool ? this._currentHandleTool : TerrainEditorData_EditorPanel_HandleTool.default;
  }
  get hasCurrentHandleTool() {
    return this._hasCurrentHandleTool;
  }
  setCurrentHandleTool(path, value) {
    return {type: 'SET', path: path.concat(['currentHandleTool']), value};
  }
  deleteCurrentHandleTool(path) {
    return {type: 'DELETE', path: path.concat(['currentHandleTool'])};
  }
  /**
   * @returns {boolean}
   */
  get chunkDisplay() {
    return this._hasChunkDisplay ? this._chunkDisplay : JsonToBoolean.default;
  }
  get hasChunkDisplay() {
    return this._hasChunkDisplay;
  }
  setChunkDisplay(path, value) {
    return {type: 'SET', path: path.concat(['chunkDisplay']), value};
  }
  deleteChunkDisplay(path) {
    return {type: 'DELETE', path: path.concat(['chunkDisplay'])};
  }
  /**
   * @returns {boolean}
   */
  get reset() {
    return this._hasReset ? this._reset : JsonToBoolean.default;
  }
  get hasReset() {
    return this._hasReset;
  }
  setReset(path, value) {
    return {type: 'SET', path: path.concat(['reset']), value};
  }
  deleteReset(path) {
    return {type: 'DELETE', path: path.concat(['reset'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "currentBrush": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_ChunkEditor(this);
              copy._hasCurrentBrush = true;
              copy._currentBrush = TerrainEditorData_EditorPanel_BrushMode.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentBrush) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_ChunkEditor(this);
              copy._hasCurrentBrush = false;
              copy._currentBrush = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currentSelectedChunkId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_ChunkEditor(this);
              copy._hasCurrentSelectedChunkId = true;
              copy._currentSelectedChunkId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentSelectedChunkId) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_ChunkEditor(this);
              copy._hasCurrentSelectedChunkId = false;
              copy._currentSelectedChunkId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currentHandleTool": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_ChunkEditor(this);
              copy._hasCurrentHandleTool = true;
              copy._currentHandleTool = TerrainEditorData_EditorPanel_HandleTool.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentHandleTool) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_ChunkEditor(this);
              copy._hasCurrentHandleTool = false;
              copy._currentHandleTool = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chunkDisplay": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_ChunkEditor(this);
              copy._hasChunkDisplay = true;
              copy._chunkDisplay = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChunkDisplay) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_ChunkEditor(this);
              copy._hasChunkDisplay = false;
              copy._chunkDisplay = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "reset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel_ChunkEditor(this);
              copy._hasReset = true;
              copy._reset = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasReset) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel_ChunkEditor(this);
              copy._hasReset = false;
              copy._reset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TerrainEditorData_EditorPanel_ChunkEditor} other
   * @returns {TerrainEditorData_EditorPanel_ChunkEditor}
   */
  merge(other) {
    const copy = new TerrainEditorData_EditorPanel_ChunkEditor(this);
    if (other._hasCurrentBrush) {
      copy._hasCurrentBrush = true;
      copy._currentBrush = other._currentBrush;
    }
    if (other._hasCurrentSelectedChunkId) {
      copy._hasCurrentSelectedChunkId = true;
      copy._currentSelectedChunkId = other._currentSelectedChunkId;
    }
    if (other._hasCurrentHandleTool) {
      copy._hasCurrentHandleTool = true;
      copy._currentHandleTool = other._currentHandleTool;
    }
    if (other._hasChunkDisplay) {
      copy._hasChunkDisplay = true;
      copy._chunkDisplay = other._chunkDisplay;
    }
    if (other._hasReset) {
      copy._hasReset = true;
      copy._reset = other._reset;
    }
    return copy;
  }
}
TerrainEditorData_EditorPanel_ChunkEditor.default = new TerrainEditorData_EditorPanel_ChunkEditor();
class TerrainEditorData_EditorPanel_ChunkEditor_Builder {
  constructor(value) {
    this._value = new TerrainEditorData_EditorPanel_ChunkEditor(value);
  }
  build() {
    return new TerrainEditorData_EditorPanel_ChunkEditor(this._value);
  }
  setCurrentBrush(value) {
    this._value._hasCurrentBrush = true;
    this._value._currentBrush = value;
    return this;
  }
  deleteCurrentBrush() {
    this._value._hasCurrentBrush = false;
    this._value._currentBrush = null;
    return this;
  }
  setCurrentSelectedChunkId(value) {
    this._value._hasCurrentSelectedChunkId = true;
    this._value._currentSelectedChunkId = value;
    return this;
  }
  deleteCurrentSelectedChunkId() {
    this._value._hasCurrentSelectedChunkId = false;
    this._value._currentSelectedChunkId = null;
    return this;
  }
  setCurrentHandleTool(value) {
    this._value._hasCurrentHandleTool = true;
    this._value._currentHandleTool = value;
    return this;
  }
  deleteCurrentHandleTool() {
    this._value._hasCurrentHandleTool = false;
    this._value._currentHandleTool = null;
    return this;
  }
  setChunkDisplay(value) {
    this._value._hasChunkDisplay = true;
    this._value._chunkDisplay = value;
    return this;
  }
  deleteChunkDisplay() {
    this._value._hasChunkDisplay = false;
    this._value._chunkDisplay = null;
    return this;
  }
  setReset(value) {
    this._value._hasReset = true;
    this._value._reset = value;
    return this;
  }
  deleteReset() {
    this._value._hasReset = false;
    this._value._reset = null;
    return this;
  }
}
TerrainEditorData_EditorPanel_ChunkEditor.Builder = TerrainEditorData_EditorPanel_ChunkEditor_Builder;
class TerrainEditorData_EditorPanel_ChunkEditor_WithParent {
  /**
   * @param {TerrainEditorData_EditorPanel_ChunkEditor} value
   * @param {TerrainEditorData_EditorPanel_ChunkEditor_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TerrainEditorData_EditorPanel_ChunkEditor.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCurrentBrush() {
    if (this._cachedHasCurrentBrush === undefined) {
      if (this._value.hasCurrentBrush) {
        this._cachedHasCurrentBrush = true;
      } else {
        this._cachedHasCurrentBrush = this._parent ? this._parent.hasCurrentBrush : false;
      }
    }
    return this._cachedHasCurrentBrush;
  }
  get currentBrush() {
    if (this._cachedCurrentBrush === undefined) {
      if (this._value.hasCurrentBrush) {
        this._cachedCurrentBrush = this._value.currentBrush;
      } else {
        this._cachedCurrentBrush = this._parent ? this._parent.currentBrush : this._value.currentBrush;
      }
    }
    return this._cachedCurrentBrush;
  }
  get hasCurrentSelectedChunkId() {
    if (this._cachedHasCurrentSelectedChunkId === undefined) {
      if (this._value.hasCurrentSelectedChunkId) {
        this._cachedHasCurrentSelectedChunkId = true;
      } else {
        this._cachedHasCurrentSelectedChunkId = this._parent ? this._parent.hasCurrentSelectedChunkId : false;
      }
    }
    return this._cachedHasCurrentSelectedChunkId;
  }
  get currentSelectedChunkId() {
    if (this._cachedCurrentSelectedChunkId === undefined) {
      if (this._value.hasCurrentSelectedChunkId) {
        this._cachedCurrentSelectedChunkId = this._value.currentSelectedChunkId;
      } else {
        this._cachedCurrentSelectedChunkId = this._parent ? this._parent.currentSelectedChunkId : this._value.currentSelectedChunkId;
      }
    }
    return this._cachedCurrentSelectedChunkId;
  }
  get hasCurrentHandleTool() {
    if (this._cachedHasCurrentHandleTool === undefined) {
      if (this._value.hasCurrentHandleTool) {
        this._cachedHasCurrentHandleTool = true;
      } else {
        this._cachedHasCurrentHandleTool = this._parent ? this._parent.hasCurrentHandleTool : false;
      }
    }
    return this._cachedHasCurrentHandleTool;
  }
  get currentHandleTool() {
    if (this._cachedCurrentHandleTool === undefined) {
      if (this._value.hasCurrentHandleTool) {
        this._cachedCurrentHandleTool = this._value.currentHandleTool;
      } else {
        this._cachedCurrentHandleTool = this._parent ? this._parent.currentHandleTool : this._value.currentHandleTool;
      }
    }
    return this._cachedCurrentHandleTool;
  }
  get hasChunkDisplay() {
    if (this._cachedHasChunkDisplay === undefined) {
      if (this._value.hasChunkDisplay) {
        this._cachedHasChunkDisplay = true;
      } else {
        this._cachedHasChunkDisplay = this._parent ? this._parent.hasChunkDisplay : false;
      }
    }
    return this._cachedHasChunkDisplay;
  }
  get chunkDisplay() {
    if (this._cachedChunkDisplay === undefined) {
      if (this._value.hasChunkDisplay) {
        this._cachedChunkDisplay = this._value.chunkDisplay;
      } else {
        this._cachedChunkDisplay = this._parent ? this._parent.chunkDisplay : this._value.chunkDisplay;
      }
    }
    return this._cachedChunkDisplay;
  }
  get hasReset() {
    if (this._cachedHasReset === undefined) {
      if (this._value.hasReset) {
        this._cachedHasReset = true;
      } else {
        this._cachedHasReset = this._parent ? this._parent.hasReset : false;
      }
    }
    return this._cachedHasReset;
  }
  get reset() {
    if (this._cachedReset === undefined) {
      if (this._value.hasReset) {
        this._cachedReset = this._value.reset;
      } else {
        this._cachedReset = this._parent ? this._parent.reset : this._value.reset;
      }
    }
    return this._cachedReset;
  }
  update(current, parent) {
    const result = new TerrainEditorData_EditorPanel_ChunkEditor_WithParent(current, parent);
    return result;
  }
}
TerrainEditorData_EditorPanel_ChunkEditor_WithParent.default = new TerrainEditorData_EditorPanel_ChunkEditor_WithParent(TerrainEditorData_EditorPanel_ChunkEditor.default, null);
TerrainEditorData_EditorPanel_ChunkEditor.WithParent = TerrainEditorData_EditorPanel_ChunkEditor_WithParent;
class TerrainEditorData_EditorPanel_ChunkEditor_Descriptor {
  get currentBrush() {
    if (!this._currentBrush) {
      this._currentBrush = {
        name: "currentBrush",
        Name: "CurrentBrush",
        number: 1,
        protoType: 14,
        protoName: "current_brush",
        type: TerrainEditorData_EditorPanel_BrushMode,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentBrush;
  }
  get currentSelectedChunkId() {
    if (!this._currentSelectedChunkId) {
      this._currentSelectedChunkId = {
        name: "currentSelectedChunkId",
        Name: "CurrentSelectedChunkId",
        number: 2,
        protoType: 9,
        protoName: "current_selected_chunk_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentSelectedChunkId;
  }
  get currentHandleTool() {
    if (!this._currentHandleTool) {
      this._currentHandleTool = {
        name: "currentHandleTool",
        Name: "CurrentHandleTool",
        number: 5,
        protoType: 14,
        protoName: "current_handle_tool",
        type: TerrainEditorData_EditorPanel_HandleTool,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentHandleTool;
  }
  get chunkDisplay() {
    if (!this._chunkDisplay) {
      this._chunkDisplay = {
        name: "chunkDisplay",
        Name: "ChunkDisplay",
        number: 9,
        protoType: 8,
        protoName: "chunk_display",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chunkDisplay;
  }
  get reset() {
    if (!this._reset) {
      this._reset = {
        name: "reset",
        Name: "Reset",
        number: 99,
        protoType: 8,
        protoName: "reset",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._reset;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.currentBrush,
        this.currentSelectedChunkId,
        this.currentHandleTool,
        this.chunkDisplay,
        this.reset,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCurrentBrush",
        Name: "DummyOneofForCurrentBrush",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrentSelectedChunkId",
        Name: "DummyOneofForCurrentSelectedChunkId",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrentHandleTool",
        Name: "DummyOneofForCurrentHandleTool",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChunkDisplay",
        Name: "DummyOneofForChunkDisplay",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForReset",
        Name: "DummyOneofForReset",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
TerrainEditorData_EditorPanel_ChunkEditor.descriptor = new TerrainEditorData_EditorPanel_ChunkEditor_Descriptor();
class TerrainEditorData_EditorPanel_EditorType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "TILE_EDITOR": return 0;
        case "ROAD_EDITOR": return 1;
        case "PROP_EDITOR": return 2;
        case "WATER_EDITOR": return 3;
        case "WAY_POINTS_EDITOR": return 4;
        case "UNITS_EDITOR": return 5;
        case "CAMERA_EDITOR": return 6;
        case "LAYER_EDITOR": return 7;
        case "REGION_EDITOR": return 8;
        case "CHUNK_EDITOR": return 9;
        case "BOX_SELECT_EDITOR": return 10;
        case "UNIT_MULTI_EDITOR": return 11;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return TerrainEditorData_EditorPanel_EditorType.fromJson(value);
  }
  static fromReact(e) {
    return TerrainEditorData_EditorPanel_EditorType.fromJson(e);
  }
}
TerrainEditorData_EditorPanel_EditorType.TILE_EDITOR = 0;
TerrainEditorData_EditorPanel_EditorType.ROAD_EDITOR = 1;
TerrainEditorData_EditorPanel_EditorType.PROP_EDITOR = 2;
TerrainEditorData_EditorPanel_EditorType.WATER_EDITOR = 3;
TerrainEditorData_EditorPanel_EditorType.WAY_POINTS_EDITOR = 4;
TerrainEditorData_EditorPanel_EditorType.UNITS_EDITOR = 5;
TerrainEditorData_EditorPanel_EditorType.CAMERA_EDITOR = 6;
TerrainEditorData_EditorPanel_EditorType.LAYER_EDITOR = 7;
TerrainEditorData_EditorPanel_EditorType.REGION_EDITOR = 8;
TerrainEditorData_EditorPanel_EditorType.CHUNK_EDITOR = 9;
TerrainEditorData_EditorPanel_EditorType.BOX_SELECT_EDITOR = 10;
TerrainEditorData_EditorPanel_EditorType.UNIT_MULTI_EDITOR = 11;
TerrainEditorData_EditorPanel_EditorType.default = 0;
TerrainEditorData_EditorPanel_EditorType.values = {
  TILE_EDITOR: 0,
  ROAD_EDITOR: 1,
  PROP_EDITOR: 2,
  WATER_EDITOR: 3,
  WAY_POINTS_EDITOR: 4,
  UNITS_EDITOR: 5,
  CAMERA_EDITOR: 6,
  LAYER_EDITOR: 7,
  REGION_EDITOR: 8,
  CHUNK_EDITOR: 9,
  BOX_SELECT_EDITOR: 10,
  UNIT_MULTI_EDITOR: 11,
};
TerrainEditorData_EditorPanel_EditorType.names = {
  0: "TILE_EDITOR",
  1: "ROAD_EDITOR",
  2: "PROP_EDITOR",
  3: "WATER_EDITOR",
  4: "WAY_POINTS_EDITOR",
  5: "UNITS_EDITOR",
  6: "CAMERA_EDITOR",
  7: "LAYER_EDITOR",
  8: "REGION_EDITOR",
  9: "CHUNK_EDITOR",
  10: "BOX_SELECT_EDITOR",
  11: "UNIT_MULTI_EDITOR",
};
class TerrainEditorData_EditorPanel_HandleTool {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "Handle_None": return 0;
        case "FreeMove": return 1;
        case "Translate": return 2;
        case "Rotate": return 3;
        case "Scale": return 4;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return TerrainEditorData_EditorPanel_HandleTool.fromJson(value);
  }
  static fromReact(e) {
    return TerrainEditorData_EditorPanel_HandleTool.fromJson(e);
  }
}
TerrainEditorData_EditorPanel_HandleTool.Handle_None = 0;
TerrainEditorData_EditorPanel_HandleTool.FreeMove = 1;
TerrainEditorData_EditorPanel_HandleTool.Translate = 2;
TerrainEditorData_EditorPanel_HandleTool.Rotate = 3;
TerrainEditorData_EditorPanel_HandleTool.Scale = 4;
TerrainEditorData_EditorPanel_HandleTool.default = 0;
TerrainEditorData_EditorPanel_HandleTool.values = {
  Handle_None: 0,
  FreeMove: 1,
  Translate: 2,
  Rotate: 3,
  Scale: 4,
};
TerrainEditorData_EditorPanel_HandleTool.names = {
  0: "Handle_None",
  1: "FreeMove",
  2: "Translate",
  3: "Rotate",
  4: "Scale",
};
class TerrainEditorData_EditorPanel_BrushMode {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "Brush_None": return 0;
        case "Paint": return 1;
        case "Precise": return 2;
        case "Erase": return 3;
        case "Select": return 4;
        case "Linear": return 5;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return TerrainEditorData_EditorPanel_BrushMode.fromJson(value);
  }
  static fromReact(e) {
    return TerrainEditorData_EditorPanel_BrushMode.fromJson(e);
  }
}
TerrainEditorData_EditorPanel_BrushMode.Brush_None = 0;
TerrainEditorData_EditorPanel_BrushMode.Paint = 1;
TerrainEditorData_EditorPanel_BrushMode.Precise = 2;
TerrainEditorData_EditorPanel_BrushMode.Erase = 3;
TerrainEditorData_EditorPanel_BrushMode.Select = 4;
TerrainEditorData_EditorPanel_BrushMode.Linear = 5;
TerrainEditorData_EditorPanel_BrushMode.default = 0;
TerrainEditorData_EditorPanel_BrushMode.values = {
  Brush_None: 0,
  Paint: 1,
  Precise: 2,
  Erase: 3,
  Select: 4,
  Linear: 5,
};
TerrainEditorData_EditorPanel_BrushMode.names = {
  0: "Brush_None",
  1: "Paint",
  2: "Precise",
  3: "Erase",
  4: "Select",
  5: "Linear",
};
class TerrainEditorData_EditorPanel {
  get descriptor() {
    return TerrainEditorData_EditorPanel.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCurrentPanel = false;
    this._currentPanel = null;
    this._hasTileEditor = false;
    this._tileEditor = null;
    this._hasRoadEditor = false;
    this._roadEditor = null;
    this._hasPropEditor = false;
    this._propEditor = null;
    this._hasWaterEditor = false;
    this._waterEditor = null;
    this._hasWayPointsEditor = false;
    this._wayPointsEditor = null;
    this._hasUnitsEditor = false;
    this._unitsEditor = null;
    this._hasCameraEditor = false;
    this._cameraEditor = null;
    this._hasRegionEditor = false;
    this._regionEditor = null;
    this._hasChunkEditor = false;
    this._chunkEditor = null;
  }
  isEmpty() {
    if (this._hasCurrentPanel) return false;
    if (this._hasTileEditor && !this._tileEditor.isEmpty()) return false;
    if (this._hasRoadEditor && !this._roadEditor.isEmpty()) return false;
    if (this._hasPropEditor && !this._propEditor.isEmpty()) return false;
    if (this._hasWaterEditor && !this._waterEditor.isEmpty()) return false;
    if (this._hasWayPointsEditor && !this._wayPointsEditor.isEmpty()) return false;
    if (this._hasUnitsEditor && !this._unitsEditor.isEmpty()) return false;
    if (this._hasCameraEditor && !this._cameraEditor.isEmpty()) return false;
    if (this._hasRegionEditor && !this._regionEditor.isEmpty()) return false;
    if (this._hasChunkEditor && !this._chunkEditor.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TerrainEditorData_EditorPanel) {
      return value;
    }
    return TerrainEditorData_EditorPanel.fromJson(value);
  }
  static fromJson(json) {
    const result = new TerrainEditorData_EditorPanel();
    if (json.currentPanel != null) {
      result._hasCurrentPanel = true;
      result._currentPanel = TerrainEditorData_EditorPanel_EditorType.fromJson(json.currentPanel);
    }
    if (json.tileEditor != null) {
      result._hasTileEditor = true;
      result._tileEditor = TerrainEditorData_EditorPanel_TileEditor.fromJson(json.tileEditor);
    }
    if (json.roadEditor != null) {
      result._hasRoadEditor = true;
      result._roadEditor = TerrainEditorData_EditorPanel_RoadEditor.fromJson(json.roadEditor);
    }
    if (json.propEditor != null) {
      result._hasPropEditor = true;
      result._propEditor = TerrainEditorData_EditorPanel_PropEditor.fromJson(json.propEditor);
    }
    if (json.waterEditor != null) {
      result._hasWaterEditor = true;
      result._waterEditor = TerrainEditorData_EditorPanel_WaterEditor.fromJson(json.waterEditor);
    }
    if (json.wayPointsEditor != null) {
      result._hasWayPointsEditor = true;
      result._wayPointsEditor = TerrainEditorData_EditorPanel_WayPointsEditor.fromJson(json.wayPointsEditor);
    }
    if (json.unitsEditor != null) {
      result._hasUnitsEditor = true;
      result._unitsEditor = TerrainEditorData_EditorPanel_UnitsEditor.fromJson(json.unitsEditor);
    }
    if (json.cameraEditor != null) {
      result._hasCameraEditor = true;
      result._cameraEditor = TerrainEditorData_EditorPanel_CameraEditor.fromJson(json.cameraEditor);
    }
    if (json.regionEditor != null) {
      result._hasRegionEditor = true;
      result._regionEditor = TerrainEditorData_EditorPanel_RegionEditor.fromJson(json.regionEditor);
    }
    if (json.chunkEditor != null) {
      result._hasChunkEditor = true;
      result._chunkEditor = TerrainEditorData_EditorPanel_ChunkEditor.fromJson(json.chunkEditor);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCurrentPanel) {
      result.currentPanel = TerrainEditorData_EditorPanel_EditorType.toJson(this._currentPanel);
    }
    if (this._hasTileEditor && !this._tileEditor.isEmpty()) {
      result.tileEditor = TerrainEditorData_EditorPanel_TileEditor.toJson(this._tileEditor);
    }
    if (this._hasRoadEditor && !this._roadEditor.isEmpty()) {
      result.roadEditor = TerrainEditorData_EditorPanel_RoadEditor.toJson(this._roadEditor);
    }
    if (this._hasPropEditor && !this._propEditor.isEmpty()) {
      result.propEditor = TerrainEditorData_EditorPanel_PropEditor.toJson(this._propEditor);
    }
    if (this._hasWaterEditor && !this._waterEditor.isEmpty()) {
      result.waterEditor = TerrainEditorData_EditorPanel_WaterEditor.toJson(this._waterEditor);
    }
    if (this._hasWayPointsEditor && !this._wayPointsEditor.isEmpty()) {
      result.wayPointsEditor = TerrainEditorData_EditorPanel_WayPointsEditor.toJson(this._wayPointsEditor);
    }
    if (this._hasUnitsEditor && !this._unitsEditor.isEmpty()) {
      result.unitsEditor = TerrainEditorData_EditorPanel_UnitsEditor.toJson(this._unitsEditor);
    }
    if (this._hasCameraEditor && !this._cameraEditor.isEmpty()) {
      result.cameraEditor = TerrainEditorData_EditorPanel_CameraEditor.toJson(this._cameraEditor);
    }
    if (this._hasRegionEditor && !this._regionEditor.isEmpty()) {
      result.regionEditor = TerrainEditorData_EditorPanel_RegionEditor.toJson(this._regionEditor);
    }
    if (this._hasChunkEditor && !this._chunkEditor.isEmpty()) {
      result.chunkEditor = TerrainEditorData_EditorPanel_ChunkEditor.toJson(this._chunkEditor);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get currentPanel() {
    return this._hasCurrentPanel ? this._currentPanel : TerrainEditorData_EditorPanel_EditorType.default;
  }
  get hasCurrentPanel() {
    return this._hasCurrentPanel;
  }
  setCurrentPanel(path, value) {
    return {type: 'SET', path: path.concat(['currentPanel']), value};
  }
  deleteCurrentPanel(path) {
    return {type: 'DELETE', path: path.concat(['currentPanel'])};
  }
  /**
   * @returns {TerrainEditorData_EditorPanel_TileEditor}
   */
  get tileEditor() {
    return this._hasTileEditor ? this._tileEditor : TerrainEditorData_EditorPanel_TileEditor.default;
  }
  get hasTileEditor() {
    return this._hasTileEditor;
  }
  setTileEditor(path, value) {
    return {type: 'SET', path: path.concat(['tileEditor']), value: value.toJson()};
  }
  deleteTileEditor(path) {
    return {type: 'DELETE', path: path.concat(['tileEditor'])};
  }
  /**
   * @returns {TerrainEditorData_EditorPanel_RoadEditor}
   */
  get roadEditor() {
    return this._hasRoadEditor ? this._roadEditor : TerrainEditorData_EditorPanel_RoadEditor.default;
  }
  get hasRoadEditor() {
    return this._hasRoadEditor;
  }
  setRoadEditor(path, value) {
    return {type: 'SET', path: path.concat(['roadEditor']), value: value.toJson()};
  }
  deleteRoadEditor(path) {
    return {type: 'DELETE', path: path.concat(['roadEditor'])};
  }
  /**
   * @returns {TerrainEditorData_EditorPanel_PropEditor}
   */
  get propEditor() {
    return this._hasPropEditor ? this._propEditor : TerrainEditorData_EditorPanel_PropEditor.default;
  }
  get hasPropEditor() {
    return this._hasPropEditor;
  }
  setPropEditor(path, value) {
    return {type: 'SET', path: path.concat(['propEditor']), value: value.toJson()};
  }
  deletePropEditor(path) {
    return {type: 'DELETE', path: path.concat(['propEditor'])};
  }
  /**
   * @returns {TerrainEditorData_EditorPanel_WaterEditor}
   */
  get waterEditor() {
    return this._hasWaterEditor ? this._waterEditor : TerrainEditorData_EditorPanel_WaterEditor.default;
  }
  get hasWaterEditor() {
    return this._hasWaterEditor;
  }
  setWaterEditor(path, value) {
    return {type: 'SET', path: path.concat(['waterEditor']), value: value.toJson()};
  }
  deleteWaterEditor(path) {
    return {type: 'DELETE', path: path.concat(['waterEditor'])};
  }
  /**
   * @returns {TerrainEditorData_EditorPanel_WayPointsEditor}
   */
  get wayPointsEditor() {
    return this._hasWayPointsEditor ? this._wayPointsEditor : TerrainEditorData_EditorPanel_WayPointsEditor.default;
  }
  get hasWayPointsEditor() {
    return this._hasWayPointsEditor;
  }
  setWayPointsEditor(path, value) {
    return {type: 'SET', path: path.concat(['wayPointsEditor']), value: value.toJson()};
  }
  deleteWayPointsEditor(path) {
    return {type: 'DELETE', path: path.concat(['wayPointsEditor'])};
  }
  /**
   * @returns {TerrainEditorData_EditorPanel_UnitsEditor}
   */
  get unitsEditor() {
    return this._hasUnitsEditor ? this._unitsEditor : TerrainEditorData_EditorPanel_UnitsEditor.default;
  }
  get hasUnitsEditor() {
    return this._hasUnitsEditor;
  }
  setUnitsEditor(path, value) {
    return {type: 'SET', path: path.concat(['unitsEditor']), value: value.toJson()};
  }
  deleteUnitsEditor(path) {
    return {type: 'DELETE', path: path.concat(['unitsEditor'])};
  }
  /**
   * @returns {TerrainEditorData_EditorPanel_CameraEditor}
   */
  get cameraEditor() {
    return this._hasCameraEditor ? this._cameraEditor : TerrainEditorData_EditorPanel_CameraEditor.default;
  }
  get hasCameraEditor() {
    return this._hasCameraEditor;
  }
  setCameraEditor(path, value) {
    return {type: 'SET', path: path.concat(['cameraEditor']), value: value.toJson()};
  }
  deleteCameraEditor(path) {
    return {type: 'DELETE', path: path.concat(['cameraEditor'])};
  }
  /**
   * @returns {TerrainEditorData_EditorPanel_RegionEditor}
   */
  get regionEditor() {
    return this._hasRegionEditor ? this._regionEditor : TerrainEditorData_EditorPanel_RegionEditor.default;
  }
  get hasRegionEditor() {
    return this._hasRegionEditor;
  }
  setRegionEditor(path, value) {
    return {type: 'SET', path: path.concat(['regionEditor']), value: value.toJson()};
  }
  deleteRegionEditor(path) {
    return {type: 'DELETE', path: path.concat(['regionEditor'])};
  }
  /**
   * @returns {TerrainEditorData_EditorPanel_ChunkEditor}
   */
  get chunkEditor() {
    return this._hasChunkEditor ? this._chunkEditor : TerrainEditorData_EditorPanel_ChunkEditor.default;
  }
  get hasChunkEditor() {
    return this._hasChunkEditor;
  }
  setChunkEditor(path, value) {
    return {type: 'SET', path: path.concat(['chunkEditor']), value: value.toJson()};
  }
  deleteChunkEditor(path) {
    return {type: 'DELETE', path: path.concat(['chunkEditor'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "currentPanel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel(this);
              copy._hasCurrentPanel = true;
              copy._currentPanel = TerrainEditorData_EditorPanel_EditorType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentPanel) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel(this);
              copy._hasCurrentPanel = false;
              copy._currentPanel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "tileEditor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel(this);
              copy._hasTileEditor = true;
              copy._tileEditor = TerrainEditorData_EditorPanel_TileEditor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTileEditor) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel(this);
              copy._hasTileEditor = false;
              copy._tileEditor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTileEditor) {
            const copy = new TerrainEditorData_EditorPanel(this);
            copy._hasTileEditor = true;
            copy._tileEditor = TerrainEditorData_EditorPanel_TileEditor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._tileEditor.apply(type, path.slice(1), value);
          if (newValue === this._tileEditor) {
            return this;
          }
          const copy = new TerrainEditorData_EditorPanel(this);
          copy._tileEditor = copy._tileEditor.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "roadEditor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel(this);
              copy._hasRoadEditor = true;
              copy._roadEditor = TerrainEditorData_EditorPanel_RoadEditor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRoadEditor) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel(this);
              copy._hasRoadEditor = false;
              copy._roadEditor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasRoadEditor) {
            const copy = new TerrainEditorData_EditorPanel(this);
            copy._hasRoadEditor = true;
            copy._roadEditor = TerrainEditorData_EditorPanel_RoadEditor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._roadEditor.apply(type, path.slice(1), value);
          if (newValue === this._roadEditor) {
            return this;
          }
          const copy = new TerrainEditorData_EditorPanel(this);
          copy._roadEditor = copy._roadEditor.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "propEditor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel(this);
              copy._hasPropEditor = true;
              copy._propEditor = TerrainEditorData_EditorPanel_PropEditor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPropEditor) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel(this);
              copy._hasPropEditor = false;
              copy._propEditor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPropEditor) {
            const copy = new TerrainEditorData_EditorPanel(this);
            copy._hasPropEditor = true;
            copy._propEditor = TerrainEditorData_EditorPanel_PropEditor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._propEditor.apply(type, path.slice(1), value);
          if (newValue === this._propEditor) {
            return this;
          }
          const copy = new TerrainEditorData_EditorPanel(this);
          copy._propEditor = copy._propEditor.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "waterEditor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel(this);
              copy._hasWaterEditor = true;
              copy._waterEditor = TerrainEditorData_EditorPanel_WaterEditor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWaterEditor) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel(this);
              copy._hasWaterEditor = false;
              copy._waterEditor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasWaterEditor) {
            const copy = new TerrainEditorData_EditorPanel(this);
            copy._hasWaterEditor = true;
            copy._waterEditor = TerrainEditorData_EditorPanel_WaterEditor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._waterEditor.apply(type, path.slice(1), value);
          if (newValue === this._waterEditor) {
            return this;
          }
          const copy = new TerrainEditorData_EditorPanel(this);
          copy._waterEditor = copy._waterEditor.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "wayPointsEditor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel(this);
              copy._hasWayPointsEditor = true;
              copy._wayPointsEditor = TerrainEditorData_EditorPanel_WayPointsEditor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWayPointsEditor) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel(this);
              copy._hasWayPointsEditor = false;
              copy._wayPointsEditor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasWayPointsEditor) {
            const copy = new TerrainEditorData_EditorPanel(this);
            copy._hasWayPointsEditor = true;
            copy._wayPointsEditor = TerrainEditorData_EditorPanel_WayPointsEditor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._wayPointsEditor.apply(type, path.slice(1), value);
          if (newValue === this._wayPointsEditor) {
            return this;
          }
          const copy = new TerrainEditorData_EditorPanel(this);
          copy._wayPointsEditor = copy._wayPointsEditor.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "unitsEditor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel(this);
              copy._hasUnitsEditor = true;
              copy._unitsEditor = TerrainEditorData_EditorPanel_UnitsEditor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitsEditor) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel(this);
              copy._hasUnitsEditor = false;
              copy._unitsEditor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasUnitsEditor) {
            const copy = new TerrainEditorData_EditorPanel(this);
            copy._hasUnitsEditor = true;
            copy._unitsEditor = TerrainEditorData_EditorPanel_UnitsEditor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._unitsEditor.apply(type, path.slice(1), value);
          if (newValue === this._unitsEditor) {
            return this;
          }
          const copy = new TerrainEditorData_EditorPanel(this);
          copy._unitsEditor = copy._unitsEditor.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "cameraEditor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel(this);
              copy._hasCameraEditor = true;
              copy._cameraEditor = TerrainEditorData_EditorPanel_CameraEditor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCameraEditor) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel(this);
              copy._hasCameraEditor = false;
              copy._cameraEditor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCameraEditor) {
            const copy = new TerrainEditorData_EditorPanel(this);
            copy._hasCameraEditor = true;
            copy._cameraEditor = TerrainEditorData_EditorPanel_CameraEditor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._cameraEditor.apply(type, path.slice(1), value);
          if (newValue === this._cameraEditor) {
            return this;
          }
          const copy = new TerrainEditorData_EditorPanel(this);
          copy._cameraEditor = copy._cameraEditor.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "regionEditor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel(this);
              copy._hasRegionEditor = true;
              copy._regionEditor = TerrainEditorData_EditorPanel_RegionEditor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRegionEditor) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel(this);
              copy._hasRegionEditor = false;
              copy._regionEditor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasRegionEditor) {
            const copy = new TerrainEditorData_EditorPanel(this);
            copy._hasRegionEditor = true;
            copy._regionEditor = TerrainEditorData_EditorPanel_RegionEditor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._regionEditor.apply(type, path.slice(1), value);
          if (newValue === this._regionEditor) {
            return this;
          }
          const copy = new TerrainEditorData_EditorPanel(this);
          copy._regionEditor = copy._regionEditor.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "chunkEditor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData_EditorPanel(this);
              copy._hasChunkEditor = true;
              copy._chunkEditor = TerrainEditorData_EditorPanel_ChunkEditor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChunkEditor) {
                return this;
              }
              const copy = new TerrainEditorData_EditorPanel(this);
              copy._hasChunkEditor = false;
              copy._chunkEditor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasChunkEditor) {
            const copy = new TerrainEditorData_EditorPanel(this);
            copy._hasChunkEditor = true;
            copy._chunkEditor = TerrainEditorData_EditorPanel_ChunkEditor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._chunkEditor.apply(type, path.slice(1), value);
          if (newValue === this._chunkEditor) {
            return this;
          }
          const copy = new TerrainEditorData_EditorPanel(this);
          copy._chunkEditor = copy._chunkEditor.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TerrainEditorData_EditorPanel} other
   * @returns {TerrainEditorData_EditorPanel}
   */
  merge(other) {
    const copy = new TerrainEditorData_EditorPanel(this);
    if (other._hasCurrentPanel) {
      copy._hasCurrentPanel = true;
      copy._currentPanel = other._currentPanel;
    }
    if (other._hasTileEditor) {
      if (copy._hasTileEditor) {
        copy._tileEditor = copy.tileEditor.merge(other.tileEditor);
      } else {
        copy._tileEditor = other._tileEditor;
      }
      copy._hasTileEditor = true;
    }
    if (other._hasRoadEditor) {
      if (copy._hasRoadEditor) {
        copy._roadEditor = copy.roadEditor.merge(other.roadEditor);
      } else {
        copy._roadEditor = other._roadEditor;
      }
      copy._hasRoadEditor = true;
    }
    if (other._hasPropEditor) {
      if (copy._hasPropEditor) {
        copy._propEditor = copy.propEditor.merge(other.propEditor);
      } else {
        copy._propEditor = other._propEditor;
      }
      copy._hasPropEditor = true;
    }
    if (other._hasWaterEditor) {
      if (copy._hasWaterEditor) {
        copy._waterEditor = copy.waterEditor.merge(other.waterEditor);
      } else {
        copy._waterEditor = other._waterEditor;
      }
      copy._hasWaterEditor = true;
    }
    if (other._hasWayPointsEditor) {
      if (copy._hasWayPointsEditor) {
        copy._wayPointsEditor = copy.wayPointsEditor.merge(other.wayPointsEditor);
      } else {
        copy._wayPointsEditor = other._wayPointsEditor;
      }
      copy._hasWayPointsEditor = true;
    }
    if (other._hasUnitsEditor) {
      if (copy._hasUnitsEditor) {
        copy._unitsEditor = copy.unitsEditor.merge(other.unitsEditor);
      } else {
        copy._unitsEditor = other._unitsEditor;
      }
      copy._hasUnitsEditor = true;
    }
    if (other._hasCameraEditor) {
      if (copy._hasCameraEditor) {
        copy._cameraEditor = copy.cameraEditor.merge(other.cameraEditor);
      } else {
        copy._cameraEditor = other._cameraEditor;
      }
      copy._hasCameraEditor = true;
    }
    if (other._hasRegionEditor) {
      if (copy._hasRegionEditor) {
        copy._regionEditor = copy.regionEditor.merge(other.regionEditor);
      } else {
        copy._regionEditor = other._regionEditor;
      }
      copy._hasRegionEditor = true;
    }
    if (other._hasChunkEditor) {
      if (copy._hasChunkEditor) {
        copy._chunkEditor = copy.chunkEditor.merge(other.chunkEditor);
      } else {
        copy._chunkEditor = other._chunkEditor;
      }
      copy._hasChunkEditor = true;
    }
    return copy;
  }
}
TerrainEditorData_EditorPanel.default = new TerrainEditorData_EditorPanel();
TerrainEditorData_EditorPanel.TileEditor = TerrainEditorData_EditorPanel_TileEditor;
TerrainEditorData_EditorPanel.RoadEditor = TerrainEditorData_EditorPanel_RoadEditor;
TerrainEditorData_EditorPanel.PropEditor = TerrainEditorData_EditorPanel_PropEditor;
TerrainEditorData_EditorPanel.WaterEditor = TerrainEditorData_EditorPanel_WaterEditor;
TerrainEditorData_EditorPanel.WayPointsEditor = TerrainEditorData_EditorPanel_WayPointsEditor;
TerrainEditorData_EditorPanel.UnitsEditor = TerrainEditorData_EditorPanel_UnitsEditor;
TerrainEditorData_EditorPanel.CameraEditor = TerrainEditorData_EditorPanel_CameraEditor;
TerrainEditorData_EditorPanel.RegionEditor = TerrainEditorData_EditorPanel_RegionEditor;
TerrainEditorData_EditorPanel.ChunkEditor = TerrainEditorData_EditorPanel_ChunkEditor;
TerrainEditorData_EditorPanel.EditorType = TerrainEditorData_EditorPanel_EditorType;
TerrainEditorData_EditorPanel.HandleTool = TerrainEditorData_EditorPanel_HandleTool;
TerrainEditorData_EditorPanel.BrushMode = TerrainEditorData_EditorPanel_BrushMode;
class TerrainEditorData_EditorPanel_Builder {
  constructor(value) {
    this._value = new TerrainEditorData_EditorPanel(value);
  }
  build() {
    return new TerrainEditorData_EditorPanel(this._value);
  }
  setCurrentPanel(value) {
    this._value._hasCurrentPanel = true;
    this._value._currentPanel = value;
    return this;
  }
  deleteCurrentPanel() {
    this._value._hasCurrentPanel = false;
    this._value._currentPanel = null;
    return this;
  }
  setTileEditor(value) {
    this._value._hasTileEditor = true;
    this._value._tileEditor = value;
    return this;
  }
  deleteTileEditor() {
    this._value._hasTileEditor = false;
    this._value._tileEditor = null;
    return this;
  }
  setRoadEditor(value) {
    this._value._hasRoadEditor = true;
    this._value._roadEditor = value;
    return this;
  }
  deleteRoadEditor() {
    this._value._hasRoadEditor = false;
    this._value._roadEditor = null;
    return this;
  }
  setPropEditor(value) {
    this._value._hasPropEditor = true;
    this._value._propEditor = value;
    return this;
  }
  deletePropEditor() {
    this._value._hasPropEditor = false;
    this._value._propEditor = null;
    return this;
  }
  setWaterEditor(value) {
    this._value._hasWaterEditor = true;
    this._value._waterEditor = value;
    return this;
  }
  deleteWaterEditor() {
    this._value._hasWaterEditor = false;
    this._value._waterEditor = null;
    return this;
  }
  setWayPointsEditor(value) {
    this._value._hasWayPointsEditor = true;
    this._value._wayPointsEditor = value;
    return this;
  }
  deleteWayPointsEditor() {
    this._value._hasWayPointsEditor = false;
    this._value._wayPointsEditor = null;
    return this;
  }
  setUnitsEditor(value) {
    this._value._hasUnitsEditor = true;
    this._value._unitsEditor = value;
    return this;
  }
  deleteUnitsEditor() {
    this._value._hasUnitsEditor = false;
    this._value._unitsEditor = null;
    return this;
  }
  setCameraEditor(value) {
    this._value._hasCameraEditor = true;
    this._value._cameraEditor = value;
    return this;
  }
  deleteCameraEditor() {
    this._value._hasCameraEditor = false;
    this._value._cameraEditor = null;
    return this;
  }
  setRegionEditor(value) {
    this._value._hasRegionEditor = true;
    this._value._regionEditor = value;
    return this;
  }
  deleteRegionEditor() {
    this._value._hasRegionEditor = false;
    this._value._regionEditor = null;
    return this;
  }
  setChunkEditor(value) {
    this._value._hasChunkEditor = true;
    this._value._chunkEditor = value;
    return this;
  }
  deleteChunkEditor() {
    this._value._hasChunkEditor = false;
    this._value._chunkEditor = null;
    return this;
  }
}
TerrainEditorData_EditorPanel.Builder = TerrainEditorData_EditorPanel_Builder;
class TerrainEditorData_EditorPanel_WithParent {
  /**
   * @param {TerrainEditorData_EditorPanel} value
   * @param {TerrainEditorData_EditorPanel_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TerrainEditorData_EditorPanel.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCurrentPanel() {
    if (this._cachedHasCurrentPanel === undefined) {
      if (this._value.hasCurrentPanel) {
        this._cachedHasCurrentPanel = true;
      } else {
        this._cachedHasCurrentPanel = this._parent ? this._parent.hasCurrentPanel : false;
      }
    }
    return this._cachedHasCurrentPanel;
  }
  get currentPanel() {
    if (this._cachedCurrentPanel === undefined) {
      if (this._value.hasCurrentPanel) {
        this._cachedCurrentPanel = this._value.currentPanel;
      } else {
        this._cachedCurrentPanel = this._parent ? this._parent.currentPanel : this._value.currentPanel;
      }
    }
    return this._cachedCurrentPanel;
  }
  get hasTileEditor() {
    if (this._cachedHasTileEditor === undefined) {
      if (this._value.hasTileEditor) {
        this._cachedHasTileEditor = true;
      } else {
        this._cachedHasTileEditor = this._parent ? this._parent.hasTileEditor : false;
      }
    }
    return this._cachedHasTileEditor;
  }
  get tileEditor() {
    if (!this._cachedTileEditor) {
      if (this._value.hasTileEditor) {
        this._cachedTileEditor = new TerrainEditorData_EditorPanel_TileEditor.WithParent(this._value.tileEditor, this._parent && this._parent.hasTileEditor ? this._parent.tileEditor : null);
      } else {
        this._cachedTileEditor = this._parent ? new TerrainEditorData_EditorPanel_TileEditor.WithParent(TerrainEditorData_EditorPanel_TileEditor.default, this._parent.tileEditor) : TerrainEditorData_EditorPanel_TileEditor.WithParent.default;
      }
    }
    return this._cachedTileEditor;
  }
  get hasRoadEditor() {
    if (this._cachedHasRoadEditor === undefined) {
      if (this._value.hasRoadEditor) {
        this._cachedHasRoadEditor = true;
      } else {
        this._cachedHasRoadEditor = this._parent ? this._parent.hasRoadEditor : false;
      }
    }
    return this._cachedHasRoadEditor;
  }
  get roadEditor() {
    if (!this._cachedRoadEditor) {
      if (this._value.hasRoadEditor) {
        this._cachedRoadEditor = new TerrainEditorData_EditorPanel_RoadEditor.WithParent(this._value.roadEditor, this._parent && this._parent.hasRoadEditor ? this._parent.roadEditor : null);
      } else {
        this._cachedRoadEditor = this._parent ? new TerrainEditorData_EditorPanel_RoadEditor.WithParent(TerrainEditorData_EditorPanel_RoadEditor.default, this._parent.roadEditor) : TerrainEditorData_EditorPanel_RoadEditor.WithParent.default;
      }
    }
    return this._cachedRoadEditor;
  }
  get hasPropEditor() {
    if (this._cachedHasPropEditor === undefined) {
      if (this._value.hasPropEditor) {
        this._cachedHasPropEditor = true;
      } else {
        this._cachedHasPropEditor = this._parent ? this._parent.hasPropEditor : false;
      }
    }
    return this._cachedHasPropEditor;
  }
  get propEditor() {
    if (!this._cachedPropEditor) {
      if (this._value.hasPropEditor) {
        this._cachedPropEditor = new TerrainEditorData_EditorPanel_PropEditor.WithParent(this._value.propEditor, this._parent && this._parent.hasPropEditor ? this._parent.propEditor : null);
      } else {
        this._cachedPropEditor = this._parent ? new TerrainEditorData_EditorPanel_PropEditor.WithParent(TerrainEditorData_EditorPanel_PropEditor.default, this._parent.propEditor) : TerrainEditorData_EditorPanel_PropEditor.WithParent.default;
      }
    }
    return this._cachedPropEditor;
  }
  get hasWaterEditor() {
    if (this._cachedHasWaterEditor === undefined) {
      if (this._value.hasWaterEditor) {
        this._cachedHasWaterEditor = true;
      } else {
        this._cachedHasWaterEditor = this._parent ? this._parent.hasWaterEditor : false;
      }
    }
    return this._cachedHasWaterEditor;
  }
  get waterEditor() {
    if (!this._cachedWaterEditor) {
      if (this._value.hasWaterEditor) {
        this._cachedWaterEditor = new TerrainEditorData_EditorPanel_WaterEditor.WithParent(this._value.waterEditor, this._parent && this._parent.hasWaterEditor ? this._parent.waterEditor : null);
      } else {
        this._cachedWaterEditor = this._parent ? new TerrainEditorData_EditorPanel_WaterEditor.WithParent(TerrainEditorData_EditorPanel_WaterEditor.default, this._parent.waterEditor) : TerrainEditorData_EditorPanel_WaterEditor.WithParent.default;
      }
    }
    return this._cachedWaterEditor;
  }
  get hasWayPointsEditor() {
    if (this._cachedHasWayPointsEditor === undefined) {
      if (this._value.hasWayPointsEditor) {
        this._cachedHasWayPointsEditor = true;
      } else {
        this._cachedHasWayPointsEditor = this._parent ? this._parent.hasWayPointsEditor : false;
      }
    }
    return this._cachedHasWayPointsEditor;
  }
  get wayPointsEditor() {
    if (!this._cachedWayPointsEditor) {
      if (this._value.hasWayPointsEditor) {
        this._cachedWayPointsEditor = new TerrainEditorData_EditorPanel_WayPointsEditor.WithParent(this._value.wayPointsEditor, this._parent && this._parent.hasWayPointsEditor ? this._parent.wayPointsEditor : null);
      } else {
        this._cachedWayPointsEditor = this._parent ? new TerrainEditorData_EditorPanel_WayPointsEditor.WithParent(TerrainEditorData_EditorPanel_WayPointsEditor.default, this._parent.wayPointsEditor) : TerrainEditorData_EditorPanel_WayPointsEditor.WithParent.default;
      }
    }
    return this._cachedWayPointsEditor;
  }
  get hasUnitsEditor() {
    if (this._cachedHasUnitsEditor === undefined) {
      if (this._value.hasUnitsEditor) {
        this._cachedHasUnitsEditor = true;
      } else {
        this._cachedHasUnitsEditor = this._parent ? this._parent.hasUnitsEditor : false;
      }
    }
    return this._cachedHasUnitsEditor;
  }
  get unitsEditor() {
    if (!this._cachedUnitsEditor) {
      if (this._value.hasUnitsEditor) {
        this._cachedUnitsEditor = new TerrainEditorData_EditorPanel_UnitsEditor.WithParent(this._value.unitsEditor, this._parent && this._parent.hasUnitsEditor ? this._parent.unitsEditor : null);
      } else {
        this._cachedUnitsEditor = this._parent ? new TerrainEditorData_EditorPanel_UnitsEditor.WithParent(TerrainEditorData_EditorPanel_UnitsEditor.default, this._parent.unitsEditor) : TerrainEditorData_EditorPanel_UnitsEditor.WithParent.default;
      }
    }
    return this._cachedUnitsEditor;
  }
  get hasCameraEditor() {
    if (this._cachedHasCameraEditor === undefined) {
      if (this._value.hasCameraEditor) {
        this._cachedHasCameraEditor = true;
      } else {
        this._cachedHasCameraEditor = this._parent ? this._parent.hasCameraEditor : false;
      }
    }
    return this._cachedHasCameraEditor;
  }
  get cameraEditor() {
    if (!this._cachedCameraEditor) {
      if (this._value.hasCameraEditor) {
        this._cachedCameraEditor = new TerrainEditorData_EditorPanel_CameraEditor.WithParent(this._value.cameraEditor, this._parent && this._parent.hasCameraEditor ? this._parent.cameraEditor : null);
      } else {
        this._cachedCameraEditor = this._parent ? new TerrainEditorData_EditorPanel_CameraEditor.WithParent(TerrainEditorData_EditorPanel_CameraEditor.default, this._parent.cameraEditor) : TerrainEditorData_EditorPanel_CameraEditor.WithParent.default;
      }
    }
    return this._cachedCameraEditor;
  }
  get hasRegionEditor() {
    if (this._cachedHasRegionEditor === undefined) {
      if (this._value.hasRegionEditor) {
        this._cachedHasRegionEditor = true;
      } else {
        this._cachedHasRegionEditor = this._parent ? this._parent.hasRegionEditor : false;
      }
    }
    return this._cachedHasRegionEditor;
  }
  get regionEditor() {
    if (!this._cachedRegionEditor) {
      if (this._value.hasRegionEditor) {
        this._cachedRegionEditor = new TerrainEditorData_EditorPanel_RegionEditor.WithParent(this._value.regionEditor, this._parent && this._parent.hasRegionEditor ? this._parent.regionEditor : null);
      } else {
        this._cachedRegionEditor = this._parent ? new TerrainEditorData_EditorPanel_RegionEditor.WithParent(TerrainEditorData_EditorPanel_RegionEditor.default, this._parent.regionEditor) : TerrainEditorData_EditorPanel_RegionEditor.WithParent.default;
      }
    }
    return this._cachedRegionEditor;
  }
  get hasChunkEditor() {
    if (this._cachedHasChunkEditor === undefined) {
      if (this._value.hasChunkEditor) {
        this._cachedHasChunkEditor = true;
      } else {
        this._cachedHasChunkEditor = this._parent ? this._parent.hasChunkEditor : false;
      }
    }
    return this._cachedHasChunkEditor;
  }
  get chunkEditor() {
    if (!this._cachedChunkEditor) {
      if (this._value.hasChunkEditor) {
        this._cachedChunkEditor = new TerrainEditorData_EditorPanel_ChunkEditor.WithParent(this._value.chunkEditor, this._parent && this._parent.hasChunkEditor ? this._parent.chunkEditor : null);
      } else {
        this._cachedChunkEditor = this._parent ? new TerrainEditorData_EditorPanel_ChunkEditor.WithParent(TerrainEditorData_EditorPanel_ChunkEditor.default, this._parent.chunkEditor) : TerrainEditorData_EditorPanel_ChunkEditor.WithParent.default;
      }
    }
    return this._cachedChunkEditor;
  }
  update(current, parent) {
    const result = new TerrainEditorData_EditorPanel_WithParent(current, parent);
    if (this._cachedTileEditor && this._value.hasTileEditor && current.hasTileEditor) {
      if (this._value.tileEditor === current.tileEditor && this._parent === parent) {
        result._cachedTileEditor = this._cachedTileEditor;
      } else {
        result._cachedTileEditor = this._cachedTileEditor.update(current.tileEditor, parent && parent.hasTileEditor ? parent.tileEditor : null);
      }
    }
    if (this._cachedRoadEditor && this._value.hasRoadEditor && current.hasRoadEditor) {
      if (this._value.roadEditor === current.roadEditor && this._parent === parent) {
        result._cachedRoadEditor = this._cachedRoadEditor;
      } else {
        result._cachedRoadEditor = this._cachedRoadEditor.update(current.roadEditor, parent && parent.hasRoadEditor ? parent.roadEditor : null);
      }
    }
    if (this._cachedPropEditor && this._value.hasPropEditor && current.hasPropEditor) {
      if (this._value.propEditor === current.propEditor && this._parent === parent) {
        result._cachedPropEditor = this._cachedPropEditor;
      } else {
        result._cachedPropEditor = this._cachedPropEditor.update(current.propEditor, parent && parent.hasPropEditor ? parent.propEditor : null);
      }
    }
    if (this._cachedWaterEditor && this._value.hasWaterEditor && current.hasWaterEditor) {
      if (this._value.waterEditor === current.waterEditor && this._parent === parent) {
        result._cachedWaterEditor = this._cachedWaterEditor;
      } else {
        result._cachedWaterEditor = this._cachedWaterEditor.update(current.waterEditor, parent && parent.hasWaterEditor ? parent.waterEditor : null);
      }
    }
    if (this._cachedWayPointsEditor && this._value.hasWayPointsEditor && current.hasWayPointsEditor) {
      if (this._value.wayPointsEditor === current.wayPointsEditor && this._parent === parent) {
        result._cachedWayPointsEditor = this._cachedWayPointsEditor;
      } else {
        result._cachedWayPointsEditor = this._cachedWayPointsEditor.update(current.wayPointsEditor, parent && parent.hasWayPointsEditor ? parent.wayPointsEditor : null);
      }
    }
    if (this._cachedUnitsEditor && this._value.hasUnitsEditor && current.hasUnitsEditor) {
      if (this._value.unitsEditor === current.unitsEditor && this._parent === parent) {
        result._cachedUnitsEditor = this._cachedUnitsEditor;
      } else {
        result._cachedUnitsEditor = this._cachedUnitsEditor.update(current.unitsEditor, parent && parent.hasUnitsEditor ? parent.unitsEditor : null);
      }
    }
    if (this._cachedCameraEditor && this._value.hasCameraEditor && current.hasCameraEditor) {
      if (this._value.cameraEditor === current.cameraEditor && this._parent === parent) {
        result._cachedCameraEditor = this._cachedCameraEditor;
      } else {
        result._cachedCameraEditor = this._cachedCameraEditor.update(current.cameraEditor, parent && parent.hasCameraEditor ? parent.cameraEditor : null);
      }
    }
    if (this._cachedRegionEditor && this._value.hasRegionEditor && current.hasRegionEditor) {
      if (this._value.regionEditor === current.regionEditor && this._parent === parent) {
        result._cachedRegionEditor = this._cachedRegionEditor;
      } else {
        result._cachedRegionEditor = this._cachedRegionEditor.update(current.regionEditor, parent && parent.hasRegionEditor ? parent.regionEditor : null);
      }
    }
    if (this._cachedChunkEditor && this._value.hasChunkEditor && current.hasChunkEditor) {
      if (this._value.chunkEditor === current.chunkEditor && this._parent === parent) {
        result._cachedChunkEditor = this._cachedChunkEditor;
      } else {
        result._cachedChunkEditor = this._cachedChunkEditor.update(current.chunkEditor, parent && parent.hasChunkEditor ? parent.chunkEditor : null);
      }
    }
    return result;
  }
}
TerrainEditorData_EditorPanel_WithParent.default = new TerrainEditorData_EditorPanel_WithParent(TerrainEditorData_EditorPanel.default, null);
TerrainEditorData_EditorPanel.WithParent = TerrainEditorData_EditorPanel_WithParent;
class TerrainEditorData_EditorPanel_Descriptor {
  get currentPanel() {
    if (!this._currentPanel) {
      this._currentPanel = {
        name: "currentPanel",
        Name: "CurrentPanel",
        number: 1,
        protoType: 14,
        protoName: "current_panel",
        type: TerrainEditorData_EditorPanel_EditorType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentPanel;
  }
  get tileEditor() {
    if (!this._tileEditor) {
      this._tileEditor = {
        name: "tileEditor",
        Name: "TileEditor",
        number: 2,
        protoType: 11,
        protoName: "tile_editor",
        type: TerrainEditorData_EditorPanel_TileEditor,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tileEditor;
  }
  get roadEditor() {
    if (!this._roadEditor) {
      this._roadEditor = {
        name: "roadEditor",
        Name: "RoadEditor",
        number: 3,
        protoType: 11,
        protoName: "road_editor",
        type: TerrainEditorData_EditorPanel_RoadEditor,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._roadEditor;
  }
  get propEditor() {
    if (!this._propEditor) {
      this._propEditor = {
        name: "propEditor",
        Name: "PropEditor",
        number: 4,
        protoType: 11,
        protoName: "prop_editor",
        type: TerrainEditorData_EditorPanel_PropEditor,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._propEditor;
  }
  get waterEditor() {
    if (!this._waterEditor) {
      this._waterEditor = {
        name: "waterEditor",
        Name: "WaterEditor",
        number: 5,
        protoType: 11,
        protoName: "water_editor",
        type: TerrainEditorData_EditorPanel_WaterEditor,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._waterEditor;
  }
  get wayPointsEditor() {
    if (!this._wayPointsEditor) {
      this._wayPointsEditor = {
        name: "wayPointsEditor",
        Name: "WayPointsEditor",
        number: 6,
        protoType: 11,
        protoName: "way_points_editor",
        type: TerrainEditorData_EditorPanel_WayPointsEditor,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._wayPointsEditor;
  }
  get unitsEditor() {
    if (!this._unitsEditor) {
      this._unitsEditor = {
        name: "unitsEditor",
        Name: "UnitsEditor",
        number: 7,
        protoType: 11,
        protoName: "units_editor",
        type: TerrainEditorData_EditorPanel_UnitsEditor,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitsEditor;
  }
  get cameraEditor() {
    if (!this._cameraEditor) {
      this._cameraEditor = {
        name: "cameraEditor",
        Name: "CameraEditor",
        number: 8,
        protoType: 11,
        protoName: "camera_editor",
        type: TerrainEditorData_EditorPanel_CameraEditor,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cameraEditor;
  }
  get regionEditor() {
    if (!this._regionEditor) {
      this._regionEditor = {
        name: "regionEditor",
        Name: "RegionEditor",
        number: 9,
        protoType: 11,
        protoName: "region_editor",
        type: TerrainEditorData_EditorPanel_RegionEditor,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._regionEditor;
  }
  get chunkEditor() {
    if (!this._chunkEditor) {
      this._chunkEditor = {
        name: "chunkEditor",
        Name: "ChunkEditor",
        number: 10,
        protoType: 11,
        protoName: "chunk_editor",
        type: TerrainEditorData_EditorPanel_ChunkEditor,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chunkEditor;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.currentPanel,
        this.tileEditor,
        this.roadEditor,
        this.propEditor,
        this.waterEditor,
        this.wayPointsEditor,
        this.unitsEditor,
        this.cameraEditor,
        this.regionEditor,
        this.chunkEditor,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCurrentPanel",
        Name: "DummyOneofForCurrentPanel",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTileEditor",
        Name: "DummyOneofForTileEditor",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRoadEditor",
        Name: "DummyOneofForRoadEditor",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPropEditor",
        Name: "DummyOneofForPropEditor",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWaterEditor",
        Name: "DummyOneofForWaterEditor",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWayPointsEditor",
        Name: "DummyOneofForWayPointsEditor",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnitsEditor",
        Name: "DummyOneofForUnitsEditor",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCameraEditor",
        Name: "DummyOneofForCameraEditor",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRegionEditor",
        Name: "DummyOneofForRegionEditor",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChunkEditor",
        Name: "DummyOneofForChunkEditor",
        fields: [
          this.fields[9],
        ],
      });
    }
    return this._oneofs;
  }
}
TerrainEditorData_EditorPanel.descriptor = new TerrainEditorData_EditorPanel_Descriptor();
export class TerrainEditorData {
  get descriptor() {
    return TerrainEditorData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasEditorPanel = false;
    this._editorPanel = null;
  }
  isEmpty() {
    if (this._hasEditorPanel && !this._editorPanel.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TerrainEditorData) {
      return value;
    }
    return TerrainEditorData.fromJson(value);
  }
  static fromJson(json) {
    const result = new TerrainEditorData();
    if (json.editorPanel != null) {
      result._hasEditorPanel = true;
      result._editorPanel = TerrainEditorData_EditorPanel.fromJson(json.editorPanel);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasEditorPanel && !this._editorPanel.isEmpty()) {
      result.editorPanel = TerrainEditorData_EditorPanel.toJson(this._editorPanel);
    }
    return result;
  }
  /**
   * @returns {TerrainEditorData_EditorPanel}
   */
  get editorPanel() {
    return this._hasEditorPanel ? this._editorPanel : TerrainEditorData_EditorPanel.default;
  }
  get hasEditorPanel() {
    return this._hasEditorPanel;
  }
  setEditorPanel(path, value) {
    return {type: 'SET', path: path.concat(['editorPanel']), value: value.toJson()};
  }
  deleteEditorPanel(path) {
    return {type: 'DELETE', path: path.concat(['editorPanel'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "editorPanel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainEditorData(this);
              copy._hasEditorPanel = true;
              copy._editorPanel = TerrainEditorData_EditorPanel.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEditorPanel) {
                return this;
              }
              const copy = new TerrainEditorData(this);
              copy._hasEditorPanel = false;
              copy._editorPanel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasEditorPanel) {
            const copy = new TerrainEditorData(this);
            copy._hasEditorPanel = true;
            copy._editorPanel = TerrainEditorData_EditorPanel.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._editorPanel.apply(type, path.slice(1), value);
          if (newValue === this._editorPanel) {
            return this;
          }
          const copy = new TerrainEditorData(this);
          copy._editorPanel = copy._editorPanel.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TerrainEditorData} other
   * @returns {TerrainEditorData}
   */
  merge(other) {
    const copy = new TerrainEditorData(this);
    if (other._hasEditorPanel) {
      if (copy._hasEditorPanel) {
        copy._editorPanel = copy.editorPanel.merge(other.editorPanel);
      } else {
        copy._editorPanel = other._editorPanel;
      }
      copy._hasEditorPanel = true;
    }
    return copy;
  }
}
TerrainEditorData.default = new TerrainEditorData();
TerrainEditorData.EditorPanel = TerrainEditorData_EditorPanel;
class TerrainEditorData_Builder {
  constructor(value) {
    this._value = new TerrainEditorData(value);
  }
  build() {
    return new TerrainEditorData(this._value);
  }
  setEditorPanel(value) {
    this._value._hasEditorPanel = true;
    this._value._editorPanel = value;
    return this;
  }
  deleteEditorPanel() {
    this._value._hasEditorPanel = false;
    this._value._editorPanel = null;
    return this;
  }
}
TerrainEditorData.Builder = TerrainEditorData_Builder;
class TerrainEditorData_WithParent {
  /**
   * @param {TerrainEditorData} value
   * @param {TerrainEditorData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TerrainEditorData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasEditorPanel() {
    if (this._cachedHasEditorPanel === undefined) {
      if (this._value.hasEditorPanel) {
        this._cachedHasEditorPanel = true;
      } else {
        this._cachedHasEditorPanel = this._parent ? this._parent.hasEditorPanel : false;
      }
    }
    return this._cachedHasEditorPanel;
  }
  get editorPanel() {
    if (!this._cachedEditorPanel) {
      if (this._value.hasEditorPanel) {
        this._cachedEditorPanel = new TerrainEditorData_EditorPanel.WithParent(this._value.editorPanel, this._parent && this._parent.hasEditorPanel ? this._parent.editorPanel : null);
      } else {
        this._cachedEditorPanel = this._parent ? new TerrainEditorData_EditorPanel.WithParent(TerrainEditorData_EditorPanel.default, this._parent.editorPanel) : TerrainEditorData_EditorPanel.WithParent.default;
      }
    }
    return this._cachedEditorPanel;
  }
  update(current, parent) {
    const result = new TerrainEditorData_WithParent(current, parent);
    if (this._cachedEditorPanel && this._value.hasEditorPanel && current.hasEditorPanel) {
      if (this._value.editorPanel === current.editorPanel && this._parent === parent) {
        result._cachedEditorPanel = this._cachedEditorPanel;
      } else {
        result._cachedEditorPanel = this._cachedEditorPanel.update(current.editorPanel, parent && parent.hasEditorPanel ? parent.editorPanel : null);
      }
    }
    return result;
  }
}
TerrainEditorData_WithParent.default = new TerrainEditorData_WithParent(TerrainEditorData.default, null);
TerrainEditorData.WithParent = TerrainEditorData_WithParent;
class TerrainEditorData_Descriptor {
  get editorPanel() {
    if (!this._editorPanel) {
      this._editorPanel = {
        name: "editorPanel",
        Name: "EditorPanel",
        number: 1,
        protoType: 11,
        protoName: "editor_panel",
        type: TerrainEditorData_EditorPanel,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._editorPanel;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.editorPanel,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForEditorPanel",
        Name: "DummyOneofForEditorPanel",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
TerrainEditorData.descriptor = new TerrainEditorData_Descriptor();
export class UndoableEditorData {
  get descriptor() {
    return UndoableEditorData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUndoableDataEditorData = false;
    this._undoableDataEditorData = null;
    this._hasUndoableTerrainEditorData = false;
    this._undoableTerrainEditorData = null;
  }
  isEmpty() {
    if (this._hasUndoableDataEditorData && !this._undoableDataEditorData.isEmpty()) return false;
    if (this._hasUndoableTerrainEditorData && !this._undoableTerrainEditorData.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableEditorData) {
      return value;
    }
    return UndoableEditorData.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableEditorData();
    if (json.undoableDataEditorData != null) {
      result._hasUndoableDataEditorData = true;
      result._undoableDataEditorData = UndoableDataEditorData.fromJson(json.undoableDataEditorData);
    }
    if (json.undoableTerrainEditorData != null) {
      result._hasUndoableTerrainEditorData = true;
      result._undoableTerrainEditorData = UndoableTerrainEditorData.fromJson(json.undoableTerrainEditorData);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUndoableDataEditorData && !this._undoableDataEditorData.isEmpty()) {
      result.undoableDataEditorData = UndoableDataEditorData.toJson(this._undoableDataEditorData);
    }
    if (this._hasUndoableTerrainEditorData && !this._undoableTerrainEditorData.isEmpty()) {
      result.undoableTerrainEditorData = UndoableTerrainEditorData.toJson(this._undoableTerrainEditorData);
    }
    return result;
  }
  /**
   * @returns {UndoableDataEditorData}
   */
  get undoableDataEditorData() {
    return this._hasUndoableDataEditorData ? this._undoableDataEditorData : UndoableDataEditorData.default;
  }
  get hasUndoableDataEditorData() {
    return this._hasUndoableDataEditorData;
  }
  setUndoableDataEditorData(path, value) {
    return {type: 'SET', path: path.concat(['undoableDataEditorData']), value: value.toJson()};
  }
  deleteUndoableDataEditorData(path) {
    return {type: 'DELETE', path: path.concat(['undoableDataEditorData'])};
  }
  /**
   * @returns {UndoableTerrainEditorData}
   */
  get undoableTerrainEditorData() {
    return this._hasUndoableTerrainEditorData ? this._undoableTerrainEditorData : UndoableTerrainEditorData.default;
  }
  get hasUndoableTerrainEditorData() {
    return this._hasUndoableTerrainEditorData;
  }
  setUndoableTerrainEditorData(path, value) {
    return {type: 'SET', path: path.concat(['undoableTerrainEditorData']), value: value.toJson()};
  }
  deleteUndoableTerrainEditorData(path) {
    return {type: 'DELETE', path: path.concat(['undoableTerrainEditorData'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "undoableDataEditorData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableEditorData(this);
              copy._hasUndoableDataEditorData = true;
              copy._undoableDataEditorData = UndoableDataEditorData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUndoableDataEditorData) {
                return this;
              }
              const copy = new UndoableEditorData(this);
              copy._hasUndoableDataEditorData = false;
              copy._undoableDataEditorData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasUndoableDataEditorData) {
            const copy = new UndoableEditorData(this);
            copy._hasUndoableDataEditorData = true;
            copy._undoableDataEditorData = UndoableDataEditorData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._undoableDataEditorData.apply(type, path.slice(1), value);
          if (newValue === this._undoableDataEditorData) {
            return this;
          }
          const copy = new UndoableEditorData(this);
          copy._undoableDataEditorData = copy._undoableDataEditorData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "undoableTerrainEditorData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableEditorData(this);
              copy._hasUndoableTerrainEditorData = true;
              copy._undoableTerrainEditorData = UndoableTerrainEditorData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUndoableTerrainEditorData) {
                return this;
              }
              const copy = new UndoableEditorData(this);
              copy._hasUndoableTerrainEditorData = false;
              copy._undoableTerrainEditorData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasUndoableTerrainEditorData) {
            const copy = new UndoableEditorData(this);
            copy._hasUndoableTerrainEditorData = true;
            copy._undoableTerrainEditorData = UndoableTerrainEditorData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._undoableTerrainEditorData.apply(type, path.slice(1), value);
          if (newValue === this._undoableTerrainEditorData) {
            return this;
          }
          const copy = new UndoableEditorData(this);
          copy._undoableTerrainEditorData = copy._undoableTerrainEditorData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableEditorData} other
   * @returns {UndoableEditorData}
   */
  merge(other) {
    const copy = new UndoableEditorData(this);
    if (other._hasUndoableDataEditorData) {
      if (copy._hasUndoableDataEditorData) {
        copy._undoableDataEditorData = copy.undoableDataEditorData.merge(other.undoableDataEditorData);
      } else {
        copy._undoableDataEditorData = other._undoableDataEditorData;
      }
      copy._hasUndoableDataEditorData = true;
    }
    if (other._hasUndoableTerrainEditorData) {
      if (copy._hasUndoableTerrainEditorData) {
        copy._undoableTerrainEditorData = copy.undoableTerrainEditorData.merge(other.undoableTerrainEditorData);
      } else {
        copy._undoableTerrainEditorData = other._undoableTerrainEditorData;
      }
      copy._hasUndoableTerrainEditorData = true;
    }
    return copy;
  }
}
UndoableEditorData.default = new UndoableEditorData();
class UndoableEditorData_Builder {
  constructor(value) {
    this._value = new UndoableEditorData(value);
  }
  build() {
    return new UndoableEditorData(this._value);
  }
  setUndoableDataEditorData(value) {
    this._value._hasUndoableDataEditorData = true;
    this._value._undoableDataEditorData = value;
    return this;
  }
  deleteUndoableDataEditorData() {
    this._value._hasUndoableDataEditorData = false;
    this._value._undoableDataEditorData = null;
    return this;
  }
  setUndoableTerrainEditorData(value) {
    this._value._hasUndoableTerrainEditorData = true;
    this._value._undoableTerrainEditorData = value;
    return this;
  }
  deleteUndoableTerrainEditorData() {
    this._value._hasUndoableTerrainEditorData = false;
    this._value._undoableTerrainEditorData = null;
    return this;
  }
}
UndoableEditorData.Builder = UndoableEditorData_Builder;
class UndoableEditorData_WithParent {
  /**
   * @param {UndoableEditorData} value
   * @param {UndoableEditorData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableEditorData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUndoableDataEditorData() {
    if (this._cachedHasUndoableDataEditorData === undefined) {
      if (this._value.hasUndoableDataEditorData) {
        this._cachedHasUndoableDataEditorData = true;
      } else {
        this._cachedHasUndoableDataEditorData = this._parent ? this._parent.hasUndoableDataEditorData : false;
      }
    }
    return this._cachedHasUndoableDataEditorData;
  }
  get undoableDataEditorData() {
    if (!this._cachedUndoableDataEditorData) {
      if (this._value.hasUndoableDataEditorData) {
        this._cachedUndoableDataEditorData = new UndoableDataEditorData.WithParent(this._value.undoableDataEditorData, this._parent && this._parent.hasUndoableDataEditorData ? this._parent.undoableDataEditorData : null);
      } else {
        this._cachedUndoableDataEditorData = this._parent ? new UndoableDataEditorData.WithParent(UndoableDataEditorData.default, this._parent.undoableDataEditorData) : UndoableDataEditorData.WithParent.default;
      }
    }
    return this._cachedUndoableDataEditorData;
  }
  get hasUndoableTerrainEditorData() {
    if (this._cachedHasUndoableTerrainEditorData === undefined) {
      if (this._value.hasUndoableTerrainEditorData) {
        this._cachedHasUndoableTerrainEditorData = true;
      } else {
        this._cachedHasUndoableTerrainEditorData = this._parent ? this._parent.hasUndoableTerrainEditorData : false;
      }
    }
    return this._cachedHasUndoableTerrainEditorData;
  }
  get undoableTerrainEditorData() {
    if (!this._cachedUndoableTerrainEditorData) {
      if (this._value.hasUndoableTerrainEditorData) {
        this._cachedUndoableTerrainEditorData = new UndoableTerrainEditorData.WithParent(this._value.undoableTerrainEditorData, this._parent && this._parent.hasUndoableTerrainEditorData ? this._parent.undoableTerrainEditorData : null);
      } else {
        this._cachedUndoableTerrainEditorData = this._parent ? new UndoableTerrainEditorData.WithParent(UndoableTerrainEditorData.default, this._parent.undoableTerrainEditorData) : UndoableTerrainEditorData.WithParent.default;
      }
    }
    return this._cachedUndoableTerrainEditorData;
  }
  update(current, parent) {
    const result = new UndoableEditorData_WithParent(current, parent);
    if (this._cachedUndoableDataEditorData && this._value.hasUndoableDataEditorData && current.hasUndoableDataEditorData) {
      if (this._value.undoableDataEditorData === current.undoableDataEditorData && this._parent === parent) {
        result._cachedUndoableDataEditorData = this._cachedUndoableDataEditorData;
      } else {
        result._cachedUndoableDataEditorData = this._cachedUndoableDataEditorData.update(current.undoableDataEditorData, parent && parent.hasUndoableDataEditorData ? parent.undoableDataEditorData : null);
      }
    }
    if (this._cachedUndoableTerrainEditorData && this._value.hasUndoableTerrainEditorData && current.hasUndoableTerrainEditorData) {
      if (this._value.undoableTerrainEditorData === current.undoableTerrainEditorData && this._parent === parent) {
        result._cachedUndoableTerrainEditorData = this._cachedUndoableTerrainEditorData;
      } else {
        result._cachedUndoableTerrainEditorData = this._cachedUndoableTerrainEditorData.update(current.undoableTerrainEditorData, parent && parent.hasUndoableTerrainEditorData ? parent.undoableTerrainEditorData : null);
      }
    }
    return result;
  }
}
UndoableEditorData_WithParent.default = new UndoableEditorData_WithParent(UndoableEditorData.default, null);
UndoableEditorData.WithParent = UndoableEditorData_WithParent;
class UndoableEditorData_Descriptor {
  get undoableDataEditorData() {
    if (!this._undoableDataEditorData) {
      this._undoableDataEditorData = {
        name: "undoableDataEditorData",
        Name: "UndoableDataEditorData",
        number: 1,
        protoType: 11,
        protoName: "undoable_data_editor_data",
        type: UndoableDataEditorData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._undoableDataEditorData;
  }
  get undoableTerrainEditorData() {
    if (!this._undoableTerrainEditorData) {
      this._undoableTerrainEditorData = {
        name: "undoableTerrainEditorData",
        Name: "UndoableTerrainEditorData",
        number: 2,
        protoType: 11,
        protoName: "undoable_terrain_editor_data",
        type: UndoableTerrainEditorData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._undoableTerrainEditorData;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.undoableDataEditorData,
        this.undoableTerrainEditorData,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUndoableDataEditorData",
        Name: "DummyOneofForUndoableDataEditorData",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUndoableTerrainEditorData",
        Name: "DummyOneofForUndoableTerrainEditorData",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
UndoableEditorData.descriptor = new UndoableEditorData_Descriptor();
class UndoableDataEditorData_UiDefinitionsEntry {
  get descriptor() {
    return UndoableDataEditorData_UiDefinitionsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableDataEditorData_UiDefinitionsEntry) {
      return value;
    }
    return UndoableDataEditorData_UiDefinitionsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableDataEditorData_UiDefinitionsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = UiDefinition.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = UiDefinition.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {UiDefinition}
   */
  get value() {
    return this._hasValue ? this._value : UiDefinition.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableDataEditorData_UiDefinitionsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new UndoableDataEditorData_UiDefinitionsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableDataEditorData_UiDefinitionsEntry(this);
              copy._hasValue = true;
              copy._value = UiDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new UndoableDataEditorData_UiDefinitionsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new UndoableDataEditorData_UiDefinitionsEntry(this);
            copy._hasValue = true;
            copy._value = UiDefinition.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new UndoableDataEditorData_UiDefinitionsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableDataEditorData_UiDefinitionsEntry} other
   * @returns {UndoableDataEditorData_UiDefinitionsEntry}
   */
  merge(other) {
    const copy = new UndoableDataEditorData_UiDefinitionsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
UndoableDataEditorData_UiDefinitionsEntry.default = new UndoableDataEditorData_UiDefinitionsEntry();
class UndoableDataEditorData_UiDefinitionsEntry_Builder {
  constructor(value) {
    this._value = new UndoableDataEditorData_UiDefinitionsEntry(value);
  }
  build() {
    return new UndoableDataEditorData_UiDefinitionsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
UndoableDataEditorData_UiDefinitionsEntry.Builder = UndoableDataEditorData_UiDefinitionsEntry_Builder;
class UndoableDataEditorData_UiDefinitionsEntry_WithParent {
  /**
   * @param {UndoableDataEditorData_UiDefinitionsEntry} value
   * @param {UndoableDataEditorData_UiDefinitionsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableDataEditorData_UiDefinitionsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new UiDefinition.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new UiDefinition.WithParent(UiDefinition.default, this._parent.value) : UiDefinition.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new UndoableDataEditorData_UiDefinitionsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
UndoableDataEditorData_UiDefinitionsEntry_WithParent.default = new UndoableDataEditorData_UiDefinitionsEntry_WithParent(UndoableDataEditorData_UiDefinitionsEntry.default, null);
UndoableDataEditorData_UiDefinitionsEntry.WithParent = UndoableDataEditorData_UiDefinitionsEntry_WithParent;
class UndoableDataEditorData_UiDefinitionsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: UiDefinition,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UndoableDataEditorData_UiDefinitionsEntry.descriptor = new UndoableDataEditorData_UiDefinitionsEntry_Descriptor();
class UndoableDataEditorData_TriggerDefinitionsEntry {
  get descriptor() {
    return UndoableDataEditorData_TriggerDefinitionsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableDataEditorData_TriggerDefinitionsEntry) {
      return value;
    }
    return UndoableDataEditorData_TriggerDefinitionsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableDataEditorData_TriggerDefinitionsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = TriggerDefinition.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = TriggerDefinition.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {TriggerDefinition}
   */
  get value() {
    return this._hasValue ? this._value : TriggerDefinition.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableDataEditorData_TriggerDefinitionsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new UndoableDataEditorData_TriggerDefinitionsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableDataEditorData_TriggerDefinitionsEntry(this);
              copy._hasValue = true;
              copy._value = TriggerDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new UndoableDataEditorData_TriggerDefinitionsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new UndoableDataEditorData_TriggerDefinitionsEntry(this);
            copy._hasValue = true;
            copy._value = TriggerDefinition.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new UndoableDataEditorData_TriggerDefinitionsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableDataEditorData_TriggerDefinitionsEntry} other
   * @returns {UndoableDataEditorData_TriggerDefinitionsEntry}
   */
  merge(other) {
    const copy = new UndoableDataEditorData_TriggerDefinitionsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
UndoableDataEditorData_TriggerDefinitionsEntry.default = new UndoableDataEditorData_TriggerDefinitionsEntry();
class UndoableDataEditorData_TriggerDefinitionsEntry_Builder {
  constructor(value) {
    this._value = new UndoableDataEditorData_TriggerDefinitionsEntry(value);
  }
  build() {
    return new UndoableDataEditorData_TriggerDefinitionsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
UndoableDataEditorData_TriggerDefinitionsEntry.Builder = UndoableDataEditorData_TriggerDefinitionsEntry_Builder;
class UndoableDataEditorData_TriggerDefinitionsEntry_WithParent {
  /**
   * @param {UndoableDataEditorData_TriggerDefinitionsEntry} value
   * @param {UndoableDataEditorData_TriggerDefinitionsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableDataEditorData_TriggerDefinitionsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new TriggerDefinition.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new TriggerDefinition.WithParent(TriggerDefinition.default, this._parent.value) : TriggerDefinition.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new UndoableDataEditorData_TriggerDefinitionsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
UndoableDataEditorData_TriggerDefinitionsEntry_WithParent.default = new UndoableDataEditorData_TriggerDefinitionsEntry_WithParent(UndoableDataEditorData_TriggerDefinitionsEntry.default, null);
UndoableDataEditorData_TriggerDefinitionsEntry.WithParent = UndoableDataEditorData_TriggerDefinitionsEntry_WithParent;
class UndoableDataEditorData_TriggerDefinitionsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: TriggerDefinition,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UndoableDataEditorData_TriggerDefinitionsEntry.descriptor = new UndoableDataEditorData_TriggerDefinitionsEntry_Descriptor();
export class UndoableDataEditorData {
  get descriptor() {
    return UndoableDataEditorData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasData = false;
    this._data = null;
    this._uiDefinitions = {};
    this._triggerDefinitions = {};
  }
  isEmpty() {
    if (this._hasData && !this._data.isEmpty()) return false;
    if (Object.keys(this._uiDefinitions).length > 0) return false;
    if (Object.keys(this._triggerDefinitions).length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableDataEditorData) {
      return value;
    }
    return UndoableDataEditorData.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableDataEditorData();
    if (json.data != null) {
      result._hasData = true;
      result._data = dcei_engine_data_proto.DataFile.fromJson(json.data);
    }
    result._uiDefinitions = JsonToMap(json.uiDefinitions, JsonToString, UiDefinition);
    result._triggerDefinitions = JsonToMap(json.triggerDefinitions, JsonToString, TriggerDefinition);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasData && !this._data.isEmpty()) {
      result.data = dcei_engine_data_proto.DataFile.toJson(this._data);
    }
    if (Object.keys(this._uiDefinitions).length > 0) {
      result.uiDefinitions = MapToJson(this._uiDefinitions, JsonToString, UiDefinition);
    }
    if (Object.keys(this._triggerDefinitions).length > 0) {
      result.triggerDefinitions = MapToJson(this._triggerDefinitions, JsonToString, TriggerDefinition);
    }
    return result;
  }
  /**
   * @returns {dcei_engine_data_proto.DataFile}
   */
  get data() {
    return this._hasData ? this._data : dcei_engine_data_proto.DataFile.default;
  }
  get hasData() {
    return this._hasData;
  }
  setData(path, value) {
    return {type: 'SET', path: path.concat(['data']), value: value.toJson()};
  }
  deleteData(path) {
    return {type: 'DELETE', path: path.concat(['data'])};
  }
  /**
   * @returns {Object<string, UiDefinition>}
   */
  get uiDefinitions() {
    return this._uiDefinitions;
  }
  setUiDefinitions(path, value) {
    return {type: 'SET', path: path.concat(['uiDefinitions']), value: MapToJson(value, JsonToString, UiDefinition)};
  }
  setUiDefinitionsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['uiDefinitions', key]), value: value.toJson()};
  }
  deleteUiDefinitions(path) {
    return {type: 'DELETE', path: path.concat(['uiDefinitions'])};
  }
  deleteUiDefinitionsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['uiDefinitions', key])};
  }
  /**
   * @returns {Object<string, TriggerDefinition>}
   */
  get triggerDefinitions() {
    return this._triggerDefinitions;
  }
  setTriggerDefinitions(path, value) {
    return {type: 'SET', path: path.concat(['triggerDefinitions']), value: MapToJson(value, JsonToString, TriggerDefinition)};
  }
  setTriggerDefinitionsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['triggerDefinitions', key]), value: value.toJson()};
  }
  deleteTriggerDefinitions(path) {
    return {type: 'DELETE', path: path.concat(['triggerDefinitions'])};
  }
  deleteTriggerDefinitionsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['triggerDefinitions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "data": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableDataEditorData(this);
              copy._hasData = true;
              copy._data = dcei_engine_data_proto.DataFile.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasData) {
                return this;
              }
              const copy = new UndoableDataEditorData(this);
              copy._hasData = false;
              copy._data = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasData) {
            const copy = new UndoableDataEditorData(this);
            copy._hasData = true;
            copy._data = dcei_engine_data_proto.DataFile.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._data.apply(type, path.slice(1), value);
          if (newValue === this._data) {
            return this;
          }
          const copy = new UndoableDataEditorData(this);
          copy._data = copy._data.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "uiDefinitions": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._uiDefinitions).length === 0) {
                return this;
              }
              const copy = new UndoableDataEditorData(this);
              copy._uiDefinitions = {};
              return copy;
            }
            case 'SET': {
              const copy = new UndoableDataEditorData(this);
              copy._uiDefinitions = {};
              for (let key in value) {
                copy._uiDefinitions[key] = UiDefinition.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableDataEditorData(this);
              copy._uiDefinitions = {...copy._uiDefinitions};
              copy._uiDefinitions[path[1]] = UiDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._uiDefinitions[path[1]]) {
                return this;
              }
              const copy = new UndoableDataEditorData(this);
              copy._uiDefinitions = {...copy._uiDefinitions};
              delete copy._uiDefinitions[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._uiDefinitions[key] === undefined) {
            const copy = new UndoableDataEditorData(this);
            copy._uiDefinitions = {...copy._uiDefinitions};
            copy._uiDefinitions[key] = UiDefinition.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._uiDefinitions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UndoableDataEditorData(this);
          copy._uiDefinitions = {...copy._uiDefinitions};
          copy._uiDefinitions[key] = newValue;
          return copy;
        }
      }
      case "triggerDefinitions": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._triggerDefinitions).length === 0) {
                return this;
              }
              const copy = new UndoableDataEditorData(this);
              copy._triggerDefinitions = {};
              return copy;
            }
            case 'SET': {
              const copy = new UndoableDataEditorData(this);
              copy._triggerDefinitions = {};
              for (let key in value) {
                copy._triggerDefinitions[key] = TriggerDefinition.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableDataEditorData(this);
              copy._triggerDefinitions = {...copy._triggerDefinitions};
              copy._triggerDefinitions[path[1]] = TriggerDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._triggerDefinitions[path[1]]) {
                return this;
              }
              const copy = new UndoableDataEditorData(this);
              copy._triggerDefinitions = {...copy._triggerDefinitions};
              delete copy._triggerDefinitions[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._triggerDefinitions[key] === undefined) {
            const copy = new UndoableDataEditorData(this);
            copy._triggerDefinitions = {...copy._triggerDefinitions};
            copy._triggerDefinitions[key] = TriggerDefinition.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._triggerDefinitions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UndoableDataEditorData(this);
          copy._triggerDefinitions = {...copy._triggerDefinitions};
          copy._triggerDefinitions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableDataEditorData} other
   * @returns {UndoableDataEditorData}
   */
  merge(other) {
    const copy = new UndoableDataEditorData(this);
    if (other._hasData) {
      if (copy._hasData) {
        copy._data = copy.data.merge(other.data);
      } else {
        copy._data = other._data;
      }
      copy._hasData = true;
    }
    copy._uiDefinitions = {...this._uiDefinitions, ...other._uiDefinitions};
    copy._triggerDefinitions = {...this._triggerDefinitions, ...other._triggerDefinitions};
    return copy;
  }
}
UndoableDataEditorData.default = new UndoableDataEditorData();
UndoableDataEditorData.UiDefinitionsEntry = UndoableDataEditorData_UiDefinitionsEntry;
UndoableDataEditorData.TriggerDefinitionsEntry = UndoableDataEditorData_TriggerDefinitionsEntry;
class UndoableDataEditorData_Builder {
  constructor(value) {
    this._value = new UndoableDataEditorData(value);
  }
  build() {
    return new UndoableDataEditorData(this._value);
  }
  setData(value) {
    this._value._hasData = true;
    this._value._data = value;
    return this;
  }
  deleteData() {
    this._value._hasData = false;
    this._value._data = null;
    return this;
  }
  setUiDefinitions(key, value) {
    this._value._uiDefinitions = {...this._value._uiDefinitions, [key]: value};
    return this;
  }
  addAllUiDefinitions(values) {
    this._value._uiDefinitions = {...this._value._uiDefinitions, ...values};
    return this;
  }
  deleteUiDefinitions(key) {
    this._value._uiDefinitions = {...this._value._uiDefinitions};
    delete this._value._uiDefinitions[key];
    return this;
  }
  clearUiDefinitions() {
    this._value._uiDefinitions = {};
    return this;
  }
  setTriggerDefinitions(key, value) {
    this._value._triggerDefinitions = {...this._value._triggerDefinitions, [key]: value};
    return this;
  }
  addAllTriggerDefinitions(values) {
    this._value._triggerDefinitions = {...this._value._triggerDefinitions, ...values};
    return this;
  }
  deleteTriggerDefinitions(key) {
    this._value._triggerDefinitions = {...this._value._triggerDefinitions};
    delete this._value._triggerDefinitions[key];
    return this;
  }
  clearTriggerDefinitions() {
    this._value._triggerDefinitions = {};
    return this;
  }
}
UndoableDataEditorData.Builder = UndoableDataEditorData_Builder;
class UndoableDataEditorData_WithParent {
  /**
   * @param {UndoableDataEditorData} value
   * @param {UndoableDataEditorData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableDataEditorData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasData() {
    if (this._cachedHasData === undefined) {
      if (this._value.hasData) {
        this._cachedHasData = true;
      } else {
        this._cachedHasData = this._parent ? this._parent.hasData : false;
      }
    }
    return this._cachedHasData;
  }
  get data() {
    if (!this._cachedData) {
      if (this._value.hasData) {
        this._cachedData = new dcei_engine_data_proto.DataFile.WithParent(this._value.data, this._parent && this._parent.hasData ? this._parent.data : null);
      } else {
        this._cachedData = this._parent ? new dcei_engine_data_proto.DataFile.WithParent(dcei_engine_data_proto.DataFile.default, this._parent.data) : dcei_engine_data_proto.DataFile.WithParent.default;
      }
    }
    return this._cachedData;
  }
  get selfUiDefinitions() {
    if (!this._selfUiDefinitions) {
      this._selfUiDefinitions = {};
      for (let i in this._value.uiDefinitions) {
        this._selfUiDefinitions[i] = new UiDefinition.WithParent(this._value.uiDefinitions[i], null);
      }
    }
    return this._selfUiDefinitions;
  }
  get inherentUiDefinitions() {
    if (!this._inherentUiDefinitions) {
      this._inherentUiDefinitions = this._parent ? this._parent.uiDefinitions : {};
    }
    return this._inherentUiDefinitions;
  }
  get uiDefinitions() {
    if (!this._allUiDefinitions) {
      this._allUiDefinitions = this._parent ? {...this._parent.uiDefinitions, ...this.selfUiDefinitions} : this.selfUiDefinitions;
    }
    return this._allUiDefinitions;
  }
  get selfTriggerDefinitions() {
    if (!this._selfTriggerDefinitions) {
      this._selfTriggerDefinitions = {};
      for (let i in this._value.triggerDefinitions) {
        this._selfTriggerDefinitions[i] = new TriggerDefinition.WithParent(this._value.triggerDefinitions[i], null);
      }
    }
    return this._selfTriggerDefinitions;
  }
  get inherentTriggerDefinitions() {
    if (!this._inherentTriggerDefinitions) {
      this._inherentTriggerDefinitions = this._parent ? this._parent.triggerDefinitions : {};
    }
    return this._inherentTriggerDefinitions;
  }
  get triggerDefinitions() {
    if (!this._allTriggerDefinitions) {
      this._allTriggerDefinitions = this._parent ? {...this._parent.triggerDefinitions, ...this.selfTriggerDefinitions} : this.selfTriggerDefinitions;
    }
    return this._allTriggerDefinitions;
  }
  update(current, parent) {
    const result = new UndoableDataEditorData_WithParent(current, parent);
    if (this._cachedData && this._value.hasData && current.hasData) {
      if (this._value.data === current.data && this._parent === parent) {
        result._cachedData = this._cachedData;
      } else {
        result._cachedData = this._cachedData.update(current.data, parent && parent.hasData ? parent.data : null);
      }
    }
    if (this._selfUiDefinitions) {
      if (this._value.uiDefinitions === current.uiDefinitions) {
        result._selfUiDefinitions = this._selfUiDefinitions;
      } else {
        result._selfUiDefinitions = {};
        for (let i in current.uiDefinitions) {
          const oldValue = this._value.uiDefinitions[i];
          if (oldValue) {
            const oldCache = this._selfUiDefinitions[i];
            if (oldValue === current.uiDefinitions[i]) {
              result._selfUiDefinitions[i] = oldCache;
            } else {
              result._selfUiDefinitions[i] = oldCache.update(current.uiDefinitions[i], null);
            }
          } else {
            result._selfUiDefinitions[i] = new UiDefinition.WithParent(current.uiDefinitions[i], null);
          }
        }
      }
    }
    if (this._selfTriggerDefinitions) {
      if (this._value.triggerDefinitions === current.triggerDefinitions) {
        result._selfTriggerDefinitions = this._selfTriggerDefinitions;
      } else {
        result._selfTriggerDefinitions = {};
        for (let i in current.triggerDefinitions) {
          const oldValue = this._value.triggerDefinitions[i];
          if (oldValue) {
            const oldCache = this._selfTriggerDefinitions[i];
            if (oldValue === current.triggerDefinitions[i]) {
              result._selfTriggerDefinitions[i] = oldCache;
            } else {
              result._selfTriggerDefinitions[i] = oldCache.update(current.triggerDefinitions[i], null);
            }
          } else {
            result._selfTriggerDefinitions[i] = new TriggerDefinition.WithParent(current.triggerDefinitions[i], null);
          }
        }
      }
    }
    return result;
  }
}
UndoableDataEditorData_WithParent.default = new UndoableDataEditorData_WithParent(UndoableDataEditorData.default, null);
UndoableDataEditorData.WithParent = UndoableDataEditorData_WithParent;
class UndoableDataEditorData_Descriptor {
  get data() {
    if (!this._data) {
      this._data = {
        name: "data",
        Name: "Data",
        number: 1,
        protoType: 11,
        protoName: "data",
        type: dcei_engine_data_proto.DataFile,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._data;
  }
  get uiDefinitions() {
    if (!this._uiDefinitions) {
      this._uiDefinitions = {
        name: "uiDefinitions",
        Name: "UiDefinitions",
        number: 2,
        protoType: 11,
        protoName: "ui_definitions",
        isMap: true,
        keyType: JsonToString,
        valueType: UiDefinition,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._uiDefinitions;
  }
  get triggerDefinitions() {
    if (!this._triggerDefinitions) {
      this._triggerDefinitions = {
        name: "triggerDefinitions",
        Name: "TriggerDefinitions",
        number: 3,
        protoType: 11,
        protoName: "trigger_definitions",
        isMap: true,
        keyType: JsonToString,
        valueType: TriggerDefinition,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._triggerDefinitions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.data,
        this.uiDefinitions,
        this.triggerDefinitions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForData",
        Name: "DummyOneofForData",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
UndoableDataEditorData.descriptor = new UndoableDataEditorData_Descriptor();
export class UndoableTerrainEditorData {
  get descriptor() {
    return UndoableTerrainEditorData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasData = false;
    this._data = null;
    this._hasRoadData = false;
    this._roadData = null;
    this._hasTileMapData = false;
    this._tileMapData = null;
    this._hasPropsData = false;
    this._propsData = null;
    this._hasWaterData = false;
    this._waterData = null;
    this._hasWaypointsData = false;
    this._waypointsData = null;
    this._hasUnitsData = false;
    this._unitsData = null;
    this._hasRegionsData = false;
    this._regionsData = null;
    this._hasTerrainChunkData = false;
    this._terrainChunkData = null;
  }
  isEmpty() {
    if (this._hasData && !this._data.isEmpty()) return false;
    if (this._hasRoadData && !this._roadData.isEmpty()) return false;
    if (this._hasTileMapData && !this._tileMapData.isEmpty()) return false;
    if (this._hasPropsData && !this._propsData.isEmpty()) return false;
    if (this._hasWaterData && !this._waterData.isEmpty()) return false;
    if (this._hasWaypointsData && !this._waypointsData.isEmpty()) return false;
    if (this._hasUnitsData && !this._unitsData.isEmpty()) return false;
    if (this._hasRegionsData && !this._regionsData.isEmpty()) return false;
    if (this._hasTerrainChunkData && !this._terrainChunkData.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableTerrainEditorData) {
      return value;
    }
    return UndoableTerrainEditorData.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableTerrainEditorData();
    if (json.data != null) {
      result._hasData = true;
      result._data = dcei_editor_terrain_proto.TerrainDataContainer.fromJson(json.data);
    }
    if (json.roadData != null) {
      result._hasRoadData = true;
      result._roadData = dcei_editor_terrain_proto.UndoableRoadData.fromJson(json.roadData);
    }
    if (json.tileMapData != null) {
      result._hasTileMapData = true;
      result._tileMapData = dcei_editor_terrain_proto.UndoableTileMapData.fromJson(json.tileMapData);
    }
    if (json.propsData != null) {
      result._hasPropsData = true;
      result._propsData = dcei_editor_terrain_proto.UndoablePropsData.fromJson(json.propsData);
    }
    if (json.waterData != null) {
      result._hasWaterData = true;
      result._waterData = dcei_editor_terrain_proto.UndoableWaterData.fromJson(json.waterData);
    }
    if (json.waypointsData != null) {
      result._hasWaypointsData = true;
      result._waypointsData = dcei_editor_terrain_proto.UndoableWaypointsData.fromJson(json.waypointsData);
    }
    if (json.unitsData != null) {
      result._hasUnitsData = true;
      result._unitsData = dcei_editor_terrain_proto.UndoableUnitsData.fromJson(json.unitsData);
    }
    if (json.regionsData != null) {
      result._hasRegionsData = true;
      result._regionsData = dcei_editor_terrain_proto.UndoableRegionsData.fromJson(json.regionsData);
    }
    if (json.terrainChunkData != null) {
      result._hasTerrainChunkData = true;
      result._terrainChunkData = dcei_editor_terrain_proto.UndoableTerrainChunkData.fromJson(json.terrainChunkData);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasData && !this._data.isEmpty()) {
      result.data = dcei_editor_terrain_proto.TerrainDataContainer.toJson(this._data);
    }
    if (this._hasRoadData && !this._roadData.isEmpty()) {
      result.roadData = dcei_editor_terrain_proto.UndoableRoadData.toJson(this._roadData);
    }
    if (this._hasTileMapData && !this._tileMapData.isEmpty()) {
      result.tileMapData = dcei_editor_terrain_proto.UndoableTileMapData.toJson(this._tileMapData);
    }
    if (this._hasPropsData && !this._propsData.isEmpty()) {
      result.propsData = dcei_editor_terrain_proto.UndoablePropsData.toJson(this._propsData);
    }
    if (this._hasWaterData && !this._waterData.isEmpty()) {
      result.waterData = dcei_editor_terrain_proto.UndoableWaterData.toJson(this._waterData);
    }
    if (this._hasWaypointsData && !this._waypointsData.isEmpty()) {
      result.waypointsData = dcei_editor_terrain_proto.UndoableWaypointsData.toJson(this._waypointsData);
    }
    if (this._hasUnitsData && !this._unitsData.isEmpty()) {
      result.unitsData = dcei_editor_terrain_proto.UndoableUnitsData.toJson(this._unitsData);
    }
    if (this._hasRegionsData && !this._regionsData.isEmpty()) {
      result.regionsData = dcei_editor_terrain_proto.UndoableRegionsData.toJson(this._regionsData);
    }
    if (this._hasTerrainChunkData && !this._terrainChunkData.isEmpty()) {
      result.terrainChunkData = dcei_editor_terrain_proto.UndoableTerrainChunkData.toJson(this._terrainChunkData);
    }
    return result;
  }
  /**
   * @returns {dcei_editor_terrain_proto.TerrainDataContainer}
   */
  get data() {
    return this._hasData ? this._data : dcei_editor_terrain_proto.TerrainDataContainer.default;
  }
  get hasData() {
    return this._hasData;
  }
  setData(path, value) {
    return {type: 'SET', path: path.concat(['data']), value: value.toJson()};
  }
  deleteData(path) {
    return {type: 'DELETE', path: path.concat(['data'])};
  }
  /**
   * @returns {dcei_editor_terrain_proto.UndoableRoadData}
   */
  get roadData() {
    return this._hasRoadData ? this._roadData : dcei_editor_terrain_proto.UndoableRoadData.default;
  }
  get hasRoadData() {
    return this._hasRoadData;
  }
  setRoadData(path, value) {
    return {type: 'SET', path: path.concat(['roadData']), value: value.toJson()};
  }
  deleteRoadData(path) {
    return {type: 'DELETE', path: path.concat(['roadData'])};
  }
  /**
   * @returns {dcei_editor_terrain_proto.UndoableTileMapData}
   */
  get tileMapData() {
    return this._hasTileMapData ? this._tileMapData : dcei_editor_terrain_proto.UndoableTileMapData.default;
  }
  get hasTileMapData() {
    return this._hasTileMapData;
  }
  setTileMapData(path, value) {
    return {type: 'SET', path: path.concat(['tileMapData']), value: value.toJson()};
  }
  deleteTileMapData(path) {
    return {type: 'DELETE', path: path.concat(['tileMapData'])};
  }
  /**
   * @returns {dcei_editor_terrain_proto.UndoablePropsData}
   */
  get propsData() {
    return this._hasPropsData ? this._propsData : dcei_editor_terrain_proto.UndoablePropsData.default;
  }
  get hasPropsData() {
    return this._hasPropsData;
  }
  setPropsData(path, value) {
    return {type: 'SET', path: path.concat(['propsData']), value: value.toJson()};
  }
  deletePropsData(path) {
    return {type: 'DELETE', path: path.concat(['propsData'])};
  }
  /**
   * @returns {dcei_editor_terrain_proto.UndoableWaterData}
   */
  get waterData() {
    return this._hasWaterData ? this._waterData : dcei_editor_terrain_proto.UndoableWaterData.default;
  }
  get hasWaterData() {
    return this._hasWaterData;
  }
  setWaterData(path, value) {
    return {type: 'SET', path: path.concat(['waterData']), value: value.toJson()};
  }
  deleteWaterData(path) {
    return {type: 'DELETE', path: path.concat(['waterData'])};
  }
  /**
   * @returns {dcei_editor_terrain_proto.UndoableWaypointsData}
   */
  get waypointsData() {
    return this._hasWaypointsData ? this._waypointsData : dcei_editor_terrain_proto.UndoableWaypointsData.default;
  }
  get hasWaypointsData() {
    return this._hasWaypointsData;
  }
  setWaypointsData(path, value) {
    return {type: 'SET', path: path.concat(['waypointsData']), value: value.toJson()};
  }
  deleteWaypointsData(path) {
    return {type: 'DELETE', path: path.concat(['waypointsData'])};
  }
  /**
   * @returns {dcei_editor_terrain_proto.UndoableUnitsData}
   */
  get unitsData() {
    return this._hasUnitsData ? this._unitsData : dcei_editor_terrain_proto.UndoableUnitsData.default;
  }
  get hasUnitsData() {
    return this._hasUnitsData;
  }
  setUnitsData(path, value) {
    return {type: 'SET', path: path.concat(['unitsData']), value: value.toJson()};
  }
  deleteUnitsData(path) {
    return {type: 'DELETE', path: path.concat(['unitsData'])};
  }
  /**
   * @returns {dcei_editor_terrain_proto.UndoableRegionsData}
   */
  get regionsData() {
    return this._hasRegionsData ? this._regionsData : dcei_editor_terrain_proto.UndoableRegionsData.default;
  }
  get hasRegionsData() {
    return this._hasRegionsData;
  }
  setRegionsData(path, value) {
    return {type: 'SET', path: path.concat(['regionsData']), value: value.toJson()};
  }
  deleteRegionsData(path) {
    return {type: 'DELETE', path: path.concat(['regionsData'])};
  }
  /**
   * @returns {dcei_editor_terrain_proto.UndoableTerrainChunkData}
   */
  get terrainChunkData() {
    return this._hasTerrainChunkData ? this._terrainChunkData : dcei_editor_terrain_proto.UndoableTerrainChunkData.default;
  }
  get hasTerrainChunkData() {
    return this._hasTerrainChunkData;
  }
  setTerrainChunkData(path, value) {
    return {type: 'SET', path: path.concat(['terrainChunkData']), value: value.toJson()};
  }
  deleteTerrainChunkData(path) {
    return {type: 'DELETE', path: path.concat(['terrainChunkData'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "data": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableTerrainEditorData(this);
              copy._hasData = true;
              copy._data = dcei_editor_terrain_proto.TerrainDataContainer.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasData) {
                return this;
              }
              const copy = new UndoableTerrainEditorData(this);
              copy._hasData = false;
              copy._data = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasData) {
            const copy = new UndoableTerrainEditorData(this);
            copy._hasData = true;
            copy._data = dcei_editor_terrain_proto.TerrainDataContainer.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._data.apply(type, path.slice(1), value);
          if (newValue === this._data) {
            return this;
          }
          const copy = new UndoableTerrainEditorData(this);
          copy._data = copy._data.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "roadData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableTerrainEditorData(this);
              copy._hasRoadData = true;
              copy._roadData = dcei_editor_terrain_proto.UndoableRoadData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRoadData) {
                return this;
              }
              const copy = new UndoableTerrainEditorData(this);
              copy._hasRoadData = false;
              copy._roadData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasRoadData) {
            const copy = new UndoableTerrainEditorData(this);
            copy._hasRoadData = true;
            copy._roadData = dcei_editor_terrain_proto.UndoableRoadData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._roadData.apply(type, path.slice(1), value);
          if (newValue === this._roadData) {
            return this;
          }
          const copy = new UndoableTerrainEditorData(this);
          copy._roadData = copy._roadData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "tileMapData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableTerrainEditorData(this);
              copy._hasTileMapData = true;
              copy._tileMapData = dcei_editor_terrain_proto.UndoableTileMapData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTileMapData) {
                return this;
              }
              const copy = new UndoableTerrainEditorData(this);
              copy._hasTileMapData = false;
              copy._tileMapData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTileMapData) {
            const copy = new UndoableTerrainEditorData(this);
            copy._hasTileMapData = true;
            copy._tileMapData = dcei_editor_terrain_proto.UndoableTileMapData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._tileMapData.apply(type, path.slice(1), value);
          if (newValue === this._tileMapData) {
            return this;
          }
          const copy = new UndoableTerrainEditorData(this);
          copy._tileMapData = copy._tileMapData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "propsData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableTerrainEditorData(this);
              copy._hasPropsData = true;
              copy._propsData = dcei_editor_terrain_proto.UndoablePropsData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPropsData) {
                return this;
              }
              const copy = new UndoableTerrainEditorData(this);
              copy._hasPropsData = false;
              copy._propsData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPropsData) {
            const copy = new UndoableTerrainEditorData(this);
            copy._hasPropsData = true;
            copy._propsData = dcei_editor_terrain_proto.UndoablePropsData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._propsData.apply(type, path.slice(1), value);
          if (newValue === this._propsData) {
            return this;
          }
          const copy = new UndoableTerrainEditorData(this);
          copy._propsData = copy._propsData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "waterData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableTerrainEditorData(this);
              copy._hasWaterData = true;
              copy._waterData = dcei_editor_terrain_proto.UndoableWaterData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWaterData) {
                return this;
              }
              const copy = new UndoableTerrainEditorData(this);
              copy._hasWaterData = false;
              copy._waterData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasWaterData) {
            const copy = new UndoableTerrainEditorData(this);
            copy._hasWaterData = true;
            copy._waterData = dcei_editor_terrain_proto.UndoableWaterData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._waterData.apply(type, path.slice(1), value);
          if (newValue === this._waterData) {
            return this;
          }
          const copy = new UndoableTerrainEditorData(this);
          copy._waterData = copy._waterData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "waypointsData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableTerrainEditorData(this);
              copy._hasWaypointsData = true;
              copy._waypointsData = dcei_editor_terrain_proto.UndoableWaypointsData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWaypointsData) {
                return this;
              }
              const copy = new UndoableTerrainEditorData(this);
              copy._hasWaypointsData = false;
              copy._waypointsData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasWaypointsData) {
            const copy = new UndoableTerrainEditorData(this);
            copy._hasWaypointsData = true;
            copy._waypointsData = dcei_editor_terrain_proto.UndoableWaypointsData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._waypointsData.apply(type, path.slice(1), value);
          if (newValue === this._waypointsData) {
            return this;
          }
          const copy = new UndoableTerrainEditorData(this);
          copy._waypointsData = copy._waypointsData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "unitsData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableTerrainEditorData(this);
              copy._hasUnitsData = true;
              copy._unitsData = dcei_editor_terrain_proto.UndoableUnitsData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitsData) {
                return this;
              }
              const copy = new UndoableTerrainEditorData(this);
              copy._hasUnitsData = false;
              copy._unitsData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasUnitsData) {
            const copy = new UndoableTerrainEditorData(this);
            copy._hasUnitsData = true;
            copy._unitsData = dcei_editor_terrain_proto.UndoableUnitsData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._unitsData.apply(type, path.slice(1), value);
          if (newValue === this._unitsData) {
            return this;
          }
          const copy = new UndoableTerrainEditorData(this);
          copy._unitsData = copy._unitsData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "regionsData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableTerrainEditorData(this);
              copy._hasRegionsData = true;
              copy._regionsData = dcei_editor_terrain_proto.UndoableRegionsData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRegionsData) {
                return this;
              }
              const copy = new UndoableTerrainEditorData(this);
              copy._hasRegionsData = false;
              copy._regionsData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasRegionsData) {
            const copy = new UndoableTerrainEditorData(this);
            copy._hasRegionsData = true;
            copy._regionsData = dcei_editor_terrain_proto.UndoableRegionsData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._regionsData.apply(type, path.slice(1), value);
          if (newValue === this._regionsData) {
            return this;
          }
          const copy = new UndoableTerrainEditorData(this);
          copy._regionsData = copy._regionsData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "terrainChunkData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableTerrainEditorData(this);
              copy._hasTerrainChunkData = true;
              copy._terrainChunkData = dcei_editor_terrain_proto.UndoableTerrainChunkData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTerrainChunkData) {
                return this;
              }
              const copy = new UndoableTerrainEditorData(this);
              copy._hasTerrainChunkData = false;
              copy._terrainChunkData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTerrainChunkData) {
            const copy = new UndoableTerrainEditorData(this);
            copy._hasTerrainChunkData = true;
            copy._terrainChunkData = dcei_editor_terrain_proto.UndoableTerrainChunkData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._terrainChunkData.apply(type, path.slice(1), value);
          if (newValue === this._terrainChunkData) {
            return this;
          }
          const copy = new UndoableTerrainEditorData(this);
          copy._terrainChunkData = copy._terrainChunkData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableTerrainEditorData} other
   * @returns {UndoableTerrainEditorData}
   */
  merge(other) {
    const copy = new UndoableTerrainEditorData(this);
    if (other._hasData) {
      if (copy._hasData) {
        copy._data = copy.data.merge(other.data);
      } else {
        copy._data = other._data;
      }
      copy._hasData = true;
    }
    if (other._hasRoadData) {
      if (copy._hasRoadData) {
        copy._roadData = copy.roadData.merge(other.roadData);
      } else {
        copy._roadData = other._roadData;
      }
      copy._hasRoadData = true;
    }
    if (other._hasTileMapData) {
      if (copy._hasTileMapData) {
        copy._tileMapData = copy.tileMapData.merge(other.tileMapData);
      } else {
        copy._tileMapData = other._tileMapData;
      }
      copy._hasTileMapData = true;
    }
    if (other._hasPropsData) {
      if (copy._hasPropsData) {
        copy._propsData = copy.propsData.merge(other.propsData);
      } else {
        copy._propsData = other._propsData;
      }
      copy._hasPropsData = true;
    }
    if (other._hasWaterData) {
      if (copy._hasWaterData) {
        copy._waterData = copy.waterData.merge(other.waterData);
      } else {
        copy._waterData = other._waterData;
      }
      copy._hasWaterData = true;
    }
    if (other._hasWaypointsData) {
      if (copy._hasWaypointsData) {
        copy._waypointsData = copy.waypointsData.merge(other.waypointsData);
      } else {
        copy._waypointsData = other._waypointsData;
      }
      copy._hasWaypointsData = true;
    }
    if (other._hasUnitsData) {
      if (copy._hasUnitsData) {
        copy._unitsData = copy.unitsData.merge(other.unitsData);
      } else {
        copy._unitsData = other._unitsData;
      }
      copy._hasUnitsData = true;
    }
    if (other._hasRegionsData) {
      if (copy._hasRegionsData) {
        copy._regionsData = copy.regionsData.merge(other.regionsData);
      } else {
        copy._regionsData = other._regionsData;
      }
      copy._hasRegionsData = true;
    }
    if (other._hasTerrainChunkData) {
      if (copy._hasTerrainChunkData) {
        copy._terrainChunkData = copy.terrainChunkData.merge(other.terrainChunkData);
      } else {
        copy._terrainChunkData = other._terrainChunkData;
      }
      copy._hasTerrainChunkData = true;
    }
    return copy;
  }
}
UndoableTerrainEditorData.default = new UndoableTerrainEditorData();
class UndoableTerrainEditorData_Builder {
  constructor(value) {
    this._value = new UndoableTerrainEditorData(value);
  }
  build() {
    return new UndoableTerrainEditorData(this._value);
  }
  setData(value) {
    this._value._hasData = true;
    this._value._data = value;
    return this;
  }
  deleteData() {
    this._value._hasData = false;
    this._value._data = null;
    return this;
  }
  setRoadData(value) {
    this._value._hasRoadData = true;
    this._value._roadData = value;
    return this;
  }
  deleteRoadData() {
    this._value._hasRoadData = false;
    this._value._roadData = null;
    return this;
  }
  setTileMapData(value) {
    this._value._hasTileMapData = true;
    this._value._tileMapData = value;
    return this;
  }
  deleteTileMapData() {
    this._value._hasTileMapData = false;
    this._value._tileMapData = null;
    return this;
  }
  setPropsData(value) {
    this._value._hasPropsData = true;
    this._value._propsData = value;
    return this;
  }
  deletePropsData() {
    this._value._hasPropsData = false;
    this._value._propsData = null;
    return this;
  }
  setWaterData(value) {
    this._value._hasWaterData = true;
    this._value._waterData = value;
    return this;
  }
  deleteWaterData() {
    this._value._hasWaterData = false;
    this._value._waterData = null;
    return this;
  }
  setWaypointsData(value) {
    this._value._hasWaypointsData = true;
    this._value._waypointsData = value;
    return this;
  }
  deleteWaypointsData() {
    this._value._hasWaypointsData = false;
    this._value._waypointsData = null;
    return this;
  }
  setUnitsData(value) {
    this._value._hasUnitsData = true;
    this._value._unitsData = value;
    return this;
  }
  deleteUnitsData() {
    this._value._hasUnitsData = false;
    this._value._unitsData = null;
    return this;
  }
  setRegionsData(value) {
    this._value._hasRegionsData = true;
    this._value._regionsData = value;
    return this;
  }
  deleteRegionsData() {
    this._value._hasRegionsData = false;
    this._value._regionsData = null;
    return this;
  }
  setTerrainChunkData(value) {
    this._value._hasTerrainChunkData = true;
    this._value._terrainChunkData = value;
    return this;
  }
  deleteTerrainChunkData() {
    this._value._hasTerrainChunkData = false;
    this._value._terrainChunkData = null;
    return this;
  }
}
UndoableTerrainEditorData.Builder = UndoableTerrainEditorData_Builder;
class UndoableTerrainEditorData_WithParent {
  /**
   * @param {UndoableTerrainEditorData} value
   * @param {UndoableTerrainEditorData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableTerrainEditorData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasData() {
    if (this._cachedHasData === undefined) {
      if (this._value.hasData) {
        this._cachedHasData = true;
      } else {
        this._cachedHasData = this._parent ? this._parent.hasData : false;
      }
    }
    return this._cachedHasData;
  }
  get data() {
    if (!this._cachedData) {
      if (this._value.hasData) {
        this._cachedData = new dcei_editor_terrain_proto.TerrainDataContainer.WithParent(this._value.data, this._parent && this._parent.hasData ? this._parent.data : null);
      } else {
        this._cachedData = this._parent ? new dcei_editor_terrain_proto.TerrainDataContainer.WithParent(dcei_editor_terrain_proto.TerrainDataContainer.default, this._parent.data) : dcei_editor_terrain_proto.TerrainDataContainer.WithParent.default;
      }
    }
    return this._cachedData;
  }
  get hasRoadData() {
    if (this._cachedHasRoadData === undefined) {
      if (this._value.hasRoadData) {
        this._cachedHasRoadData = true;
      } else {
        this._cachedHasRoadData = this._parent ? this._parent.hasRoadData : false;
      }
    }
    return this._cachedHasRoadData;
  }
  get roadData() {
    if (!this._cachedRoadData) {
      if (this._value.hasRoadData) {
        this._cachedRoadData = new dcei_editor_terrain_proto.UndoableRoadData.WithParent(this._value.roadData, this._parent && this._parent.hasRoadData ? this._parent.roadData : null);
      } else {
        this._cachedRoadData = this._parent ? new dcei_editor_terrain_proto.UndoableRoadData.WithParent(dcei_editor_terrain_proto.UndoableRoadData.default, this._parent.roadData) : dcei_editor_terrain_proto.UndoableRoadData.WithParent.default;
      }
    }
    return this._cachedRoadData;
  }
  get hasTileMapData() {
    if (this._cachedHasTileMapData === undefined) {
      if (this._value.hasTileMapData) {
        this._cachedHasTileMapData = true;
      } else {
        this._cachedHasTileMapData = this._parent ? this._parent.hasTileMapData : false;
      }
    }
    return this._cachedHasTileMapData;
  }
  get tileMapData() {
    if (!this._cachedTileMapData) {
      if (this._value.hasTileMapData) {
        this._cachedTileMapData = new dcei_editor_terrain_proto.UndoableTileMapData.WithParent(this._value.tileMapData, this._parent && this._parent.hasTileMapData ? this._parent.tileMapData : null);
      } else {
        this._cachedTileMapData = this._parent ? new dcei_editor_terrain_proto.UndoableTileMapData.WithParent(dcei_editor_terrain_proto.UndoableTileMapData.default, this._parent.tileMapData) : dcei_editor_terrain_proto.UndoableTileMapData.WithParent.default;
      }
    }
    return this._cachedTileMapData;
  }
  get hasPropsData() {
    if (this._cachedHasPropsData === undefined) {
      if (this._value.hasPropsData) {
        this._cachedHasPropsData = true;
      } else {
        this._cachedHasPropsData = this._parent ? this._parent.hasPropsData : false;
      }
    }
    return this._cachedHasPropsData;
  }
  get propsData() {
    if (!this._cachedPropsData) {
      if (this._value.hasPropsData) {
        this._cachedPropsData = new dcei_editor_terrain_proto.UndoablePropsData.WithParent(this._value.propsData, this._parent && this._parent.hasPropsData ? this._parent.propsData : null);
      } else {
        this._cachedPropsData = this._parent ? new dcei_editor_terrain_proto.UndoablePropsData.WithParent(dcei_editor_terrain_proto.UndoablePropsData.default, this._parent.propsData) : dcei_editor_terrain_proto.UndoablePropsData.WithParent.default;
      }
    }
    return this._cachedPropsData;
  }
  get hasWaterData() {
    if (this._cachedHasWaterData === undefined) {
      if (this._value.hasWaterData) {
        this._cachedHasWaterData = true;
      } else {
        this._cachedHasWaterData = this._parent ? this._parent.hasWaterData : false;
      }
    }
    return this._cachedHasWaterData;
  }
  get waterData() {
    if (!this._cachedWaterData) {
      if (this._value.hasWaterData) {
        this._cachedWaterData = new dcei_editor_terrain_proto.UndoableWaterData.WithParent(this._value.waterData, this._parent && this._parent.hasWaterData ? this._parent.waterData : null);
      } else {
        this._cachedWaterData = this._parent ? new dcei_editor_terrain_proto.UndoableWaterData.WithParent(dcei_editor_terrain_proto.UndoableWaterData.default, this._parent.waterData) : dcei_editor_terrain_proto.UndoableWaterData.WithParent.default;
      }
    }
    return this._cachedWaterData;
  }
  get hasWaypointsData() {
    if (this._cachedHasWaypointsData === undefined) {
      if (this._value.hasWaypointsData) {
        this._cachedHasWaypointsData = true;
      } else {
        this._cachedHasWaypointsData = this._parent ? this._parent.hasWaypointsData : false;
      }
    }
    return this._cachedHasWaypointsData;
  }
  get waypointsData() {
    if (!this._cachedWaypointsData) {
      if (this._value.hasWaypointsData) {
        this._cachedWaypointsData = new dcei_editor_terrain_proto.UndoableWaypointsData.WithParent(this._value.waypointsData, this._parent && this._parent.hasWaypointsData ? this._parent.waypointsData : null);
      } else {
        this._cachedWaypointsData = this._parent ? new dcei_editor_terrain_proto.UndoableWaypointsData.WithParent(dcei_editor_terrain_proto.UndoableWaypointsData.default, this._parent.waypointsData) : dcei_editor_terrain_proto.UndoableWaypointsData.WithParent.default;
      }
    }
    return this._cachedWaypointsData;
  }
  get hasUnitsData() {
    if (this._cachedHasUnitsData === undefined) {
      if (this._value.hasUnitsData) {
        this._cachedHasUnitsData = true;
      } else {
        this._cachedHasUnitsData = this._parent ? this._parent.hasUnitsData : false;
      }
    }
    return this._cachedHasUnitsData;
  }
  get unitsData() {
    if (!this._cachedUnitsData) {
      if (this._value.hasUnitsData) {
        this._cachedUnitsData = new dcei_editor_terrain_proto.UndoableUnitsData.WithParent(this._value.unitsData, this._parent && this._parent.hasUnitsData ? this._parent.unitsData : null);
      } else {
        this._cachedUnitsData = this._parent ? new dcei_editor_terrain_proto.UndoableUnitsData.WithParent(dcei_editor_terrain_proto.UndoableUnitsData.default, this._parent.unitsData) : dcei_editor_terrain_proto.UndoableUnitsData.WithParent.default;
      }
    }
    return this._cachedUnitsData;
  }
  get hasRegionsData() {
    if (this._cachedHasRegionsData === undefined) {
      if (this._value.hasRegionsData) {
        this._cachedHasRegionsData = true;
      } else {
        this._cachedHasRegionsData = this._parent ? this._parent.hasRegionsData : false;
      }
    }
    return this._cachedHasRegionsData;
  }
  get regionsData() {
    if (!this._cachedRegionsData) {
      if (this._value.hasRegionsData) {
        this._cachedRegionsData = new dcei_editor_terrain_proto.UndoableRegionsData.WithParent(this._value.regionsData, this._parent && this._parent.hasRegionsData ? this._parent.regionsData : null);
      } else {
        this._cachedRegionsData = this._parent ? new dcei_editor_terrain_proto.UndoableRegionsData.WithParent(dcei_editor_terrain_proto.UndoableRegionsData.default, this._parent.regionsData) : dcei_editor_terrain_proto.UndoableRegionsData.WithParent.default;
      }
    }
    return this._cachedRegionsData;
  }
  get hasTerrainChunkData() {
    if (this._cachedHasTerrainChunkData === undefined) {
      if (this._value.hasTerrainChunkData) {
        this._cachedHasTerrainChunkData = true;
      } else {
        this._cachedHasTerrainChunkData = this._parent ? this._parent.hasTerrainChunkData : false;
      }
    }
    return this._cachedHasTerrainChunkData;
  }
  get terrainChunkData() {
    if (!this._cachedTerrainChunkData) {
      if (this._value.hasTerrainChunkData) {
        this._cachedTerrainChunkData = new dcei_editor_terrain_proto.UndoableTerrainChunkData.WithParent(this._value.terrainChunkData, this._parent && this._parent.hasTerrainChunkData ? this._parent.terrainChunkData : null);
      } else {
        this._cachedTerrainChunkData = this._parent ? new dcei_editor_terrain_proto.UndoableTerrainChunkData.WithParent(dcei_editor_terrain_proto.UndoableTerrainChunkData.default, this._parent.terrainChunkData) : dcei_editor_terrain_proto.UndoableTerrainChunkData.WithParent.default;
      }
    }
    return this._cachedTerrainChunkData;
  }
  update(current, parent) {
    const result = new UndoableTerrainEditorData_WithParent(current, parent);
    if (this._cachedData && this._value.hasData && current.hasData) {
      if (this._value.data === current.data && this._parent === parent) {
        result._cachedData = this._cachedData;
      } else {
        result._cachedData = this._cachedData.update(current.data, parent && parent.hasData ? parent.data : null);
      }
    }
    if (this._cachedRoadData && this._value.hasRoadData && current.hasRoadData) {
      if (this._value.roadData === current.roadData && this._parent === parent) {
        result._cachedRoadData = this._cachedRoadData;
      } else {
        result._cachedRoadData = this._cachedRoadData.update(current.roadData, parent && parent.hasRoadData ? parent.roadData : null);
      }
    }
    if (this._cachedTileMapData && this._value.hasTileMapData && current.hasTileMapData) {
      if (this._value.tileMapData === current.tileMapData && this._parent === parent) {
        result._cachedTileMapData = this._cachedTileMapData;
      } else {
        result._cachedTileMapData = this._cachedTileMapData.update(current.tileMapData, parent && parent.hasTileMapData ? parent.tileMapData : null);
      }
    }
    if (this._cachedPropsData && this._value.hasPropsData && current.hasPropsData) {
      if (this._value.propsData === current.propsData && this._parent === parent) {
        result._cachedPropsData = this._cachedPropsData;
      } else {
        result._cachedPropsData = this._cachedPropsData.update(current.propsData, parent && parent.hasPropsData ? parent.propsData : null);
      }
    }
    if (this._cachedWaterData && this._value.hasWaterData && current.hasWaterData) {
      if (this._value.waterData === current.waterData && this._parent === parent) {
        result._cachedWaterData = this._cachedWaterData;
      } else {
        result._cachedWaterData = this._cachedWaterData.update(current.waterData, parent && parent.hasWaterData ? parent.waterData : null);
      }
    }
    if (this._cachedWaypointsData && this._value.hasWaypointsData && current.hasWaypointsData) {
      if (this._value.waypointsData === current.waypointsData && this._parent === parent) {
        result._cachedWaypointsData = this._cachedWaypointsData;
      } else {
        result._cachedWaypointsData = this._cachedWaypointsData.update(current.waypointsData, parent && parent.hasWaypointsData ? parent.waypointsData : null);
      }
    }
    if (this._cachedUnitsData && this._value.hasUnitsData && current.hasUnitsData) {
      if (this._value.unitsData === current.unitsData && this._parent === parent) {
        result._cachedUnitsData = this._cachedUnitsData;
      } else {
        result._cachedUnitsData = this._cachedUnitsData.update(current.unitsData, parent && parent.hasUnitsData ? parent.unitsData : null);
      }
    }
    if (this._cachedRegionsData && this._value.hasRegionsData && current.hasRegionsData) {
      if (this._value.regionsData === current.regionsData && this._parent === parent) {
        result._cachedRegionsData = this._cachedRegionsData;
      } else {
        result._cachedRegionsData = this._cachedRegionsData.update(current.regionsData, parent && parent.hasRegionsData ? parent.regionsData : null);
      }
    }
    if (this._cachedTerrainChunkData && this._value.hasTerrainChunkData && current.hasTerrainChunkData) {
      if (this._value.terrainChunkData === current.terrainChunkData && this._parent === parent) {
        result._cachedTerrainChunkData = this._cachedTerrainChunkData;
      } else {
        result._cachedTerrainChunkData = this._cachedTerrainChunkData.update(current.terrainChunkData, parent && parent.hasTerrainChunkData ? parent.terrainChunkData : null);
      }
    }
    return result;
  }
}
UndoableTerrainEditorData_WithParent.default = new UndoableTerrainEditorData_WithParent(UndoableTerrainEditorData.default, null);
UndoableTerrainEditorData.WithParent = UndoableTerrainEditorData_WithParent;
class UndoableTerrainEditorData_Descriptor {
  get data() {
    if (!this._data) {
      this._data = {
        name: "data",
        Name: "Data",
        number: 1,
        protoType: 11,
        protoName: "data",
        type: dcei_editor_terrain_proto.TerrainDataContainer,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._data;
  }
  get roadData() {
    if (!this._roadData) {
      this._roadData = {
        name: "roadData",
        Name: "RoadData",
        number: 3,
        protoType: 11,
        protoName: "road_data",
        type: dcei_editor_terrain_proto.UndoableRoadData,
        options: {
          comments: "bool is_current_terrain =2;",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._roadData;
  }
  get tileMapData() {
    if (!this._tileMapData) {
      this._tileMapData = {
        name: "tileMapData",
        Name: "TileMapData",
        number: 4,
        protoType: 11,
        protoName: "tile_map_data",
        type: dcei_editor_terrain_proto.UndoableTileMapData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tileMapData;
  }
  get propsData() {
    if (!this._propsData) {
      this._propsData = {
        name: "propsData",
        Name: "PropsData",
        number: 5,
        protoType: 11,
        protoName: "props_data",
        type: dcei_editor_terrain_proto.UndoablePropsData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._propsData;
  }
  get waterData() {
    if (!this._waterData) {
      this._waterData = {
        name: "waterData",
        Name: "WaterData",
        number: 6,
        protoType: 11,
        protoName: "water_data",
        type: dcei_editor_terrain_proto.UndoableWaterData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._waterData;
  }
  get waypointsData() {
    if (!this._waypointsData) {
      this._waypointsData = {
        name: "waypointsData",
        Name: "WaypointsData",
        number: 7,
        protoType: 11,
        protoName: "waypoints_data",
        type: dcei_editor_terrain_proto.UndoableWaypointsData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._waypointsData;
  }
  get unitsData() {
    if (!this._unitsData) {
      this._unitsData = {
        name: "unitsData",
        Name: "UnitsData",
        number: 8,
        protoType: 11,
        protoName: "units_data",
        type: dcei_editor_terrain_proto.UndoableUnitsData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitsData;
  }
  get regionsData() {
    if (!this._regionsData) {
      this._regionsData = {
        name: "regionsData",
        Name: "RegionsData",
        number: 9,
        protoType: 11,
        protoName: "regions_data",
        type: dcei_editor_terrain_proto.UndoableRegionsData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._regionsData;
  }
  get terrainChunkData() {
    if (!this._terrainChunkData) {
      this._terrainChunkData = {
        name: "terrainChunkData",
        Name: "TerrainChunkData",
        number: 10,
        protoType: 11,
        protoName: "terrain_chunk_data",
        type: dcei_editor_terrain_proto.UndoableTerrainChunkData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._terrainChunkData;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.data,
        this.roadData,
        this.tileMapData,
        this.propsData,
        this.waterData,
        this.waypointsData,
        this.unitsData,
        this.regionsData,
        this.terrainChunkData,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForData",
        Name: "DummyOneofForData",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRoadData",
        Name: "DummyOneofForRoadData",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTileMapData",
        Name: "DummyOneofForTileMapData",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPropsData",
        Name: "DummyOneofForPropsData",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWaterData",
        Name: "DummyOneofForWaterData",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWaypointsData",
        Name: "DummyOneofForWaypointsData",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnitsData",
        Name: "DummyOneofForUnitsData",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRegionsData",
        Name: "DummyOneofForRegionsData",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTerrainChunkData",
        Name: "DummyOneofForTerrainChunkData",
        fields: [
          this.fields[8],
        ],
      });
    }
    return this._oneofs;
  }
}
UndoableTerrainEditorData.descriptor = new UndoableTerrainEditorData_Descriptor();
class ProjectData_OpenedMap {
  get descriptor() {
    return ProjectData_OpenedMap.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
    this._hasPath = false;
    this._path = null;
    this._hasDirty = false;
    this._dirty = null;
    this._clients = [];
  }
  isEmpty() {
    if (this._hasName) return false;
    if (this._hasPath) return false;
    if (this._hasDirty) return false;
    if (this._clients.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ProjectData_OpenedMap) {
      return value;
    }
    return ProjectData_OpenedMap.fromJson(value);
  }
  static fromJson(json) {
    const result = new ProjectData_OpenedMap();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.path != null) {
      result._hasPath = true;
      result._path = JsonToString.fromJson(json.path);
    }
    if (json.dirty != null) {
      result._hasDirty = true;
      result._dirty = JsonToBoolean.fromJson(json.dirty);
    }
    result._clients = JsonToList(json.clients, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasPath) {
      result.path = JsonToString.toJson(this._path);
    }
    if (this._hasDirty) {
      result.dirty = JsonToBoolean.toJson(this._dirty);
    }
    if (this._clients.length > 0) {
      result.clients = ArrayToJson(this._clients, JsonToString);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {string}
   */
  get path() {
    return this._hasPath ? this._path : JsonToString.default;
  }
  get hasPath() {
    return this._hasPath;
  }
  setPath(path, value) {
    return {type: 'SET', path: path.concat(['path']), value};
  }
  deletePath(path) {
    return {type: 'DELETE', path: path.concat(['path'])};
  }
  /**
   * @returns {boolean}
   */
  get dirty() {
    return this._hasDirty ? this._dirty : JsonToBoolean.default;
  }
  get hasDirty() {
    return this._hasDirty;
  }
  setDirty(path, value) {
    return {type: 'SET', path: path.concat(['dirty']), value};
  }
  deleteDirty(path) {
    return {type: 'DELETE', path: path.concat(['dirty'])};
  }
  /**
   * @returns {string[]}
   */
  get clients() {
    return this._clients;
  }
  addClients(path, value) {
    return {type: 'ADD', path: path.concat(['clients']), value};
  }
  setClients(path, value) {
    return {type: 'SET', path: path.concat(['clients']), value: ArrayToJson(value, JsonToString)};
  }
  setClientsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['clients', key]), value};
  }
  deleteClients(path) {
    return {type: 'DELETE', path: path.concat(['clients'])};
  }
  deleteClientsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['clients', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ProjectData_OpenedMap(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new ProjectData_OpenedMap(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "path": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ProjectData_OpenedMap(this);
              copy._hasPath = true;
              copy._path = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPath) {
                return this;
              }
              const copy = new ProjectData_OpenedMap(this);
              copy._hasPath = false;
              copy._path = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "dirty": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ProjectData_OpenedMap(this);
              copy._hasDirty = true;
              copy._dirty = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDirty) {
                return this;
              }
              const copy = new ProjectData_OpenedMap(this);
              copy._hasDirty = false;
              copy._dirty = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "clients": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ProjectData_OpenedMap(this);
              copy._clients = [];        for (let i of value) {
                copy._clients.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ProjectData_OpenedMap(this);
              copy._clients = copy._clients.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._clients.length === 0) {
                return this;
              }
              const copy = new ProjectData_OpenedMap(this);
              copy._clients = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._clients.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ProjectData_OpenedMap(this);
              copy._clients = copy._clients.slice();
              copy._clients[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ProjectData_OpenedMap(this);
              copy._clients = copy._clients.slice(0, path[1]).concat(copy._clients.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._clients.length) {
            return this;
          }
          const oldValue = this._clients[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ProjectData_OpenedMap(this);
          copy._clients = copy._clients.slice();
          copy._clients[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ProjectData_OpenedMap} other
   * @returns {ProjectData_OpenedMap}
   */
  merge(other) {
    const copy = new ProjectData_OpenedMap(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasPath) {
      copy._hasPath = true;
      copy._path = other._path;
    }
    if (other._hasDirty) {
      copy._hasDirty = true;
      copy._dirty = other._dirty;
    }
    copy._clients = this._clients.concat(other._clients);
    return copy;
  }
}
ProjectData_OpenedMap.default = new ProjectData_OpenedMap();
class ProjectData_OpenedMap_Builder {
  constructor(value) {
    this._value = new ProjectData_OpenedMap(value);
  }
  build() {
    return new ProjectData_OpenedMap(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setPath(value) {
    this._value._hasPath = true;
    this._value._path = value;
    return this;
  }
  deletePath() {
    this._value._hasPath = false;
    this._value._path = null;
    return this;
  }
  setDirty(value) {
    this._value._hasDirty = true;
    this._value._dirty = value;
    return this;
  }
  deleteDirty() {
    this._value._hasDirty = false;
    this._value._dirty = null;
    return this;
  }
  addAllClients(values) {
    this._value._clients = this._value._clients.concat(values);
    return this;
  }
  addClients(value) {
    this._value._clients = this._value._clients.concat([value]);
    return this;
  }
  setClients(index, value) {
    this._value._clients = this._value._clients.concat();
    this._value._clients[index] = value;
    return this;
  }
  clearClients() {
    this._value._clients = [];
    return this;
  }
}
ProjectData_OpenedMap.Builder = ProjectData_OpenedMap_Builder;
class ProjectData_OpenedMap_WithParent {
  /**
   * @param {ProjectData_OpenedMap} value
   * @param {ProjectData_OpenedMap_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ProjectData_OpenedMap.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasPath() {
    if (this._cachedHasPath === undefined) {
      if (this._value.hasPath) {
        this._cachedHasPath = true;
      } else {
        this._cachedHasPath = this._parent ? this._parent.hasPath : false;
      }
    }
    return this._cachedHasPath;
  }
  get path() {
    if (this._cachedPath === undefined) {
      if (this._value.hasPath) {
        this._cachedPath = this._value.path;
      } else {
        this._cachedPath = this._parent ? this._parent.path : this._value.path;
      }
    }
    return this._cachedPath;
  }
  get hasDirty() {
    if (this._cachedHasDirty === undefined) {
      if (this._value.hasDirty) {
        this._cachedHasDirty = true;
      } else {
        this._cachedHasDirty = this._parent ? this._parent.hasDirty : false;
      }
    }
    return this._cachedHasDirty;
  }
  get dirty() {
    if (this._cachedDirty === undefined) {
      if (this._value.hasDirty) {
        this._cachedDirty = this._value.dirty;
      } else {
        this._cachedDirty = this._parent ? this._parent.dirty : this._value.dirty;
      }
    }
    return this._cachedDirty;
  }
  get selfClients() {
    return this._value.clients;
  }
  get inherentClients() {
    if (!this._inherentClients) {
      this._inherentClients = this._parent ? this._parent.clients : [];
    }
    return this._inherentClients;
  }
  get clients() {
    if (!this._allClients) {
      this._allClients = this._parent ? this._parent.clients.concat(this.selfClients) : this.selfClients;
    }
    return this._allClients;
  }
  update(current, parent) {
    const result = new ProjectData_OpenedMap_WithParent(current, parent);
    return result;
  }
}
ProjectData_OpenedMap_WithParent.default = new ProjectData_OpenedMap_WithParent(ProjectData_OpenedMap.default, null);
ProjectData_OpenedMap.WithParent = ProjectData_OpenedMap_WithParent;
class ProjectData_OpenedMap_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get path() {
    if (!this._path) {
      this._path = {
        name: "path",
        Name: "Path",
        number: 2,
        protoType: 9,
        protoName: "path",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._path;
  }
  get dirty() {
    if (!this._dirty) {
      this._dirty = {
        name: "dirty",
        Name: "Dirty",
        number: 3,
        protoType: 8,
        protoName: "dirty",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dirty;
  }
  get clients() {
    if (!this._clients) {
      this._clients = {
        name: "clients",
        Name: "Clients",
        number: 4,
        protoType: 9,
        protoName: "clients",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "The list of clients that are editting this map.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._clients;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
        this.path,
        this.dirty,
        this.clients,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPath",
        Name: "DummyOneofForPath",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDirty",
        Name: "DummyOneofForDirty",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ProjectData_OpenedMap.descriptor = new ProjectData_OpenedMap_Descriptor();
export class ProjectData {
  get descriptor() {
    return ProjectData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPath = false;
    this._path = null;
    this._maps = [];
    this._hasSettings = false;
    this._settings = null;
  }
  isEmpty() {
    if (this._hasPath) return false;
    if (this._maps.length > 0) return false;
    if (this._hasSettings && !this._settings.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ProjectData) {
      return value;
    }
    return ProjectData.fromJson(value);
  }
  static fromJson(json) {
    const result = new ProjectData();
    if (json.path != null) {
      result._hasPath = true;
      result._path = JsonToString.fromJson(json.path);
    }
    result._maps = JsonToList(json.maps, ProjectData_OpenedMap);
    if (json.settings != null) {
      result._hasSettings = true;
      result._settings = dcei_editor_settings_proto.ProjectSettings.fromJson(json.settings);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPath) {
      result.path = JsonToString.toJson(this._path);
    }
    if (this._maps.length > 0) {
      result.maps = ArrayToJson(this._maps, ProjectData_OpenedMap);
    }
    if (this._hasSettings && !this._settings.isEmpty()) {
      result.settings = dcei_editor_settings_proto.ProjectSettings.toJson(this._settings);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get path() {
    return this._hasPath ? this._path : JsonToString.default;
  }
  get hasPath() {
    return this._hasPath;
  }
  setPath(path, value) {
    return {type: 'SET', path: path.concat(['path']), value};
  }
  deletePath(path) {
    return {type: 'DELETE', path: path.concat(['path'])};
  }
  /**
   * @returns {ProjectData_OpenedMap[]}
   */
  get maps() {
    return this._maps;
  }
  addMaps(path, value) {
    return {type: 'ADD', path: path.concat(['maps']), value: value.toJson()};
  }
  setMaps(path, value) {
    return {type: 'SET', path: path.concat(['maps']), value: ArrayToJson(value, ProjectData_OpenedMap)};
  }
  setMapsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['maps', key]), value: value.toJson()};
  }
  deleteMaps(path) {
    return {type: 'DELETE', path: path.concat(['maps'])};
  }
  deleteMapsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['maps', key])};
  }
  /**
   * @returns {dcei_editor_settings_proto.ProjectSettings}
   */
  get settings() {
    return this._hasSettings ? this._settings : dcei_editor_settings_proto.ProjectSettings.default;
  }
  get hasSettings() {
    return this._hasSettings;
  }
  setSettings(path, value) {
    return {type: 'SET', path: path.concat(['settings']), value: value.toJson()};
  }
  deleteSettings(path) {
    return {type: 'DELETE', path: path.concat(['settings'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "path": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ProjectData(this);
              copy._hasPath = true;
              copy._path = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPath) {
                return this;
              }
              const copy = new ProjectData(this);
              copy._hasPath = false;
              copy._path = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "maps": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ProjectData(this);
              copy._maps = [];        for (let i of value) {
                copy._maps.push(ProjectData_OpenedMap.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ProjectData(this);
              copy._maps = copy._maps.concat([ProjectData_OpenedMap.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._maps.length === 0) {
                return this;
              }
              const copy = new ProjectData(this);
              copy._maps = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._maps.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ProjectData(this);
              copy._maps = copy._maps.slice();
              copy._maps[path[1]] = ProjectData_OpenedMap.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ProjectData(this);
              copy._maps = copy._maps.slice(0, path[1]).concat(copy._maps.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._maps.length) {
            return this;
          }
          const oldValue = this._maps[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ProjectData(this);
          copy._maps = copy._maps.slice();
          copy._maps[key] = newValue;
          return copy;
        }
      }
      case "settings": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ProjectData(this);
              copy._hasSettings = true;
              copy._settings = dcei_editor_settings_proto.ProjectSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSettings) {
                return this;
              }
              const copy = new ProjectData(this);
              copy._hasSettings = false;
              copy._settings = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasSettings) {
            const copy = new ProjectData(this);
            copy._hasSettings = true;
            copy._settings = dcei_editor_settings_proto.ProjectSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._settings.apply(type, path.slice(1), value);
          if (newValue === this._settings) {
            return this;
          }
          const copy = new ProjectData(this);
          copy._settings = copy._settings.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ProjectData} other
   * @returns {ProjectData}
   */
  merge(other) {
    const copy = new ProjectData(this);
    if (other._hasPath) {
      copy._hasPath = true;
      copy._path = other._path;
    }
    copy._maps = this._maps.concat(other._maps);
    if (other._hasSettings) {
      if (copy._hasSettings) {
        copy._settings = copy.settings.merge(other.settings);
      } else {
        copy._settings = other._settings;
      }
      copy._hasSettings = true;
    }
    return copy;
  }
}
ProjectData.default = new ProjectData();
ProjectData.OpenedMap = ProjectData_OpenedMap;
class ProjectData_Builder {
  constructor(value) {
    this._value = new ProjectData(value);
  }
  build() {
    return new ProjectData(this._value);
  }
  setPath(value) {
    this._value._hasPath = true;
    this._value._path = value;
    return this;
  }
  deletePath() {
    this._value._hasPath = false;
    this._value._path = null;
    return this;
  }
  addAllMaps(values) {
    this._value._maps = this._value._maps.concat(values);
    return this;
  }
  addMaps(value) {
    this._value._maps = this._value._maps.concat([value]);
    return this;
  }
  setMaps(index, value) {
    this._value._maps = this._value._maps.concat();
    this._value._maps[index] = value;
    return this;
  }
  clearMaps() {
    this._value._maps = [];
    return this;
  }
  setSettings(value) {
    this._value._hasSettings = true;
    this._value._settings = value;
    return this;
  }
  deleteSettings() {
    this._value._hasSettings = false;
    this._value._settings = null;
    return this;
  }
}
ProjectData.Builder = ProjectData_Builder;
class ProjectData_WithParent {
  /**
   * @param {ProjectData} value
   * @param {ProjectData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ProjectData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPath() {
    if (this._cachedHasPath === undefined) {
      if (this._value.hasPath) {
        this._cachedHasPath = true;
      } else {
        this._cachedHasPath = this._parent ? this._parent.hasPath : false;
      }
    }
    return this._cachedHasPath;
  }
  get path() {
    if (this._cachedPath === undefined) {
      if (this._value.hasPath) {
        this._cachedPath = this._value.path;
      } else {
        this._cachedPath = this._parent ? this._parent.path : this._value.path;
      }
    }
    return this._cachedPath;
  }
  get selfMaps() {
    if (!this._selfMaps) {
      this._selfMaps = [];
      for (let i of this._value.maps) {
        this._selfMaps.push(new ProjectData_OpenedMap.WithParent(i, null));
      }
    }
    return this._selfMaps;
  }
  get inherentMaps() {
    if (!this._inherentMaps) {
      this._inherentMaps = this._parent ? this._parent.maps : [];
    }
    return this._inherentMaps;
  }
  get maps() {
    if (!this._allMaps) {
      this._allMaps = this._parent ? this._parent.maps.concat(this.selfMaps) : this.selfMaps;
    }
    return this._allMaps;
  }
  get hasSettings() {
    if (this._cachedHasSettings === undefined) {
      if (this._value.hasSettings) {
        this._cachedHasSettings = true;
      } else {
        this._cachedHasSettings = this._parent ? this._parent.hasSettings : false;
      }
    }
    return this._cachedHasSettings;
  }
  get settings() {
    if (!this._cachedSettings) {
      if (this._value.hasSettings) {
        this._cachedSettings = new dcei_editor_settings_proto.ProjectSettings.WithParent(this._value.settings, this._parent && this._parent.hasSettings ? this._parent.settings : null);
      } else {
        this._cachedSettings = this._parent ? new dcei_editor_settings_proto.ProjectSettings.WithParent(dcei_editor_settings_proto.ProjectSettings.default, this._parent.settings) : dcei_editor_settings_proto.ProjectSettings.WithParent.default;
      }
    }
    return this._cachedSettings;
  }
  update(current, parent) {
    const result = new ProjectData_WithParent(current, parent);
    if (this._selfMaps) {
      if (this._value.maps === current.maps) {
        result._selfMaps = this._selfMaps;
      } else {
        result._selfMaps = [];
        for (let i = 0; i < current.maps.length; i++) {
          const oldValue = this._value.maps[i];
          if (oldValue) {
            const oldCache = this._selfMaps[i];
            if (oldValue === current.maps[i]) {
              result._selfMaps[i] = oldCache;
            } else {
              result._selfMaps[i] = oldCache.update(current.maps[i], null);
            }
          } else {
            result._selfMaps[i] = new ProjectData_OpenedMap.WithParent(current.maps[i], null);
          }
        }
      }
    }
    if (this._cachedSettings && this._value.hasSettings && current.hasSettings) {
      if (this._value.settings === current.settings && this._parent === parent) {
        result._cachedSettings = this._cachedSettings;
      } else {
        result._cachedSettings = this._cachedSettings.update(current.settings, parent && parent.hasSettings ? parent.settings : null);
      }
    }
    return result;
  }
}
ProjectData_WithParent.default = new ProjectData_WithParent(ProjectData.default, null);
ProjectData.WithParent = ProjectData_WithParent;
class ProjectData_Descriptor {
  get path() {
    if (!this._path) {
      this._path = {
        name: "path",
        Name: "Path",
        number: 1,
        protoType: 9,
        protoName: "path",
        type: JsonToString,
        options: {
          comments: "The project folder that contains the .dreameditor file. Empty if no map is opened.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._path;
  }
  get maps() {
    if (!this._maps) {
      this._maps = {
        name: "maps",
        Name: "Maps",
        number: 2,
        protoType: 11,
        protoName: "maps",
        type: ProjectData_OpenedMap,
        isRepeated: true,
        options: {
          comments: "The list of all opened maps in the current project.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maps;
  }
  get settings() {
    if (!this._settings) {
      this._settings = {
        name: "settings",
        Name: "Settings",
        number: 11,
        protoType: 11,
        protoName: "settings",
        type: dcei_editor_settings_proto.ProjectSettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._settings;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.path,
        this.maps,
        this.settings,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPath",
        Name: "DummyOneofForPath",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSettings",
        Name: "DummyOneofForSettings",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ProjectData.descriptor = new ProjectData_Descriptor();
